webpackJsonp([1],Array(18).concat([
/* 18 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return serviceihub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(383);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(384);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_settings_js__ = __webpack_require__(41);





var ajax = __WEBPACK_IMPORTED_MODULE_3_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi
});

ajax.interceptors.request.use(function (config) {
    var token = localStorage.getItem('auth');
    if (token) {
        config.headers['Authorization'] = "Bearer " + token;
    }
    return config;
}, function (error) {
    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(error);
});

ajax.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    var html = '';
    var errs = void 0;
    try {
        errs = JSON.parse(error.response.data.Message);
    } catch (e) {
        errs = error.response.data.Message;
    }
    if (Array.isArray(errs)) {
        errs.forEach(function (err) {
            html += err + "</br>";
        });
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(html);
    }{
        html = errs;
        return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_promise___default.a.reject(html);
    }
    // return Promise.reject(error)
});

var serviceihub = function () {
    function serviceihub() {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, serviceihub);
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(serviceihub, [{
        key: "getCustomerContactByCustomerId",
        value: function getCustomerContactByCustomerId(id) {
            var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var ihubapplicationId = arguments[2];

            return ajax.get(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + ("/CustomerContacts/" + id + "?all=" + all + "&ihubapplicationId=" + ihubapplicationId));
        }
    }, {
        key: "getCustomerContactXLicenseXProfilesByCustomerId",
        value: function getCustomerContactXLicenseXProfilesByCustomerId(id) {
            var all = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
            var ihubapplicationId = arguments[2];

            return ajax.get(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + ("/CCXLXPs/" + id + "?all=" + all + "&ihubapplicationId=" + ihubapplicationId));
        }
    }, {
        key: "addInstaller",
        value: function addInstaller(installer) {
            return ajax.post(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + "/CCXLXPs", installer);
        }
    }, {
        key: "updateCustomerContacts",
        value: function updateCustomerContacts(users) {
            return ajax.put(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + "/CCXLXPs", users);
        }
    }, {
        key: "updateCustomerContact",
        value: function updateCustomerContact(user) {
            return ajax.put(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + "/CustomerContact", user);
        }
    }, {
        key: "updateCustomerContactPassword",
        value: function updateCustomerContactPassword(o) {
            return ajax.put(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + "/CustomerContactPassword", o);
        }
    }, {
        key: "getProfilesByCustomerId",
        value: function getProfilesByCustomerId(customerId, ihubapplication) {
            return ajax.get(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + ("/GetProfilesByCustomerId/" + customerId + "?ihubApplicationId=" + ihubapplication));
        }
    }, {
        key: "getCustomer",
        value: function getCustomer(id) {
            return ajax.get(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + ("/Customers/" + id));
        }
    }, {
        key: "updateCustomer",
        value: function updateCustomer(customer) {
            return ajax.put(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + ("/Customers/" + customer.Id), customer);
        }
    }, {
        key: "requestDemo",
        value: function requestDemo(customer) {
            return ajax.post(__WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].iHubBaseUrlApi + "/Customers/RequestDemo", customer);
        }
    }]);

    return serviceihub;
}();



/***/ }),
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Retry_vue__ = __webpack_require__(187);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f9939c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Retry_vue__ = __webpack_require__(434);
function injectStyle (ssrContext) {
  __webpack_require__(433)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Retry_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_20f9939c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Retry_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 32 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datatable_vue__ = __webpack_require__(192);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c473585_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datatable_vue__ = __webpack_require__(443);
function injectStyle (ssrContext) {
  __webpack_require__(442)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Datatable_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3c473585_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Datatable_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 33 */,
/* 34 */,
/* 35 */,
/* 36 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomPicture_vue__ = __webpack_require__(233);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057bdc6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomPicture_vue__ = __webpack_require__(548);
function injectStyle (ssrContext) {
  __webpack_require__(547)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-057bdc6a"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomPicture_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_057bdc6a_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomPicture_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var settings = {
    // baseUrlApi: "http://localhost:60385/api",
    baseUrlApi: "https://firelog-api.ipcom.be/api",
    // iHubBaseUrlApi: "http://localhost:64406/api",
    iHubBaseUrlApi: "https://ihub-api.ipcom.be/api",
    // oryxUrlApi: "http://localhost:13279/",
    oryxUrlApi: "https://pim.oryx.ipcomdigital.eu/api",
    oryxUrlBaseUrl: "https://pim.oryx.ipcomdigital.eu/",
    // oryxUrlBaseUrl: "http://localhost:13279/",


    // admin: 10,
    // readonly: 11,
    // installer: 17,    

    admin: 7,
    readonly: 8,
    installer: 14,
    noaccess: 15,

    firelogapplicationId: 2
};

/* harmony default export */ __webpack_exports__["a"] = (settings);

/***/ }),
/* 42 */,
/* 43 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyList_vue__ = __webpack_require__(188);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0f18a1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyList_vue__ = __webpack_require__(436);
function injectStyle (ssrContext) {
  __webpack_require__(435)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5b0f18a1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EmptyList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5b0f18a1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EmptyList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomMarkup_vue__ = __webpack_require__(209);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd63233e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomMarkup_vue__ = __webpack_require__(485);
function injectStyle (ssrContext) {
  __webpack_require__(477)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-dd63233e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ZoomMarkup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_dd63233e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ZoomMarkup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */,
/* 58 */,
/* 59 */,
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadLogbook_vue__ = __webpack_require__(193);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5efa480c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadLogbook_vue__ = __webpack_require__(444);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadLogbook_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5efa480c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadLogbook_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 66 */,
/* 67 */,
/* 68 */,
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(234);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d082902_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(552);
function injectStyle (ssrContext) {
  __webpack_require__(549)
  __webpack_require__(550)
  __webpack_require__(551)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4d082902"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d082902_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index_js__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_qs__);






var ajax = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].oryxUrlApi
});

ajax.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        localStorage.removeItem("auth");
        localStorage.removeItem("user");
        __WEBPACK_IMPORTED_MODULE_3__router_index_js__["a" /* default */].go();
    } else if (error.response.status === 404) {
        __WEBPACK_IMPORTED_MODULE_3__router_index_js__["a" /* default */].push({ name: "Error", params: { status: 404 } });
    } else if (error.response.status === 403) {
        __WEBPACK_IMPORTED_MODULE_3__router_index_js__["a" /* default */].push({ name: "Error", params: { status: 403 } });
    } else {
        //window.location.href = `${settings.baseUrl}/Error`
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

/* harmony default export */ __webpack_exports__["a"] = ({
    steps: function steps(params) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].oryxUrlApi + "/Steps", {
            params: params,
            paramsSerializer: function paramsSerializer(params) {
                return __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params, { indices: false });
            }
        });
    },
    getSelectedSolution: function getSelectedSolution(params) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].oryxUrlApi + "/SelectedSolution", {
            params: params,
            paramsSerializer: function paramsSerializer(params) {
                return __WEBPACK_IMPORTED_MODULE_4_qs___default.a.stringify(params, { indices: false });
            }
        });
    },
    getLegalDocument: function getLegalDocument(customerId) {
        return ajax.get({
            url: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].oryxUrlApi + "/LegalAttachments/DownloadLegalAttachment?companyId=" + customerId,
            method: 'GET',
            responseType: 'blob'
        });
    }
});

/***/ }),
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */,
/* 94 */,
/* 95 */,
/* 96 */,
/* 97 */,
/* 98 */,
/* 99 */,
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(373);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__views_authentication_Login__ = __webpack_require__(374);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__views_projects_Index__ = __webpack_require__(432);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__views_projects_ProjectsDetails__ = __webpack_require__(451);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__views_buildingComponents_BuildingComponentsDetails__ = __webpack_require__(459);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__views_blueprints_BlueprintsDetails__ = __webpack_require__(466);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__views_blueprints_edit_BlueprintsDetails__ = __webpack_require__(488);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__views_settings_Index__ = __webpack_require__(506);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__views_users_Index__ = __webpack_require__(513);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__views_error_BadRequest__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__views_markers_Details__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__views_markers_edit_Details__ = __webpack_require__(640);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__views_solutions_Index__ = __webpack_require__(643);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__views_solutions_SolutionDetail__ = __webpack_require__(665);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__views_solutions_ProductDetail__ = __webpack_require__(669);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__views_qr_Index__ = __webpack_require__(672);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__views_users_Profile__ = __webpack_require__(680);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__views_error_Error__ = __webpack_require__(689);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__views_todo_Index__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__views_todo_InstallersTodos__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__views_reports_Index__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__views_reports_oldReports__ = __webpack_require__(698);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_store__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__components_BackButton__ = __webpack_require__(700);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__views_help_Index__ = __webpack_require__(702);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__views_markers_markerXSolutions_Details__ = __webpack_require__(705);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__views_projects_archived_ArchivedProjects__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__views_projects_archived_ProjectsDetails__ = __webpack_require__(720);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__views_buildingComponents_archived_BuildingComponentsDetails__ = __webpack_require__(723);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_31__views_blueprints_archived_BlueprintsDetails__ = __webpack_require__(725);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_32__views_markers_archived_Details__ = __webpack_require__(728);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_33__views_markers_markerXSolutions_archived_Details__ = __webpack_require__(731);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_34__views_authentication_PasswordReset__ = __webpack_require__(734);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_35__views_terms_Index__ = __webpack_require__(737);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_36_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_36_jwt_decode__);



































// import Register from '@/views/authentication/register'



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

var router = new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  scrollBehavior: function scrollBehavior(to, from, savedPosition) {
    return { x: 0, y: 0 };
  },

  mode: 'history',
  routes: [{
    path: '/',
    name: 'Projects',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_3__views_projects_Index__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Archived/Projects',
    name: 'ArchivedProjects',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_28__views_projects_archived_ArchivedProjects__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Login',
    name: 'Login',
    component: __WEBPACK_IMPORTED_MODULE_2__views_authentication_Login__["a" /* default */],
    meta: {
      guest: true
    }
  }, {
    path: '/password-reset',
    name: 'PasswordReset',
    component: __WEBPACK_IMPORTED_MODULE_34__views_authentication_PasswordReset__["a" /* default */],
    meta: {
      guest: true
    }
  }, {
    path: '/Projects/:id',
    name: 'ProjectDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_4__views_projects_ProjectsDetails__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Archived/Projects/:id',
    name: 'ArchivedProjectDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_29__views_projects_archived_ProjectsDetails__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/BuildingComponents/:id',
    name: 'BuildingComponentDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_5__views_buildingComponents_BuildingComponentsDetails__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    // component: BuildingComponentDetails,
    meta: {
      guest: false
    }
  }, {
    path: '/Archived/BuildingComponents/:id',
    name: 'ArchivedBuildingComponentDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_30__views_buildingComponents_archived_BuildingComponentsDetails__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    // component: BuildingComponentDetails,
    meta: {
      guest: false
    }
  }, {
    path: '/Blueprints/:id',
    name: 'BlueprintsDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_6__views_blueprints_BlueprintsDetails__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    // component: BlueprintsDetails,
    meta: {
      guest: false
    }
  }, {
    path: '/Blueprints/Edit/:id',
    name: 'EditBlueprintsDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_7__views_blueprints_edit_BlueprintsDetails__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    // component: BlueprintsDetails,
    meta: {
      guest: false
    }
  }, {
    path: '/Archived/Blueprints/:id',
    name: 'ArchivedBlueprintsDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_31__views_blueprints_archived_BlueprintsDetails__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    // component: BlueprintsDetails,
    meta: {
      guest: false
    }
  }, {
    path: '/Markers/Edit/:id',
    name: 'EditMarkerDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_12__views_markers_edit_Details__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    // component: MarkerDetails,
    meta: {
      guest: false
    }
  }, {
    path: '/Markers/:id',
    name: 'MarkerDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_11__views_markers_Details__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    // component: MarkerDetails,
    meta: {
      guest: false
    }
  }, {
    path: '/Archived/Markers/:id',
    name: 'ArchivedMarkerDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_32__views_markers_archived_Details__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    // component: MarkerDetails,
    meta: {
      guest: false
    }
  }, {
    path: '/Markers/:id/Solution/:markerXSolutionId',
    name: 'MarkerXSolutionDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_26__views_markers_markerXSolutions_Details__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Archived/Markers/:id/Solution/:markerXSolutionId',
    name: 'ArchivedMarkerXSolutionDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_33__views_markers_markerXSolutions_archived_Details__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Settings',
    name: 'Settings',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_8__views_settings_Index__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Users',
    name: 'Users',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_9__views_users_Index__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Error',
    name: 'BadRequest',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_10__views_error_BadRequest__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: true
    }
  }, {
    path: '/Solutions',
    name: 'Solutions',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_13__views_solutions_Index__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Solutions/:id',
    name: 'SolutionDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_14__views_solutions_SolutionDetail__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Solutions/:solutionId/product/:id',
    name: 'ProductDetails',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_15__views_solutions_ProductDetail__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */],
      breadcrumb: __WEBPACK_IMPORTED_MODULE_27__components_Breadcrumb__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/QR/:id',
    name: 'QR',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_16__views_qr_Index__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: true
    }
  }, {
    path: '/Error',
    name: 'Error',
    component: __WEBPACK_IMPORTED_MODULE_18__views_error_Error__["a" /* default */],
    meta: {
      guest: false
    }
  }, {
    path: '/Profile',
    name: 'Profile',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_17__views_users_Profile__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Todo',
    name: 'Todo',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_19__views_todo_Index__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Todos/installers',
    name: 'InstallersTodos',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_20__views_todo_InstallersTodos__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Reports',
    name: 'Reports',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_21__views_reports_Index__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Reports/old',
    name: 'Reports',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_22__views_reports_oldReports__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Help',
    name: 'Help',
    components: {
      default: __WEBPACK_IMPORTED_MODULE_25__views_help_Index__["a" /* default */],
      header: __WEBPACK_IMPORTED_MODULE_24__components_BackButton__["a" /* default */]
    },
    meta: {
      guest: false
    }
  }, {
    path: '/Terms',
    name: 'Terms',
    component: __WEBPACK_IMPORTED_MODULE_35__views_terms_Index__["a" /* default */],
    meta: {
      guest: false
    }
  }]
});

router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.guest;
  })) {
    next();
  } else {
    if (localStorage.getItem('auth') === null) {
      if (to.name === "Error") {
        next();
      } else if (to.path === "/password-reset") {
        next();
      } else {
        next({ name: 'Login' });
      }
    } else {
      next();
    }
  }
});

/* harmony default export */ __webpack_exports__["a"] = (router);

/***/ }),
/* 112 */,
/* 113 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IsLocked_vue__ = __webpack_require__(205);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d68b42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IsLocked_vue__ = __webpack_require__(469);
function injectStyle (ssrContext) {
  __webpack_require__(468)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_IsLocked_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29d68b42_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_IsLocked_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadBlueprint_vue__ = __webpack_require__(206);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa9a79b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadBlueprint_vue__ = __webpack_require__(472);
function injectStyle (ssrContext) {
  __webpack_require__(470)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UploadBlueprint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6fa9a79b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UploadBlueprint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanQRCode_vue__ = __webpack_require__(214);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa59638c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanQRCode_vue__ = __webpack_require__(486);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ScanQRCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aa59638c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ScanQRCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 120 */,
/* 121 */,
/* 122 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 123 */,
/* 124 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddQRCode_vue__ = __webpack_require__(232);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9563734_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddQRCode_vue__ = __webpack_require__(546);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddQRCode_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9563734_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddQRCode_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 125 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__ = __webpack_require__(235);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c63f1d80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__ = __webpack_require__(554);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Reports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c63f1d80_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Reports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 126 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreYouSure2_vue__ = __webpack_require__(236);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a51668_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreYouSure2_vue__ = __webpack_require__(553);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreYouSure2_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_09a51668_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreYouSure2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 127 */,
/* 128 */,
/* 129 */,
/* 130 */,
/* 131 */,
/* 132 */,
/* 133 */,
/* 134 */,
/* 135 */,
/* 136 */,
/* 137 */,
/* 138 */,
/* 139 */,
/* 140 */,
/* 141 */,
/* 142 */,
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PIMSolutionDetails_vue__ = __webpack_require__(280);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6a151b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PIMSolutionDetails_vue__ = __webpack_require__(662);
function injectStyle (ssrContext) {
  __webpack_require__(659)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b6a151b0"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PIMSolutionDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b6a151b0_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PIMSolutionDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 144 */,
/* 145 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__ = __webpack_require__(287);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfc955f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__ = __webpack_require__(677);
function injectStyle (ssrContext) {
  __webpack_require__(676)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4cfc955f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Products_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4cfc955f_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Products_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(218);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__ = __webpack_require__(219);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuex__ = __webpack_require__(67);






__WEBPACK_IMPORTED_MODULE_3_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_4_vuex__["a" /* default */].Store({
    state: {
        loggedIn: false,
        isMobile: false,
        isOffline: false,
        rows: [15, 50, 100],
        colors: {
            primary: "#0A3051",
            highlight: "#009BD9",
            subhighlight: "#85C9F0",
            error: "#f44336",
            green: "#176e4b",
            orange: "#F5A800",
            grey: "#DCDCDC"

        },
        previous: null,
        offline: {
            offBlueprint: null,
            offMarkers: [],
            offProductSolutions: null,
            offInstallers: null,
            offUnusedAttributes: null
        },
        offForm: [],
        offQrs: [],
        markers: [],
        markersReadonly: [],
        productSolutions: null,
        hasChanges: false,
        drawable: false,
        languages: null,
        breadcrumb: null,
        allAttributes: null,
        offlineSyncing: false,
        grid: true,
        openBlueprint: false,
        markerDetailSaved: true,
        readyForOffline: false
    },

    mutations: {
        change: function change(state, value) {
            state.isOffline = value;
        },
        updateMarker: function updateMarker(state, value) {
            //Anwar: When marker is updated, notify the table
            //state.markers = [...state.markers.filter(x => x.id !== value.id), value]  

            state.markers.filter(function (x) {
                if (x.id === value.id) {

                    x.isApproved = true;
                    value.markerXSolutions.forEach(function (mxs) {
                        if (mxs.attachments.length > 0) {
                            if (mxs.attachments[0].approved == false) {

                                x.isApproved = 1;
                                mxs.isApproved = 1;
                            } else {
                                x.isApproved = 2;
                                mxs.isApproved = 2;
                            }
                        } else {
                            x.isApproved = 0;
                            mxs.isApproved = 0;
                        }
                    });
                    //Bart, 13/6/19: manual setting of isApproved flag based on picture still needed
                    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_core_js_object_assign___default()(x, value);
                }
            });
        },
        addOrUpdateOffForm: function addOrUpdateOffForm(state, value) {
            if (state.offForm.find(function (x) {
                return x.marker.id == value.marker.id;
            })) {
                state.offForm = state.offForm.filter(function (x) {
                    return x.marker.id != value.marker.id;
                });
                state.offForm.push(value);
            } else {
                state.offForm.push(value);
            }
        },
        highlight: function highlight(state, value) {
            state.markers = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.markers.filter(function (x) {
                if (x.id !== value.id) {
                    x.highlight = false;
                    return x;
                }
            })), [value]);
        },
        unHighlight: function unHighlight(state, value) {
            state.markers = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.markers.filter(function (x) {
                if (x.id !== value.id) {
                    x.highlight = false;
                    return x;
                }
            })), [value]);
        },
        select: function select(state, value) {
            if (value === null) {
                state.markers = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.markers.filter(function (x) {
                    x.draggable = false;
                    x.highlight = false;
                    return x;
                })));
            } else {
                state.markers = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.markers.filter(function (x) {
                    if (x.id !== value.id) {
                        x.draggable = false;
                        x.highlight = false;
                        return x;
                    }
                })), [value]);
            }
        },
        selectReadonly: function selectReadonly(state, value) {
            if (value === null) {
                state.markersReadonly = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.markersReadonly.filter(function (x) {
                    x.draggable = false;
                    x.highlight = false;
                    return x;
                })));
            } else {
                state.markersReadonly = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.markersReadonly.filter(function (x) {
                    if (x.id !== value.id) {
                        x.draggable = false;
                        x.highlight = false;
                        return x;
                    }
                })), [value]);
            }
        },
        AddAndSetUIelements: function AddAndSetUIelements(state, value) {
            var markerui = {
                xRect: value.coordX - 5,
                yRect: value.coordY - 5,
                xStartLine: value.coordX,
                yStartLine: value.coordY,
                xEndLine: value.coordX <= value.coordX2 ? value.coordX2 - 20 : value.coordX2 + 20,
                yEndLine: value.coordY2,
                xCircle: value.coordX2,
                yCircle: value.coordY2,
                xLabel: value.coordX2 - 17.5,
                yLabel: value.coordY2 - 8.5,
                text: value.number,
                highlight: false,
                draggable: false
            };

            state.markers = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.markers.filter(function (x) {
                return x.id !== value.id;
            })), [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value, markerui)]);
        },
        AddAndSetUIelementsReadonly: function AddAndSetUIelementsReadonly(state, value) {
            var markerui = {
                xRect: value.coordX - 5,
                yRect: value.coordY - 5,
                xStartLine: value.coordX,
                yStartLine: value.coordY,
                xEndLine: value.coordX <= value.coordX2 ? value.coordX2 - 20 : value.coordX2 + 20,
                yEndLine: value.coordY2,
                xCircle: value.coordX2,
                yCircle: value.coordY2,
                xLabel: value.coordX2 - 17.5,
                yLabel: value.coordY2 - 8.5,
                text: value.number,
                highlight: false,
                draggable: false
            };

            state.markersReadonly = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.markersReadonly.filter(function (x) {
                return x.id !== value.id;
            })), [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value, markerui)]);
        },
        offAddAndSetUIelements: function offAddAndSetUIelements(state, value) {
            var markerui = {
                xRect: value.coordX - 5,
                yRect: value.coordY - 5,
                xStartLine: value.coordX,
                yStartLine: value.coordY,
                xEndLine: value.coordX <= value.coordX2 ? value.coordX2 - 20 : value.coordX2 + 20,
                yEndLine: value.coordY2,
                xCircle: value.coordX2,
                yCircle: value.coordY2,
                xLabel: value.coordX2 - 17.5,
                yLabel: value.coordY2 - 8.5,
                text: value.number,
                highlight: false,
                draggable: false
            };

            state.offline.offMarkers = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(state.offline.offMarkers.filter(function (x) {
                return x.id !== value.id;
            })), [__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, value, markerui)]);
        }
    },
    getters: {
        isOffline: function isOffline(state) {
            return state.isOffline;
        },
        //Bart, 15/5/2019: map viewmodel Marker onto Marker ready for canvas rendering

        //Anwar, 29/05/2019: no getter used, because you can't watch changes(highlight)
        // markersui: state => state.markers.map(function(e) {
        //     return {
        //         id: e.id,
        //         xRect: e.coordX - 5,
        //         yRect: e.coordY - 5,
        //         xStartLine: e.coordX,
        //         yStartLine: e.coordY,
        //         xEndLine: e.coordX <= e.coordX2 ? e.coordX2 - 40 : e.coordX2 + 40,
        //         yEndLine: e.coordY2,
        //         xCircle: e.coordX2,
        //         yCircle: e.coordY2,
        //         xLabel: e.coordX2 - 7.5,
        //         yLabel: e.coordY2 - 12.5,
        //         label: e.name,
        //         highlight: false
        //     }
        // }),
        markers: function markers(state) {
            return state.markers.sort(function (a, b) {
                return a.number - b.number;
            });
        },
        markersReadonly: function markersReadonly(state) {
            return state.markersReadonly.sort(function (a, b) {
                return a.number - b.number;
            });
        }

    }
});

/***/ }),
/* 147 */,
/* 148 */,
/* 149 */,
/* 150 */,
/* 151 */,
/* 152 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_string_from_code_point__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_noty_dist_vuejs_noty_css__ = __webpack_require__(363);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vuejs_noty_dist_vuejs_noty_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vuejs_noty_dist_vuejs_noty_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__ = __webpack_require__(364);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_vuetify_dist_vuetify_min_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_DownloadStickers__ = __webpack_require__(365);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_SuperUser__ = __webpack_require__(367);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__settings_settings_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_jwt_decode__);




//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "app",
  components: {
    downloadStickers: __WEBPACK_IMPORTED_MODULE_6__components_DownloadStickers__["a" /* default */],
    superUser: __WEBPACK_IMPORTED_MODULE_7__components_SuperUser__["a" /* default */]
  },
  data: function data() {
    return {
      drawer: true,
      user: "",
      noConnection: false,
      loading: false,
      loadingText: "",
      menuActive: 0,
      notifications: {},
      releaseNoteOverview: null,
      menu: false
    };
  },

  methods: {
    getDescription: function getDescription(descriptions) {
      return descriptions[localStorage.getItem("language").toLowerCase()] !== undefined ? descriptions[localStorage.getItem("language").toLowerCase()] : "";
    },
    readReleaseNotes: function readReleaseNotes() {
      var _this = this;

      this.$http.readReleaseNotes().then(function (res) {
        _this.releaseNoteOverview.count = 0;
      }).catch(function (err) {
        console.log(err);
      });
    },
    getReleaseNotes: function getReleaseNotes() {
      var _this2 = this;

      this.$http.getReleaseNotes().then(function (res) {
        _this2.releaseNoteOverview = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    checkIfUserHasAcceptedTermsAndServices: function checkIfUserHasAcceptedTermsAndServices() {
      // if (
      //   jwtdecode(localStorage.getItem("auth")).license.QRLOG
      //     .acceptTermsAndService
      // ) {
      //   this.$router.push({
      //     name: "Terms"
      //   });
      // }
    },
    changeLanguage: function changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
      this.$router.go();
    },
    logout: function logout() {
      this.$router.push({
        name: "Login"
      });

      this.$store.state.loggedIn = false;
    },
    login: function login() {
      this.$store.state.loggedIn = true;
      this.user = localStorage.getItem("user");
    },
    goBack: function goBack() {
      if (this.$store.state.previous) {
        this.$router.push({
          name: this.$store.state.previous.name,
          params: { id: this.$store.state.previous.id }
        });
      } else {
        this.$router.push({
          name: "Projects"
        });
      }
    },
    downloadExcel: function downloadExcel() {
      var _this3 = this;

      this.loading = true;
      this.$http.downloadExcelExport().then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", "Excel_Overview" + date.toLocaleDateString() + ".xlsx");
        document.body.appendChild(link);
        link.click();
        _this3.loading = false;
      }).catch(function (err) {
        _this3.$noty.error(_this3.$t("error"));
        console.log(err);
        _this3.loading = false;
      });
    },
    fromCodePoint: function fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[0]) + __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[1]);
      }
      return __WEBPACK_IMPORTED_MODULE_3_babel_runtime_core_js_string_from_code_point___default()(codepoint);
    },
    onResize: function onResize() {
      if (window.innerWidth <= 1264) {
        this.$store.state.isMobile = true;
      } else {
        this.$store.state.isMobile = false;
      }
    },
    checkConnection: function checkConnection() {
      var _this4 = this;

      if (!navigator.onLine) this.noConnection = true;
      window.addEventListener("offline", function () {
        _this4.noConnection = true;
        _this4.$store.state.isOffline = true;
      });
      window.addEventListener("online", function () {
        _this4.noConnection = false;
        _this4.$store.state.isOffline = false;
      });
    },
    toggleDrawer: function toggleDrawer() {
      this.drawer = !this.drawer;
    },
    getNotifications: function getNotifications() {
      var _this5 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this5.$http.getNotifications();

              case 3:
                res = _context.sent;

                _this5.notifications = res.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this5, [[0, 7]]);
      }))();
    }
  },
  beforeCreate: function beforeCreate() {
    document.body.className = "home";
  },
  watch: {
    isOffline: function isOffline(n, o) {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
        var vm, deleteMxSRequests, newMarkerRequests, updateMarkerRequests, linkQRRequests, newMarkers, updatedMarkers;
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                // this.dialog = true;
                _this6.loadingText = _this6.$t("notOnline");
                vm = _this6;

                if (!n) {
                  _context2.next = 7;
                  break;
                }

                _this6.drawer = false;
                window.onbeforeunload = function () {
                  return "You're leaving the site.";
                };
                _context2.next = 46;
                break;

              case 7:
                window.onbeforeunload = function () {
                  return "You're leaving the site.";
                };

                if (!(_this6.$store.state.offForm.length > 0)) {
                  _context2.next = 44;
                  break;
                }

                window.onbeforeunload = function () {
                  return undefined;
                };

                _this6.$store.state.offlineSyncing = true;
                _context2.prev = 11;
                deleteMxSRequests = [];
                newMarkerRequests = [];
                updateMarkerRequests = [];
                linkQRRequests = [];

                _this6.$store.state.offForm.forEach(function (element) {
                  if (element.marker.new) {
                    newMarkerRequests.push(_this6.$http.addMarker(element.marker));
                  } else {
                    updateMarkerRequests.push(_this6.$http.updateMarker(element.marker));
                  }
                  if (element.deleteMarkerXSolution) {
                    deleteMxSRequests.push(_this6.$http.deleteMarkerXSolution(element.deleteMarkerXSolution));
                  }
                });

                _this6.loadingText = _this6.$t("await: new/update markers");
                _context2.next = 20;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(newMarkerRequests);

              case 20:
                newMarkers = _context2.sent;

                newMarkers.forEach(function (res) {
                  _this6.$store.commit("AddAndSetUIelements", res.data);
                  if (_this6.$store.state.markersReadonly.length > 0) {
                    _this6.$store.commit("AddAndSetUIelementsReadonly", res.data);
                  }
                  _this6.$forceUpdate();
                });
                _context2.next = 24;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(updateMarkerRequests);

              case 24:
                updatedMarkers = _context2.sent;

                updatedMarkers.forEach(function (res) {
                  _this6.$store.commit("AddAndSetUIelements", res.data);

                  if (_this6.$store.state.markersReadonly.length > 0) {
                    _this6.$store.commit("AddAndSetUIelementsReadonly", res.data);
                  }
                  _this6.$forceUpdate();
                });
                _this6.loadingText = _this6.$t("done: new/update markers");
                _this6.loadingText = _this6.$t("await: delete mxs");
                _context2.next = 30;
                return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.all(deleteMxSRequests);

              case 30:
                _this6.loadingText = _this6.$t("done: delete mxs");
                // if (this.$store.state.offQrs.length > 0) {
                //   this.$store.state.offQrs.forEach((o) => {
                //     linkQRRequests.push(
                //       this.$http.getMarkerByQRId(o.qrId, o.markerId)
                //     );
                //   });
                // }
                // this.loadingText = this.$t("await linkQRRequests");
                // await Promise.all(linkQRRequests)
                // .then(async res => {
                //   let updatedMarkersAgain = await Promise.all(updateMarkerRequestsAgain);
                // updatedMarkersAgain.forEach((res) => {
                //   this.$store.commit("AddAndSetUIelements", res.data);
                //   if (this.$store.state.markersReadonly.length > 0) {
                //     this.$store.commit("AddAndSetUIelementsReadonly", res.data);
                //   }
                //   this.$forceUpdate();
                // });
                // })
                // .catch(err => {
                //   console.log(err)
                // })
                // console.log("qrcodes")
                // this.loadingText = this.$t("done: link QR codes");
                // this.loadingText = this.$t("done syncing offline changes");
                // this.$router.go();

                _this6.$store.state.offlineSyncing = false;
                //reset offline form
                _this6.$store.state.offForm = [];

                _context2.next = 42;
                break;

              case 35:
                _context2.prev = 35;
                _context2.t0 = _context2["catch"](11);

                _this6.loadingText = _context2.t0;
                console.log(_context2.t0);
                _this6.$noty.error(_context2.t0);
                _this6.$store.state.offlineSyncing = false;
                //reset offline form
                _this6.$store.state.offForm = [];

              case 42:
                _context2.next = 46;
                break;

              case 44:
                _this6.dialog = false;
                window.onbeforeunload = function () {
                  return undefined;
                };

              case 46:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, _this6, [[11, 35]]);
      }))();
    },
    $route: function $route(to, from) {
      if (localStorage.getItem("auth") != null) {
        this.checkIfUserHasAcceptedTermsAndServices();
      }
    }
  },
  computed: {
    isSuper: function isSuper() {
      var tokenRaw = localStorage.getItem("auth");
      var token = tokenRaw != null ? __WEBPACK_IMPORTED_MODULE_9_jwt_decode___default()(tokenRaw) : null;

      return token != null && token.QRLOG && token.QRLOG.includes('shadow_account');
    },
    items: function items() {
      return [{
        sub: true,
        text: this.$t("projects"),
        icon: "home",
        notification: 0,
        subgroups: [{
          name: "/",
          text: this.$t("activeProjects"),
          icon: "device_hub",
          can: this.$can("read", "projects"),
          notification: 0
        }, {
          name: "/Archived/Projects",
          text: this.$t("archivedProjects"),
          icon: "archive",
          can: this.$can("read", "archivedProjects"),
          notification: 0
        }],
        can: this.$can("read", "projects")
      }, {
        sub: this.$can("read", "usersTodos") ? true : false,
        name: "/Todo",
        text: this.$can("read", "usersTodos") ? this.$t("todos") : this.$t("myTodos"),
        can: this.$can("read", "todos"),
        icon: "assignment",
        color: "secondary",
        notification: this.$can("read", "usersTodos") ? 0 : this.notifications.todos ? this.notifications.todos : 0,
        subgroups: [{
          name: "/Todo",
          color: "secondary",
          text: this.$t("myTodos"),
          icon: "assignment",
          can: this.$can("read", "todos"),
          notification: this.notifications.todos ? this.notifications.todos : 0
        }, {
          name: "/Todos/installers",
          color: "secondary",
          text: this.$t("todosForInstallers"),
          icon: "playlist_add_check",
          notification: 0,
          can: this.$can("read", "usersTodos")
        }]
      }, {
        sub: true,
        text: this.$t("reports"),
        icon: "report_problem",
        color: "red",
        notification: this.notifications.reports ? this.notifications.reports : 0,
        subgroups: [{
          name: "/Reports",
          text: this.$t("reports"),
          icon: "report_problem",
          can: this.$can("read", "reports"),
          color: "red",
          notification: this.notifications.reports ? this.notifications.reports : 0
        }, {
          name: "/Reports/old",
          text: this.$t("archivedReports"),
          icon: "fa-history",
          can: this.$can("read", "reports"),
          notification: 0
        }],
        can: this.$can("read", "reports")
      }, {
        sub: true,
        text: this.$t("settings"),
        icon: "settings",
        notification: 0,
        subgroups: [{
          name: "/Solutions",
          text: this.$t("solutions"),
          icon: "list_alt",
          can: this.$can("read", "settings"),
          notification: 0
        }, {
          name: "/Users",
          text: this.$t("users"),
          icon: "people",
          can: this.$can("read", "users"),
          notification: 0
        }, {
          name: "/Settings",
          group: true,
          text: this.$t("attributes"),
          icon: "toggle_on",
          can: this.$can("read", "settings"),
          notification: 0
        }],
        can: this.$can("read", "settings")
      }, {
        name: "/Help",
        group: true,
        notification: 0,
        text: this.$t("help"),
        icon: "help",
        can: true
      }];
    },
    snackbar: function snackbar() {
      return this.offlineUsers.length > 0;
    },
    isOffline: function isOffline() {
      return this.$store.state.isOffline;
    }
  },
  ready: function ready() {
    window.addEventListener("resize", this.onResize);
  },
  mounted: function mounted() {},
  created: function created() {
    var _this7 = this;

    this.$http.getLanguages().then(function (res) {
      _this7.$store.state.languages = res.data;
    }).catch(function (err) {
      console.log(err);
    });
    this.user = localStorage.getItem("user");
    if (localStorage.getItem("auth") != null) {
      this.$store.state.loggedIn = true;
      this.getNotifications();
      this.checkIfUserHasAcceptedTermsAndServices();
      this.getReleaseNotes();
    }
    this.checkConnection();
  }
});

/***/ }),
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      items: [10, 20, 30, 40, 50, 100, 200],
      amount: null,
      type: 0,
      loading: false,
      stickerTemplate: null,
      firelogLogo: __webpack_require__(110)
    };
  },

  // created(){
  //   this.getLogo();
  // },
  // mounted() {
  //   this.$nextTick(() => {
  //     this.getLogo();
  //   });
  // },
  watch: {
    dialog: function dialog() {
      if (this.dialog) {
        if (this.stickerTemplate === null) {
          this.getLogo();
        }
      }
    }
  },
  methods: {
    uploadLogo: function uploadLogo() {
      var _this = this;

      var form = new FormData();
      form.append("logo", this.$refs.file.files[0]);

      this.$http.uploadLogo(form).then(function (res) {
        _this.stickerTemplate = res.data;
        _this.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this.$noty.error(_this.$t("error"));
        console.log(err);
      });
    },
    getLogo: function getLogo() {
      var _this2 = this;

      this.$http.getStickerTemplate().then(function (res) {
        _this2.stickerTemplate = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    downloadStickers: function downloadStickers() {
      var _this3 = this;

      if (this.amount) {
        this.loading = true;
        this.$http.downloadQRStickers(this.amount, this.type).then(function (res) {
          var url = window.URL.createObjectURL(new Blob([res.data]));
          var link = document.createElement("a");
          link.href = url;
          var date = new Date();
          if (_this3.type === 1) {
            link.setAttribute("download", "QRcode_Stickers" + date.toLocaleDateString() + ".csv");
          } else {
            link.setAttribute("download", "QRcode_Stickers" + date.toLocaleDateString() + ".docx");
          }
          document.body.appendChild(link);
          link.click();
          _this3.dialog = false;
          _this3.loading = false;
        }).catch(function (err) {
          _this3.$noty.error(_this3.$t("error"));
          console.log(err);
          _this3.loading = false;
        });
      }
    }
  }
});

/***/ }),
/* 169 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dialog: Boolean,
    text: String
  },
  data: function data() {
    return {
      loading: false,
      items: [],
      search: null,
      select: null,
      progress: false
    };
  },

  watch: {
    search: function search(val) {
      var _this = this;

      if (val && val.length >= 3 && val !== this.select) {
        setTimeout(function () {
          _this.querySelections(val);
        }, 300);
      }
    }
  },
  methods: {
    login: function login() {
      var _this2 = this;

      this.progress = true;
      this.$http.loginAsCustomer({
        id: this.select.Id
      }).then(function (res) {
        if (res.data) {
          if (__WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(res.data)["QRLOG"]) {
            _this2.$noty.success('<i class="fas fa-check"></i>');
            localStorage.setItem("auth", res.data);
            localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(res.data).name);

            _this2.$router.go();
          } else {
            _this2.$noty.error(_this2.$t("noaccess"));
            _this2.progress = false;
          }
        } else {
          _this2.$noty.error(_this2.$t("userNotFound"));
          _this2.progress = false;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    querySelections: function querySelections(v) {
      var _this3 = this;

      if (!v) return;
      if (v.length < 3) return;
      this.loading = true;
      this.$http.getAccounts(v).then(function (res) {
        _this3.loading = false;
        _this3.items = res.data;
      }).catch(function (err) {
        _this3.loading = false;
        console.log(err);
      });
    }
  }
});

/***/ }),
/* 170 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 171 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha256__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Pages_Authentication_Login__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pages_Authentication_Signup__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_Pages_Authentication_ForgotPassword__ = __webpack_require__(405);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Login",
  data: function data() {
    return {
      tab: null,
      forgot: false
    };
  },

  computed: {
    logo: function logo() {
      console.log("Host is " + window.location.host);
      if (window.location.host.includes('sbk')) {
        return "sbklogo.jpg";
      } else {
        return "logo_with_text.png";
      }
    }
  },
  components: {
    login: __WEBPACK_IMPORTED_MODULE_3__components_Pages_Authentication_Login__["a" /* default */],
    signup: __WEBPACK_IMPORTED_MODULE_4__components_Pages_Authentication_Signup__["a" /* default */],
    forgotPassword: __WEBPACK_IMPORTED_MODULE_5__components_Pages_Authentication_ForgotPassword__["a" /* default */]
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    document.body.className = "login";
    if (from.name !== "Login" && from.name !== null) {
      localStorage.removeItem("auth");
      localStorage.removeItem("user");
    }
    next(function (vm) {
      // access to component instance via `vm`
      if (localStorage.getItem("auth") != null) {
        vm.$router.push({ name: "Projects" });
      } else {
        next();
      }
    });
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    document.body.className = "home";
    next();
  },

  methods: {
    changeLanguage: function changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
    },
    fromCodePoint: function fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[0]) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[1]);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint);
    }
  },
  beforeCreate: function beforeCreate() {
    document.body.className = "login";
  }
});

/***/ }),
/* 172 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(173);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c708bfe6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(380);
function injectStyle (ssrContext) {
  __webpack_require__(379)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c708bfe6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 173 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha256__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sha256__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoginComponent",
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    document.body.className = "login";
    if (from.name !== "Login" && from.name !== null) {
      localStorage.removeItem("auth");
      localStorage.removeItem("user");
    }
    next(function (vm) {
      // access to component instance via `vm`
      if (localStorage.getItem("auth") != null) {
        vm.$router.push({ name: "Projects" });
      } else {
        next();
      }
    });
  },
  mounted: function mounted() {
    var form = document.getElementById("log_in_form");
    var newScript = document.createElement("script");
    var inlineScript = document.createTextNode("var __ss_noform = __ss_noform || [];\
    __ss_noform.push(['baseURI', 'https://app-3QNF04NCZU.marketingautomation.services/webforms/receivePostback/MzawMDGzMDO3BAA/']);\
    __ss_noform.push(['form','log_in_form', 'a2246a5c-b387-4bab-bf8a-a4fd11141522']);\
    __ss_noform.push(['submitType', 'manual']);");
    newScript.appendChild(inlineScript);
    form.parentNode.insertBefore(newScript, form.nextSibling);

    var sharpspringElement = document.createElement("script");
    sharpspringElement.setAttribute("src", "https://koi-3QNF04NCZU.marketingautomation.services/client/noform.js?ver=1.24");
    newScript.parentNode.insertBefore(sharpspringElement, newScript.nextSibling);
  },

  components: {},
  data: function data() {
    return {
      tab: null,
      show: false,
      loading: false,
      valid: false,
      credentials: {
        username: "",
        inputP: "",
        password: "",
        honeypot: "",
        ihubApplicationId: 2
      }
    };
  },
  methods: {
    changeLanguage: function changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
    },
    fromCodePoint: function fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[0]) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[1]);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint);
    },
    login: function login() {
      var _this = this;

      if (this.valid && this.$refs.form.validate()) {
        if (this.credentials.honeypot.length == 0) {
          this.loading = true;
          this.encrypt();
          if (localStorage.getItem("language") == null) {
            localStorage.setItem("language", "EN");
          }
          __ss_noform.push(["submit", null, "a2246a5c-b387-4bab-bf8a-a4fd11141522"]);
          this.$http.login(this.credentials).then(function (res) {
            if (res.data) {
              if (__WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(res.data)["QRLOG"]) {
                _this.$noty.success('<i class="fas fa-check"></i>');
                localStorage.setItem("auth", res.data);
                localStorage.setItem("user", __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(res.data).name);

                _this.$router.go();
              } else {
                _this.$noty.error(_this.$t("noaccess"));
                _this.loading = false;
              }
            } else {
              _this.$noty.error(_this.$t("userNotFound"));
              _this.loading = false;
            }
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
            _this.loading = false;
          });
        }
      }
    },
    emailRules: function emailRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$t("email") + " " + _this2.$t("required");
      }, function (v) {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || _this2.$t("email") + " " + _this2.$t("invalid");
      }];
    },
    passwordRules: function passwordRules() {
      var _this3 = this;

      return [function (v) {
        return !!v || _this3.$t("password") + " " + _this3.$t("required");
      }];
    },
    encrypt: function encrypt() {
      this.credentials.password = __WEBPACK_IMPORTED_MODULE_2_sha256___default()(this.credentials.inputP);
    }
  },
  beforeCreate: function beforeCreate() {
    // document.body.className = "login";
  }
});

/***/ }),
/* 174 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_ihub_js__ = __webpack_require__(27);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_1__services_service_ihub_js__["a" /* serviceihub */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  computed: {
    countries: function countries() {
      var countries = [{ code: "BE", name: this.$t("belgium") }, { code: "EN", name: this.$t("unitedKingdom") }, { code: "DE", name: this.$t("germany") }, { code: "AU", name: this.$t("austria") }, { code: "RO", name: this.$t("romania") }, { code: "SE", name: this.$t("sweden") }, { code: "HU", name: this.$t("hungary") }, { code: "NL", name: this.$t("netherlands") }, { code: "NN", name: this.$t("norway") }, { code: "SW", name: this.$t("switzerland") }, { code: "SP", name: this.$t("spain") }];
      return countries.sort(function (a, b) {
        return a.name > b.name ? 1 : b.name > a.name ? -1 : 0;
      });
    }
  },
  data: function data() {
    return {
      registered: false,
      loading: false,
      valid: false,
      selectedCountry: null,
      selectedCompany: null,
      noPartner: {
        id: 0,
        name: "No partner"
      },
      companies: [{ id: 2, code: "BE", name: "Isowill" }, { id: 1, code: "BE", name: "Waeyeart Vermeersch" }, { id: 12, code: "BE", name: "Caremiso" }, { id: 3, code: "NL", name: "Jacosol" },
      // { id: 6, code: "DE", name: "Kiesewetter" },
      // { id: 6, code: "DE", name: "Seidemann" },
      { id: 7, code: "SE", name: "Profisol" }, { id: 8, code: "SW", name: "Regisol" }, { id: 4, code: "AU", name: "Isolier- und Dämmtechnik" }, { id: 7, code: "DE", name: "Isopartner" }, { id: 9, code: "EN", name: "TIDL" }, { id: 10, code: "HU", name: "Isolier- und Dämmtechnik" }, { id: 13, code: "RO", name: "Isolier- und Dämmtechnik" }, { id: 14, code: "SP", name: "Grupo Flexicel" }],
      customer: {
        name: "",
        firstname: "",
        lastname: "",
        street: "",
        streetNr: "",
        postalCode: "",
        city: "",
        country: "",
        VATNumber: "",
        email: "",
        phone: "",
        honeypot: "",
        company: null,
        isCustomer: false
      }
    };
  },
  mounted: function mounted() {
    var form = document.getElementById("sign_up_form");
    var newScript = document.createElement("script");
    var inlineScript = document.createTextNode("var __ss_noform = __ss_noform || [];\
    __ss_noform.push(['baseURI', 'https://app-3QNF04NCZU.marketingautomation.services/webforms/receivePostback/MzawMDGzMDO3BAA/']);\
    __ss_noform.push(['form','sign_up_form', 'da97a78a-bb79-44c6-b6a3-643228b4caaa']);\
    __ss_noform.push(['submitType', 'manual']);");
    newScript.appendChild(inlineScript);
    form.parentNode.insertBefore(newScript, form.nextSibling);

    var sharpspringElement = document.createElement("script");
    sharpspringElement.setAttribute("src", "https://koi-3QNF04NCZU.marketingautomation.services/client/noform.js?ver=1.24");
    newScript.parentNode.insertBefore(sharpspringElement, newScript.nextSibling);
  },

  methods: {
    changeLanguage: function changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
    },
    fromCodePoint: function fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[0]) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[1]);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint);
    },
    requestDemo: function requestDemo() {
      var _this = this;

      if (this.valid && this.$refs.form.validate()) {
        if (this.customer.honeypot.length == 0) {
          this.loading = true;
          this.customer.country = this.selectedCountry;
          this.customer.company = this.selectedCompany;
          if (localStorage.getItem("language") == null) {
            localStorage.setItem("language", "EN");
          }
          window.__ss_noform.push(["submit", null, "da97a78a-bb79-44c6-b6a3-643228b4caaa"]);
          _serviceIhub.requestDemo(this.customer).then(function (res) {
            _this.loading = false;
            _this.registered = true;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
            _this.loading = false;
          });
        }
      }
    },
    emailRules: function emailRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$t("email") + " " + _this2.$t("required");
      }, function (v) {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || _this2.$t("email") + " " + _this2.$t("invalid");
      }];
    },
    requiredRules: function requiredRules(property) {
      var _this3 = this;

      return [function (v) {
        return !!v || property + " " + _this3.$t("required");
      }];
    }
  }
});

/***/ }),
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sha256__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sha256__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "LoginComponent",
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    document.body.className = "login";
    if (from.name !== "Login" && from.name !== null) {
      localStorage.removeItem("auth");
      localStorage.removeItem("user");
    }
    next(function (vm) {
      // access to component instance via `vm`
      if (localStorage.getItem("auth") != null) {
        vm.$router.push({ name: "Projects" });
      } else {
        next();
      }
    });
  },


  // beforeRouteEnter(to, from, next) {},
  components: {},
  data: function data() {
    return {
      loading: false,
      valid: false,
      credentials: {
        email: "",
        honeypot: ""
      },
      checkEmail: false
    };
  },
  methods: {
    resetPassword: function resetPassword() {
      var _this = this;

      if (this.valid && this.$refs.form.validate()) {
        if (this.credentials.honeypot.length == 0) {
          this.loading = true;

          this.$http.forgotPasswordChallenge(this.credentials.email).then(function (res) {
            _this.checkEmail = true;
            _this.loading = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
            _this.loading = false;
          });
        }
      }
    },
    emailRules: function emailRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$t("email") + " " + _this2.$t("required");
      }, function (v) {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || _this2.$t("email") + " " + _this2.$t("invalid");
      }];
    },
    passwordRules: function passwordRules() {
      var _this3 = this;

      return [function (v) {
        return !!v || _this3.$t("password") + " " + _this3.$t("required");
      }];
    },
    encrypt: function encrypt() {
      this.credentials.password = __WEBPACK_IMPORTED_MODULE_1_sha256___default()(this.credentials.inputP);
    }
  }
});

/***/ }),
/* 182 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij48cGF0aCBkPSJNMCAwaDI0djI0SDB6IiBmaWxsPSJub25lIi8+PHBhdGggZD0iTTcgMTRINXY1aDV2LTJIN3YtM3ptLTItNGgyVjdoM1Y1SDV2NXptMTIgN2gtM3YyaDV2LTVoLTJ2M3pNMTQgNXYyaDN2M2gyVjVoLTV6Ii8+PC9zdmc+"

/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/building_logo_low_opacity.b0c4427.png";

/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/buildings_logo_low_opacity.e0a24b6.png";

/***/ }),
/* 185 */
/***/ (function(module, exports) {

module.exports = "data:image/jpeg;base64,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"

/***/ }),
/* 186 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Retry__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Projects_AddProject__ = __webpack_require__(437);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Datatable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadLogbook__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_InstallPWA__ = __webpack_require__(445);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuelidate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//










/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Projects",
  components: {
    addProject: __WEBPACK_IMPORTED_MODULE_2__components_pages_Projects_AddProject__["a" /* default */],
    retry: __WEBPACK_IMPORTED_MODULE_0__components_Retry__["a" /* default */],
    emptyList: __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__["a" /* default */],
    dataTable: __WEBPACK_IMPORTED_MODULE_3__components_Datatable__["a" /* default */],
    downloadLogbook: __WEBPACK_IMPORTED_MODULE_4__components_DownloadLogbook__["a" /* default */],
    installPWA: __WEBPACK_IMPORTED_MODULE_5__components_InstallPWA__["a" /* default */]
  },
  data: function data() {
    return {
      progress: true,
      projects: [],
      headers: null,
      loading: false,
      search: "",
      sortDesc: false,
      retry: false,
      showInstall: false
    };
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.checkBrowser();
      next();
    });
  },

  methods: {
    checkBrowser: function checkBrowser() {
      var isIos = /iphone|ipad|ipod/.test(window.navigator.userAgent.toLowerCase());
      // Detects if device is in standalone mode
      var isInStandaloneMode = window.navigator.standalone;

      // Checks if should display install popup notification:
      if (isIos && !isInStandaloneMode) {
        this.showInstall = true;
      }
    },
    showArchivedProjects: function showArchivedProjects() {
      this.$router.push({ name: "ArchivedProjects" });
    },
    archiveProject: function archiveProject(item) {
      var _this = this;

      item.status = "ARCHIVED";
      var project = item;
      delete project.buildingComponents;
      this.$http.updateProject(project).then(function (res) {
        _this.projects = _this.projects.filter(function (x) {
          return x.id != item.id;
        });
        _this.$forceUpdate();
        _this.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this.$noty.error(_this.$t("error"));
        console.log(err);
      });
    },
    downloadExcel: function downloadExcel(project) {
      var _this2 = this;

      this.loading = true;
      this.$http.downloadExcelExport(project.id).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", project.name + "_" + date.toLocaleDateString() + ".xlsx");
        document.body.appendChild(link);
        link.click();
        _this2.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.$noty.error(_this2.$t("error"));
        _this2.loading = false;
      });
    },
    downloadLogbook: function downloadLogbook(project, separated, withDocuments) {
      var _this3 = this;

      this.loading = true;
      this.$http.downloadLogbook(project.id, null, separated, withDocuments).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", project.name + "_" + date.toLocaleDateString() + ".zip");
        document.body.appendChild(link);
        link.click();
        _this3.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this3.$noty.error(_this3.$t("error"));
        _this3.loading = false;
      });
    },
    addProject: function addProject(newProject) {
      var _this4 = this;

      this.$http.addProject(newProject).then(function (res) {
        _this4.projects.push(res.data);
        _this4.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this4.$noty.error(err);
        console.log(err);
      });
    },
    deleteProject: function deleteProject(id) {
      this.projects = this.projects.filter(function (p) {
        return p.id != id;
      });
    },
    projectDetails: function projectDetails(item) {
      this.$router.push({ name: "ProjectDetails", params: { id: item.id } });
    },
    buildHeaders: function buildHeaders() {
      if (this.$can("delete", "projects")) {
        this.headers = [{
          text: this.$t("name"),
          align: "left",
          value: "name"
        }, { text: this.$t("building"), value: "buildingName" }, {
          text: this.$t("buildingComponents"),
          value: "buildingComponents.length"
        },
        // { text: this.$t("table.status"), value: "status" },
        { text: this.$t("createdTs"), value: "createdTs" }, { text: this.$t("actions"), sortable: false, value: "actions" }];
      } else {
        this.headers = [{
          text: this.$t("name"),
          align: "left",
          value: "name"
        }, { text: this.$t("building"), value: "buildingName" }, {
          text: this.$t("buildingComponents"),
          value: "buildingComponents.length"
        }, { text: this.$t("createdTs"), value: "createdTs" }];
      }
    },
    getData: function getData() {
      var _this5 = this;

      this.progress = true;
      this.$http.getProjects().then(function (res) {
        _this5.projects = res.data;
        _this5.progress = false;
        _this5.retry = false;
      }).catch(function (error) {
        _this5.progress = false;
        _this5.retry = true;
        console.log(error.response.status);
      });
    }
  },
  created: function created() {
    this.getData();
    this.buildHeaders();
    this.$store.state.previous = null;
    this.$store.state.breadcrumb = null;
  }
});

/***/ }),
/* 187 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  methods: {
    retry: function retry() {
      this.$emit("retry");
    }
  }
});

/***/ }),
/* 188 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["title", "description", "image", "fit"]
});

/***/ }),
/* 189 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "addProject",
  data: function data() {
    var _ref;

    return _ref = {
      valid: false,
      dialog: false,
      name: null,
      buildingName: null,
      image: null,
      hasImage: false,
      loading: false,
      street: null,
      no: null,
      postalcode: null,
      city: null,
      country: null,
      contactName: null,
      mobile: null,
      email: null
    }, __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "valid", true), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "emptyImage", __webpack_require__(18)), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "installers", []), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "allInstallers", null), __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_defineProperty___default()(_ref, "contactFunction", null), _ref;
  },
  mounted: function mounted() {
    // this.getAllInstallers();
  },

  methods: {
    close: function close() {
      this.dialog = false;
    },
    rules: function rules() {
      var _this = this;

      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$t('name');

      var rules = [function (v) {
        return !!v || property + " " + _this.$t("required");
      }, function (v) {
        return v && v.length <= 512 || "";
      }];
      return rules;
    },

    setImage: function setImage(output) {
      this.hasImage = true;
      this.image = output.dataUrl;
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        if (this.valid) {
          var newProject = {
            id: __WEBPACK_IMPORTED_MODULE_3_uuid___default.a.v4(),
            name: this.name,
            image: this.image ? this.image : null,
            buildingName: this.buildingName,
            status: "OPEN",
            createdBy: localStorage.getItem("user"),
            modifiedBy: localStorage.getItem("user"),
            street: this.street,
            no: this.no,
            postalcode: this.postalcode,
            city: this.city,
            country: this.country,
            contactName: this.contactName,
            mobile: this.mobile,
            email: this.email,
            contactFunction: this.contactFunction
          };
          this.$emit("add-project", newProject);
          this.close();
        }
      }
    },
    getAllInstallers: function getAllInstallers() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this2.$http.getInstallers();

              case 3:
                res = _context.sent;

                _this2.allInstallers = res.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[0, 7]]);
      }))();
    }
  }
});

/***/ }),
/* 190 */,
/* 191 */,
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    headers: Array,
    progress: Boolean,
    items: Array
    // search: String
  },
  data: function data() {
    return {
      page: 1,
      search: "",
      itemsPerPage: 10,
      pageCount: 0
    };
  },

  computed: {
    itemsPerPageRules: function itemsPerPageRules() {
      var _this = this;

      var rules = [function (value) {
        return !!value || _this.$t("itemsPerPage") + " " + _this.$t("required");
      }, function (value) {
        return parseInt(value, 10) || "Must be a number";
      }, function (value) {
        return value < 30 || "Maximum reached";
      }];
      return rules;
    }
  },
  watch: {
    itemsPerPage: function itemsPerPage(n, o) {
      this.$forceUpdate();
    },
    pageCount: function pageCount(n, o) {}
  },
  methods: {
    onClickItem: function onClickItem(item) {
      this.$emit("clickItem", item);
    },
    changeItemsPerPage: function changeItemsPerPage(numberInput) {
      if (numberInput !== parseInt(numberInput, 10) && numberInput < 1 && numberInput < 31) return;
      if (numberInput == parseInt(numberInput, 10)) {
        this.itemsPerPage = parseInt(numberInput, 10);
      }
      this.calculatePageCount();
      //  itemsPerPage = parseInt($event, 10)
    },
    changePageCount: function changePageCount(pagecount) {
      if (pagecount !== parseInt(pagecount, 10)) return;
      this.pageCount = pagecount;
    },
    nextPage: function nextPage() {
      if (this.page + 1 <= this.pageCount) this.page += 1;
    },
    formerPage: function formerPage() {
      if (this.page - 1 >= 1) this.page -= 1;
    },
    updateItemsPerPage: function updateItemsPerPage(number) {
      this.itemsPerPage = number;
      this.calculatePageCount();
    },
    calculatePageCount: function calculatePageCount() {
      this.pageCount = Math.ceil(this.items.length / this.itemsPerPage);
    }
  }
});

/***/ }),
/* 193 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      dialog: false,
      blueprintSeparated: false,
      withDocuments: false,
      loading: false
    };
  },

  watch: {
    dialog: function dialog() {}
  },
  methods: {
    downloadLogbook: function downloadLogbook() {
      this.$emit("download", this.blueprintSeparated, this.withDocuments);
      this.dialog = false;
    }
  }
});

/***/ }),
/* 194 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),
/* 195 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Retry__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_BuildingComponents_AddBuildingComponent__ = __webpack_require__(453);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Projects_EditProject__ = __webpack_require__(455);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Datatable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_DownloadLogbook__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ProjectsDetails",
  components: {
    addBuildingComponent: __WEBPACK_IMPORTED_MODULE_2__components_pages_BuildingComponents_AddBuildingComponent__["a" /* default */],
    editProject: __WEBPACK_IMPORTED_MODULE_3__components_pages_Projects_EditProject__["a" /* default */],
    retry: __WEBPACK_IMPORTED_MODULE_0__components_Retry__["a" /* default */],
    emptyList: __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__["a" /* default */],
    dataTable: __WEBPACK_IMPORTED_MODULE_4__components_Datatable__["a" /* default */],
    downloadLogbook: __WEBPACK_IMPORTED_MODULE_5__components_DownloadLogbook__["a" /* default */]
  },
  data: function data() {
    return {
      progress: true,
      project: null,
      buildingComponents: [],
      headers: null,
      loading: false,
      search: "",
      sortDesc: false,
      sortBy: "name",
      retry: false
    };
  },

  methods: {
    downloadExcel: function downloadExcel(buildingcomponent) {
      var _this = this;

      this.loading = true;
      this.$http.downloadExcelExport(null, buildingcomponent.id, null).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", buildingcomponent.name + "_" + date.toLocaleDateString() + ".xlsx");
        document.body.appendChild(link);
        link.click();
        _this.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this.$noty.error(_this.$t("error"));
        _this.loading = false;
      });
    },
    downloadLogbook: function downloadLogbook(buildingcomponent, separated, withDocuments) {
      var _this2 = this;

      console.log(separated, withDocuments);
      this.loading = true;
      this.$http.downloadLogbook(null, buildingcomponent.id, separated, withDocuments).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", buildingcomponent.name + "_" + date.toLocaleDateString() + ".zip");
        document.body.appendChild(link);
        link.click();
        _this2.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.$noty.error(_this2.$t("error"));
        _this2.loading = false;
      });
    },
    editProject: function editProject(project) {
      var _this3 = this;

      this.$http.updateProject(project).then(function (res) {
        _this3.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this3.$noty.error(err);
        console.log(err);
      });
    },
    add: function add(newBuildingComponent) {
      var _this4 = this;

      this.$http.addBuildingComponent(newBuildingComponent).then(function (res) {
        _this4.buildingComponents.push(res.data);
        _this4.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this4.$noty.error(err);
        console.log(err);
      });
    },
    remove: function remove(id) {
      this.buildingComponents = this.buildingComponents.filter(function (p) {
        return p.id != id;
      });
    },
    details: function details(item) {
      this.$router.push({
        name: "BuildingComponentDetails",
        params: { id: item.id }
      });
    },
    buildHeaders: function buildHeaders() {
      if (this.$can("delete", "buildingComponents")) {
        this.headers = [{
          text: this.$t("name"),
          align: "left",
          value: "name"
        }, {
          text: this.$t("description"),
          align: "left",
          value: "description"
        }, { text: this.$t("blueprints"), value: "blueprintsCount" }, {
          text: this.$t("createdTs"),
          align: "left",
          value: "createdTs"
        }, { text: this.$t("actions"), sortable: false, value: "actions" }];
      } else {
        this.headers = [{
          text: this.$t("name"),
          align: "left",
          value: "name"
        }, {
          text: this.$t("description"),
          align: "left",
          value: "description"
        }, { text: this.$t("blueprints"), value: "blueprintsCount" }, {
          text: this.$t("createdTs"),
          align: "left",
          value: "createdTs"
        }];
      }
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("projects"),
        to: { name: "Projects" }
      }, {
        name: this.project.name
      }];
    },
    getData: function getData() {
      var _this5 = this;

      this.progress = true;
      this.$http.getProject(this.$route.params.id).then(function (res) {
        _this5.project = res.data;
        _this5.makeBreadcrumb();
      }).catch(function (err) {
        return console.log(err);
      });

      this.$http.getBuildingComponents(this.$route.params.id).then(function (res) {
        _this5.buildingComponents = res.data;
        _this5.progress = false;
        _this5.retry = false;
      }).catch(function (err) {
        console.log(err);
        _this5.progress = false;
        _this5.retry = true;
      });
    }
  },
  watch: {
    project: function project(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedProjectDetails",
            params: { id: n.id }
          });
        }
      }
    }
  },
  created: function created() {
    this.$store.state.previous = {
      name: "Projects",
      id: null,
      breadcrumb: this.$t("projects")
    };
    this.getData();
    this.buildHeaders();
  }
});

/***/ }),
/* 196 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "addBuildingComponent",
  data: function data() {
    return {
      valid: false,
      dialog: false,
      name: "",
      description: ""
    };
  },
  methods: {
    close: function close() {
      this.dialog = false;
    },
    rules: function rules() {
      var _this = this;

      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$t('name');

      var rules = [function (v) {
        return !!v || property + " " + _this.$t("required");
      }, function (v) {
        return v && v.length <= 512 || "";
      }];
      return rules;
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        var newBuildingComponent = {
          id: __WEBPACK_IMPORTED_MODULE_0_uuid___default.a.v4(),
          name: this.name,
          description: this.description,
          createdBy: localStorage.getItem("user"),
          modifiedBy: localStorage.getItem("user"),
          projectId: this.$route.params.id
        };
        this.$emit("add-buildingComponent", newBuildingComponent);
        this.close();
      }
    }
  }
});

/***/ }),
/* 197 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    project: Object
  },
  data: function data() {
    return {
      valid: false,
      dialog: false,
      hasImage: false,
      emptyImage: __webpack_require__(18)
    };
  },
  created: function created() {},

  methods: {
    close: function close() {
      this.dialog = false;
    },
    nameRules: function nameRules() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$t("name") + " " + _this.$t("required");
      }];
    },
    buildingRules: function buildingRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$t("building") + " " + _this2.$t("required");
      }];
    },

    setImage: function setImage(output) {
      this.hasImage = true;
      this.project.image = output.dataUrl;
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        if (this.valid) {
          this.project.modifiedBy = localStorage.getItem("user");
          this.$emit("edit", this.project);
          this.close();
        }
      }
    }
  }
});

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Retry__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Blueprints_Blueprints__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Blueprints_AddBlueprint__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_BuildingComponents_EditBuildingComponent__ = __webpack_require__(462);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_Datatable__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//









/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BuildingComponentsDetails",
  components: {
    editBuildingComponent: __WEBPACK_IMPORTED_MODULE_5__components_pages_BuildingComponents_EditBuildingComponent__["a" /* default */],
    blueprints: __WEBPACK_IMPORTED_MODULE_2__components_pages_Blueprints_Blueprints__["a" /* default */],
    addBlueprint: __WEBPACK_IMPORTED_MODULE_3__components_pages_Blueprints_AddBlueprint__["a" /* default */],
    retry: __WEBPACK_IMPORTED_MODULE_0__components_Retry__["a" /* default */],
    emptyList: __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__["a" /* default */],
    dataTable: __WEBPACK_IMPORTED_MODULE_6__components_Datatable__["a" /* default */]
  },
  data: function data() {
    return {
      progress: true,
      buildingComponent: null,
      blueprints: [],
      headers: [],
      loading: false,
      response: false,
      dialog: false,
      readonlyblueprint: null,
      search: "",
      sortBy: "name",
      sortDesc: false,
      retry: false
    };
  },

  computed: {},
  watch: {
    headers: function headers() {
      this.$forceUpdate();
    },
    blueprints: function blueprints(n, o) {
      if (n.length > 0) {
        if (this.blueprints.some(function (x) {
          return x.isLocked;
        })) {
          this.headers = [{
            text: this.$t("name"),
            align: "left",
            value: "name"
          }, {
            text: this.$t("description"),
            align: "left",
            value: "description"
          }, {
            text: this.$t("markers"),
            value: "markers.length"
          }, {
            text: this.$t("isEditing"),
            value: "lockedByUserName"
          }, {
            text: this.$t("editStart"),
            value: "lockedTs"
          }, { text: this.$t("actions"), sortable: false, value: "actions" }];
        } else {
          this.headers = [{
            text: this.$t("name"),
            align: "left",
            value: "name"
          }, {
            text: this.$t("description"),
            align: "left",
            value: "description"
          }, {
            text: this.$t("markers"),
            value: "markers.length"
          }, { text: this.$t("actions"), sortable: false, value: "actions"
            //{ text: this.$t("table.markUp"), sortable: false }
          }];
        }
      }
    },
    buildingComponent: function buildingComponent(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedBuildingComponentDetails",
            params: { id: n.id }
          });
        }
      }
    }
  },
  methods: {
    breakLock: function breakLock(blueprint) {
      var _this = this;

      this.$http.lockBlueprint(blueprint.id, true).then(function (res) {
        var i = _this.blueprints.findIndex(function (p) {
          return p.id === blueprint.id;
        });
        var markers = _this.blueprints[i].markers;
        res.data.markers = markers;
        _this.blueprints[i] = res.data;
        _this.blueprints = _this.blueprints.slice(); //Bart, 13/2/20: clone to trigger vue
      }).catch(function (err) {
        console.log(err);
        _this.$noty.error(_this.$t("error"));
      });
    },
    downloadExcel: function downloadExcel(blueprint) {
      var _this2 = this;

      this.loading = true;
      this.$http.downloadExcelExport(null, null, blueprint.id).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", blueprint.name + "_" + date.toLocaleDateString() + ".xlsx");
        document.body.appendChild(link);
        link.click();
        _this2.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.$noty.error(_this2.$t("error"));
        _this2.loading = false;
      });
    },
    addBlueprint: function addBlueprint(newBlueprint) {
      var _this3 = this;

      this.$http.addBlueprint(newBlueprint).then(function (res) {
        _this3.blueprints.push(res.data);
        _this3.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this3.$noty.error(err);
        console.log(err);
      });
    },
    editBlueprint: function editBlueprint(item) {
      var _this4 = this;

      if (this.$can("update", "markers")) {
        if (__WEBPACK_IMPORTED_MODULE_4_jwt_decode___default()(localStorage.getItem("auth")).contactId != item.lockedByUserId) {
          this.$http.lockBlueprint(item.id).then(function (res) {
            if (item.lockedByUserName !== null) {
              _this4.dialog = true;
              _this4.readonlyblueprint = item;
            } else {
              _this4.editBlueprintDetails(item);
            }
          }).catch(function (err) {
            _this4.$noty.error(_this4.$t("error"));
            console.log(err);
          });
        } else {
          this.editBlueprintDetails(item);
        }
      } else {
        this.blueprintDetails(item);
      }
    },
    editBuildingComponent: function editBuildingComponent(buildingComponent) {
      var _this5 = this;

      this.$http.updateBuildingComponent(buildingComponent).then(function (res) {
        _this5.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this5.$noty.error(_this5.$t("error"));
        console.log(err);
      });
    },
    responseReadonly: function responseReadonly(yes) {
      if (yes) {
        this.dialog = false;
        if (this.readonlyblueprint) this.blueprintDetails(this.readonlyblueprint, true);
      }
      this.readonlyblueprint = null;
      this.dialog = false;
    },
    deleteBlueprint: function deleteBlueprint(id) {
      this.blueprints = this.blueprints.filter(function (p) {
        return p.id != id;
      });
    },
    editBlueprintDetails: function editBlueprintDetails(item, editable) {
      this.$router.push({
        name: "EditBlueprintsDetails",
        params: { id: item.id }
      });
    },
    blueprintDetails: function blueprintDetails(item) {
      this.$router.push({
        name: "BlueprintsDetails",
        params: {
          id: item.id
        }
      });
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("projects"),
        to: { name: "Projects" }
      }, {
        name: this.buildingComponent.project,
        to: {
          name: "ProjectDetails",
          params: { id: this.buildingComponent.projectId }
        }
      }, {
        name: this.buildingComponent.name
      }];
    },
    getData: function getData() {
      var _this6 = this;

      this.progress = true;
      this.$http.getBuildingComponent(this.$route.params.id).then(function (res) {
        _this6.buildingComponent = res.data;
        _this6.$store.state.previous = {
          name: "ProjectDetails",
          id: res.data.projectId,
          breadcrumb: _this6.$t("project")
        };
        _this6.makeBreadcrumb();
      }).catch(function (err) {
        return console.log(err);
      });

      this.$http.getBlueprints(this.$route.params.id).then(function (res) {
        _this6.blueprints = res.data;
        _this6.progress = false;
        _this6.retry = false;
      }).catch(function (err) {
        console.log(err);
        _this6.progress = false;
        _this6.retry = true;
      });
    }
  },
  created: function created() {
    this.getData();
  }
});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blueprints_vue__ = __webpack_require__(200);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075fbe36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blueprints_vue__ = __webpack_require__(461);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Blueprints_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_075fbe36_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Blueprints_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 200 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_Blueprints_AddBlueprint__ = __webpack_require__(201);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuelidate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Blueprints",
  components: {
    AddBlueprint: __WEBPACK_IMPORTED_MODULE_0__components_pages_Blueprints_AddBlueprint__["a" /* default */]
  },
  data: function data() {
    return {
      blueprints: [],
      headers: [{
        text: this.$t("name"),
        align: 'left',
        value: 'name'
      }, {
        text: this.$t("description"),
        align: 'left',
        value: 'description'
      }, {
        text: this.$t("markerName"),
        align: 'left',
        value: 'markerName'
      }, {
        text: this.$t("order"),
        align: 'left',
        value: 'order'
      }, { text: this.$t("actions"), sortable: false }]
    };
  },

  methods: {
    toggleMenu: function toggleMenu() {
      this.menuVisible = !this.menuVisible;
    },
    addBlueprint: function addBlueprint(newBlueprint) {
      var _this = this;

      this.$http.addBlueprint(newBlueprint).then(function (res) {
        _this.blueprints.push(res.data);
        _this.$noty.success(_this.$t("success"));
      }).catch(function (err) {
        _this.$noty.error(_this.$t("error"));
        console.log(err);
      });
    },
    deleteBlueprint: function deleteBlueprint(id) {
      this.$http.deleteBlueprint(id);
      this.projects = this.blueprints.filter(function (p) {
        return p.id != id;
      });
    },
    blueprintDetails: function blueprintDetails(id) {
      this.$router.push({ name: 'BlueprintsDetails', params: { id: id } });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.getBlueprints(this.$route.params.id).then(function (res) {
      return _this2.blueprints = res.data;
    }).catch(function (err) {
      return console.log(err);
    });
  }
});

/***/ }),
/* 201 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBlueprint_vue__ = __webpack_require__(202);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ff2780_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBlueprint_vue__ = __webpack_require__(460);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBlueprint_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_00ff2780_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBlueprint_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 202 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AddBlueprint",
  data: function data() {
    return {
      menu: false,
      valid: false,
      dialog: false,
      name: "",
      description: "",
      markerName: "",
      installers: [],
      deadline: null,
      allInstallers: []
    };
  },
  methods: {
    close: function close() {
      this.dialog = false;
    },
    getAllInstallers: function getAllInstallers() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$http.getInstallers();

              case 3:
                res = _context.sent;

                _this.allInstallers = res.data;
                _context.next = 10;
                break;

              case 7:
                _context.prev = 7;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 7]]);
      }))();
    },
    rules: function rules() {
      var _this2 = this;

      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$t("name");

      var rules = [function (v) {
        return !!v || property + " " + _this2.$t("required");
      }, function (v) {
        return v && v.length <= 512 || "";
      }];
      return rules;
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        var newBlueprint = {
          id: __WEBPACK_IMPORTED_MODULE_2_uuid___default.a.v4(),
          name: this.name,
          description: this.description,
          installers: this.installers,
          deadline: this.deadline,
          createdBy: localStorage.getItem("user"),
          modifiedBy: localStorage.getItem("user"),
          buildingComponentId: this.$route.params.id
        };
        this.$emit("add-blueprint", newBlueprint);
        this.close();
      }
    }
  },
  mounted: function mounted() {
    this.getAllInstallers();
  }
});

/***/ }),
/* 203 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    buildingComponent: Object
  },
  name: "test",
  data: function data() {
    return {
      valid: false,
      dialog: false,
      hasImage: false
    };
  },
  created: function created() {},

  methods: {
    close: function close() {
      this.dialog = false;
    },
    nameRules: function nameRules() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$t("name") + " " + _this.$t("required");
      }];
    },
    descriptionRules: function descriptionRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$t("description") + " " + _this2.$t("required");
      }];
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        if (this.valid) {
          this.buildingComponent.modifiedBy = localStorage.getItem("user");
          this.$emit("edit", this.buildingComponent);
          this.close();
        }
      }
    }
  }
});

/***/ }),
/* 204 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Blueprints_IsLocked__ = __webpack_require__(114);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Blueprints_UploadBlueprint__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_List__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Markers_ZoomMarkup__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_async__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Markers_ScanQRCode__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_service_ihub_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_q__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_q__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_10__services_service_ihub_js__["a" /* serviceihub */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "blueprintsDetails",
  components: {
    uploadBlueprint: __WEBPACK_IMPORTED_MODULE_4__components_pages_Blueprints_UploadBlueprint__["a" /* default */],
    markers: __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_List__["a" /* default */],
    zoomMarkup: __WEBPACK_IMPORTED_MODULE_6__components_pages_Markers_ZoomMarkup__["a" /* default */],
    scanQRCode: __WEBPACK_IMPORTED_MODULE_9__components_pages_Markers_ScanQRCode__["a" /* default */],
    isLocked: __WEBPACK_IMPORTED_MODULE_3__components_pages_Blueprints_IsLocked__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      blueprint: null,
      loadingText: "",
      hideMarkup: false,
      dialog: false,
      uploadForm: false,
      attributeTypes: null,
      leadThroughTypes: null,
      insulationTypes: null,
      menu: false,
      valid: false,
      nameRules: [function (v) {
        return !!v || _this.$t("name") + " " + _this.$t("required");
      }],
      markers: [],
      image: null,
      connection: navigator.onLine,
      saveDialog: false,
      to: null,
      fullscreen: false,
      showLockedMessage: false
    };
  },

  computed: {
    markersui: function markersui() {
      return this.$store.getters.markersui;
    },
    isOffline: function isOffline() {
      return this.$store.state.isOffline;
    }
  },
  methods: {
    toggleFullscreen: function toggleFullscreen(f) {
      this.fullscreen = !f;
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("projects"),
        to: { name: "Projects" }
      }, {
        name: this.blueprint.project,
        to: {
          name: "ProjectDetails",
          params: { id: this.blueprint.projectId }
        }
      }, {
        name: this.blueprint.buildingComponent,
        to: {
          name: "BuildingComponentDetails",
          params: { id: this.blueprint.buildingComponentId }
        }
      }, {
        name: this.blueprint.name
      }];
    },
    lockBlueprint: function lockBlueprint() {
      var _this2 = this;

      this.$store.state.readyForOffline = false;
      if (this.$can("update", "markers")) {
        this.$http.lockBlueprint(this.blueprint.id).then(function (res) {
          if (res.data.isLocked) {
            if (res.data.lockedByUserId == __WEBPACK_IMPORTED_MODULE_7_jwt_decode___default()(localStorage.getItem("auth")).contactId) {
              _this2.$store.state.markers = [];
              _this2.$router.push({
                name: "EditBlueprintsDetails",
                params: { id: res.data.id }
              });
            } else {
              _this2.showLockedMessage = true;
            }
          } else {
            //   if (res.data.isLocked) {
            //     this.readonly = false;
            //   }
            //   this.blueprint.isLocked = res.data.isLocked;
            //   this.blueprint.lockedByUserId = res.data.lockedByUserId;
            //   this.blueprint.lockedByUserName = res.data.lockedByUserName;
            _this2.lockBlueprint();
          }

          // if (this.blueprint.isLocked == res.data.isLocked) {
          //   this.readonly = true;
          // } else {
          //   this.blueprint.isLocked = true;
          //   this.readonly = false;
          // }
        }).catch(function (err) {
          console.log(err);
          _this2.$noty.error(_this2.$t("error"));
        });
      } else {}
    },
    response: function response(answer) {
      if (answer) {
        this.$refs.markup.$refs.markupFullscreen.update();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params
      });
    },
    showMarkerDetails: function showMarkerDetails(marker) {
      this.$store.state.markers = [];
      if (this.$store.state.isOffline) {
        this.dialog = true;
        this.loadingText = this.$t("loadPageFailed");
      } else {
        this.$router.push({
          name: "MarkerDetails",
          params: {
            id: marker.id
          }
        });
      }
    },
    setOffline: function setOffline() {
      if (navigator.onLine) {
        this.$store.state.isOffline = !this.$store.state.isOffline;
      }
    }
  },
  mounted: function mounted() {
    var _this3 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var resBlueprint;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this3.$http.getBlueprint(_this3.$route.params.id);

            case 2:
              resBlueprint = _context.sent;

              _this3.blueprint = resBlueprint.data;
              _this3.makeBreadcrumb();

              //backbutton
              _this3.$store.state.previous = {
                name: "BuildingComponentDetails",
                id: _this3.blueprint.buildingComponentId,
                breadcrumb: _this3.$t("buildingComponent")
              };

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this3);
    }))();
  },
  created: function created() {},

  watch: {
    isOffline: function isOffline(n, o) {
      if (!n) this.dialog = false;
    },
    readonly: function readonly(n, o) {},
    blueprint: function blueprint(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedBlueprintsDetails",
            params: { id: n.id }
          });
        }
      }
    }
  }
});

/***/ }),
/* 205 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["blueprint", "showLockedMessage"],
  methods: {
    close: function close() {
      this.$emit("close");
    },
    takeover: function takeover() {
      var _this = this;

      this.$http.takeOverBlueprintEdit(this.blueprint.id).then(function (res) {
        _this.$router.push({
          name: "EditBlueprintsDetails",
          params: { id: _this.blueprint.id }
        });
      }).catch(function (err) {
        _this.$noty.info(err);
      });
    }
  }
});

/***/ }),
/* 206 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_upload_button__ = __webpack_require__(471);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuetify_upload_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuetify_upload_button__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "uploadBlueprint",
  props: {
    blueprintPage: Boolean,
    readonly: Boolean,
    blueprintId: String
  },
  data: function data() {
    return {
      // selectedFile: null,
      hasImage: false,
      image: null,
      loading: false,
      showPageSelector: false,
      page: 1,
      uploadReady: true
    };
  },

  components: {
    uploadButton: __WEBPACK_IMPORTED_MODULE_0_vuetify_upload_button___default.a
  },
  methods: {
    setImage: function setImage(output, e) {
      console.log(output, e);
      if (output.type === "application/pdf") {
        this.uploadPdf(output);
      } else {
        this.hasImage = true;
        this.image = output;
        this.onUpload();
      }
    },
    close: function close() {
      var _this = this;

      this.showPageSelector = false;
      this.uploadReady = false;
      this.$nextTick(function () {
        _this.uploadReady = true;
      });
    },
    noBlueprint: function noBlueprint() {
      var _this2 = this;

      this.loading = true;

      var formData = new FormData();
      formData.append("blueprintId", this.blueprintId);
      this.$http.addBlueprintFile(formData).then(function (res) {
        _this2.loading = false;
        _this2.$router.go();
      }).catch(function (err) {
        console.log(err);
        _this2.loading = false;
        _this2.$noty.error(err);
      });
    },
    uploadFile: function uploadFile() {
      var _this3 = this;

      this.loading = true;
      var formData = new FormData();
      formData.append("file", this.file);
      formData.append("blueprintId", this.blueprintId);
      formData.append("page", this.page);
      this.$http.addBlueprintFile(formData).then(function (res) {
        _this3.$router.go();
      }).catch(function (err) {
        _this3.uploadReady = false;
        _this3.$nextTick(function () {
          _this3.uploadReady = true;
        });
        console.log(err);
        _this3.loading = false;
        _this3.$noty.error(err);
      });
    },
    onFileChanged: function onFileChanged(event) {
      if (!event.target.files.length) return;
      this.file = event.target.files[0];
      if (this.file.type === "application/pdf") {
        this.showPageSelector = true;
      } else {
        this.uploadFile();
      }
    },
    onUpload: function onUpload() {
      var _this4 = this;

      if (this.hasImage) {
        var formData = new FormData();
        formData.append("file", this.image);
        formData.append("blueprintId", this.blueprintId);
        this.$http.addBlueprintFile(formData).then(function (res) {
          _this4.loading = false;
          _this4.$router.go();
        }).catch(function (err) {
          console.log(err);
          _this4.loading = false;
          _this4.$noty.error(err);
        });
      }

      // this.$http.addBlueprintFile(this.$route.params.id, formData).then(res => {
      //   //
      // });
    }
  }
});

/***/ }),
/* 207 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(208);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f952e4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(476);
function injectStyle (ssrContext) {
  __webpack_require__(473)
  __webpack_require__(474)
  __webpack_require__(475)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4f952e4c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4f952e4c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 208 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "markers",
  props: {
    blueprintFile: Object
  },
  components: {},
  data: function data() {
    return {
      showDelete: false,
      selected: undefined,
      loading: false,
      markerStatus: [4],
      search: ''
    };
  },

  methods: {
    filterMarkers: function filterMarkers(marker) {
      return marker.status == 1 &&
      // !this.requiredFields(marker) &&
      this.markerStatus.includes(1) || marker.status == 0 &&
      // !this.requiredFields(marker) &&
      this.markerStatus.includes(0) || marker.status == 3 &&
      // this.requiredFields(marker) &&
      this.markerStatus.includes(3) || marker.status == 2 && this.markerStatus.includes(2) || this.markerStatus.includes(4) ? "inherit" : "none";
    },
    markerDetails: function markerDetails(marker) {
      this.$emit("showMarkerDetails", marker);
    },
    select: function select(item, i) {
      item.draggable = true;
      this.$store.commit("selectReadonly", item);
      this.$store.commit("select", item);
    },
    getMarkersLight: function getMarkersLight() {
      var _this = this;

      this.$http.getMarkers(this.$route.params.id, true).then(function (res) {
        _this.loading = false;
        console.log("Loading store...");
        //adding the markerui fields here..
        res.data.forEach(function (element) {
          _this.$store.commit("AddAndSetUIelementsReadonly", element);
        });
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },
  computed: {
    markers: function markers() {
      return this.$store.getters.markersReadonly;
    },
    filteredItems: function filteredItems() {
      var _this2 = this;

      return this.$store.getters.markersReadonly.filter(function (item) {
        return item.label ? item.label.toLowerCase().includes(_this2.search.toLowerCase()) : '' || item.number.toString().toLowerCase().includes(_this2.search.toLowerCase());
      });
    }
  },
  watch: {
    markers: function markers(after, before) {},
    markerStatus: function markerStatus(n, o) {
      if (n.length > 1) {
        if (n[n.length - 1] === 4) {
          this.markerStatus = [4];
        } else {
          if (n.includes(4)) {
            this.markerStatus = this.markerStatus.filter(function (x) {
              return x != 4;
            });
          }
        }
      }
    }
  },
  created: function created() {
    // this.loading = true;
    // if (!this.$store.state.isOffline) {
    //   if (
    //     this.$store.state.markersReadonly.find(
    //       x => x.blueprintId == this.$route.params.id
    //     )
    //   ) {
    //     //if coming from marker details,
    //     if (this.$store.state.markersReadonly.length <= 1) {
    //       this.$store.state.markersReadonly = [];
    //       if (!this.$store.state.isOffline) {
    //         this.getMarkersLight();
    //       }
    //     } else {
    //       this.loading = false;
    //     }
    //   } else {
    //     //if blueprint has changed, empty list
    //     this.$store.state.markersReadonly = [];
    //     this.getMarkersLight();
    //   }
    // } else {
    //   this.loading = false;
    // }

    this.loading = true;
    this.$store.state.markersReadonly = [];
    this.getMarkersLight();
  }
});

/***/ }),
/* 209 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pose__ = __webpack_require__(210);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_Markers_MarkUpFullScreen__ = __webpack_require__(482);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var transition = {
  duration: 400,
  ease: [0.08, 0.69, 0.2, 0.99]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "zoomPicture",
  props: {
    blueprint: Object,
    detailPage: Boolean,
    readonly: Boolean
  },
  data: function data() {
    return { isZoomed: false,
      poseComplete: false };
  },
  computed: {
    pose: function pose() {
      return this.isZoomed ? "zoomedIn" : "zoomedOut";
    },
    toggleZoom: function toggleZoom() {
      this.$emit('fullscreen', this.isZoomed);
      return this.isZoomed ? this.zoomOut : this.zoomIn;
    }
  },
  methods: {
    complete: function complete() {
      this.poseComplete = true;
    },
    showMarkerDetails: function showMarkerDetails(marker) {
      if (this.readonly) {
        this.$router.push({
          name: "MarkerDetails",
          params: {
            id: marker.id,
            marker: marker,
            blueprint: this.blueprint
          }
        });
      } else {
        this.$router.push({
          name: "EditMarkerDetails",
          params: {
            id: marker.id,
            marker: marker,
            blueprint: this.blueprint
          }
        });
      }
    },
    zoomIn: function zoomIn() {
      //window.addEventListener("scroll", this.zoomOut);
      this.$forceUpdate();
      this.isZoomed = true;
    },
    zoomOut: function zoomOut() {
      //window.removeEventListener("scroll", this.zoomOut);
      this.isZoomed = false;
    }
  },
  components: {
    markupFullscreen: __WEBPACK_IMPORTED_MODULE_1__components_pages_Markers_MarkUpFullScreen__["a" /* default */],
    Frame: __WEBPACK_IMPORTED_MODULE_0_vue_pose__["a" /* default */].div({
      zoomedOut: {
        applyAtEnd: { display: "none" },
        opacity: 0
      },
      zoomedIn: {
        applyAtStart: { display: "block" },
        opacity: 1
      }
    }),
    ZoomImage: __WEBPACK_IMPORTED_MODULE_0_vue_pose__["a" /* default */].div({
      zoomedOut: {
        position: "static",
        width: "auto",
        height: "auto",
        transition: transition,
        flip: true
      },
      zoomedIn: {
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: transition,
        flip: true,
        width: "auto",
        height: "auto"
      }
    })
  }
});

/***/ }),
/* 210 */,
/* 211 */,
/* 212 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuex__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Blueprints_UploadBlueprint__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_DownloadLogbook__ = __webpack_require__(65);




var _methods;

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







var lastDist = 0;
var point = void 0;
var startPos;
var body = document.body,
    html = document.documentElement;

var height = Math.max(html.clientHeight);

var width = Math.max(html.clientWidth);

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    uploadBlueprint: __WEBPACK_IMPORTED_MODULE_6__components_pages_Blueprints_UploadBlueprint__["a" /* default */],
    downloadLogbook: __WEBPACK_IMPORTED_MODULE_7__components_DownloadLogbook__["a" /* default */]
  },
  props: {
    detailPage: Boolean,
    readonly: Boolean,
    blueprint: Object
  },
  data: function data() {
    return {
      markerDetailView: false,
      moveImage: false,
      moveMarker: false,

      clickedInImage: false,
      dialog: false,
      layerSize: {
        draggable: true,
        x: null,
        duration: 0.5
      },
      groupConfig: {
        visible: true
      },
      image: null,
      icon: null,
      i: __webpack_require__(182),
      isZoomed: false,
      hover: false,
      overview: false,
      scale: null,
      fullscreen: false,
      stageSize: {
        width: 0,
        height: 0
      },
      loading: false,
      loadingText: null,
      addedEventlistener: false,
      activeMarker: null
    };
  },

  methods: (_methods = {
    resizeStage: function resizeStage() {
      height = Math.max(html.clientHeight);
      width = Math.max(html.clientWidth);
      this.stageSize.width = width;
      this.stageSize.height = height;
    },
    disableSwipeTogoBack: function disableSwipeTogoBack() {
      if (this.addedEventlistener == false) {
        var element = document.getElementsByClassName("blueprint")[0];
        if (element) {
          this.addedEventlistener = true;
          element.addEventListener("touchstart", function (e) {
            // is not near edge of view, exit
            if (e.pageX > 10 && e.pageX < window.innerWidth - 10) return;

            // prevent swipe to navigate back gesture
            e.preventDefault();
          });
        }
      }
    },
    deleteBlueprintFile: function deleteBlueprintFile() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _this.$http.deleteBlueprintFile(_this.blueprint.id);

              case 3:
                _this.$router.go();
                _context.next = 10;
                break;

              case 6:
                _context.prev = 6;
                _context.t0 = _context["catch"](0);

                console.log(_context.t0);
                _this.$noty.error(_context.t0);

              case 10:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 6]]);
      }))();
    },
    dragBound: function dragBound(pos) {
      //prevent markers to be outside blueprint image
      var X = pos.x;
      var Y = pos.y;
      var minX = this.layer2.getX() + 10;
      var maxX = this.layer2.getX() + this.layer2.attrs.scaleX * (this.image.width - 30);
      var minY = this.layer2.getY() + 10;
      var maxY = this.layer2.getY() + this.layer2.attrs.scaleY * (this.image.height - 30);
      if (X < minX) {
        X = minX;
      }
      if (X > maxX) {
        X = maxX;
      }
      if (Y < minY) {
        Y = minY;
      }
      if (Y > maxY) {
        Y = maxY;
      }
      return {
        x: X,
        y: Y
      };
    },
    color: function color(marker) {
      //change color based on status
      if (marker.draggable) {
        return this.$store.state.colors.highlight;
      } else if (marker.status == 0) {
        return this.$store.state.colors.error;
      } else if (marker.status == 1) {
        return this.$store.state.colors.orange;
      } else if (marker.status == 2) {
        return this.$store.state.colors.green;
      } else return this.$store.state.colors.primary;
    },
    postMarker: function postMarker(o) {
      var _this2 = this;

      console.log("Posting Marker for Blueprint " + this.blueprint.id);

      if (!this.readonly) {
        this.$store.state.hasChanges = true;
      }

      if (this.$store.state.isOffline) {
        this.$noty.warning(this.$t("cached"));
        o.number = this.$store.getters.markers.length == 0 ? 1 : Math.max.apply(Math, this.$store.getters.markers.map(function (x) {
          return x.number;
        })) + 1;
        o.new = true;

        // this.$store.commit("offAddAndSetUIelements", o);
        this.$store.commit("AddAndSetUIelements", o);

        var offForm = {
          marker: o
        };
        this.$store.commit("addOrUpdateOffForm", offForm);
        // this.addMarkerToDb(o);
      } else {
        this.$http.addMarker(o).then(function (res) {
          _this2.$store.commit("AddAndSetUIelements", res.data);
          _this2.$store.commit("AddAndSetUIelementsReadonly", res.data);
          _this2.$noty.success('<i class="fas fa-check"></i>');
          //this.$store.state.drawable = true;
        }).catch(function (err) {
          _this2.$noty.error(_this2.$t("error"));
          console.log(err);
        });
      }
    },
    fitBlueprint: function fitBlueprint() {
      //fits blueprint inside stagesize
      //not necessary
      var stage = this.$refs.stageFullscreen2.getStage();
      var container = stage.container();
      //scalefactor = desiredSize / size, for both width and height
      //desiredSize
      var containerWidth = container.offsetWidth;
      this.scale = containerWidth / this.stageSize.width;

      stage.width(this.stageSize.width * this.scale);
      stage.height(this.stageSize.height * this.scale);

      //scaling
      stage.scale({ x: this.scale, y: this.scale });
      stage.draw();
    },
    hideMarkers: function hideMarkers() {
      //this.groupConfig.visible = false;
    },
    handleTouchMove: function handleTouchMove(event) {
      if (this.$store.state.drawable) {
        //hide all other markers
        this.hideMarkers();

        this.layerSize.draggable = false;
        if (startPos === undefined) {
          startPos = this.$refs.stageFullscreen2.getStage().getPointerPosition();

          // let layer = this.$refs.stageFullscreen2.getStage().children[0];
          var stage = this.$refs.stageFullscreen2.getStage();
          //If images has been moved..
          if (this.layer2.position().x != startPos.x && this.layer2.position().y != startPos.y) {
            console.log("start");
            if (this.layer2.scaleX() === 1) {
              //in order to draw the markers in the correct position if the image has been moved
              startPos.x -= this.layer2.position().x;
              startPos.y -= this.layer2.position().y;
              startPos.x = startPos.x / this.scale;
              startPos.y = startPos.y / this.scale;
            } else {
              //todo when image is zoomed, put markers on correct spot
              //this.layer2.scaleX();
              startPos.x -= this.layer2.position().x;
              startPos.y -= this.layer2.position().y;
              startPos.x = startPos.x / this.layer2.scaleX() / this.scale;
              startPos.y = startPos.y / this.layer2.scaleX() / this.scale;
            }
          }

          console.log("Touch start: " + startPos.x + ", " + startPos.y);
        }
      } else {
        this.layerSize.draggable = true;
        this.isZoomed = true;
      }
    },
    handleTouchEnd: function handleTouchEnd(event) {
      this.unSelect();
      if (this.$store.state.drawable) {
        this.$store.state.drawable = false;
        this.layerSize.draggable = false;
        var pos = this.$refs.stageFullscreen2.getStage().getPointerPosition();
        var layer = this.$refs.stageFullscreen2.getStage().children[0];
        var stage = this.$refs.stageFullscreen2.getStage();

        //If images has been moved..
        if (this.layer2.position().x != pos.x && this.layer2.position().y != pos.y) {
          if (this.layer2.scaleX() === 1) {
            //after many trial and error, here multiply x and y with the scale for some reason
            //in order to draw the markers in the correct position if the image has been moved
            pos.x -= this.layer2.position().x;
            pos.y -= this.layer2.position().y;
            pos.x = pos.x / this.scale;
            pos.y = pos.y / this.scale;
          } else {
            //this.layer2.scale({x: this.scale, y: this.scale});
            //todo when image is zoomed, put markers on correct spot
            pos.x -= this.layer2.position().x;
            pos.y -= this.layer2.position().y;
            pos.x = pos.x / this.layer2.scaleX() / this.scale;
            pos.y = pos.y / this.layer2.scaleX() / this.scale;
          }
        }

        var newMarker = {
          id: __WEBPACK_IMPORTED_MODULE_5_uuid___default.a.v4(),
          coordX: startPos.x,
          coordY: startPos.y,
          coordX2: pos.x,
          coordY2: pos.y,
          BluePrintId: this.blueprint.id,
          attachments: [],
          markerXSolutions: []
        };
        this.postMarker(newMarker);
        startPos = undefined;

        if (!this.readonly) {
          this.$store.state.hasChanges = true;
        }

        console.log("Touched");
      } else {
        this.layerSize.draggable = true;
        this.isZoomed = true;
      }
      this.groupConfig.visible = true;
    },
    getDistance: function getDistance(p1, p2) {
      return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
    },

    //zooming
    pinchZoomWheelEvent: function pinchZoomWheelEvent(stage) {
      var _this3 = this;

      if (this.$refs.stageFullscreen2) {
        stage.getContent().addEventListener("wheel", function (e) {
          if (e.ctrlKey) {
            var layer = stage.children[0];
            e.preventDefault();
            var oldScale = _this3.layer2.scaleX();
            oldScale == 1 ? _this3.isZoomed = false : _this3.isZoomed = true;
            var pointer = stage.getPointerPosition();
            var _startPos = {
              x: pointer.x / oldScale - _this3.layer2.x() / oldScale,
              y: pointer.y / oldScale - _this3.layer2.y() / oldScale
            };

            var deltaYBounded = !(e.deltaY % 1) ? Math.abs(Math.min(-10, Math.max(10, e.deltaY))) : Math.abs(e.deltaY);
            var scaleBy = 1.01 + deltaYBounded / 70;
            var newScale = e.deltaY > 0 ? oldScale / scaleBy : oldScale * scaleBy;
            _this3.layer2.scale({ x: newScale, y: newScale });

            var newPosition = {
              x: (pointer.x / newScale - _startPos.x) * newScale,
              y: (pointer.y / newScale - _startPos.y) * newScale
            };
            _this3.layer2.position(newPosition);
            _this3.layer2.batchDraw();
          }
        });
      }
    },
    generateLogbook: function generateLogbook(blueprintSeparated, withDocuments) {
      var _this4 = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee3() {
        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this4.loading = true;

                //unselect markers
                _this4.$nextTick(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
                  var form;
                  return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
                    while (1) {
                      switch (_context2.prev = _context2.next) {
                        case 0:
                          form = new FormData();

                          form.append("blueprintId", _this4.blueprint.id);
                          form.append("blueprintSeparated", blueprintSeparated);
                          form.append("withDocuments", withDocuments);
                          form.append("lc", localStorage.getItem("language"));
                          _this4.$http.getLog(form).then(function (res) {
                            var url = window.URL.createObjectURL(new Blob([res.data]));
                            var link = document.createElement("a");
                            link.href = url;
                            var date = new Date();
                            link.setAttribute("download", "Logbook_" + date.toLocaleDateString() + "." + (blueprintSeparated || withDocuments ? "zip" : "docx"));
                            document.body.appendChild(link);
                            link.click();
                            _this4.loading = false;
                          }).catch(function (err) {
                            _this4.$noty.error(_this4.$t("error"));
                            console.log(err);
                            _this4.loading = false;
                          });

                        case 6:
                        case "end":
                          return _context2.stop();
                      }
                    }
                  }, _callee2, _this4);
                })));

              case 2:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, _this4);
      }))();
    },
    adjustPoint: function adjustPoint(e) {
      //adjust rect
      if (!this.readonly) {
        this.$store.state.hasChanges = true;
      }

      this.activeMarker = this.markers.find(function (x) {
        return x.id == e.currentTarget.attrs.id;
      });

      var rec = e.currentTarget;
      this.activeMarker.coordX = rec.attrs.x;
      this.activeMarker.coordY = rec.attrs.y;
      this.activeMarker.xStartLine = rec.attrs.x;
      this.activeMarker.yStartLine = rec.attrs.y;
      this.activeMarker.coordX = rec.attrs.x;
      this.activeMarker.coordY = rec.attrs.y;
      this.activeMarker.xRect = rec.attrs.x;
      this.activeMarker.yRect = rec.attrs.y;
    },
    adjustText: function adjustText(e) {
      if (!this.readonly) {
        this.$store.state.hasChanges = true;
      }
      this.activeMarker = this.markers.find(function (x) {
        return x.id == e.currentTarget.attrs.id;
      });
      var text = e.currentTarget;
      this.activeMarker.coordX2 = text.attrs.x + 17.5;
      this.activeMarker.coordY2 = text.attrs.y + 8.5;
      this.activeMarker.xCircle = text.attrs.x + 17.5;
      this.activeMarker.yCircle = text.attrs.y + 8.5;
      this.activeMarker.xEndLine = text.attrs.x + 17.5;
      this.activeMarker.yEndLine = text.attrs.y + 8.5;
      this.activeMarker.xLabel = text.attrs.x;
      this.activeMarker.yLabel = text.attrs.y;
    },
    grab: function grab() {
      this.$refs.stageFullscreen2.getStage().content.style.cursor = "grab";
    },
    moveCursor: function moveCursor() {
      this.$refs.stageFullscreen2.getStage().content.style.cursor = "move";
    },
    pointer: function pointer() {
      this.$refs.stageFullscreen2.getStage().content.style.cursor = "pointer";
    },
    defaultCursor: function defaultCursor() {
      this.$refs.stageFullscreen2.getStage().content.style.cursor = "default";
    },
    updatePosition: function updatePosition(e) {
      this.$emit("update", this.activeMarker);
    },
    highlight: function highlight(e) {
      var markerId = e.currentTarget.VueComponent.$vnode.data.key;
      var marker = this.$store.state.markers.find(function (x) {
        return x.id == markerId;
      });
      marker.highlight = true;
      this.$store.commit("highlight", marker);
      if (marker.draggable) this.grab();else this.pointer();

      var width = this.$refs.stageFullscreen2.$el.clientWidth;
      this.layerSize.x = -marker.coordX + width / 2;
    },
    unHighlight: function unHighlight(e) {
      var markerId = e.currentTarget.VueComponent.$vnode.data.key;
      var marker = this.$store.state.markers.find(function (x) {
        return x.id == markerId;
      });
      if (marker.draggable) marker.highlight = true;else marker.highlight = false;
      this.$store.commit("unHighlight", marker);
      this.defaultCursor();
    },
    unSelect: function unSelect(e) {
      if (!this.$store.state.drawable) {
        this.$store.commit("select", null);
        this.$store.commit("selectReadonly", null);
        //document.getElementById(`marker-${i}`).scrollIntoView();
      }
    },
    select: function select(marker, i) {
      this.clickedInImage = true;
      var stage = this.$refs.stageFullscreen2.getStage();
      //check if the user is drawing
      if (!this.$store.state.drawable) {
        this.$refs.stageFullscreen2.getStage().children[0].draw();

        marker.draggable = true;
        // this.layerSize.draggable = false;
        this.$store.commit("select", marker);
      }
    },
    showDetails: function showDetails(marker) {
      this.$emit("showMarkerDetails", marker);
    },
    update: function update() {
      var _this5 = this;

      this.loading = true;
      if (this.$store.state.isOffline) {
        this.$store.getters.markers.forEach(function (element) {
          var offForm = {
            marker: element
          };
          _this5.$store.commit("addOrUpdateOffForm", offForm);
          _this5.$store.commit("AddAndSetUIelements", element);
        });
        this.$noty.warning(this.$t("cached"));
        this.$store.state.hasChanges = false;
        this.loading = false;
      } else {
        this.$store.state.markersReadonly = [];
        var requests = [];
        this.$store.getters.markers.forEach(function (element) {
          requests.push(_this5.$http.updateMarker(element));
        });

        __WEBPACK_IMPORTED_MODULE_4_q__["Promise"].all(requests).then(function (res) {
          _this5.$noty.success('<i class="fas fa-check"></i>');
          _this5.$store.state.hasChanges = false;
          _this5.loading = false;
        }).catch(function (err) {
          console.log(err);
          _this5.$noty.error(_this5.$t("error"));
          _this5.loading = false;
        });
      }
    },
    resetView: function resetView() {
      var _this6 = this;

      this.isZoomed = false;
      return new __WEBPACK_IMPORTED_MODULE_4_q__["Promise"](function (resolve) {
        _this6.layer2.to({
          x: 0,
          y: 0,
          scaleX: 1,
          scaleY: 1,
          duration: 0.2,
          onFinish: resolve
        });
      });

      // layer.scale({ x: 1.0, y: 1.0 });
      // layer.position({ x: 0, y: 0 });
    },
    focusMarker: function focusMarker(marker) {
      if (!this.fullscreen && marker) {
        //focus on the marker point
        //width of stage

        var wrapper = this.$refs["markup-wrapper"].$el;
        if (!this.moveMarker) {
          if (this.$refs.stageFullscreen2) {
            var _width = this.$refs.stageFullscreen2.$el.clientWidth;
            //height of stage
            var _height = this.$refs.stageFullscreen2.$el.clientHeight;
            var layer = this.$refs.stageFullscreen2.getStage().children[0];
            //animate layer to focus on marker

            this.layer2.to({
              x: -marker.coordX + wrapper.clientWidth / 2,
              // + width / 2,
              y: -marker.coordY + wrapper.clientHeight / 2,
              // + height / 2
              scaleX: 1,
              scaleY: 1,
              duration: 0.2
            });

            this.isZoomed = true;
          }
        }
      }
      this.clickedInImage = false;
    },
    pinch: function pinch(e) {
      var stage = this.$refs.stageFullscreen2.getStage();
      var t1 = e.evt.touches[0];
      var t2 = e.evt.touches[1];
      var layer = stage.children[0];

      if (t1 && t2) {
        e.evt.preventDefault();
        e.evt.stopPropagation();
        var oldScale = this.layer2.scaleX();
        if (t1 && t2) {
          var dist = this.getDistance({
            x: t1.clientX,
            y: t1.clientY
          }, {
            x: t2.clientX,
            y: t2.clientY
          });

          if (!lastDist) lastDist = dist;

          var delta = dist - lastDist;

          var scale = this.layer2.scaleX() * dist / lastDist;

          // this.layer2.scaleX(scale);
          // this.layer2.scaleY(scale);

          var px = (t1.clientX + t2.clientX) / 2;
          var py = (t1.clientY + t2.clientY) / 2;
          var pointer = point || {
            x: px,
            y: py
          };
          if (!point) point = pointer;

          var _startPos2 = {
            x: pointer.x / oldScale - this.layer2.x() / oldScale,
            y: pointer.y / oldScale - this.layer2.y() / oldScale
          };

          var scaleBy = 1.01 + Math.abs(delta) / 100;
          var newScale = delta < 0 ? oldScale / scaleBy : oldScale * scaleBy;
          this.layer2.scale({ x: newScale, y: newScale });

          var newPosition = {
            x: (pointer.x / newScale - _startPos2.x) * newScale,
            y: (pointer.y / newScale - _startPos2.y) * newScale
          };

          this.layer2.position(newPosition);

          this.layer2.draw();
          lastDist = dist;
        }
      }
    },
    pinchEnd: function pinchEnd(e) {
      lastDist = 0;
      point = undefined;
    }
  }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "getDistance", function getDistance(p1, p2) {
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
  }), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_methods, "loadImage", function loadImage() {
    var _this7 = this;

    this.scale = 1;
    var image = new window.Image();
    this.$forceUpdate();
    this.$nextTick(function () {
      image.src = _this7.blueprint.blueprintFile.content; //"https://konvajs.org/assets/yoda.jpg";
    });

    image.onload = function () {
      // // set image only when it is loaded

      setTimeout(function () {
        _this7.image = image;
        //make stage same size as image
        var body = document.body,
            html = document.documentElement;

        var height = Math.max(html.clientHeight);

        var width = Math.max(html.clientWidth);
        //this.stageSize.width = image.width;
        _this7.stageSize.width = width;
        _this7.stageSize.height = height;
        // this.stageSize.height = height;
        // this.image.height > 700 ? this.image.height : 700;
      }, 0);

      _this7.pinchZoomWheelEvent(_this7.$refs.stageFullscreen2.getStage());
    };

    var i = new window.Image();
    i.src = this.i;
    this.icon = i;
  }), _methods),
  computed: {
    // stageSize() {
    //   var body = document.body,
    //     html = document.documentElement;

    //   var height = Math.max(html.clientHeight);

    //   let width = Math.max(html.clientWidth);
    //   return {
    //     width: width,
    //     height: height
    //   };
    // },
    // layer1(){
    //   return this.$refs.stageFullscreen2.getStage().children[0];
    // },
    stage: function stage() {
      return this.$refs.stageFullscreen2.getStage();
    },
    layer2: function layer2() {
      return this.$refs.stageFullscreen2.getStage().children[0];
    },
    defaultStageSize: function defaultStageSize() {
      return {
        width: width,
        height: height
      };
    },
    markers: function markers() {
      var _this8 = this;

      if (this.readonly) {
        if (this.$store.getters.markersReadonly.filter(function (x) {
          return x.id == _this8.$route.params.id;
        }).length != 0) {
          //show only one marker on map
          this.overview = false;
          return this.$store.getters.markersReadonly.filter(function (x) {
            return x.id == _this8.$route.params.id;
          });
        } else {
          this.overview = true;
          return this.$store.state.markersReadonly;
        }
      } else {
        if (this.$store.getters.markers.filter(function (x) {
          return x.id == _this8.$route.params.id;
        }).length != 0) {
          //show only one marker on map
          this.overview = false;
          return this.$store.getters.markers.filter(function (x) {
            return x.id == _this8.$route.params.id;
          });
        } else {
          this.overview = true;
          return this.$store.state.markers;
        }
      }
    },
    drawable: function drawable() {
      return this.$store.state.drawable;
    },
    openBlueprint: function openBlueprint() {
      return this.$store.state.openBlueprint;
    }
  },
  watch: {
    fullscreen: function fullscreen(n, o) {
      this.$emit("fullscreen");
      this.resizeStage();
    },
    markers: function markers(n, o) {
      if (n.some(function (e) {
        return e.draggable;
      })) {
        // this.layerSize.draggable = false;
        this.focusMarker(n.find(function (x) {
          return x.draggable;
        }));
      }
    },
    activeMarker: function activeMarker(n, o) {
      this.focusMarker(n);
    },
    moveMarker: function moveMarker(n, o) {
      if (n) {
        this.moveCursor();
        this.$store.state.drawable = false;
      } else {
        this.defaultCursor();
      }
    },
    drawable: function drawable(n, o) {
      if (n) {
        this.moveMarker = false;
        this.pointer();
      } else {
        this.defaultCursor();
      }
    },
    openBlueprint: function openBlueprint(n, o) {
      if (n) {
        this.fullscreen = true;
      }
    }
  },
  created: function created() {
    this.loadImage();
    this.markerDetailView = this.$route.name === "MarkerDetails" || this.$route.name === "EditMarkerDetails";
    if (this.$route.name === "MarkerDetails") {
      this.markers.forEach(function (marker) {
        if (marker.draggable) {
          marker.draggable = false;
        }
      });
    }
    //}
  }
});

/***/ }),
/* 213 */,
/* 214 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "addQRCode",
  data: function data() {
    return {
      show: false,
      dialog: false,
      warning: false,
      success: false,
      qrId: ""
    };
  },
  props: {
    marker: Object
  },
  methods: {
    close: function close() {
      this.dialog = false;
    },
    onDecode: function onDecode(url) {
      var _this = this;

      this.qrId = url.substr(url.lastIndexOf("/") + 1);
      if (this.$validator.isUUID(this.qrId)) {
        if (this.$store.state.markers.find(function (x) {
          return x.qrId == _this.qrId;
        })) {
          this.$emit("showMarkerDetails", this.$store.state.markers.find(function (x) {
            return x.qrId == _this.qrId;
          }));
        } else if (this.$store.state.markersReadonly.find(function (x) {
          return x.qrId == _this.qrId;
        })) {
          this.$emit("showMarkerDetails", this.$store.state.markersReadonly.find(function (x) {
            return x.qrId == _this.qrId;
          }));
        } else {
          this.warning = true;
        }
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Blueprints_UploadBlueprint__ = __webpack_require__(115);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_Edit_List__ = __webpack_require__(490);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_ZoomMarkup__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_async__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Markers_ScanQRCode__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_service_ihub_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_q__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_q__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_9__services_service_ihub_js__["a" /* serviceihub */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "blueprintsDetails",
  components: {
    uploadBlueprint: __WEBPACK_IMPORTED_MODULE_3__components_pages_Blueprints_UploadBlueprint__["a" /* default */],
    markers: __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_Edit_List__["a" /* default */],
    zoomMarkup: __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_ZoomMarkup__["a" /* default */],
    scanQRCode: __WEBPACK_IMPORTED_MODULE_8__components_pages_Markers_ScanQRCode__["a" /* default */]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    var _this = this;

    console.log("BeforeRouteLeave: Store is " + (this.$store.state.isOffline ? 'offline' : 'online') + ", Store " + (this.$store.state.hasChanges ? "has changes" : "has no changes"));
    /*Before someone goes to other page (in app)
    show a warning if they are working offline.
    If they leave the page, offline changes will not be saved
    */
    if (this.$store.state.isOffline && to.name != "EditMarkerDetails") {
      var answer = window.confirm("Do you really want to leave? you have unsaved changes!");
      if (answer) {
        next();
      } else {
        next(false);
      }
    } else {
      if (this.$store.state.hasChanges && !this.$store.state.isOffline) {
        this.saveDialog = true;
        this.$store.state.hasChanges = false;
        this.to = to;
        next(false);
      } else {
        this.$store.state.hasChanges = false;
        if (to.name != "EditMarkerDetails") {
          if (this.$can("update", "markers")) {
            if (this.blueprint.isLocked && this.blueprint.lockedByUserId == parseInt(__WEBPACK_IMPORTED_MODULE_6_jwt_decode___default()(localStorage.getItem("auth")).contactId)) {
              this.$http.lockBlueprint(this.blueprint.id).then(function (res) {
                if (to.name === "Login") {
                  localStorage.removeItem("auth");
                  localStorage.removeItem("user");
                }
                _this.$store.state.markers = [];
                next();
              }).catch(function (err) {
                console.log(err);
              });
            } else {
              next();
            }
          } else {
            next();
          }
        } else {
          next();
        }
      }
    }
  },
  data: function data() {
    var _this2 = this;

    return {
      blueprint: null,
      loadingText: "",
      hideMarkup: false,
      dialog: false,
      uploadForm: false,
      attributeTypes: null,
      leadThroughTypes: null,
      insulationTypes: null,
      menu: false,
      valid: false,
      nameRules: [function (v) {
        return !!v || _this2.$t("name") + " " + _this2.$t("required");
      }],
      markers: [],
      image: null,
      saveDialog: false,
      to: null,
      fullscreen: false,
      prevRoute: null
    };
  },

  computed: {
    markersui: function markersui() {
      return this.$store.getters.markersui;
    },
    isOffline: function isOffline() {
      return this.$store.state.isOffline;
    }
  },
  methods: {
    toggleFullscreen: function toggleFullscreen(f) {
      this.fullscreen = !f;
    },
    getAllAttributesAndSaveInStore: function getAllAttributesAndSaveInStore() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this3.$store.state.allAttributes == null)) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this3.$http.getAttributes(false, true);

              case 4:
                res = _context.sent;

                _this3.$store.state.allAttributes = res.data;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 8]]);
      }))();
    },
    checkIfBlueprintIsLocked: function checkIfBlueprintIsLocked() {
      if (this.blueprint.isLocked) {
        if (this.blueprint.lockedByUserId != parseInt(__WEBPACK_IMPORTED_MODULE_6_jwt_decode___default()(localStorage.getItem("auth")).contactId)) {
          this.$noty.info(this.blueprint.lockedByUserName + "  " + this.$t("blueprintLockedSince") + " " + this.blueprint.lockedTs);

          this.$router.push({
            name: "BlueprintsDetails",
            params: { id: this.$route.params.id }
          });
        }
      } else {
        this.$router.push({
          name: "BlueprintsDetails",
          params: { id: this.$route.params.id }
        });
      }
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("projects"),
        to: { name: "Projects" }
      }, {
        name: this.blueprint.project,
        to: {
          name: "ProjectDetails",
          params: { id: this.blueprint.projectId }
        }
      }, {
        name: this.blueprint.buildingComponent,
        to: {
          name: "BuildingComponentDetails",
          params: { id: this.blueprint.buildingComponentId }
        }
      }, {
        name: this.blueprint.name
      }];
    },
    response: function response(answer) {
      if (answer) {
        this.$refs.markup.$refs.markupFullscreen.update();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params
      });
    },
    updateBlueprint: function updateBlueprint() {
      var _this4 = this;

      if (this.valid) {

        this.blueprint.buildingComponent = null;
        this.$http.updateBlueprint(this.blueprint).then(function (res) {
          _this4.$noty.success('<i class="fas fa-check"></i>');
        }).catch(function (err) {
          _this4.$noty.error(err);
          console.log(err);
        });
      }
    },
    showMarkerDetails: function showMarkerDetails(marker) {
      this.$router.push({
        name: "EditMarkerDetails",
        params: {
          id: marker.id,
          marker: marker,
          blueprint: this.blueprint
        }
      });
    },
    setOffline: function setOffline() {
      if (navigator.onLine) {
        this.$store.state.isOffline = !this.$store.state.isOffline;
      }
    }
  },
  mounted: function mounted() {
    var _this5 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var resBlueprint, _resBlueprint, resProductSolutions, offline, requests;

      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;

              if (!_this5.$store.state.isOffline) {
                _context2.next = 6;
                break;
              }

              _this5.blueprint = _this5.$route.params.blueprint;
              _this5.$store.state.previous = {
                name: "BuildingComponentDetails",
                id: _this5.blueprint.buildingComponentId
              };
              _context2.next = 33;
              break;

            case 6:
              _this5.blueprint = _this5.$route.params.blueprint;

              if (!_this5.blueprint) {
                _context2.next = 18;
                break;
              }

              if (!(_this5.blueprint.id != _this5.$route.params.id)) {
                _context2.next = 14;
                break;
              }

              _context2.next = 11;
              return _this5.$http.getBlueprint(_this5.$route.params.id);

            case 11:
              resBlueprint = _context2.sent;

              if (resBlueprint.data.blueprintFileId == null) {
                _this5.uploadForm = true;
              }
              _this5.blueprint = resBlueprint.data;

            case 14:
              _this5.checkIfBlueprintIsLocked();
              _this5.$store.state.previous = {
                name: "BuildingComponentDetails",
                id: _this5.blueprint.buildingComponentId,
                breadcrumb: _this5.$t("buildingComponent")
              };
              _context2.next = 25;
              break;

            case 18:
              _context2.next = 20;
              return _this5.$http.getBlueprint(_this5.$route.params.id);

            case 20:
              _resBlueprint = _context2.sent;

              if (_resBlueprint.data.blueprintFileId == null) {
                _this5.uploadForm = true;
              }
              _this5.blueprint = _resBlueprint.data;
              _this5.checkIfBlueprintIsLocked();
              _this5.$store.state.previous = {
                name: "BuildingComponentDetails",
                id: _this5.blueprint.buildingComponentId,
                breadcrumb: _this5.$t("buildingComponent")
              };

            case 25:
              if (!(_this5.$store.state.productSolutions == null)) {
                _context2.next = 30;
                break;
              }

              _context2.next = 28;
              return _this5.$http.getProductSolutions(true);

            case 28:
              resProductSolutions = _context2.sent;

              _this5.$store.state.productSolutions = resProductSolutions.data;

            case 30:
              offline = {
                // offInstallers: null,
                offUnusedAttributes: null
              };
              requests = [];
              // requests.push(this.$http.getProductSolutions(true)); already loaded in line 418
              // requests.push(this.$http.getAttributes(true, true));

              __WEBPACK_IMPORTED_MODULE_10_q__["Promise"].all(requests).then(function (res) {
                // this.$store.state.productSolutions = res[0].data;

                // offline.offUnusedAttributes = res[0].data;
                //
                _this5.dialog = false;
                _this5.$store.state.offline = offline;
                _this5.loadingText = _this5.$t("wait2");
              });

            case 33:
              _this5.makeBreadcrumb();
              _this5.getAllAttributesAndSaveInStore();
              _this5.checkIfBlueprintIsLocked();
              _context2.next = 41;
              break;

            case 38:
              _context2.prev = 38;
              _context2.t0 = _context2["catch"](0);

              console.log(_context2.t0);

            case 41:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this5, [[0, 38]]);
    }))();
  },
  beforeRouteEnter: function beforeRouteEnter(to, from, next) {
    next(function (vm) {
      vm.prevRoute = from;
    });
  },
  created: function created() {},

  watch: {
    blueprint: function blueprint(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedBlueprintsDetails",
            params: { id: n.id }
          });
        }
      }
    }
  }
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_swipe_actions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swipe_actions_dist_vue_swipe_actions_css__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swipe_actions_dist_vue_swipe_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_swipe_actions_dist_vue_swipe_actions_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "markers",
  props: {
    blueprintFile: Object
  },
  components: {
    SwipeOut: __WEBPACK_IMPORTED_MODULE_1_vue_swipe_actions__["b" /* SwipeOut */],
    SwipeList: __WEBPACK_IMPORTED_MODULE_1_vue_swipe_actions__["a" /* SwipeList */]
  },
  data: function data() {
    return {
      search: "",
      showDelete: false,
      selected: undefined,
      headers: [{
        text: this.$t("marker"),
        align: "left",
        value: "number"
      }, {
        text: this.$t("status"),
        align: "left",
        value: "isApproved"
      }, { text: "Actions", sortable: false }],
      loading: false,
      markerStatus: [4]
    };
  },

  methods: {
    filterMarkers: function filterMarkers(marker) {
      return marker.status == 1 && this.markerStatus.includes(1) || marker.status == 0 && this.markerStatus.includes(0) || marker.status == 3 && this.markerStatus.includes(3) || marker.status == 2 && this.markerStatus.includes(2) || this.markerStatus.includes(4) ? "inherit" : "none";
    },
    openBlueprint: function openBlueprint() {
      this.$store.state.openBlueprint = true;
      this.$store.state.drawable = true;
    },
    addMarker: function addMarker() {
      var _this = this;

      this.$store.state.markersReadonly = [];
      var newMarker = {
        id: __WEBPACK_IMPORTED_MODULE_0_uuid___default.a.v4(),
        coordX: 24,
        coordY: 34,
        coordX2: 117,
        coordY2: 110,
        //just not all in a corner
        BluePrintId: this.$route.params.id,
        attachments: [],
        markerXSolutions: []
      };
      if (this.$store.state.isOffline) {
        this.$noty.warning(this.$t("cached"));
        newMarker.number = this.$store.getters.markers.length == 0 ? 1 : Math.max.apply(Math, this.$store.getters.markers.map(function (x) {
          return x.number;
        })) + 1;
        newMarker.new = true;

        // this.$store.commit("offAddAndSetUIelements", newMarker);
        this.$store.commit("AddAndSetUIelements", newMarker);

        var offForm = {
          marker: newMarker
        };
        this.$store.commit("addOrUpdateOffForm", offForm);
        // this.addMarkerToDb(newMarker)
      } else {
        this.$http.addMarker(newMarker).then(function (res) {
          _this.$store.commit("AddAndSetUIelements", res.data);
          _this.$noty.success('<i class="fas fa-check"></i>');
          //this.$store.state.drawable = true;
        }).catch(function (err) {
          _this.$noty.error(_this.$t("error"));
          console.log(err);
        });
      }
    },
    setDrawable: function setDrawable() {
      if (!this.$store.state.drawable) this.$store.state.drawable = true;
    },
    deleteMarker: function deleteMarker(id) {
      this.$store.state.markers = this.$store.state.markers.filter(function (p) {
        return p.id != id;
      });
      this.$store.state.markersReadonly = [];
    },
    markerDetails: function markerDetails(marker) {
      this.select(marker);
      this.$emit("showMarkerDetails", marker);
    },
    select: function select(item) {
      item.draggable = true;
      this.$store.commit("select", item);
    },
    getMarkers: function getMarkers() {
      var _this2 = this;

      var light = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      this.$http.getMarkers(this.$route.params.id, light).then(function (res) {
        _this2.loading = false;
        console.log("Loading store...");
        var markers = [];
        //adding the markerui fields here..
        res.data.forEach(function (element) {
          _this2.$store.commit("AddAndSetUIelements", element);
        });
        if (!light) _this2.$store.state.readyForOffline = true;

        console.log("Store markers has " + _this2.$store.state.markers.length + " items");
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },
  computed: {
    markers: function markers() {
      return this.$store.getters.markers;
    },
    filteredItems: function filteredItems() {
      var _this3 = this;

      return this.$store.getters.markers.filter(function (item) {
        return item.label ? item.label.toLowerCase().includes(_this3.search.toLowerCase()) : "" || item.number.toString().toLowerCase().includes(_this3.search.toLowerCase());
      });
    }
  },
  watch: {
    markers: function markers(after, before) {},
    markerStatus: function markerStatus(n, o) {
      if (n.length > 1) {
        if (n[n.length - 1] === 4) {
          this.markerStatus = [4];
        } else {
          if (n.includes(4)) {
            this.markerStatus = this.markerStatus.filter(function (x) {
              return x != 4;
            });
          }
        }
      }
    }
  },
  created: function created() {
    var _this4 = this;

    this.loading = true;
    if (!this.$store.state.isOffline) {

      if (this.$store.state.markers.find(function (x) {
        return x.blueprintId == _this4.$route.params.id;
      })) {
        //if coming from marker details,
        if (this.$store.state.markers.length <= 1) {
          this.$store.state.markers = [];
          if (!this.$store.state.isOffline) {
            this.getMarkers();
          }
        } else {
          this.loading = false;
        }
      } else {
        //if blueprint has changed, empty list
        this.$store.state.markers = [];

        this.getMarkers();
      }
    } else {
      this.loading = false;
    }
  }
});

/***/ }),
/* 217 */,
/* 218 */,
/* 219 */,
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_sortablejs__ = __webpack_require__(509);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Settings_AddAttribute__ = __webpack_require__(510);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Settings",
  components: { addAttribute: __WEBPACK_IMPORTED_MODULE_4__components_pages_Settings_AddAttribute__["a" /* default */] },
  directives: {
    sortableList: {
      bind: function bind(el, binding, vnode) {
        var sortableElement = el.getElementsByTagName("tbody")[0];
        var options = {
          handle: ".sortHandle",
          animation: 150,
          onUpdate: function onUpdate(event) {
            vnode.child.$emit("sorted", event);
          }
        };
        __WEBPACK_IMPORTED_MODULE_3_sortablejs__["a" /* default */].create(sortableElement, options);
      }
    }
  },
  data: function data() {
    return {
      loading: false,
      selectedAttribute: null,
      cloneDialog: false,
      clonedAttributeName: null,
      active: null,
      expanded: [],
      showValueList: false,
      edit: false,
      attributeId: "",
      attributes: [],
      attributeClasses: [],
      attributeValues: [],
      newAttributeCode: "",
      newAttributeClass: "",
      newAttributeValue: "",
      headers: [{
        text: this.$t("name"),
        data: "code",
        sortable: false
      }, {
        text: this.$t("class"),
        data: "class",
        sortable: false
      }, { text: this.$t("active"), sortable: false }, { text: this.$t("required"), sortable: false }, { text: this.$t("clone"), sortable: false }, { text: this.$t("delete"), sortable: false },
      // { text: this.$t("actions"), sortable: false },

      { text: "", sortable: false }]
    };
  },

  methods: {
    clone: function clone() {
      var _this = this;

      if (this.$refs.cloneForm.validate()) {
        var a = JSON.parse(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.selectedAttribute));
        a.code = this.clonedAttributeName;
        this.$http.cloneQRLogAttribute(a).then(function (res) {
          _this.cloneDialog = false;
          _this.$router.go();
        }).catch(function (err) {
          console.log(err);
          _this.cloneDialog = false;
          _this.$noty.error(err);
        });
      }
    },
    putQrlogAttributeListValue: function putQrlogAttributeListValue(value) {
      var _this2 = this;

      this.loading = true;
      this.$http.updateAttributeValue(value).then(function (res) {
        _this2.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.loading = false;
      });
    },
    saveOrder: function saveOrder(_ref) {
      var _this3 = this;

      var oldIndex = _ref.oldIndex,
          newIndex = _ref.newIndex;

      this.loading = true;
      var movedItem = this.attributes.splice(oldIndex, 1)[0];
      this.attributes.splice(newIndex, 0, movedItem);
      for (var i = 0; i < this.attributes.length; i++) {
        this.attributes[i].index = i;
      }
      this.$http.updateAttributesPosition(this.attributes.map(function (x) {
        return { id: x.id, index: x.index };
      })).then(function (res) {
        _this3.$noty.success('<i class="fas fa-check"></i>');
        _this3.$store.state.allAttributes = null;
        _this3.loading = false;
      }).catch(function (err) {
        _this3.$noty.error(_this3.$t("error"));
        console.log(err);
        _this3.loading = false;
      });
    },
    saveValue: function saveValue(attributeId) {
      var _this4 = this;

      if (this.newAttributeValue && this.newAttributeValue !== "") {
        this.loading = true;
        var attributeValue = {
          id: __WEBPACK_IMPORTED_MODULE_1_uuid___default.a.v4(),
          description: this.newAttributeValue,
          qrLogAttributeId: attributeId,
          isActive: true,
          qrLogAttributeListValueGlobalRefId: null
        };
        this.$http.saveAttributeValue(attributeValue).then(function (res) {
          res.data.qrLogAttributeListValueGlobalRefId = null;
          res.data.canDelete = true;
          _this4.attributeValues.push(res.data);
          _this4.newAttributeValue = "";
          _this4.$noty.success('<i class="fas fa-check"></i>');
          _this4.$store.state.allAttributes = null;
          _this4.loading = false;
          // this.expanded.pop();
          // this.attributeId = null;
        }).catch(function (err) {
          _this4.$noty.error(_this4.$t("error"));
          console.log(err);
          _this4.loading = false;
        });
      }
    },
    addAttribute: function addAttribute(attribute) {
      this.attributes.push(attribute);
      this.$store.state.allAttributes = null;
    },
    showValues: function showValues(attribute, attributeClass) {
      var _this5 = this;

      this.loading = true;
      if (this.attributeId == attribute.id && this.expanded.length > 0) {
        this.expanded.pop();
        this.loading = false;
      } else {
        this.expanded.pop();
        this.expanded.push(attribute);
        if (this.attributeValues.length > 0) {
          if (this.attributeValues[0].qrLogAttributeId != attribute.id) {
            this.attributeId = attribute.id;
            this.$http.showValues(attribute.id).then(function (res) {
              _this5.attributeValues = res.data;
              _this5.$forceUpdate();
              _this5.loading = false;
            }).catch(function (err) {
              console.log(err);
              _this5.loading = false;
            });
          } else {
            this.loading = false;
          }
        } else {
          this.attributeId = attribute.id;
          this.$http.showValues(attribute.id).then(function (res) {
            _this5.attributeValues = res.data;
            _this5.$forceUpdate();
            _this5.loading = false;
          }).catch(function (err) {
            console.log(err);
            _this5.loading = false;
          });
        }
      }
    },
    deleteValue: function deleteValue(valueId) {
      this.attributeValues = this.attributeValues.filter(function (p) {
        return p.id != valueId;
      });
      this.$store.state.allAttributes = null;
    },
    update: function update() {
      var _this6 = this;

      this.loading = true;
      this.$http.updateAttribute(this.attributes).then(function (res) {
        _this6.$noty.success('<i class="fas fa-check"></i>');
        _this6.$store.state.allAttributes = null;
        _this6.loading = false;
      }).catch(function (err) {
        _this6.$noty.error(err);
        console.log(err);
        _this6.loading = false;
      });

      this.$http.updateAttributeValues(this.attributeValues).then(function (res) {
        // this.$noty.success('<i class="fas fa-check"></i>');
        _this6.$store.state.allAttributes = null;
      }).catch(function (err) {
        _this6.$noty.error(_this6.$t("error"));
        console.log(err);
      });
    },
    deleteAttribute: function deleteAttribute(id) {
      this.attributes = this.attributes.filter(function (p) {
        return p.id != id;
      });
      this.$store.state.allAttributes = null;
    },
    changeVisibility: function changeVisibility(attribute) {
      var _this7 = this;

      this.$http.changeVisibility(attribute).then(function (res) {
        _this7.$noty.success('<i class="fas fa-check"></i>');
        _this7.$store.state.allAttributes = null;
      }).catch(function (err) {
        _this7.$noty.error(_this7.$t("error"));
        console.log(err);
      });
    },
    changeRequired: function changeRequired(attribute) {
      var _this8 = this;

      this.$http.changeVisibility(attribute).then(function (res) {
        _this8.$noty.success('<i class="fas fa-check"></i>');
        _this8.$store.state.allAttributes = null;
      }).catch(function (err) {
        _this8.$noty.error(_this8.$t("error"));
        console.log(err);
      });
    },
    syncAttributes: function syncAttributes() {
      var _this9 = this;

      this.loading = true;
      this.$http.syncAttributes().then(function (res) {
        _this9.$noty.success('<i class="fas fa-check"></i>');
        _this9.$store.state.allAttributes = null;
        _this9.loading = false;
        _this9.$router.go();
      }).catch(function (err) {
        console.log(err);
        _this9.loading = false;
      });
    }
  },
  created: function created() {
    var _this10 = this;

    this.loading = true;
    this.$http.getAttributes().then(function (res) {
      _this10.attributes = res.data;
      _this10.loading = false;
    }).catch(function (err) {
      console.log(err);
      _this10.loading = false;
    });

    this.$http.getAttributeClasses().then(function (res) {
      _this10.attributeClasses = res.data;
    }).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),
/* 221 */,
/* 222 */,
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "addProductSolution",
  props: ["attributeClasses", "index"],
  data: function data() {
    return {
      show: false,
      dialog: false,
      name: null,
      classId: null,
      valid: true,
      // attributeClasses: [],
      search: null
    };
  },
  methods: {
    close: function close() {
      this.dialog = false;
    },
    rules: function rules() {
      var _this = this;

      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$t("name");

      var rules = [function (v) {
        return !!v || property + " " + _this.$t("required");
      }, function (v) {
        return v && v.length <= 512 || "";
      }];
      return rules;
    },
    add: function add() {
      var _this2 = this;

      if (this.$refs.form.validate() && this.classId) {
        var qRLogAttribute = {
          id: __WEBPACK_IMPORTED_MODULE_0_uuid___default.a.v4(),
          code: this.name,
          qrLogAttributeClassId: this.classId,
          visible: true,
          //add next index
          index: this.index
        };
        this.$http.saveAttribute(qRLogAttribute).then(function (res) {
          _this2.$emit("add", res.data);
          _this2.name = "";
          _this2.$noty.success('<i class="fas fa-check"></i>');
          _this2.close();
        }).catch(function (err) {
          _this2.$noty.error(err);
          console.log(err);
        });
      }
    }
  },
  watch: {}
});

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__ = __webpack_require__(515);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__ = __webpack_require__(227);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_settings_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_service_ihub_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_vuedraggable__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Users_AddUser__ = __webpack_require__(534);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Users_EditUser__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Users_UserManager__ = __webpack_require__(538);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_5__services_service_ihub_js__["a" /* serviceihub */]();





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Users",
  components: {
    draggable: __WEBPACK_IMPORTED_MODULE_6_vuedraggable___default.a,
    addInstaller: __WEBPACK_IMPORTED_MODULE_7__components_pages_Users_AddUser__["a" /* default */],
    editUser: __WEBPACK_IMPORTED_MODULE_8__components_pages_Users_EditUser__["a" /* default */],
    userManager: __WEBPACK_IMPORTED_MODULE_9__components_pages_Users_UserManager__["a" /* default */]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.hasChanges) {
      if (this.$can("update", "installers")) {
        this.saveDialog = true;
        this.hasChanges = false;
        this.to = to;
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
  data: function data() {
    return {
      users: null,
      admins: null,
      readonlys: null,
      installers: null,
      hasChanges: false,
      saveDialog: false,
      profiles: null,
      noaccess: [],
      usersGroupedByProfile: [],
      valid: false,
      to: null,
      selectedUser: null,
      dialog: false
    };
  },

  methods: {
    selectUser: function selectUser(index, user) {
      if (index !== 0) {
        this.dialog = false;
        this.dialog = true;
        this.selectedUser = user;
      }
    },
    changeUserProfile: function changeUserProfile(e, ev) {
      // console.log(e);
      // console.log("move event", e);

      var user = e.draggedContext.element.ProfileId = e.relatedContext.component.$attrs.id;
      this.hasChanges = true;

      // console.log("usersgroupedbyprofile", this.usersGroupedByProfile);
    },
    response: function response(answer) {
      if (answer) {
        this.update();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params
      });
    },
    update: function update() {
      var _this = this;

      if (this.valid) {
        var users = [];
        this.usersGroupedByProfile.forEach(function (profiles, key) {
          profiles.forEach(function (element) {
            element.ProfileId = key;
            if (element.id != __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(localStorage.getItem("auth")).contactId) {
              users.push(element);
            }
          });
        });
        // this.noaccess.forEach(element => {
        //   if (element.id != jwtdecode(localStorage.getItem("auth")).contactId) {
        //     users.push(element);
        //   }
        // });
        _serviceIhub.updateCustomerContacts(users).then(function (res) {
          _this.$noty.success('<i class="fas fa-check"></i>');
          _this.saveDialog = false;
          _this.hasChanges = false;

          _this.$router.go();
        }).catch(function (error) {
          _this.$noty.error(error);
        });
      } else {
        // this.$noty.warning(this.$t("error"));
      }
    },
    addInstaller: function addInstaller(installer) {
      var _this2 = this;

      this.$http.addInstaller(installer).then(function (res) {
        _this2.$noty.success('<i class="fas fa-check"></i>');
        _this2.$router.go();
      }).catch(function (error) {
        // this.$router.go();
        _this2.$noty.error(error);
      });
    }
  },
  watch: {
    profiles: function profiles() {},
    validation: function validation() {},
    admins: function admins(n, o) {
      if (o != null && n != o) this.hasChanges = true;
    },
    readonlys: function readonlys(n, o) {
      if (o != null && n != o) this.hasChanges = true;
    },
    installers: function installers(n, o) {
      if (o != null && n != o) this.hasChanges = true;
    },
    usersGroupedByProfile: function usersGroupedByProfile(n, o) {
      var _this3 = this;

      this.valid = true;
      this.profiles.forEach(function (profile) {
        if (_this3.usersGroupedByProfile[profile.Id].length > profile.Limit) {
          _this3.valid = false;
        }
      });
      if (o != [] && n != o) this.hasChanges = true;
    }
  },
  created: function created() {
    var _this4 = this;

    var customerId = __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(localStorage.getItem("auth")).customerId;
    _serviceIhub.getProfilesByCustomerId(customerId, __WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].firelogapplicationId).then(function (res) {
      console.log("profiles", res.data);
      _this4.profiles = res.data;

      _serviceIhub.getCustomerContactXLicenseXProfilesByCustomerId(__WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(localStorage.getItem("auth")).customerId, true, __WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].firelogapplicationId).then(function (res) {
        console.log(res.data);

        _this4.users = res.data;
        _this4.noaccess = _this4.users.filter(function (x) {
          return x.ProfileId == __WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].noaccess;
        });
        var distictProfileIds = [].concat(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_toConsumableArray___default()(new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_set___default.a(_this4.users.map(function (item) {
          return item.ProfileId;
        }))));
        _this4.profiles.forEach(function (profile) {
          _this4.usersGroupedByProfile[profile.Id] = _this4.users.filter(function (x) {
            return x.ProfileId == profile.Id;
          });
          _this4.$forceUpdate();
        });
        console.log(_this4.usersGroupedByProfile, "és");
        _this4.admins = _this4.users.filter(function (x) {
          return x.ProfileId == __WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].admin;
        });
        _this4.readonlys = _this4.users.filter(function (x) {
          return x.ProfileId == __WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].readonly;
        });
        _this4.installers = _this4.users.filter(function (x) {
          return x.ProfileId == __WEBPACK_IMPORTED_MODULE_4__settings_settings_js__["a" /* default */].installer;
        });
      }).catch(function (err) {
        console.log(err);
      });
    }).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),
/* 225 */,
/* 226 */,
/* 227 */,
/* 228 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha256__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_jwt_decode__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "addInstaller",
  props: ["profiles"],
  data: function data() {
    return {
      show: false,
      dialog: false,
      email: "",
      login: "",
      inputP: "",
      name: "",
      firstname: "",
      key: "",
      profile: null,
      valid: true
    };
  },
  methods: {
    close: function close() {
      this.dialog = false;
    },
    nameRules: function nameRules() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$t("name") + " " + _this.$t("required");
      }];
    },
    profileRules: function profileRules() {
      return [function (v) {
        return !!v || "";
      }];
    },
    emailRules: function emailRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$t("email") + " " + _this2.$t("required");
      }, function (v) {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || _this2.$t("email") + " " + _this2.$t("invalid");
      }];
    },
    passwordRules: function passwordRules() {
      var _this3 = this;

      return [function (v) {
        return !!v || _this3.$t("password") + " " + _this3.$t("required");
      }, function (v) {
        return v.length >= 8 || "" + _this3.$t("min8");
      }];
    },
    encrypt: function encrypt() {
      this.key = __WEBPACK_IMPORTED_MODULE_2_sha256___default()(this.inputP);
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        var _newInstaller;

        var newInstaller = (_newInstaller = {
          email: this.email,
          firstname: this.firstname,
          name: this.name,
          key: this.key
        }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newInstaller, "email", this.email), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newInstaller, "login", this.login), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newInstaller, "customerId", __WEBPACK_IMPORTED_MODULE_3_jwt_decode___default()(localStorage.getItem("auth")).customerId), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newInstaller, "LicenseXProfileId", this.profile), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_newInstaller, "iHubApplicationId", 2), _newInstaller);
        this.$emit("add-installer", newInstaller);
        this.close();
      }
    }
  }
});

/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sha256__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["user"],
  data: function data() {
    return {
      // editedUser: {},
      show: false,
      dialog: false,
      inputP: "",
      key: "",
      valid: true
    };
  },
  computed: {
    editedUser: function editedUser() {
      return this.user;
    }
  },
  methods: {
    close: function close() {
      this.dialog = false;
    },
    nameRules: function nameRules() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$t("name") + " " + _this.$t("required");
      }];
    },
    emailRules: function emailRules() {
      var _this2 = this;

      return [function (v) {
        return !!v || _this2.$t("email") + " " + _this2.$t("required");
      }, function (v) {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || _this2.$t("email") + " " + _this2.$t("invalid");
      }];
    },
    passwordRules: function passwordRules() {
      var _this3 = this;

      return [function (v) {
        return !!v || _this3.$t("password") + " " + _this3.$t("required");
      }, function (v) {
        return v.length >= 8 || "" + _this3.$t("min8");
      }];
    },
    encrypt: function encrypt() {
      this.editedUser.key = __WEBPACK_IMPORTED_MODULE_1_sha256___default()(this.inputP);
    },
    save: function save() {
      var _this4 = this;

      if (this.$refs.form.validate()) {
        this.editedUser.id = this.editedUser.Id;
        this.$http.updateCustomerContact(this.editedUser).then(function (res) {
          _this4.$emit("update-user", _this4.editedUser);
          _this4.$noty.success(_this4.$t('success'));
          _this4.close();
        }).catch(function (error) {
          console.log(error);
          _this4.$noty.error(error);
        });
      }
    }
  }
});

/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ["selectedUser", "dialog"],
  data: function data() {
    return {
      dialog: false,
      selectedUser: null,
      selectedProjects: [],
      selectedProject: null,
      projects: null,
      buildingComponents: null,
      selectedBuildingComponents: [],
      selectedBuildingComponent: null,
      blueprints: [],
      selectedBlueprints: [],
      disabled: false,
      selectAllProjects: false,
      selectAllBuildingComponents: false,
      selectAllBlueprints: false,
      searchProjects: "",
      searchBuildingComponents: "",
      searchBlueprints: ""
    };
  },

  computed: {
    filteredProjects: function filteredProjects() {
      var _this = this;

      console.log("selectedProjects are " + this.selectedProjects);

      if (!this.projects) return;
      return this.projects.filter(function (item) {
        return item.name.toLowerCase().includes(_this.searchProjects.toLowerCase());
      });
    },
    filteredBuildingComponents: function filteredBuildingComponents() {
      var _this2 = this;

      if (!this.buildingComponents) return;
      return this.buildingComponents.filter(function (item) {
        return item.name.toLowerCase().includes(_this2.searchBuildingComponents.toLowerCase());
      });
    },
    filteredBlueprints: function filteredBlueprints() {
      var _this3 = this;

      if (!this.blueprints) return;
      return this.blueprints.filter(function (item) {
        return item.name.toLowerCase().includes(_this3.searchBlueprints.toLowerCase());
      });
    }
  },
  methods: {
    closeDialog: function closeDialog() {
      this.$emit("close");
    },
    getProjects: function getProjects() {
      var _this4 = this;

      // this.progress = true;
      this.$http.getProjects(false, this.selectedUser.CustomerContactId).then(function (res) {
        _this4.projects = res.data;

        console.log("CustomerContactId is " + _this4.selectedUser.CustomerContactId);

        if (_this4.projects) {
          _this4.selectedProjects = [];
          _this4.projects.forEach(function (project) {
            if (project.installers.some(function (x) {
              return x.id == _this4.selectedUser.CustomerContactId;
            })) {
              _this4.selectedProjects.push(project.id);
            }
          });
        }
      }).catch(function (error) {
        console.log(error.response.status);
      });
    },
    getBuildingComponents: function getBuildingComponents() {
      var _this5 = this;

      this.$http.getBuildingComponents(this.selectedProject.id).then(function (res) {
        _this5.buildingComponents = res.data;

        if (_this5.buildingComponents) {
          _this5.selectedBuildingComponents = [];
          _this5.buildingComponents.forEach(function (bc) {
            if (bc.installers.some(function (x) {
              return x.id == _this5.selectedUser.CustomerContactId;
            })) {
              _this5.selectedBuildingComponents.push(bc.id);
            }
          });
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getBlueprints: function getBlueprints() {
      var _this6 = this;

      this.$http.getBlueprints(this.selectedBuildingComponent.id).then(function (res) {
        _this6.blueprints = res.data;

        if (_this6.blueprints) {
          _this6.selectedBlueprints = [];
          _this6.blueprints.forEach(function (blueprint) {
            if (blueprint.installers.some(function (x) {
              return x.id == _this6.selectedUser.CustomerContactId;
            })) {
              _this6.selectedBlueprints.push(blueprint.id);
            }
          });
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    updateUsers: function updateUsers() {
      var _this7 = this;

      this.disabled = true;
      var data = {
        selectedUserId: this.selectedUser.CustomerContactId,
        entityIds: this.selectedProjects
      };
      this.$http.updateProjectsXInstallers(data).then(function (res) {
        _this7.disabled = false;
        if (_this7.buildingComponents.some(function (x) {
          return x.projectId == _this7.selectedProject.id;
        })) {
          if (_this7.selectedProjects.some(function (s) {
            return s == _this7.selectedProject.id;
          })) {
            _this7.buildingComponents.forEach(function (bc) {
              _this7.selectedBuildingComponents.push(bc.id);
            });

            _this7.blueprints.forEach(function (b) {
              _this7.selectedBlueprints.push(b.id);
            });
          } else {
            _this7.selectedBuildingComponents = [];
            _this7.selectedBlueprints = [];
          }
        }
      }).catch(function (err) {
        _this7.disabled = false;
        console.log(err);
      });
    },
    updateUsersComponents: function updateUsersComponents() {
      var _this8 = this;

      this.disabled = true;
      var data = {
        selectedUserId: this.selectedUser.CustomerContactId,
        entityIds: this.selectedBuildingComponents
      };

      this.$http.updateBuildingComponentsXInstallers(data).then(function (res) {
        _this8.disabled = false;
        if (!_this8.selectedProjects.some(function (x) {
          return x == _this8.selectedProject.id;
        })) {
          _this8.selectedProjects.push(_this8.selectedProject.id);
        }

        if (_this8.selectedBuildingComponents.length === 0) {
          _this8.selectedProjects = _this8.selectedProjects.filter(function (x) {
            return x != _this8.selectedProject.id;
          });
        }
        if (_this8.blueprints.some(function (x) {
          return x.buildingComponentId == _this8.selectedBuildingComponent.id;
        })) {
          if (_this8.selectedBuildingComponents.some(function (s) {
            return s == _this8.selectedBuildingComponent.id;
          })) {
            _this8.blueprints.forEach(function (blueprint) {
              _this8.selectedBlueprints.push(blueprint.id);
            });
          } else {
            _this8.selectedBlueprints = [];
          }
        }
      }).catch(function (err) {
        _this8.disabled = false;
        console.log(err);
      });
    },
    updateUsersBlueprints: function updateUsersBlueprints() {
      var _this9 = this;

      this.disabled = true;
      var data = {
        selectedUserId: this.selectedUser.CustomerContactId,
        entityIds: this.selectedBlueprints,
        parentId: this.selectedBuildingComponent.id
      };

      this.$http.updateBlueprintXInstallers(data).then(function (res) {
        _this9.disabled = false;
        // this.selectedProjects = [];
        //   this.selectedBuildingComponents = [];
        //   if(this.selectedBuildingComponents.some(x => x.))
        _this9.selectedBuildingComponents.push(_this9.selectedBuildingComponent.id);
        _this9.selectedProjects.push(_this9.selectedProject.id);
        if (_this9.selectedBlueprints.length === 0) {
          _this9.selectedBuildingComponents = _this9.selectedBuildingComponents.filter(function (x) {
            return x != _this9.selectedBuildingComponent.id;
          });

          if (_this9.selectedBuildingComponents.length === 0) {
            _this9.selectedProjects = _this9.selectedProjects.filter(function (x) {
              return x != _this9.selectedProject.id;
            });
          }
        }
      }).catch(function (err) {
        _this9.disabled = false;
        console.log(err);
      });
    },
    onChangeSelectAllProjects: function onChangeSelectAllProjects() {
      var _this10 = this;

      if (this.selectAllProjects) {
        this.projects.forEach(function (project) {
          if (project.installers.some(function (x) {
            return x.id == _this10.selectedUser.CustomerContactId;
          })) return;
          _this10.selectedProjects.push(project.id);
        });
        this.updateUsers();
      } else {
        this.selectedProjects = [];
        this.updateUsers();
      }
    },
    onChangeSelectAllBuildingComponents: function onChangeSelectAllBuildingComponents() {
      var _this11 = this;

      if (this.selectAllBuildingComponents) {
        this.buildingComponents.forEach(function (buildingComponent) {
          if (buildingComponent.installers.some(function (x) {
            return x.id == _this11.selectedUser.CustomerContactId;
          })) return;
          _this11.selectedBuildingComponents.push(buildingComponent.id);
        });
        this.updateUsersComponents();
      } else {
        this.selectedBuildingComponents = [];
        this.updateUsersComponents();
      }
    },
    onChangeSelectAllBlueprints: function onChangeSelectAllBlueprints() {
      var _this12 = this;

      if (this.selectAllBlueprints) {
        this.blueprints.forEach(function (blueprint) {
          if (blueprint.installers.some(function (x) {
            return x.id == _this12.selectedUser.CustomerContactId;
          })) return;
          _this12.selectedBlueprints.push(blueprint.id);
        });
        this.updateUsersBlueprints();
      } else {
        this.selectedBlueprints = [];
        this.updateUsersBlueprints();
      }
    }
  },
  watch: {
    selectedUser: function selectedUser(n, o) {
      var _this13 = this;

      this.selectedBuildingComponent = null;
      this.selectedProject = null;
      if (this.projects) {
        this.selectedProjects = [];
        this.projects.forEach(function (project) {
          if (project.installers.some(function (x) {
            return x.id == _this13.selectedUser.CustomerContactId;
          })) {
            _this13.selectedProjects.push(project.id);
          }
        });
      }

      this.getProjects();
    },
    selectedProject: function selectedProject(n, o) {
      this.buildingComponents = null;
      this.blueprints = null;
      this.selectedBuildingComponent = null;
      this.getBuildingComponents();
    },
    selectedBuildingComponent: function selectedBuildingComponent(n, o) {
      this.blueprints = null;
      this.getBlueprints();
    },
    selectedProjects: function selectedProjects(n, o) {
      if (n.length == this.projects.length) {
        this.selectAllProjects = true;
      } else {
        this.selectAllProjects = false;
      }
    },
    selectedBuildingComponents: function selectedBuildingComponents(n, o) {
      if (n.length == this.buildingComponents.length) {
        this.selectAllBuildingComponents = true;
      } else {
        this.selectAllBuildingComponents = false;
      }
    },
    selectedBlueprints: function selectedBlueprints(n, o) {
      if (n.length == this.blueprints.length) {
        this.selectAllBlueprints = true;
      } else {
        this.selectAllBlueprints = false;
      }
    },
    searchProjects: function searchProjects(n, o) {
      // this.$nextTick(() => {
      //   setTimeout(() => {
      //   this.$forceUpdate();
      // }, 1000);
      // })

    }
  }
});

/***/ }),
/* 231 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_AddQRCode__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_ZoomPicture__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Markers_MarkerXSolutions_List__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Markers_Reports__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Markers_archivedReports__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Markers_ZoomMarkup__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_service_ihub_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_crypto__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_q__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_Blueprints_IsLocked__ = __webpack_require__(114);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_10__services_service_ihub_js__["a" /* serviceihub */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "markerDetails",
  components: {
    zoomPicture: __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_ZoomPicture__["a" /* default */],
    addQRCode: __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_AddQRCode__["a" /* default */],
    solutionsList: __WEBPACK_IMPORTED_MODULE_6__components_pages_Markers_MarkerXSolutions_List__["a" /* default */],
    zoomMarkup: __WEBPACK_IMPORTED_MODULE_9__components_pages_Markers_ZoomMarkup__["a" /* default */],
    reports: __WEBPACK_IMPORTED_MODULE_7__components_pages_Markers_Reports__["a" /* default */],
    isLocked: __WEBPACK_IMPORTED_MODULE_13__components_pages_Blueprints_IsLocked__["a" /* default */],
    archivedReports: __WEBPACK_IMPORTED_MODULE_8__components_pages_Markers_archivedReports__["a" /* default */]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.$store.state.hasChanges) {
      this.$store.state.hasChanges = false;
      next();

      //     if (to.name !== "MarkerXSolutionDetails") {
      //       this.saveDialog = true;
      //       this.$store.state.hasChanges = false;
      //       this.to = to;
      //       next(false);
      //     } else {
      //       next();
      //     }
      //   }
      // } else {
      //   if (this.readonly) {
      //     next();
      //   } else {
      //     if (
      //       to.name != "BlueprintsDetails" &&
      //       to.name != "MarkerXSolutionDetails"
      //     ) {
      //       if (this.$can("update", "markers")) {
      //         this.$http
      //           .lockBlueprint(this.blueprint.id)
      //           .then(res => {
      //             if (to.name === "Login") {
      //               localStorage.removeItem("auth");
      //               localStorage.removeItem("user");
      //             }
      //             next();
      //           })
      //           .catch(err => {
      //             console.log(err);
      //           });
      //       } else {
      //         next();
      //       }
      //     } else {
      //       next();
      //     }
      //   }
    } else {
      next();
    }
  },

  props: {
    markerid: String
    //marker: Object
  },
  data: function data() {
    return {
      admin: false,
      dialog: false,
      // installers: null,
      attachment: null,
      loaded: false,
      marker: null,
      menu: false,
      valid: false,
      //productSolutions: "",
      blueprint: null,
      selectedFile: null,
      nameRules: [function (v) {
        return !!v || "Name is required";
      }],
      isLoading: false,
      search: null,
      readonly: false,
      saveDialog: false,
      to: null,
      loadingText: "",
      showLockedMessage: false
    };
  },

  computed: {
    isOffline: function isOffline() {
      return this.$store.state.isOffline;
    },
    statusItems: function statusItems() {
      return [{
        id: "0",
        name: this.$t("broken"),
        icon: "priority_high",
        color: "red",
        disabled: false
      }, {
        id: "1",
        name: this.$t("inProcess"),
        icon: "priority_high",
        color: "orange",
        disabled: true
      }, {
        id: "2",
        name: this.$t("approved"),
        icon: "check_circle",
        color: "success",
        disabled: false
      }];
    }
  },
  methods: {
    openSolution: function openSolution(mxs) {
      this.$router.push({
        name: "MarkerXSolutionDetails",
        params: {
          id: this.marker.id,
          markerXSolutionId: mxs.id,
          markerXSolution: mxs,
          marker: this.marker,
          blueprint: this.blueprint,
          readonly: true
        }
      });
    },
    lockBlueprint: function lockBlueprint() {
      var _this = this;

      this.$store.state.readyForOffline = false;
      if (this.$can("update", "markers")) {
        if (this.blueprint.lockedByUserId == parseInt(__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem("auth")).contactId)) {
          this.$router.push({
            name: "EditMarkerDetails",
            params: { id: this.marker.id }
          });
        } else {
          this.$http.lockBlueprint(this.blueprint.id).then(function (res) {
            if (res.data.lockedByUserId == parseInt(__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem("auth")).contactId)) {
              _this.$router.push({
                name: "EditMarkerDetails",
                params: { id: _this.marker.id }
              });
            } else {
              _this.showLockedMessage = true;
            }
          }).catch(function (err) {
            console.log(err);
            _this.$noty.error(_this.$t("error"));
          });
        }
      }
    },
    makeBackButton: function makeBackButton() {
      this.$store.state.previous = {
        name: "BlueprintsDetails",
        id: this.blueprint.id,
        breadcrumb: this.$t("blueprint")
      };
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("projects"),
        to: { name: "Projects" }
      }, {
        name: this.blueprint.project,
        to: {
          name: "ProjectDetails",
          params: { id: this.blueprint.projectId }
        }
      }, {
        name: this.blueprint.buildingComponent,
        to: {
          name: "BuildingComponentDetails",
          params: { id: this.blueprint.buildingComponentId }
        }
      }, {
        name: this.blueprint.name,
        to: {
          name: "BlueprintsDetails",
          params: { id: this.blueprint.id }
        }
      }, {
        name: this.$t("marker") + " " + this.marker.number + " " + (this.marker.label ? " - " + this.marker.label : "")
      }];
    },
    getProductSolutions: function getProductSolutions() {
      var _this2 = this;

      if (this.$store.state.productSolutions == null) {
        this.$http.getProductSolutions(true).then(function (res) {
          _this2.$store.state.productSolutions = res.data;
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    getAllAttributesAndSaveInStore: function getAllAttributesAndSaveInStore() {
      var _this3 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this3.$store.state.allAttributes == null)) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this3.$http.getAttributes(false, true);

              case 4:
                res = _context.sent;

                _this3.$store.state.allAttributes = res.data;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this3, [[1, 8]]);
      }))();
    }
  },
  watch: {
    marker: function marker(n, o) {
      if (n != null || n != undefined) {
        if (n.installerId == null) {
          this.marker.installerId = parseInt(__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem("auth")).contactId);
        }
      }
    },
    blueprint: function blueprint(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedBlueprintsDetails",
            params: { id: n.id }
          });
        }
      }
    },
    readonly: function readonly() {}
  },
  created: function created() {
    var _this4 = this;

    if (this.$store.state.isOffline) {
      alert("could not load marker, connect to internet");
      this.blueprint = this.$store.state.offline.offBlueprint;
      this.makeBackButton();
    } else {
      this.getAllAttributesAndSaveInStore();
      // this.marker = this.$route.params.marker;
      this.blueprint = this.$route.params.blueprint;
      // if (this.marker === undefined) {
      this.$http.getMarker(this.$route.params.id).then(function (res) {
        _this4.marker = res.data;
        // this.$store.state.markers = [];
        _this4.$store.commit("AddAndSetUIelementsReadonly", res.data);
        _this4.$http.getBlueprint(_this4.marker.blueprintId).then(function (res) {
          _this4.blueprint = res.data;
          _this4.makeBackButton();
          _this4.makeBreadcrumb();
        }).catch(function (err) {
          return console.log(err);
        });
      });
      // } else {
      //   this.makeBackButton();
      //   this.makeBreadcrumb();
      //   if (this.$route.params.edit) {
      //     this.$nextTick(() => {
      //       this.lockBlueprint();
      //     });
      //   }
      // }
      this.getProductSolutions();
    }
  }
});

/***/ }),
/* 232 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "addQRCode",
  data: function data() {
    return {
      show: false,
      dialog: false,
      warning: false,
      warning2: false,
      warning3: false,
      warning4: false,
      success: false,
      qrId: ""
    };
  },
  props: {
    marker: Object
  },
  methods: {
    close: function close() {
      this.dialog = false;
    },
    onDecode: function onDecode(url) {
      this.$store.state.markersReadonly = [];
      this.qrId = url.substr(url.lastIndexOf("/") + 1);
      if (this.$validator.isUUID(this.qrId)) {
        if (this.marker.qrId && this.marker.qrId != this.qrId) {
          this.warning = true;
        } else if (this.marker.qrId && this.marker.qrId == this.qrId) {
          this.warning3 = true;
        } else {
          this.getMarkerByQRId(this.qrId);
        }
      } else {}
    },
    getMarkerByQRId: function getMarkerByQRId(id) {
      var _this = this;

      var markerId = this.$route.params.id;
      if (this.$store.state.isOffline) {
        var o = {
          markerId: markerId,
          qrId: id
        };
        if (this.$store.state.offQrs.find(function (x) {
          return x.qrId == id;
        }) || this.$store.state.markers.find(function (x) {
          return x.qrId == id;
        })) {
          this.warning2 = true;
        } else {
          this.marker.qrId = id;
          this.warning4 = true;
          this.success = true;
          this.dialog = false;
          this.$emit("updateMarker");
        }
      } else {
        this.$http.getMarkerByQRId(id, markerId).then(function (res) {
          _this.marker.qrId = id;
          _this.warning = false;
          _this.success = true;
          _this.dialog = false;
        }).catch(function (err) {
          _this.warning2 = true;
        });
      }
    }
  },
  created: function created() {}
});

/***/ }),
/* 233 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_pose__ = __webpack_require__(210);
//
//
//
//
//
//
//



var transition = {
  duration: 400,
  ease: [0.08, 0.69, 0.2, 0.99]
};

/* harmony default export */ __webpack_exports__["a"] = ({
  props: ['imageWidth', 'imageHeight', 'src'],
  data: function data() {
    return { isZoomed: false };
  },
  computed: {
    pose: function pose() {
      return this.isZoomed ? 'zoomedIn' : 'zoomedOut';
    },
    toggleZoom: function toggleZoom() {
      return this.isZoomed ? this.zoomOut : this.zoomIn;
    }
  },
  methods: {
    zoomIn: function zoomIn() {
      // window.addEventListener('scroll', this.zoomOut);
      this.isZoomed = true;
    },
    zoomOut: function zoomOut() {
      // window.removeEventListener('scroll', this.zoomOut);
      this.isZoomed = false;
    }
  },
  components: {
    Frame: __WEBPACK_IMPORTED_MODULE_0_vue_pose__["a" /* default */].div({
      zoomedOut: {
        applyAtStart: { display: 'none' },
        opacity: 0
      },
      zoomedIn: {
        applyAtStart: { display: 'block' },
        opacity: 1
      }
    }),
    ZoomImage: __WEBPACK_IMPORTED_MODULE_0_vue_pose__["a" /* default */].img({
      zoomedOut: {
        position: 'static',
        width: 'auto',
        height: '360px',
        transition: transition,
        flip: true
      },
      zoomedIn: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        transition: transition,
        flip: true,
        height: 'auto'
      }
    })
  }
});

/***/ }),
/* 234 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_swipe_actions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swipe_actions_dist_vue_swipe_actions_css__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swipe_actions_dist_vue_swipe_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vue_swipe_actions_dist_vue_swipe_actions_css__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  name: "markers",
  components: {
    SwipeOut: __WEBPACK_IMPORTED_MODULE_1_vue_swipe_actions__["b" /* SwipeOut */],
    SwipeList: __WEBPACK_IMPORTED_MODULE_1_vue_swipe_actions__["a" /* SwipeList */]
  },
  props: {
    marker: Object,
    blueprint: Object,
    readonly: Boolean
  },
  data: function data() {
    return {
      showDelete: false,
      selected: undefined,
      isReady: false,
      headers: [{
        text: this.$t("marker"),
        align: "left",
        value: "number"
      }, {
        text: this.$t("status"),
        align: "left",
        value: "isApproved"
      }, { text: "Actions", sortable: false }],
      loading: false,
      markerStatus: 4
    };
  },

  methods: {
    addSolution: function addSolution() {
      var markerXSolution = {
        id: __WEBPACK_IMPORTED_MODULE_0_uuid___default.a.v4(),
        markerId: this.$route.params.id,
        solutionId: null,
        qrLogAttributeXMarkerXSolutions: [],
        unusedAttributes: [],
        attachments: [],
        new: true,
        dimensionDialog: false,
        attributesDialog: false,
        comments: null
      };
      var arr = [];
      for (var i = 0; i < this.$store.state.allAttributes.length; i++) {
        arr.push({
          id: __WEBPACK_IMPORTED_MODULE_0_uuid___default.a.v4(),
          markerXSolutionsId: markerXSolution.id,
          qrLogAttribute: this.$store.state.allAttributes[i],
          qrLogAttributeId: this.$store.state.allAttributes[i].id,
          qrLogAttributeListValue: null,
          qrLogAttributeListValueId: null,
          value: null
        });
      }
      markerXSolution.qrLogAttributeXMarkerXSolutions = arr;
      this.$emit("addMarkerXSolution", markerXSolution);
    },
    deleteMarkerXSolution: function deleteMarkerXSolution(id) {
      var _this = this;

      if (this.marker.markerXSolutions.find(function (x) {
        return x.id == id;
      }).new) {
        this.marker.markerXSolutions = this.marker.markerXSolutions.filter(function (x) {
          return x.id != id;
        });
      } else {
        if (this.$store.state.isOffline) {
          var offForm = {
            deleteMarkerXSolution: id
          };
          this.$store.state.offForm.push(offForm);
        } else {
          this.$http.deleteMarkerXSolution(id).then(function (res) {
            _this.marker.markerXSolutions = _this.marker.markerXSolutions.filter(function (x) {
              return x.id != id;
            });
            _this.$store.commit("updateMarker", _this.marker);
            _this.$noty.success('<i class="fas fa-check"></i>');
          }).catch(function (err) {
            console.log(err);
            _this.$noty.error(_this.$t("error"));
          });
        }
      }
    },
    solutionDetails: function solutionDetails(mxs) {
      this.$emit('open', mxs);
      // this.$router.push({
      //   name: "MarkerXSolutionDetails",
      //   params: {
      //     id: mxs.markerId,
      //     markerXSolutionId: mxs.id,
      //     markerXSolution: mxs,
      //     marker: this.marker,
      //     blueprint: this.blueprint,
      //     readonly: this.readonly
      //   }
      // });
    }
  },
  computed: {
    markerXSolutions: function markerXSolutions() {
      if (this.marker) {
        return this.marker.markerXSolutions;
      }
    }
  },
  watch: {
    marker: function marker(n) {}
  },
  created: function created() {
    if (!this.$store.state.isOffline) {
      var requests = [];

      if (this.$store.state.productSolutions == null) {
        requests.push(this.$http.getProductSolutions(true)());
      }

      this.isReady = true;
    } else {
      this.isReady = true;
    }
  }
});

/***/ }),
/* 235 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_AreYouSure2__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Markers_MarkerXSolutions_List__ = __webpack_require__(83);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    areyousure2: __WEBPACK_IMPORTED_MODULE_1__components_AreYouSure2__["a" /* default */],
    markerXSolutions: __WEBPACK_IMPORTED_MODULE_2__components_pages_Markers_MarkerXSolutions_List__["a" /* default */]
  },
  name: "Reports",
  props: {
    marker: Object
  },
  data: function data() {
    return {
      dialog: false
    };
  },
  methods: {
    addToThisSolution: function addToThisSolution(report, mxs) {
      report.markerXSolutionId = mxs.id;
      report.markerXSolution = this.marker.markerXSolutions.find(function (x) {
        return x.id == report.markerXSolutionId;
      }).solution.name;
      this.$forceUpdate();
    },
    close: function close() {
      this.dialog = false;
    },
    deleteReport: function deleteReport(report) {
      this.marker.reports = this.marker.reports.filter(function (p) {
        return p.id != report.id;
      });
      if (this.marker.reports.length === 0) {
        this.close();
      }
      this.save();
    },
    save: function save() {
      var _this = this;

      this.marker.reports.forEach(function (report) {
        var id = __WEBPACK_IMPORTED_MODULE_0_uuid___default.a.v4();
        if (report.markerXSolutionId) {
          var date = new Date();

          var attachment = {
            id: id,
            markerId: _this.$route.params.id,
            markerXSolutionsId: report.markerXSolutionId,
            name: "report.jpg",
            content: report.image,
            approved: false,
            createdBy: "REPORTED",
            createdTs: date.toJSON(),
            reportId: report.id,
            new: true
          };
          _this.marker.markerXSolutions.find(function (x) {
            return x.id == attachment.markerXSolutionsId;
          }).attachments.unshift(attachment);
          _this.$store.commit("updateMarker", _this.marker);
          _this.marker.reports = _this.marker.reports.filter(function (x) {
            return x.id != report.id;
          });
          _this.$emit("updateMarker");
        }

        _this.dialog = false;
      });
    }
  },
  created: function created() {}
});

/***/ }),
/* 236 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    object: String,
    id: String,
    icon: Boolean,
    button: Boolean,
    fk: String,
    small: Boolean,
    text: String,
    headline: String,
    message: String,
    list_item: Boolean,
    cancelbuttonText: {
      type: String,
      default: 'no'
    },
    actionButtonText: {
      type: String,
      default: 'yes'
    },
    color: {
      type: String,
      default: "error"
    }
  },
  data: function data() {
    return {
      dialog: false
    };
  },

  methods: {
    remove: function remove(id, fk) {
      var _this = this;

      switch (this.object) {
        case "project":
          this.$http.deleteProject(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "buildingComponent":
          this.$http.deleteBuildingComponents(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "blueprint":
          this.$http.deleteBlueprint(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "marker":
          // code block
          this.$http.deleteMarker(id).then(function (rs) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "attachment":
          // code block
          this.$http.deleteAttachment(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "attribute":
          // code block
          this.$http.deleteAttribute(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("deleteAttribute", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "attributeValue":
          // code block
          this.$http.deleteValues(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("deleteValue", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "solution":
          // code block
          break;
        case "solutionXproduct":
          if (fk !== "") {
            this.$http.deleteSolutionXproduct(id, fk).then(function (res) {
              _this.$noty.success('<i class="fas fa-check"></i>');
              _this.$emit("deleteSolutionXproduct", fk);
              _this.dialog = false;
            }).catch(function (err) {
              _this.$noty.error(_this.$t("error"));
              console.log(err);
            });
          }

          break;
        case "installer":
          // code block
          break;
        case "productAttachment":
          this.$http.deleteProductAttachment(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "report":
          this.$http.deleteReport(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
        default:
          this.$emit("delete");
          this.dialog = false;
      }
      this.dialog = false;
    }
  }
});

/***/ }),
/* 237 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_archivedReports_vue__ = __webpack_require__(238);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc6053da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_archivedReports_vue__ = __webpack_require__(555);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_archivedReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cc6053da_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_archivedReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 238 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Reports",
  props: {
    marker: Object
  },
  data: function data() {
    return {
      dialog: false
    };
  },
  methods: {
    close: function close() {
      this.dialog = false;
    }
  },
  created: function created() {}
});

/***/ }),
/* 239 */,
/* 240 */,
/* 241 */,
/* 242 */,
/* 243 */,
/* 244 */,
/* 245 */,
/* 246 */,
/* 247 */,
/* 248 */,
/* 249 */
/***/ (function(module, exports) {

module.exports = {"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}

/***/ }),
/* 250 */,
/* 251 */,
/* 252 */,
/* 253 */,
/* 254 */,
/* 255 */,
/* 256 */
/***/ (function(module, exports) {

module.exports = {"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}

/***/ }),
/* 257 */,
/* 258 */,
/* 259 */,
/* 260 */,
/* 261 */,
/* 262 */,
/* 263 */,
/* 264 */,
/* 265 */,
/* 266 */,
/* 267 */,
/* 268 */,
/* 269 */,
/* 270 */
/***/ (function(module, exports) {

module.exports = {"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}

/***/ }),
/* 271 */,
/* 272 */,
/* 273 */,
/* 274 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_AddQRCode__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_ZoomPicture__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Markers_MarkerXSolutions_List__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Markers_Reports__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Markers_archivedReports__ = __webpack_require__(237);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_pages_Markers_ZoomMarkup__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__services_service_ihub_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_crypto__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_q__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_q__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_pages_Blueprints_IsLocked__ = __webpack_require__(114);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//














var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_10__services_service_ihub_js__["a" /* serviceihub */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "markerDetails",
  components: {
    zoomPicture: __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_ZoomPicture__["a" /* default */],
    addQRCode: __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_AddQRCode__["a" /* default */],
    solutionsList: __WEBPACK_IMPORTED_MODULE_6__components_pages_Markers_MarkerXSolutions_List__["a" /* default */],
    zoomMarkup: __WEBPACK_IMPORTED_MODULE_9__components_pages_Markers_ZoomMarkup__["a" /* default */],
    reports: __WEBPACK_IMPORTED_MODULE_7__components_pages_Markers_Reports__["a" /* default */],
    isLocked: __WEBPACK_IMPORTED_MODULE_13__components_pages_Blueprints_IsLocked__["a" /* default */],
    archivedReports: __WEBPACK_IMPORTED_MODULE_8__components_pages_Markers_archivedReports__["a" /* default */]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.$store.state.hasChanges) {
      if (to.name !== "MarkerXSolutionDetails") {
        this.saveDialog = true;
        //this.$store.state.hasChanges = false;
        this.to = to;
        next(false);
      } else {
        next();
      }
    } else {
      if (to.name != "EditBlueprintsDetails" && to.name != "MarkerXSolutionDetails") {
        if (this.$can("update", "markers")) {
          this.$http.lockBlueprint(this.blueprint.id).then(function (res) {
            if (to.name === "Login") {
              localStorage.removeItem("auth");
              localStorage.removeItem("user");
            }
            next();
          }).catch(function (err) {
            console.log(err);
          });
        } else {
          next();
        }
      } else {
        next();
      }
    }
  },

  props: {
    markerid: String
    //marker: Object
  },
  data: function data() {
    return {
      admin: false,
      dialog: false,
      // installers: null,
      attachment: null,
      loaded: false,
      marker: null,
      menu: false,
      valid: false,
      //productSolutions: "",
      blueprint: null,
      selectedFile: null,
      nameRules: [function (v) {
        return !!v || "Name is required";
      }],
      isLoading: false,
      search: null,
      saveDialog: false,
      to: null,
      loadingText: "",
      showLockedMessage: false
    };
  },

  computed: {
    isOffline: function isOffline() {
      return this.$store.state.isOffline;
    },
    isSyncing: function isSyncing() {
      return this.$store.state.offlineSyncing;
    },
    statusItems: function statusItems() {
      return [{
        id: "0",
        name: this.$t("broken"),
        icon: "priority_high",
        color: "red",
        disabled: false
      }, {
        id: "1",
        name: this.$t("inProcess"),
        icon: "priority_high",
        color: "orange",
        disabled: true
      }, {
        id: "2",
        name: this.$t("approved"),
        icon: "check_circle",
        color: "success",
        disabled: false
      }];
    },
    label: function label() {
      if (this.marker) {
        return this.marker.label;
      }
    }
  },
  methods: {
    openSolution: function openSolution(mxs) {
      this.$router.push({
        name: "MarkerXSolutionDetails",
        params: {
          id: this.marker.id,
          markerXSolutionId: mxs.id,
          markerXSolution: mxs,
          marker: this.marker,
          blueprint: this.blueprint,
          readonly: false
        }
      });
    },
    deleteMarker: function deleteMarker(id) {
      this.$store.state.markers = this.$store.state.markers.filter(function (p) {
        return p.id != id;
      });
      this.$store.state.markersReadonly = [];
      this.$router.push({
        name: "EditBlueprintsDetails",
        params: {
          id: this.blueprint.id,
          blueprint: this.blueprint
        }
      });
    },
    changeStatusMarker: function changeStatusMarker(e) {
      this.$store.state.hasChanges = true;
      this.marker.manualStatus = e;
      this.marker.status = e;
    },
    checkIfBlueprintIsLocked: function checkIfBlueprintIsLocked() {
      if (this.blueprint.isLocked) {
        if (this.blueprint.lockedByUserId != parseInt(__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem("auth")).contactId)) {
          this.$noty.info(this.blueprint.lockedByUserName + "  " + this.$t("blueprintLockedSince") + " " + this.blueprint.lockedTs);

          this.$router.push({
            name: "MarkerDetails",
            params: { id: this.$route.params.id }
          });
        }
      } else {
        this.$router.push({
          name: "MarkerDetails",
          params: { id: this.$route.params.id }
        });
      }
    },
    lockBlueprint: function lockBlueprint() {
      var _this = this;

      if (this.$can("update", "markers")) {
        this.$http.lockBlueprint(this.blueprint.id).then(function (res) {
          if (res.data.lockedByUserId == parseInt(__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem("auth")).contactId)) {
            _this.blueprint.isLocked = res.data.isLocked;
            _this.blueprint.lockedByUserId = res.data.lockedByUserId;
            _this.blueprint.lockedByUserName = res.data.lockedByUserName;
          } else {
            _this.showLockedMessage = true;
          }
        }).catch(function (err) {
          console.log(err);
          _this.$noty.error(_this.$t("error"));
        });
      }
    },
    response: function response(answer) {
      if (answer) {
        this.updateMarker();
        this.$store.state.markerDetailSaved = true;
      } else {
        this.$store.state.markerDetailSaved = false;
        this.$store.state.hasChanges = false;
      }
      this.saveDialog = false;
      // this.$router.push({
      //   name: this.to.name,
      //   params: this.to.params,
      // });
    },
    makeBackButton: function makeBackButton() {
      this.$store.state.previous = {
        name: "EditBlueprintsDetails",
        params: {
          id: this.blueprint.id,
          blueprint: this.blueprint
        },
        id: this.blueprint.id,
        breadcrumb: this.$t("blueprint")
      };
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("projects"),
        to: { name: "Projects" }
      }, {
        name: this.blueprint.project,
        to: {
          name: "ProjectDetails",
          params: { id: this.blueprint.projectId }
        }
      }, {
        name: this.blueprint.buildingComponent,
        to: {
          name: "BuildingComponentDetails",
          params: { id: this.blueprint.buildingComponentId }
        }
      }, {
        name: this.blueprint.name,
        to: {
          name: "EditBlueprintsDetails",
          params: { id: this.blueprint.id }
        }
      }, {
        name: this.$t("marker") + " " + this.marker.number + " " + (this.marker.label ? " - " + this.marker.label : "")
      }];
    },
    selected: function selected(solutionId, _selected) {
      this.marker.markerXSolutions.forEach(function (mxs) {
        if (mxs.solutionId == solutionId) {
          mxs.selectedProducts = _selected.reduce(function (res, x) {
            if (x.selected) {
              var someNewValue = {
                id: __WEBPACK_IMPORTED_MODULE_3_uuid___default.a.v4(),
                markerXSolutionsId: mxs.id,
                productId: x.id
              };
              res.push(someNewValue);
            }
            return res;
          }, []);
        }
      });
    },
    updateMarker: function updateMarker(event) {
      var _this2 = this;

      var fromMxsDetails = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      this.$store.state.markersReadonly = [];
      var markerFromStore = this.$store.getters.markers.find(function (x) {
        return x.id == _this2.$route.params.id;
      });
      //marker changes like adding solutions,images,etc we pass the marker object down to the components.
      //marker position changes are set in the list of markers in the store.

      this.marker.coordX = markerFromStore.coordX;
      this.marker.coordX2 = markerFromStore.coordX2;
      this.marker.coordY = markerFromStore.coordY;
      this.marker.coordY2 = markerFromStore.coordY2;

      if (this.valid) {
        this.$store.state.hasChanges = false;

        if (this.$store.state.isOffline) {
          var offForm = {
            marker: this.marker
          };

          this.$store.commit("addOrUpdateOffForm", offForm);
          this.$noty.warning(this.$t("cached"));
          this.$store.commit("AddAndSetUIelements", this.marker);
        } else {
          if (this.marker.markerXSolutions.some(function (e) {
            return e.solutionId !== null;
          })) {
            this.$http.updateMarker(this.marker).then(function (res) {
              _this2.marker = res.data;
              _this2.$store.commit("AddAndSetUIelements", _this2.marker);
              _this2.$noty.success('<i class="fas fa-check"></i>');

              //change the new markerxsolutions to existing
              _this2.marker.markerXSolutions.forEach(function (mxs) {
                if (mxs.new) delete mxs.new;
                mxs.attachments.forEach(function (attachment) {
                  if (attachment.new) delete attachment.new;
                });
              });
            }).catch(function (err) {
              console.log(err);
              _this2.$noty.error(_this2.$t("error"));
            });
          } else {
            this.$noty.warning(this.$t("selectsolution"));
          }
        }
      } else {
        this.$noty.warning(this.$t("fillinrequiredfields"));
      }
    },
    addSolution: function addSolution(newSolution) {
      var _this3 = this;

      this.$http.addSolution(newSolution).then(function (res) {
        _this3.$store.state.productSolutions.push(res.data);
        _this3.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this3.$noty.error(_this3.$t("error"));
        console.log(err);
      });
    },
    canDelete: function canDelete(date) {
      if (date.substring(0, 10) == new Date().toLocaleDateString("fr-CA"))
        //yyyy-MM-dd
        return true;else return false;
    },
    getProductSolutions: function getProductSolutions() {
      var _this4 = this;

      if (this.$store.state.productSolutions == null) {
        this.$http.getProductSolutions(true).then(function (res) {
          _this4.$store.state.productSolutions = res.data;
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    addMarkerXSolution: function addMarkerXSolution(markerXSolution) {
      var _this5 = this;

      this.marker.markerXSolutions.push(markerXSolution);
      setTimeout(function () {
        _this5.$router.push({
          name: "MarkerXSolutionDetails",
          params: {
            id: _this5.marker.id,
            markerXSolutionId: markerXSolution.id,
            markerXSolution: markerXSolution,
            marker: _this5.marker,
            blueprint: _this5.blueprint,
            readonly: false
          }
        });
      }, 500);
    },
    updatePosition: function updatePosition(marker) {
      this.marker.coordX2 = marker.coordX2;
      this.marker.coordY2 = marker.coordY2;
      this.marker.coordX = marker.coordX;
      this.marker.coordY = marker.coordY;
    },
    getAllAttributesAndSaveInStore: function getAllAttributesAndSaveInStore() {
      var _this6 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this6.$store.state.allAttributes == null)) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this6.$http.getAttributes(false, true);

              case 4:
                res = _context.sent;

                _this6.$store.state.allAttributes = res.data;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this6, [[1, 8]]);
      }))();
    }
  },
  watch: {
    marker: function marker(n, o) {
      console.log("Watching marker now...");

      if (n != null || n != undefined) {
        if (n.installerId == null) {
          this.marker.installerId = parseInt(__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem("auth")).contactId);
        }
      }
    },
    isSyncing: function isSyncing(n, o) {
      var _this7 = this;

      if (!n && o === true) {
        this.marker = this.$store.state.markers.find(function (x) {
          return x.id == _this7.$route.params.id;
        });
      }
    },
    blueprint: function blueprint(n, o) {
      if (n) {
        if (n.isArchived) {
          this.$router.push({
            name: "ArchivedBlueprintsDetails",
            params: { id: n.id }
          });
        }
      }
    },
    label: function label(n, o) {
      if (o && n !== o) {
        this.$store.state.hasChanges = true;
      }
    }
  },
  created: function created() {
    var _this8 = this;

    if (this.$store.state.isOffline) {
      this.marker = this.$store.state.markers.find(function (x) {
        return x.id == _this8.$route.params.id;
      });
      this.blueprint = this.$route.params.blueprint;
      this.makeBackButton();
      if (this.$route.params.saveMarker) {
        this.$nextTick(function () {
          _this8.updateMarker();
          _this8.$route.params.saveMarker;
        });
      } else if (this.$route.params.deleteMarkerXSolution) {
        this.marker = this.$route.params.deleteMarkerXSolution;
        this.$store.commit("AddAndSetUIelements", this.marker);
      }

      this.checkIfBlueprintIsLocked();
    } else {

      this.getAllAttributesAndSaveInStore();
      this.marker = this.$route.params.marker;
      this.blueprint = this.$route.params.blueprint;
      if (this.marker === undefined) {

        this.$http.getMarker(this.$route.params.id).then(function (res) {
          _this8.marker = res.data;
          _this8.$store.state.markers = [];
          _this8.$store.commit("AddAndSetUIelements", res.data);
          _this8.$http.getBlueprint(_this8.marker.blueprintId).then(function (res) {
            _this8.blueprint = res.data;
            _this8.makeBackButton();
            _this8.makeBreadcrumb();
            _this8.checkIfBlueprintIsLocked();
          }).catch(function (err) {
            return console.log(err);
          });
        });
      } else {

        this.makeBackButton();
        this.makeBreadcrumb();
        if (this.$route.params.saveMarker) {
          this.$nextTick(function () {
            _this8.updateMarker(null, true);
          });
        }

        this.checkIfBlueprintIsLocked();
      }

      this.getProductSolutions();
    }
  }
});

/***/ }),
/* 275 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_Solutions_AddSolution__ = __webpack_require__(645);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_Solutions_PIMSolutions__ = __webpack_require__(657);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_EmptyList_vue__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Retry_vue__ = __webpack_require__(31);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  components: { addSolution: __WEBPACK_IMPORTED_MODULE_0__components_pages_Solutions_AddSolution__["a" /* default */], PIMSolutions: __WEBPACK_IMPORTED_MODULE_1__components_pages_Solutions_PIMSolutions__["a" /* default */], emptyList: __WEBPACK_IMPORTED_MODULE_2__components_EmptyList_vue__["a" /* default */],
    retry: __WEBPACK_IMPORTED_MODULE_3__components_Retry_vue__["a" /* default */] },
  data: function data() {
    return {
      items: null,
      loading: true,
      retry: false,
      searchtable: null,
      searchCustomeSolution: "",
      search: null,
      headers: [{
        text: this.$t("name"),
        value: "name"
      }],
      emptyImage: __webpack_require__(18)
    };
  },

  computed: {
    filteredItems: function filteredItems() {
      var _this = this;

      return this.items.filter(function (item) {
        return item.name.toLowerCase().includes(_this.searchCustomeSolution.toLowerCase());
      });
    }
  },
  methods: {
    addSolution: function addSolution(newSolution) {
      var _this2 = this;

      this.$http.addSolution(newSolution).then(function (res) {
        _this2.items.push(res.data);
        _this2.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this2.$noty.error(_this2.$t("error"));
        console.log(err);
      });
    },
    getCustomSolutions: function getCustomSolutions() {
      var _this3 = this;

      this.$http.getProductSolutions().then(function (res) {
        _this3.items = res.data;
        console.log(_this3.items);
        _this3.loading = false;
        _this3.retry = false;
      }).catch(function (err) {
        _this3.loading = false;
        _this3.retry = true;
        console.log(err);
      });
    },
    goToDetails: function goToDetails(item) {
      this.$router.push({
        name: "SolutionDetails",
        params: { id: item.id }
      });
    }
  },
  created: function created() {
    this.getCustomSolutions();
    this.$store.state.previous = null;
    this.$store.state.breadcrumb = null;
  }
});

/***/ }),
/* 276 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__(221);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_uuid__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  name: "addProductSolution",
  data: function data() {
    return {
      show: false,
      dialog: false,
      name: null,
      product: null,
      valid: true,
      products: [],
      items: [],
      search: null,
      file: null,
      solutionAttachment: []
    };
  },
  methods: {
    addAttachment: function addAttachment() {
      this.solutionAttachment.push(this.file);
      this.file = null;
    },
    changeAttachment: function changeAttachment() {
      this.file = this.$refs.file.files[0];
      this.addAttachment();
    },
    close: function close() {
      this.dialog = false;
    },
    rules: function rules() {
      var _this = this;

      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$t('name');

      var rules = [function (v) {
        return !!v || property + " " + _this.$t("required");
      }, function (v) {
        return v && v.length <= 512 || "";
      }];
      return rules;
    },
    counterRules: function counterRules() {
      return [function (v) {
        return v && v.length <= 50 || "";
      }];
    },
    listRules: function listRules() {
      if (!this.products.length > 0) {
        return [this.$t("name") + " " + this.$t("list")];
      }
    },
    add: function add() {
      var _this2 = this;

      //   if (this.product.id) {
      //     const product = {
      //       id: this.product.id,
      //       name: this.product.name
      //     };
      //     if (!this.products.map(x => x.id).includes(this.product.id))
      //       this.products.push(product);
      //     this.product = null;
      //   } else {
      //     const product = {
      //       id: uuid.v4(),
      //       name: this.product
      //     };
      //     if (!this.products.map(x => x.name).includes(this.product))
      //       this.products.push(product);
      //     this.product = "";
      //   }
      setTimeout(function () {
        if (_this2.product) {
          if (typeof _this2.product === "string") {
            _this2.products.push({
              id: __WEBPACK_IMPORTED_MODULE_2_uuid___default.a.v4(),
              name: _this2.product
            });
            _this2.product = null;
          } else if (__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_typeof___default()(_this2.product) === "object") {
            _this2.products.push({
              id: _this2.product.id,
              name: _this2.product.name,
              isPIM: true
            });
            _this2.product = null;
          }
        }
      }, 10);
    },
    save: function save() {
      if (this.$refs.form.validate()) {
        var newSolution = {
          id: __WEBPACK_IMPORTED_MODULE_2_uuid___default.a.v4(),
          name: this.name,
          IsSolution: true,
          published: true,
          products: this.products
          // productAttachments: this.solutionAttachment
        };
        var form = new FormData();
        this.solutionAttachment.forEach(function (attachment) {
          form.append("productAttachments", attachment);
        });

        form.append("solution", __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(newSolution));

        this.$emit("add-solution", form);
        this.name = null;
        this.products = null;
        this.solutionAttachment = null;
        this.close();
      }
    },
    remove: function remove(id) {
      this.products = this.products.filter(function (v) {
        return v.id != id;
      });
    },
    removeAttachment: function removeAttachment(index) {
      this.solutionAttachment = this.solutionAttachment.filter(function (v, i) {
        return i != index;
      });
    }
  },
  watch: {
    search: function search(s) {
      var _this3 = this;

      if (s && s.length > 1) {
        this.$http.getProducts(true, s).then(function (res) {
          _this3.items = res.data;
        }).catch(function (err) {
          console.log(err);
        });
      }
    }
  }
});

/***/ }),
/* 277 */,
/* 278 */,
/* 279 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_pages_solutions_PIMSolutionDetails__ = __webpack_require__(143);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    pimSolutionDetails: __WEBPACK_IMPORTED_MODULE_0__components_pages_solutions_PIMSolutionDetails__["a" /* default */]
  },
  data: function data() {
    return {
      dialog: false,
      items: [],
      searchtable: null,
      search: "",
      headers: [{
        text: this.$t("name"),
        value: "name"
      }, {
        text: this.$t("active"),
        value: "published"
      }],
      selectedSolutionId: null,
      selectedSolutionName: null
    };
  },

  computed: {
    filteredItems: function filteredItems() {
      var _this = this;

      return this.items.filter(function (item) {
        return item.name.toLowerCase().includes(_this.search.toLowerCase());
      });
    }
  },
  methods: {
    openSolutionDetails: function openSolutionDetails(item) {
      this.selectedSolutionId = item.id, this.selectedSolutionName = item.name;
      this.$forceUpdate();
      this.dialog = true;
    },
    hidePIMSolution: function hidePIMSolution(item) {
      var _this2 = this;

      console.log(item);
      if (item.published) {
        this.$http.unhidePIMSolution(item.id).then(function (res) {
          _this2.$noty.success('<i class="fas fa-check"></i>');
        }).catch(function (err) {
          console.log(err);
          _this2.$noty.error(_this2.$t("error"));
        });
      } else {
        this.$http.hidePIMSolution(item.id).then(function (res) {
          _this2.$noty.success('<i class="fas fa-check"></i>');
        }).catch(function (err) {
          console.log(err);
          _this2.$noty.error(_this2.$t("error"));
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.getPIMProductSolutions().then(function (res) {
      _this3.items = res.data;
    }).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),
/* 280 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service_oryx_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Markers_ZoomPicture__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "selectedSolutionComponent",
  components: {
    zoomPicture: __WEBPACK_IMPORTED_MODULE_2__components_pages_Markers_ZoomPicture__["a" /* default */]
  },
  props: {
    id: String,
    name: String
  },
  data: function data() {
    return {
      data: null,
      loading: false,
      error: false
    };
  },

  watch: {
    id: function id() {

      this.getSelectedSolution();
    }
  },
  created: function created() {
    this.getSelectedSolution();
  },

  methods: {
    backToSolutionList: function backToSolutionList() {
      //send message to parent to clear selected solution
      this.$emit("back");
    },
    getSelectedSolution: function getSelectedSolution() {
      var _this = this;

      this.data = null;
      var params = {
        solutionId: this.id,
        tax263415Id: null,
        companyId: __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(localStorage.getItem("auth")).companyId,
        lc: localStorage.getItem("language")
      };

      __WEBPACK_IMPORTED_MODULE_0__services_service_oryx_js__["a" /* default */].getSelectedSolution(params).then(function (res) {
        _this.data = res.data;
        _this.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this.loading = false;
        _this.error = true;
      });
    }
  }
});

/***/ }),
/* 281 */,
/* 282 */,
/* 283 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(277);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vue_swipe_actions__ = __webpack_require__(120);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_swipe_actions_dist_vue_swipe_actions_css__ = __webpack_require__(122);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_swipe_actions_dist_vue_swipe_actions_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vue_swipe_actions_dist_vue_swipe_actions_css__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.hasChanges) {
      if (this.$can("update", "solutions")) {
        this.saveDialog = true;
        this.hasChanges = false;
        this.to = to;
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },

  components: {
    SwipeOut: __WEBPACK_IMPORTED_MODULE_2_vue_swipe_actions__["b" /* SwipeOut */],
    SwipeList: __WEBPACK_IMPORTED_MODULE_2_vue_swipe_actions__["a" /* SwipeList */]
  },
  data: function data() {
    var _this = this;

    return {
      solution: null,
      products: [],
      nameRules: [function (v) {
        return !!v || _this.$t("name") + " " + _this.$t("required");
      }, function (v) {
        return v.length <= 50 || "";
      }],
      file: null,
      searchtable: null,
      product: "",
      search: null,
      pimProducts: [],
      hasChanges: false,
      selectedSolution: null,
      selectedProduct: null,
      items: [],
      showDelete: false,
      valid: false,
      valid2: false,
      emptyImage: __webpack_require__(18),
      saveDialog: false,
      to: null
    };
  },

  methods: {
    makeBackButton: function makeBackButton() {
      this.$store.state.previous = {
        name: "Solutions",
        breadcrumb: this.$t("solutions")
      };
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("customsolutions"),
        to: { name: "Solutions" }
      }, {
        name: this.solution.name
      }];
    },
    goToProductDetails: function goToProductDetails(item) {
      if (!item.isPIM) {
        this.$router.push({
          name: "ProductDetails",
          params: {
            id: item.id,
            solutionId: this.solution.id,
            solutionName: this.solution.name
          }
        });
      }
    },
    changeAttachment: function changeAttachment() {
      this.file = this.$refs.file.files[0];
    },
    uploadAttachment: function uploadAttachment() {
      var _this2 = this;

      var form = new FormData();
      form.append("attachment", this.file);
      form.append("solutionId", this.solution.id);
      this.$http.uploadAttachment(form).then(function (res) {
        _this2.solution.productAttachments.push(res.data);
        _this2.file = null;
        _this2.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this2.$noty.error(_this2.$t("error"));
        console.log(err);
      });
    },
    warning: function warning() {
      if (this.hasChanges) {
        this.saveDialog = true;
      }
    },
    response: function response(answer, callback) {
      if (answer) {
        callback();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params
      });
    },
    deleteProduct: function deleteProduct(id) {
      this.products = this.products.filter(function (x) {
        return x.id != id;
      });
    },
    deleteProductAttachment: function deleteProductAttachment(id) {
      this.solution.productAttachments = this.solution.productAttachments.filter(function (x) {
        return x.id != id;
      });
    },
    setSolutionImage: function setSolutionImage(output) {
      this.solution.image = output.dataUrl;
      // this.hasChanges = true;
    },
    add: function add() {
      var _this3 = this;

      if (this.product && this.valid2) {
        if (typeof this.product === "string") {
          this.$http.addProduct(this.solution.id, {
            id: __WEBPACK_IMPORTED_MODULE_1_uuid___default.a.v4(),
            name: this.product
          }).then(function (res) {
            _this3.$noty.success('<i class="fas fa-check"></i>');
            _this3.products.push(res.data);
          }).catch(function (err) {
            console.log(err);
            _this3.$noty.error(_this3.$t("error"));
          });
          this.product = null;
        } else if (__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(this.product) === "object") {
          this.$http.addProduct(this.solution.id, {
            id: this.product.id,
            name: this.product.name,
            isPIM: this.product.isPIM
          }).then(function (res) {
            _this3.$noty.success('<i class="fas fa-check"></i>');
            _this3.products.push(res.data);
          }).catch(function (err) {
            console.log(err);
            _this3.$noty.error(_this3.$t("error"));
          });
          this.product = null;
        }
      }
    },
    addSolution: function addSolution(newSolution) {
      var _this4 = this;

      this.$http.addSolution(newSolution).then(function (res) {
        _this4.items.push(newSolution);
        _this4.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this4.$noty.error(_this4.$t("error"));
        console.log(err);
      });
    },
    save: function save() {
      var _this5 = this;

      if (this.solution) {
        this.$http.updateSolution(this.solution).then(function (res) {
          _this5.$noty.success('<i class="fas fa-check"></i>');
          _this5.hasChanges = false;
        }).catch(function (err) {
          console.log(err);
          _this5.$noty.error(_this5.$t("error"));
        });
      }
    },
    getProductById: function getProductById() {
      var _this6 = this;

      this.$http.getProductById(this.$route.params.id).then(function (res) {
        _this6.solution = res.data;
        _this6.getProductsBySolutionId();
        _this6.makeBackButton();
        _this6.makeBreadcrumb();
      }).catch(function (err) {
        console.log(err);
      });
    },
    getProductsBySolutionId: function getProductsBySolutionId() {
      var _this7 = this;

      this.$http.getProductsBySolutionId(this.solution.id, true).then(function (res) {
        _this7.products = res.data;
        // this.getProductsBySolutionId();
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  created: function created() {
    this.getProductById();
  },

  watch: {
    solution: {
      handler: function handler(n, o) {
        if (o != null) {
          this.hasChanges = true;
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 284 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.hasChanges) {
      if (this.$can('update', 'solutions')) {
        this.saveDialog = true;
        this.hasChanges = false;
        this.to = to;
        next(false);
      } else {
        next();
      }
    } else {
      next();
    }
  },
  data: function data() {
    var _this = this;

    return {
      product: null,
      nameRules: [function (v) {
        return !!v || _this.$t("name") + ' ' + _this.$t("required");
      }, function (v) {
        return v.length <= 50 || "";
      }],
      hasChanges: false,
      valid: false,
      valid2: false,
      emptyImage: __webpack_require__(18),
      saveDialog: false,
      to: null
    };
  },

  methods: {
    makeBackButton: function makeBackButton() {
      this.$store.state.previous = {
        name: "SolutionDetails",
        id: this.$route.params.solutionId,
        breadcrumb: this.$t("solution")
      };
    },
    makeBreadcrumb: function makeBreadcrumb() {
      if (this.$route.params.solutionName) {
        this.$store.state.breadcrumb = [{
          name: this.$t("customsolutions"),
          to: { name: "Solutions" }
        }, {
          name: this.$route.params.solutionName,
          to: {
            name: "SolutionDetails",
            params: {
              id: this.$route.params.solutionId
            }
          }
        }, {
          name: this.product.name
        }];
      }
    },
    warning: function warning() {
      if (this.hasChanges) {
        this.saveDialog = true;
      }
    },
    response: function response(answer, callback) {
      if (answer) {
        callback();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params
      });
    },
    setSolutionImage: function setSolutionImage(output) {
      this.product.image = output.dataUrl;
    },
    save: function save() {
      var _this2 = this;

      if (this.product) {
        this.$http.updateSolution(this.product).then(function (res) {
          _this2.$noty.success('<i class="fas fa-check"></i>');
          _this2.hasChanges = false;
        }).catch(function (err) {
          console.log(err);
          _this2.$noty.error(_this2.$t("error"));
        });
      }
    },
    getProductById: function getProductById() {
      var _this3 = this;

      this.$http.getProductById(this.$route.params.id).then(function (res) {
        _this3.product = res.data;
        _this3.makeBackButton();
        _this3.makeBreadcrumb();
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  created: function created() {
    this.getProductById();
  },

  watch: {
    product: {
      handler: function handler(n, o) {
        if (o != null) {
          this.hasChanges = true;
        }
      },

      deep: true
    }
  }
});

/***/ }),
/* 285 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__ = __webpack_require__(64);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_QR_Solutions__ = __webpack_require__(674);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Pages_Authentication_Login__ = __webpack_require__(172);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__services_service_ihub_js__ = __webpack_require__(27);



//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_5__services_service_ihub_js__["a" /* serviceihub */]();
/* harmony default export */ __webpack_exports__["a"] = ({
  name: "QR",
  components: {
    solutions: __WEBPACK_IMPORTED_MODULE_3__components_pages_QR_Solutions__["a" /* default */],
    login: __WEBPACK_IMPORTED_MODULE_4__components_Pages_Authentication_Login__["a" /* default */]
    // zoomMarkup,
  },
  data: function data() {
    return {
      valid: true,
      validForm: false,
      payload: null,
      dialog: false,
      status: "NOK",
      comment: null,
      name: null,
      company: null,
      email: null,
      hasImage: false,
      image: null,
      reported: false,
      loginDialog: false,
      reports: [],
      customer: null
      // blueprint: null
    };
  },

  methods: {
    getCustomer: function getCustomer() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee() {
        var _ref, data;

        return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                _context.next = 3;
                return _serviceIhub.getCustomer(_this.payload.marker.customerId);

              case 3:
                _ref = _context.sent;
                data = _ref.data;

                _this.customer = data;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](0);

                console.log(err);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this, [[0, 8]]);
      }))();
    },
    changeLanguage: function changeLanguage(language) {
      this.$i18n.locale = language;
      localStorage.setItem("language", language);
      this.$router.go();
    },
    fromCodePoint: function fromCodePoint(codepoint) {
      if (codepoint.split(" ").length > 0) {
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[0]) + __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint.split(" ")[1]);
      }
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_string_from_code_point___default()(codepoint);
    },

    setImage: function setImage(output) {
      this.hasImage = true;
      this.image = output.dataUrl;
    },
    rules: function rules() {
      var _this2 = this;

      var property = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.$t("name");

      var rules = [function (v) {
        return !!v || property + " " + _this2.$t("required");
      }, function (v) {
        return v && v.length <= 512 || "";
      }];
      return rules;
    },
    addReport: function addReport() {
      var _this3 = this;

      this.$nextTick(function () {
        if (_this3.$refs.form.validate()) {
          var date = new Date();
          var report = {
            markerId: _this3.payload.marker.id,
            status: _this3.status,
            name: _this3.name,
            company: _this3.company,
            email: _this3.email,
            comment: _this3.comment,
            image: _this3.image,
            date: date.toJSON()
          };

          _this3.$http.addReport(report).then(function (res) {
            // this.marker = res.data;
            _this3.$noty.success('<i class="fas fa-check"></i>');
            _this3.dialog = false;
            // sessionStorage.setItem("reported", true);
            _this3.reported = true;
            _this3.reports.push(report);
          }).catch(function (err) {
            console.log(err);
            _this3.$noty.error(err);
          });
        }
      });
    }
  },
  mounted: function mounted() {
    if (sessionStorage.getItem("reported") != null) {
      this.reported = true;
    }
  },
  created: function created() {
    var _this4 = this;

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.mark(function _callee2() {
      var lc;
      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              lc = localStorage.getItem("language");

              if (lc === null) lc = "EN";
              _this4.$http.getMarkerId(_this4.$route.params.id, lc).then(function (res) {
                if (_this4.$store.state.loggedIn) {
                  _this4.$router.push({
                    name: "MarkerDetails",
                    params: { id: res.data.marker.id }
                  });
                } else {
                  _this4.payload = res.data;
                  _this4.getCustomer();
                  _this4.loginDialog = true;
                }
              }).catch(function (err) {
                _this4.valid = false;
              });

            case 3:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, _this4);
    }))();
  }
});

/***/ }),
/* 286 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Products__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Markers_ZoomPicture__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    marker: Object,
    allAttributes: Object
  },
  components: {
    products: __WEBPACK_IMPORTED_MODULE_1__components_Products__["a" /* default */],
    zoomPicture: __WEBPACK_IMPORTED_MODULE_2__components_pages_Markers_ZoomPicture__["a" /* default */]
  },
  data: function data() {
    return {
      active: null,
      attributes: [],
      dialog: false,
      img: null,
      showDelete: false,
      isShowing: false,
      unusedAttributes: null,
      options: {
        duration: 300,
        easing: "easeInOutCubic",
        offset: 0
      },
      dimensionDialog: false,
      attributesDialog: false,
      emptyImage: __webpack_require__(18)
    };
  },

  computed: {
    markerXSolutions: function markerXSolutions() {
      if (this.marker.markerXSolutions) {
        this.marker.markerXSolutions.forEach(function (mxs) {
          mxs.product = mxs.solution.image;
          try {
            mxs.qrLogAttributeXMarkerXSolutions.sort(function (a, b) {
              return a.qrLogAttribute.index > b.qrLogAttribute.index ? 1 : b.qrLogAttribute.index > a.qrLogAttribute.index ? -1 : 0;
            });
          } catch (error) {}
        });
      }
      return this.marker.markerXSolutions;
    }
  },
  methods: {
    attributesToString: function attributesToString(mxs) {
      var _this = this;

      var text = "";

      mxs.qrLogAttributeXMarkerXSolutions.forEach(function (x) {
        if (_this.allAttributes.some(function (f) {
          return f.id == x.qrLogAttributeId;
        })) {
          if (!x.value) {
            var attribute = _this.allAttributes.filter(function (f) {
              return f.id == x.qrLogAttributeId;
            })[0].qrLogAttributeListValue.find(function (z) {
              return z.id == x.qrLogAttributeListValueId;
            });
            if (attribute) {
              text += "<small class=\"subtitle-2\">" + _this.allAttributes.filter(function (f) {
                return f.id == x.qrLogAttributeId;
              })[0].code + "</small>: " + attribute.description + ", ";
            }
          } else {
            text += _this.allAttributes.filter(function (f) {
              return f.id == x.qrLogAttributeId;
            })[0].code + ": " + x.value + ", ";
          }
        }
      });
      // this.changeImage();
      return text;
    },
    dimensionsToString: function dimensionsToString(mxs) {
      var html = "";
      if (mxs.amount != undefined) {
        html += "<small class=\"subtitle-2\">" + this.$t("amount") + "</small>: " + mxs.amount + ",";
      }
      if (mxs.unit != undefined) {
        html += "<small class=\"subtitle-2\"> " + this.$t("unit") + "\n        </small>: " + mxs.unit + ",";
      }
      if (mxs.width != undefined) {
        html += "<small class=\"subtitle-2\"> " + this.$t("width") + "</small>: " + mxs.width + ",";
      }
      if (mxs.height != undefined) {
        html += "<small class=\"subtitle-2\">" + this.$t("height") + "</small>: " + mxs.height + ",";
      }
      if (mxs.length != undefined) {
        html += "<small class=\"subtitle-2\">" + this.$t("length") + "</small>: " + mxs.length + ",";
      }
      if (mxs.diameter != undefined) {
        html += this.$t("diameter") + ": " + mxs.diameter;
      }
      return html;
    },
    selected: function selected(solutionId, _selected) {
      this.$emit("selected", solutionId, _selected);
    },
    setActive: function setActive(mxs) {
      var _this2 = this;

      this.markerXSolutions.filter(function (x, i) {
        if (x.id == mxs.id) _this2.active = i;
      });
      this.$forceUpdate();
    },
    zoomPicture: function zoomPicture(img) {
      this.img = img;
      this.dialog = true;
    },
    created: function created() {}
    // });

    // watch: {
    //   markerXSolutions(n, o) {
    //     if (o.length > 0 && n.length == 0 && this.$store.state.hasChanges) {
    //       this.$store.state.hasChanges = false;
    //     }
    //   }
    // }

  }
});

/***/ }),
/* 287 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Products",
  props: {
    readonly: Boolean,
    productSolutionId: null,
    selectedProducts: null
  },
  watch: {
    productSolutionId: function productSolutionId() {
      this.products = [];
      this.getProducts(true);
    },
    products: function products() {}
  },
  data: function data() {
    return {
      products: [],
      empty: false,
      emptyImage: __webpack_require__(18)
    };
  },

  methods: {
    getProducts: function getProducts() {
      var _this = this;

      this.empty = false;
      if (this.productSolutionId) {
        this.$http.getProductsBySolutionId(this.productSolutionId, true).then(function (res) {
          _this.products = res.data;
          if (res.data.length == 0) _this.empty = true;else _this.empty = false;

          _this.products.forEach(function (p) {
            if (_this.selectedProducts) {
              _this.selectedProducts.forEach(function (s) {
                if (p.id == s.productId) {
                  p.selected = true;
                }
              });
            }
          });
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    nameFormat: function nameFormat(name) {
      if (name.length > 10) return name.slice(0, 10) + "...";else return name;
    },
    select: function select(productId) {
      if (!this.readonly) {
        this.products.forEach(function (o) {
          if (o.id == productId) {
            if (o.selected) {
              o.selected = !o.selected;
            } else {
              o.selected = true;
            }
          }
        });

        this.$emit("selected", this.productSolutionId, this.products.filter(function (x) {
          return x.selected != undefined;
        }));
        this.$forceUpdate();
        this.$store.state.hasChanges = true;
      }
    }
  },
  created: function created() {
    this.loading = true;
    this.getProducts(true);
  }
});

/***/ }),
/* 288 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_ihub_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha256__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sha256__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Users_Customer__ = __webpack_require__(682);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Users_Storage__ = __webpack_require__(290);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_1__services_service_ihub_js__["a" /* serviceihub */]();




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    customer: __WEBPACK_IMPORTED_MODULE_3__components_pages_Users_Customer__["a" /* default */],
    storage: __WEBPACK_IMPORTED_MODULE_4__components_pages_Users_Storage__["a" /* default */]
  },
  data: function data() {
    return {
      dialog: false,
      id: null,
      firstName: null,
      name: null,
      login: null,
      contactEmail: null,
      show: false,
      valid: false,
      validpswd: false,
      currentpwd: null,
      newpwd: null,
      confirmpwd: null,
      password: null
    };
  },
  created: function created() {
    this.id = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(localStorage.getItem("auth")).contactId;
    this.firstName = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(localStorage.getItem("auth")).given_name;
    this.name = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(localStorage.getItem("auth")).family_name;
    this.login = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(localStorage.getItem("auth")).sub;
    this.contactEmail = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(localStorage.getItem("auth")).email;
  },

  methods: {
    emailRules: function emailRules() {
      return [function (v) {
        return !!v || "";
      }, function (v) {
        var pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        return pattern.test(v) || "";
      }];
    },
    changePassword: function changePassword() {
      var _this = this;

      var o = {
        id: this.id,
        currentpwd: __WEBPACK_IMPORTED_MODULE_2_sha256___default()(this.currentpwd),
        newpwd: __WEBPACK_IMPORTED_MODULE_2_sha256___default()(this.newpwd),
        ihubApplicationId: 2
      };

      _serviceIhub.updateCustomerContactPassword(o).then(function (res) {
        if (res.data) {
          _this.$noty.success('<i class="fas fa-check"></i>');
          _this.dialog = false;
        } else {
          _this.$noty.error(_this.$t("userNotFound"));
        }
      }).catch(function (err) {
        _this.$noty.error(_this.$t("error"));
        console.log(err);
      });
    },
    submit: function submit() {
      var _this2 = this;

      if (this.valid && this.$refs.form.validate()) {
        var user = {
          id: this.id,
          name: this.name,
          firstName: this.firstName,
          login: this.login,
          email: this.contactEmail,
          CustomerContactId: this.id
        };
        this.$http.updateCustomerContact(user).then(function (res) {
          localStorage.removeItem("auth");
          localStorage.removeItem("user");
          localStorage.setItem("auth", res.data);
          localStorage.setItem("user", _this2.firstName + " " + _this2.name);
          _this2.$noty.success('<i class="fas fa-check"></i>');
          window.location = "/";
        }).catch(function (err) {
          _this2.$noty.error(err);
        });
      }
    }
  }
});

/***/ }),
/* 289 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__services_service_ihub_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Retry__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Users_Storage__ = __webpack_require__(290);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_1__services_service_ihub_js__["a" /* serviceihub */]();


/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    retry: __WEBPACK_IMPORTED_MODULE_2__components_Retry__["a" /* default */],
    storage: __WEBPACK_IMPORTED_MODULE_3__components_pages_Users_Storage__["a" /* default */]
  },
  data: function data() {
    return {
      emptyImage: __webpack_require__(18),
      customer: null,
      retry: false,
      loading: false
    };
  },
  created: function created() {
    this.getCustomer();
  },

  methods: {
    getCustomer: function getCustomer() {
      var _this = this;

      this.loading = true;
      _serviceIhub.getCustomer(__WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(localStorage.getItem("auth")).customerId).then(function (res) {
        _this.retry = false;
        _this.customer = res.data;
        _this.loading = false;
      }).catch(function (err) {
        _this.loading = false;
        _this.retry = true;
        console.log(err);
      });
    },
    setCustomerLogo: function setCustomerLogo(output) {
      this.customer.Logo = output.dataUrl;
    },
    saveCustomer: function saveCustomer() {
      var _this2 = this;

      if (this.customer) {
        _serviceIhub.updateCustomer(this.customer).then(function (res) {
          _this2.$noty.success(_this2.$t("success"));
        }).catch(function (res) {
          _this2.$noty.error(_this2.$t("error"));
        });
      }
    }
  }
});

/***/ }),
/* 290 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Storage_vue__ = __webpack_require__(291);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0974eabb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Storage_vue__ = __webpack_require__(686);
function injectStyle (ssrContext) {
  __webpack_require__(685)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0974eabb"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Storage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0974eabb_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Storage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 291 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Retry__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_AreYouSure2__ = __webpack_require__(126);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    retry: __WEBPACK_IMPORTED_MODULE_1__components_Retry__["a" /* default */],
    areyousure2: __WEBPACK_IMPORTED_MODULE_2__components_AreYouSure2__["a" /* default */]
  },
  data: function data() {
    return {
      licnese: "",
      usedStorage: 0,
      storageLimit: 0,
      customerLimit: 40000,
      retry: false,
      selectedUpgradeStorage: null,
      hasRequested: false,
      storageUpgrades: []
    };
  },

  computed: {
    usedStorageInPercentage: function usedStorageInPercentage() {
      return this.usedStorage / this.storageLimit * 100;
    }
  },
  methods: {
    getUnprocessedRequest: function getUnprocessedRequest() {
      var _this = this;

      this.$http.getUnprocessedRequest().then(function (res) {
        if (res.data.length > 0) {
          _this.hasRequested = true;
        }
      }).catch(function (err) {
        console.log(err);
      });
    },
    getLicenseInfo: function getLicenseInfo() {
      var _this2 = this;

      this.$http.getLicenseInfo().then(function (res) {
        _this2.usedStorage = parseFloat(res.data.replace(",", ""));
        _this2.retry = false;
      }).catch(function (err) {
        console.log(err);
        _this2.retry = true;
      });
    },
    getStorageUpgrades: function getStorageUpgrades() {
      var _this3 = this;

      this.$http.getStorageUpgrades().then(function (res) {
        _this3.storageUpgrades = res.data;
      }).catch(function (err) {
        console.log(err);
      });
    },
    upgradeStorage: function upgradeStorage() {
      var _this4 = this;

      if (this.selectedUpgradeStorage == null) return;
      this.$http.upgradeStorage(this.storageUpgrades[this.selectedUpgradeStorage]).then(function (res) {
        localStorage.setItem("auth", res.data);
        _this4.$router.go();
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  watch: {
    selectedUpgradeStorage: function selectedUpgradeStorage(n, o) {
      console.log(n, o);
      if (n != null) {
        this.storageUpgrades[n].color = true;
      }if (o != null) {
        this.storageUpgrades[o].color = false;
      }
    }
  },
  created: function created() {
    this.licnese = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(localStorage.getItem("auth")).license.QRLOG.license;
    this.storageLimit = __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(localStorage.getItem("auth")).license.QRLOG.storageLimit;
    this.getLicenseInfo();
    this.getStorageUpgrades();
  }
});

/***/ }),
/* 292 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      status: null
    };
  },

  computed: {
    title: function title() {
      if (this.status == 404) {
        return "Page not found!";
      } else if (this.status == 403) {
        return "Access denied!";
      }
    },
    message: function message() {
      if (this.status == 404) {
        return "This page could not be found.";
      } else if (this.status == 403) {
        return "You don't have the right permission to do that.";
      }
    }
  },
  created: function created() {
    this.status = this.$route.params.status;
  }
});

/***/ }),
/* 293 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Datatable__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Todo",
  components: {
    dataTable: __WEBPACK_IMPORTED_MODULE_1__components_Datatable__["a" /* default */]
  },
  data: function data() {
    return {
      todo: [],
      // reports: [],
      progress: true,
      headers: [],
      response: false,
      dialog: false,
      readonlyblueprint: null
    };
  },


  methods: {
    blueprintDetails: function blueprintDetails(item) {
      //will be redirected anyways to readonly if not allowed
      this.$router.push({
        name: "EditBlueprintsDetails",
        params: { id: item.id }
      });
    },
    markerDetails: function markerDetails(item) {
      this.$router.push({
        name: "MarkerDetails",
        params: { id: item.markerId }
      });
    },
    editBlueprint: function editBlueprint(item) {
      var _this = this;

      if (this.$can("update", "markers")) {
        if (__WEBPACK_IMPORTED_MODULE_0_jwt_decode___default()(localStorage.getItem("auth")).contactId != item.lockedByUserId) {
          this.$http.lockBlueprint(item.id).then(function (res) {
            if (item.lockedByUserName !== null) {
              _this.dialog = true;
              _this.readonlyblueprint = item;
            } else {
              _this.blueprintDetails(item, true);
            }
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
        } else {
          this.blueprintDetails(item, true);
        }
      } else {
        this.blueprintDetails(item, false);
      }
    },
    responseReadonly: function responseReadonly(yes) {
      if (yes) {
        this.dialog = false;
        if (this.readonlyblueprint) this.blueprintDetails(this.readonlyblueprint, true);
      }
      this.readonlyblueprint = null;
      this.dialog = false;
    }
  },
  watch: {
    todo: function todo(n, o) {
      if (n.length > 0) {
        if (n.some(function (x) {
          return x.isLocked;
        })) {
          this.headers = [{
            text: this.$t("project"),
            align: "left",
            value: "project"
          }, {
            text: this.$t("buildingComponent"),
            align: "left",
            value: "buildingComponent"
          }, {
            text: this.$t("blueprint"),
            align: "left",
            value: "blueprint"
          }, {
            text: this.$t("deadline"),
            align: "left",
            value: "deadline"
          }, {
            text: this.$t("isEditing"),
            value: "lockedByUserName"
          }, {
            text: this.$t("editStart"),
            value: "lockedTs"
          }, {
            text: this.$t("todo"),
            align: "left",
            value: "markers"
          }, { text: this.$t("actions"), sortable: false, value: "actions" }];
        } else {
          this.headers = [{
            text: this.$t("project"),
            align: "left",
            value: "project"
          }, {
            text: this.$t("buildingComponent"),
            align: "left",
            value: "buildingComponent"
          }, {
            text: this.$t("blueprint"),
            align: "left",
            value: "blueprint"
          }, {
            text: this.$t("deadline"),
            align: "left",
            value: "deadline"
          }, {
            text: this.$t("todo"),
            align: "left",
            value: "markers"
          }, { text: this.$t("actions"), sortable: false, value: "actions" }];
        }
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.getTodo().then(function (res) {
      _this2.todo = res.data;
      _this2.progress = false;
    }).catch(function (err) {
      _this2.progress = false;
      console.log(err);
    });
    this.$store.state.previous = null;
  }
});

/***/ }),
/* 294 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Datatable__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Todo",
  components: {
    dataTable: __WEBPACK_IMPORTED_MODULE_1__components_Datatable__["a" /* default */]
  },
  data: function data() {
    return {
      items: [],
      // reports: [],
      progress: true,
      response: false,
      dialog: false,
      readonlyblueprint: null
    };
  },


  methods: {
    isOverFlow: function isOverFlow(todo, i) {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.todo) {
          if (todo.isOverflowing === undefined) {
            var elements = _this.$refs.todo;
            var el = elements[i];
            var curOverflow = el.style.overflow;
            if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
            var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

            el.style.overflow = curOverflow;

            if (isOverflowing) todo.isOverflowing = true;else todo.isOverflowing = false;
            if (!isOverflowing) el.classList.remove("content");
            _this.$forceUpdate();
          }
        } else {
          todo.isOverflowing = false;
        }
        return todo.isOverflowing;
      });
    },
    collapse: function collapse(document) {
      document.active = !document.active;
      this.$forceUpdate();
    },
    blueprintDetails: function blueprintDetails(item) {
      //will be redirected anyways to readonly if not allowed
      this.$router.push({
        name: "EditBlueprintsDetails",
        params: { id: item.id }
      });
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.getTodosGroupedByInstaller().then(function (res) {
      _this2.items = res.data;
      _this2.progress = false;
    }).catch(function (err) {
      _this2.progress = false;
      console.log(err);
    });
    this.$store.state.previous = null;
  }
});

/***/ }),
/* 295 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Reports",
  data: function data() {
    return {
      todo: [],
      reports: []
    };
  },

  computed: {},
  methods: {
    markerDetails: function markerDetails(item) {
      var _this = this;

      if (this.$can("update", "markers")) {
        this.$http.lockBlueprint(item.marker.blueprintId).then(function (res) {
          _this.$router.push({
            name: "MarkerDetails",
            params: { id: item.markerId }
          });
        }).catch(function (err) {
          _this.$noty.error(_this.$t("error"));
          console.log(err);
        });
      } else {
        this.$router.push({
          name: "MarkerDetails",
          params: { id: item.markerId }
        });
      }
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.getReports().then(function (res) {
      _this2.reports = res.data;
    }).catch(function (err) {
      _this2.$noty.error(_this2.$t("error"));
      console.log(err);
    });
  }
});

/***/ }),
/* 296 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Retry__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Datatable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_vuelidate__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "OldReports",
  components: {
    retry: __WEBPACK_IMPORTED_MODULE_0__components_Retry__["a" /* default */],
    emptyList: __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__["a" /* default */],
    dataTable: __WEBPACK_IMPORTED_MODULE_2__components_Datatable__["a" /* default */]
  },
  data: function data() {
    return {
      progress: true,
      items: [],
      headers: null,
      loading: false,
      search: "",
      sortDesc: false,
      retry: false
    };
  },

  methods: {
    goToMarker: function goToMarker(item) {
      this.$router.push({ name: "MarkerDetails", params: { id: item.markerId } });
    },
    buildHeaders: function buildHeaders() {

      this.headers = [{
        text: this.$t("name"),
        align: "left",
        value: "name"
      }, { text: this.$t("email"), value: "email" }, {
        text: this.$t("project"),
        value: "project"
      }, { text: this.$t("date"), value: "dateFormated" }];
    },
    getData: function getData() {
      var _this = this;

      this.progress = true;
      this.$http.getOldReports().then(function (res) {
        _this.items = res.data;
        _this.progress = false;
        _this.retry = false;
      }).catch(function (error) {
        _this.progress = false;
        _this.retry = true;
        console.log(error.response.status);
      });
    }
  },
  created: function created() {
    this.getData();
    this.buildHeaders();
    this.$store.state.previous = null;
    this.$store.state.breadcrumb = null;
  }
});

/***/ }),
/* 297 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BackButton",
  data: function data() {
    return {};
  },

  computed: {
    bb: function bb() {
      return this.$store.state.previous;
    }
  },
  methods: {
    goBack: function goBack() {
      if (this.$store.state.previous) {
        if (this.$store.state.previous.params) {
          this.$router.push({
            name: this.$store.state.previous.name,
            params: this.$store.state.previous.params
          });
        } else {
          this.$router.push({
            name: this.$store.state.previous.name,
            params: { id: this.$store.state.previous.id }
          });
        }
      } else {
        this.$router.push({
          name: "Projects"
        });
      }
    },
    openDrawer: function openDrawer() {
      this.$emit('openDrawer');
    }
  },
  watch: {
    bb: function bb(n, o) {}
  },
  created: function created() {}
});

/***/ }),
/* 298 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Help",
  data: function data() {
    return {
      items: null,
      styleDescriptionAuto: {
        height: "auto"
      }
    };
  },

  methods: {
    isOverFlow: function isOverFlow(helpvm, i) {
      var _this = this;

      this.$nextTick(function () {
        if (_this.$refs.helpvm) {
          if (helpvm.isOverflowing === undefined) {
            var elements = _this.$refs.helpvm;
            var el = elements[i];
            var curOverflow = el.style.overflow;
            if (!curOverflow || curOverflow === "visible") el.style.overflow = "hidden";
            var isOverflowing = el.clientWidth < el.scrollWidth || el.clientHeight < el.scrollHeight;

            el.style.overflow = curOverflow;

            if (isOverflowing) helpvm.isOverflowing = true;else helpvm.isOverflowing = false;
            if (!isOverflowing) el.classList.remove("content");
            _this.$forceUpdate();
          }
        } else {
          helpvm.isOverflowing = false;
        }
      });
    },
    collapse: function collapse(document) {
      document.active = !document.active;
      this.$forceUpdate();
    }
  },
  created: function created() {
    var _this2 = this;

    this.$http.getHelp().then(function (res) {
      _this2.items = res.data;
    }).catch(function (err) {
      console.log(err);
    });
  }
});

/***/ }),
/* 299 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Products__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Markers_AddAttachment__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_ZoomPicture__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_SolutionSelector_Index__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_solutions_PIMSolutionDetails__ = __webpack_require__(143);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_AreYouSure2__ = __webpack_require__(126);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//








/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    products: __WEBPACK_IMPORTED_MODULE_2__components_Products__["a" /* default */],
    addAttachment: __WEBPACK_IMPORTED_MODULE_3__components_pages_Markers_AddAttachment__["a" /* default */],
    zoomPicture: __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_ZoomPicture__["a" /* default */],
    solutionSelector: __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_SolutionSelector_Index__["a" /* default */],
    pimSolutionDetails: __WEBPACK_IMPORTED_MODULE_6__components_pages_solutions_PIMSolutionDetails__["a" /* default */],
    areyousure2: __WEBPACK_IMPORTED_MODULE_7__components_AreYouSure2__["a" /* default */]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.$store.state.hasChanges) {
      //if (to.name !== "MarkerXSolutionDetails") {
      this.saveDialog = true;
      //this.$store.state.hasChanges = false;
      this.to = to;
      next(false);
    } else {
      next();
    }
  },
  data: function data() {
    var _ref;

    return _ref = {
      list: true,
      attributesDialog: false,
      pimSolutionDialog: false,
      markerXSolution: null,
      marker: null,
      blueprint: null,
      readonly: false,
      active: null,
      attributes: [],
      isReady: false,
      dialog: false,
      img: null,
      showDelete: false,
      isShowing: false,
      unusedAttributes: null,
      options: {
        duration: 300,
        easing: "easeInOutCubic",
        offset: 0
      },
      dimensionDialog: false
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "attributesDialog", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "emptyImage", __webpack_require__(18)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "valid", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "saveDialog", false), _ref;
  },

  methods: {
    response: function response(answer) {
      console.log(answer);

      if (answer) {
        this.$store.state.hasChanges = false;
        this.saveDialog = false;
        this.saveSolution();
      } else {
        this.$store.state.hasChanges = false;
        this.saveDialog = false;

        this.$router.push({
          name: this.to.name,
          params: this.to.params
        });
      }
    },
    addReport: function addReport(report) {
      var _this = this;

      // this.report.markerXSolutionsId = this.markerXSolution.id
      this.marker.reports.find(function (s) {
        return s.id == report.id;
      }).markerXSolutionId = this.markerXSolution.id;
      this.marker.reports.forEach(function (r) {
        var id = __WEBPACK_IMPORTED_MODULE_1_uuid___default.a.v4();
        if (r.markerXSolutionId === _this.markerXSolution.id) {
          var date = new Date();
          var attachment = {
            id: id,
            markerId: _this.marker.id,
            markerXSolutionsId: r.markerXSolutionId,
            name: "report.jpg",
            content: r.image,
            approved: false,
            createdBy: "REPORTED",
            createdTs: date.toJSON(),
            reportId: r.id,
            new: true
          };
          _this.marker.markerXSolutions.find(function (x) {
            return x.id == attachment.markerXSolutionsId;
          }).attachments.unshift(attachment);
          _this.$store.commit("updateMarker", _this.marker);
          _this.marker.reports = _this.marker.reports.filter(function (x) {
            return x.id != r.id;
          });
        }
      });
    },
    deleteReport: function deleteReport(report) {
      this.marker.reports = this.marker.reports.filter(function (p) {
        return p.id != report.id;
      });
      // if (this.marker.reports.length === 0) {
      this.$store.commit("updateMarker", this.marker);
      // }
    },
    deleteMarkerXSolution: function deleteMarkerXSolution(id) {
      var _this2 = this;

      if (this.marker.markerXSolutions.find(function (x) {
        return x.id == id;
      }).new) {
        this.marker.markerXSolutions = this.marker.markerXSolutions.filter(function (x) {
          return x.id != id;
        });
      } else {
        if (this.$store.state.isOffline) {
          var offForm = {
            deleteMarkerXSolution: id
          };
          this.$store.state.offForm.push(offForm);
        } else {
          this.$http.deleteMarkerXSolution(id).then(function (res) {
            _this2.marker.markerXSolutions = _this2.marker.markerXSolutions.filter(function (x) {
              return x.id != id;
            });
            _this2.$store.commit("updateMarker", _this2.marker);
            _this2.$noty.success('<i class="fas fa-check"></i>');
          }).catch(function (err) {
            console.log(err);
            _this2.$noty.error(_this2.$t("error"));
          });
        }
      }

      this.$store.state.previous.params.deleteMarkerXSolution = this.marker;
      this.$router.push({
        name: this.$store.state.previous.name,
        params: this.$store.state.previous.params
      });
    },
    bindAttributeSelectbox: function bindAttributeSelectbox(attribute, textbox) {
      var _this3 = this;

      if (this.markerXSolution.solutionId) {
        if (textbox) {
          if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(function (x) {
            return x.qrLogAttributeId == attribute.id;
          })) {
            return this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
              return x.qrLogAttributeId == attribute.id;
            })[0].value;
          }
        } else {
          if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.length > 0 && this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(function (s) {
            return s.qrLogAttributeId == attribute.id;
          })) {
            return attribute.qrLogAttributeListValue.filter(function (s) {
              return s.id == _this3.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
                return x.qrLogAttributeId == attribute.id;
              })[0].qrLogAttributeListValueId;
            }).length > 0 ? attribute.qrLogAttributeListValue.filter(function (s) {
              return s.id == _this3.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
                return x.qrLogAttributeId == attribute.id;
              })[0].qrLogAttributeListValueId;
            })[0].id : null;
          }
        }

        // this.changeImage();
      }
    },
    attributeSelected: function attributeSelected(value, attribute) {
      var _this4 = this;

      if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(function (x) {
        return x.qrLogAttributeId == attribute.id;
      })) {
        this.markerXSolution.qrLogAttributeXMarkerXSolutions.forEach(function (qaxmsx, i) {
          if (attribute.id == qaxmsx.qrLogAttributeId) {
            if (value == undefined) {
              qaxmsx.value = null;
              qaxmsx.qrLogAttributeListValueId = null;
            } else {
              if (_this4.$validator.isUUID(value)) {
                qaxmsx.qrLogAttributeListValueId = value;
                return;
              } else {
                qaxmsx.value = value;
                return;
              }
            }
          }
        });
      } else {
        this.markerXSolution.qrLogAttributeXMarkerXSolutions.push({
          id: __WEBPACK_IMPORTED_MODULE_1_uuid___default.a.v4(),
          markerXSolutionsId: this.markerXSolution.id,
          qrLogAttributeId: attribute.id,
          qrLogAttributeListValueId: this.$validator.isUUID(value) ? value : null,
          value: !this.$validator.isUUID(value) ? value : null
        });
      }
      this.changeImage();
    },
    solutionSelectorSelectedSolution: function solutionSelectorSelectedSolution(event, markerXSolutionIndex) {
      var _this5 = this;

      this.markerXSolution.solutionId = event.solution.Id;

      this.markerXSolution.qrLogAttributeXMarkerXSolutions.forEach(function (qaxmxs, i) {
        _this5.$store.state.allAttributes.forEach(function (atr, o) {
          atr.qrLogAttributeListValue.forEach(function (listvalue) {
            event.taxonomies.forEach(function (taxId) {
              if (atr.qrLogAttributeListValue.some(function (x) {
                return x.id == taxId;
              })) {
                if (taxId == listvalue.id && qaxmxs.qrLogAttributeId == atr.id) {
                  _this5.markerXSolution.qrLogAttributeXMarkerXSolutions[i].qrLogAttributeListValueId = taxId;
                }
              }
            });
          });
        });
      });

      this.$refs.form.validate();
      this.changeImage();
    },
    required: function required(_required) {
      var _this6 = this;

      if (_required) {
        return [function (v) {
          return v != "00000000-0000-0000-0000-000000000000" || "" + _this6.$t("required");
        }, function (v) {
          return !!v || "" + _this6.$t("required");
        }];
      }
    },
    showRequiredMessage: function showRequiredMessage() {
      return this.$t("fillinrequiredfields");
    },
    attributesToString: function attributesToString(mxs) {
      var _this7 = this;

      var text = "";

      mxs.qrLogAttributeXMarkerXSolutions.forEach(function (x) {
        if (_this7.$store.state.allAttributes.some(function (f) {
          return f.id == x.qrLogAttributeId;
        })) {
          if (!x.value) {
            var attribute = _this7.$store.state.allAttributes.filter(function (f) {
              return f.id == x.qrLogAttributeId;
            })[0].qrLogAttributeListValue.find(function (z) {
              return z.id == x.qrLogAttributeListValueId;
            });
            if (attribute) {
              text += "<small class=\"subtitle-2\">" + _this7.$store.state.allAttributes.filter(function (f) {
                return f.id == x.qrLogAttributeId;
              })[0].code + "</small>: " + attribute.description + ", ";
            }
          } else {
            text += _this7.$store.state.allAttributes.filter(function (f) {
              return f.id == x.qrLogAttributeId;
            })[0].code + ": " + x.value + ", ";
          }
        }
      });
      // this.changeImage();
      return text;
    },
    dimensionsToString: function dimensionsToString(mxs) {
      var html = "";
      if (mxs.amount != undefined) {
        html += "<small class=\"subtitle-2\">" + this.$t("amount") + "</small>: " + mxs.amount + ",";
      }
      if (mxs.unit != undefined) {
        html += "<small class=\"subtitle-2\"> " + this.$t("unit") + "\n        </small>: " + mxs.unit + ",";
      }
      if (mxs.width != undefined) {
        html += "<small class=\"subtitle-2\"> " + this.$t("width") + "</small>: " + mxs.width + ",";
      }
      if (mxs.height != undefined) {
        html += "<small class=\"subtitle-2\">" + this.$t("height") + "</small>: " + mxs.height + ",";
      }
      if (mxs.length != undefined) {
        html += "<small class=\"subtitle-2\">" + this.$t("length") + "</small>: " + mxs.length + ",";
      }
      if (mxs.diameter != undefined) {
        html += this.$t("diameter") + ": " + mxs.diameter;
      }
      return html;
    },
    selected: function selected(solutionId, _selected) {
      this.marker.markerXSolutions.forEach(function (mxs) {
        if (mxs.solutionId == solutionId) {
          mxs.selectedProducts = _selected.reduce(function (res, x) {
            if (x.selected) {
              var someNewValue = {
                id: __WEBPACK_IMPORTED_MODULE_1_uuid___default.a.v4(),
                markerXSolutionsId: mxs.id,
                productId: x.id
              };
              res.push(someNewValue);
            }
            return res;
          }, []);
        }
      });
    },
    zoomPicture: function zoomPicture(img) {
      this.img = img;
      this.dialog = true;
    },
    deletePicture: function deletePicture(attachment) {
      this.markerXSolution.attachments = this.markerXSolution.attachments.filter(function (p) {
        return p.id != attachment.id;
      });
      this.$store.commit("updateMarker", this.marker);
    },
    addPicture: function addPicture(picture) {
      this.markerXSolution.attachments.unshift(picture);
      this.$store.commit("updateMarker", this.marker);
    },
    canDelete: function canDelete(date) {
      if (date.substring(0, 10) == new Date().toLocaleDateString("fr-CA"))
        //yyyy-MM-dd
        return true;else return false;
    },
    goBackToMarker: function goBackToMarker() {
      this.$router.push({
        name: this.readonly ? "MarkerDetails" : "EditMarkerDetails",
        params: { id: this.$route.params.id }
      });
    },
    saveSolution: function saveSolution() {
      this.$store.state.previous.params.saveMarker = true;
      this.$router.push({
        name: this.$store.state.previous.name,
        params: this.$store.state.previous.params
      });
    },
    lockBlueprint: function lockBlueprint() {
      this.$store.state.readyForOffline = false;
      this.$store.state.previous.params.edit = true;
      this.$router.push({
        name: this.$store.state.previous.name,
        params: this.$store.state.previous.params
      });
    },
    makeBackButton: function makeBackButton() {
      this.$store.state.previous = {
        name: this.readonly ? "MarkerDetails" : "EditMarkerDetails",
        params: {
          id: this.markerXSolution.markerId,
          marker: this.$route.params.marker,
          blueprint: this.$route.params.blueprint
        },
        breadcrumb: this.$t("marker")
      };
    },
    changeImage: function changeImage() {
      var _this8 = this;

      if (this.markerXSolution.solutionId) {
        this.markerXSolution.product = this.$store.state.productSolutions.find(function (x) {
          return x.id == _this8.markerXSolution.solutionId;
        }).image;
      }

      //using form to check required attributes
      if (this.$refs.form) {
        // if (this.markerXSolution.attributesDialog == true) {
        this.$nextTick(function () {
          if (_this8.$refs.form.validate()) {
            _this8.markerXSolution.valid = false;
            _this8.$forceUpdate();
          } else {
            _this8.markerXSolution.valid = true;
            _this8.$forceUpdate();
          }
        });

        // }
        // else{
        if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
          return _this8.$store.state.allAttributes.filter(function (x) {
            return x.required;
          }).some(function (s) {
            return s.id == x.qrLogAttributeId;
          }) && (x.qrLogAttributeListValueId != null || x.value != null);
        })) {
          this.markerXSolution.valid = true;
        } else {
          this.markerXSolution.valid = false;
        }
        // }
      } else {
        // if (
        //   this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(
        //     s =>
        //       s.qrLogAttributeId == x.id &&
        //       (s.qrLogAttributeListValueId != null || s.value != null)
        //   )
        // ) {
        //   console.log("1");
        //   this.markerXSolution.valid = false;
        // } else {
        //   console.log(2, this.markerXSolution);
        //   this.markerXSolution.valid = true;
        // }

        if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
          return _this8.$store.state.allAttributes.filter(function (x) {
            return x.required;
          }).some(function (s) {
            return s.id == x.qrLogAttributeId;
          }) && (x.qrLogAttributeListValueId != null || x.value != null);
        })) {
          this.markerXSolution.valid = true;
        } else {
          this.markerXSolution.valid = false;
        }
      }
    }
  },
  watch: {
    markerXSolution: function markerXSolution(n, o) {
      this.changeImage();
      try {
        n.qrLogAttributeXMarkerXSolutions.sort(function (a, b) {
          return a.qrLogAttribute.index > b.qrLogAttribute.index ? 1 : b.qrLogAttribute.index > a.qrLogAttribute.index ? -1 : 0;
        });
      } catch (error) {}
    }
  },
  created: function created() {
    if (this.$route.params.markerXSolution !== undefined && this.$route.params.marker !== undefined && this.$route.params.blueprint !== undefined) {
      this.markerXSolution = this.$route.params.markerXSolution;
      this.readonly = this.$route.params.readonly;
      this.isReady = true;
      this.marker = this.$route.params.marker;
      this.blueprint = this.$route.params.blueprint;
      this.makeBackButton();
      this.changeImage();
    } else {
      this.goBackToMarker();
    }
  }
});

/***/ }),
/* 300 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAttachment_vue__ = __webpack_require__(301);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c7d4692_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAttachment_vue__ = __webpack_require__(708);
function injectStyle (ssrContext) {
  __webpack_require__(707)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAttachment_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7c7d4692_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAttachment_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 301 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_uuid__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["a"] = ({
  name: "AddAttachment",
  components: {},
  props: {
    markerXSolution: Object
  },
  data: function data() {
    return {
      loading: false,
      valid: true,
      dialog: false,
      approved: null,
      hasImage: false,
      image: null,
      name: ''
    };
  },

  methods: {
    setImage2: function setImage2(input) {
      var _this = this;

      if (input.target.files.length) {
        this.name = input.target.files[0].name;
        var reader = new FileReader();
        reader.onload = function (e) {
          _this.image = e.target.result;
        };
        reader.readAsDataURL(input.target.files[0]); // convert to base64 string
      }
    },

    setImage: function setImage(output) {
      var _this2 = this;

      this.hasImage = true;
      this.image = output;
      var canvas = this.$refs.prev;
      var ctx = canvas.getContext("2d");
      var image = new Image();

      image.onload = function () {
        canvas.width = image.width;
        canvas.height = image.height;
        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.drawImage(image, image.width / -2, image.height / -2);
        _this2.$forceUpdate();
      };
      image.src = this.image.dataUrl;
    },
    rotate: function rotate() {
      var _this3 = this;

      this.rotateFunction(this.image, 90, function (resultBase64) {
        _this3.image = resultBase64;
        _this3.$forceUpdate();
      });
    },
    rotateFunction: function rotateFunction(srcBase64, degrees, callback) {
      var canvas = this.$refs.prev;
      var ctx = canvas.getContext("2d");
      var image = new Image();

      image.onload = function () {
        canvas.width = degrees % 180 === 0 ? image.width : image.height;
        canvas.height = degrees % 180 === 0 ? image.height : image.width;

        ctx.translate(canvas.width / 2, canvas.height / 2);
        ctx.rotate(degrees * Math.PI / 180);
        ctx.drawImage(image, image.width / -2, image.height / -2);

        callback(canvas.toDataURL());
      };

      image.src = srcBase64;
    },
    onUpload: function onUpload() {
      if (this.image != null) {
        if (this.$refs.form.validate()) {
          var date = new Date();
          var attachment = {
            id: __WEBPACK_IMPORTED_MODULE_0_uuid___default.a.v4(),
            markerId: this.$route.params.id,
            markerXSolutionsId: this.markerXSolution.id,
            name: this.name,
            content: this.image,
            approved: this.approved,
            createdBy: localStorage.getItem("user"),
            createdTs: date.toJSON(),
            new: true
          };
          if (this.$store.state.isOffline) {
            this.$emit("add-picture", attachment);
            this.$store.state.hasChanges = true;
            this.close();
            this.image = null;
            this.approved = null;
          } else {
            //if (this.markerXSolution.new) {
            this.$emit("add-picture", attachment);
            this.$store.state.hasChanges = true;
            this.close();
            this.image = null;
            this.approved = null;
          }
        }
      }
    },
    close: function close() {
      this.dialog = false;
    }
  }
});

/***/ }),
/* 302 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(303);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac956148_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(713);
function injectStyle (ssrContext) {
  __webpack_require__(709)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ac956148"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ac956148_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 303 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service_oryx_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_Markers_SolutionSelector_Detail__ = __webpack_require__(710);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      loading: false,
      data: null,
      selectedSolutionId: null,
      tax263415Id: null,
      dialog: false,
      selectedTaxonomies: []
    };
  },

  components: {
    selectedSolutionComponent: __WEBPACK_IMPORTED_MODULE_1__components_pages_Markers_SolutionSelector_Detail__["a" /* default */]
  },
  created: function created() {
    this.steps();
    //this.reset();
  },

  methods: {
    selectedSolution: function selectedSolution(solution) {
      this.selectedSolutionId = solution.Id;
      this.tax263415Id = solution.Tax263415Id;
    },
    useInMarker: function useInMarker(solution, taxonomies) {
      this.$emit("selectedSolution", {
        solution: solution,
        taxonomies: taxonomies
      });
      this.dialog = false;
    },
    useInMarkerFromDetails: function useInMarkerFromDetails(data) {
      this.$emit("selectedSolution", data);
      this.dialog = false;
    },
    getPreviousStepIndex: function getPreviousStepIndex() {
      var index = this.selectedTaxonomies.length;
      while (index-- && !this.selectedTaxonomies[index]) {}
      return index;
    },
    prevStep: function prevStep(sliceIndex) {
      if (sliceIndex && sliceIndex !== 0) {
        if (this.data.Selected[sliceIndex] === null) {
          sliceIndex++;
          if (this.data.Selected[sliceIndex] === null) {
            sliceIndex++;
            if (this.data.Selected[sliceIndex] === null) {
              sliceIndex++;
            }
          }
        }
        this.data.Selected = this.data.Selected.slice(0, sliceIndex);
        this.selectedTaxonomies = this.selectedTaxonomies.slice(0, sliceIndex);
      } else {
        this.data.Selected = [];
        this.selectedTaxonomies = [];
      }

      this.steps();
    },
    insertIdinCorrectPosition: function insertIdinCorrectPosition(id) {
      if (this.data && id !== undefined) {
        this.data.Selected.push(id);
      }
    },
    steps: function steps(id, taxname) {
      var _this = this;

      this.loading = true;
      this.insertIdinCorrectPosition(id);
      //if (this.data) this.data.Selected.push(id);
      var params = {
        taxIds: this.data ? this.data.Selected : [],
        companyId: __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem("auth")).companyId,
        lc: localStorage.getItem("language")
      };

      __WEBPACK_IMPORTED_MODULE_0__services_service_oryx_js__["a" /* default */].steps(params).then(function (res) {
        _this.data = res.data;
        _this.loading = false;
        if (taxname) _this.selectedTaxonomies.push(taxname);
        _this.data.Selected.forEach(function (selected, i) {
          if (selected == null && _this.selectedTaxonomies[i] !== null) {
            _this.selectedTaxonomies.splice(i, 0, null);
          }
        });
      }).catch(function (err) {
        console.log(err);
        _this.loading = false;
      });
    },
    reset: function reset() {
      this.data = null;
      this.selectedTaxonomies = [];
      this.steps();
    }
  }
});

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service_oryx_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_pages_Markers_ZoomPicture__ = __webpack_require__(36);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




/* harmony default export */ __webpack_exports__["a"] = ({
  name: "selectedSolutionComponent",
  components: {
    zoomPicture: __WEBPACK_IMPORTED_MODULE_2__components_pages_Markers_ZoomPicture__["a" /* default */]
  },
  props: {
    id: String,
    taxId: String
  },
  data: function data() {
    return {
      data: null,
      loading: false,
      error: false
    };
  },
  created: function created() {
    this.getSelectedSolution();
  },

  methods: {
    backToSolutionList: function backToSolutionList() {
      //send message to parent to clear selected solution
      this.$emit("back");
    },
    useInMarker: function useInMarker() {
      var taxonomies = this.data.SelectedTaxonomies.filter(function (x) {
        return x !== null;
      }).map(function (x) {
        return x.Id;
      });
      this.$emit("useInMarkerFromDetails", {
        solution: this.data,
        taxonomies: taxonomies
      });
    },
    getSelectedSolution: function getSelectedSolution() {
      var _this = this;

      var params = {
        solutionId: this.id,
        tax263415Id: this.taxId,
        companyId: __WEBPACK_IMPORTED_MODULE_1_jwt_decode___default()(localStorage.getItem("auth")).companyId,
        lc: localStorage.getItem("language")
      };

      __WEBPACK_IMPORTED_MODULE_0__services_service_oryx_js__["a" /* default */].getSelectedSolution(params).then(function (res) {
        _this.data = res.data;
        _this.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this.loading = false;
        _this.error = true;
      });
    }
  }
});

/***/ }),
/* 305 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BackButton",
  data: function data() {
    return {};
  },

  computed: {
    breadcrumb: function breadcrumb() {
      return this.$store.state.breadcrumb;
    }
  },
  methods: {},
  watch: {
    breadcrumb: function breadcrumb(n, o) {}
  },
  created: function created() {}
});

/***/ }),
/* 306 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Retry__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Datatable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_DownloadLogbook__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "Projects",
  components: {
    retry: __WEBPACK_IMPORTED_MODULE_0__components_Retry__["a" /* default */],
    emptyList: __WEBPACK_IMPORTED_MODULE_1__components_EmptyList__["a" /* default */],
    dataTable: __WEBPACK_IMPORTED_MODULE_2__components_Datatable__["a" /* default */],
    downloadLogbook: __WEBPACK_IMPORTED_MODULE_3__components_DownloadLogbook__["a" /* default */]
  },
  data: function data() {
    return {
      progress: true,
      projects: [],
      headers: null,
      loading: false,
      search: "",
      sortBy: "name",
      sortDesc: false,
      retry: false
    };
  },

  methods: {
    restoreProject: function restoreProject(item) {
      var _this = this;

      item.status = "OPEN";
      var project = item;
      delete project.buildingComponents;
      this.$http.updateProject(project).then(function (res) {
        _this.projects = _this.projects.filter(function (x) {
          return x.id != item.id;
        });
        _this.$noty.success('<i class="fas fa-check"></i>');
      }).catch(function (err) {
        _this.$noty.error(_this.$t("error"));
        console.log(err);
      });
    },
    downloadExcel: function downloadExcel(project) {
      var _this2 = this;

      this.loading = true;
      this.$http.downloadExcelExport(project.id).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", project.name + "_" + date.toLocaleDateString() + ".xlsx");
        document.body.appendChild(link);
        link.click();
        _this2.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.$noty.error(_this2.$t("error"));
        _this2.loading = false;
      });
    },
    downloadLogbook: function downloadLogbook(project) {
      var _this3 = this;

      this.loading = true;
      this.$http.downloadLogbook(project.id, null).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", project.name + "_" + date.toLocaleDateString() + ".zip");
        document.body.appendChild(link);
        link.click();
        _this3.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this3.$noty.error(_this3.$t("error"));
        _this3.loading = false;
      });
    },
    deleteProject: function deleteProject(id) {
      this.projects = this.projects.filter(function (p) {
        return p.id != id;
      });
    },
    projectDetails: function projectDetails(item) {
      this.$router.push({
        name: "ArchivedProjectDetails",
        params: { id: item.id }
      });
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("projects"),
        to: { name: "Projects" }
      }];
      this.$store.state.previous = {
        name: "Projects",
        id: null,
        breadcrumb: this.$t("projects")
      };
    },
    buildHeaders: function buildHeaders() {
      if (this.$can("delete", "projects")) {
        this.headers = [{
          text: this.$t("name"),
          align: "left",
          value: "name"
        }, { text: this.$t("building"), value: "buildingName" }, {
          text: this.$t("buildingComponents"),
          value: "buildingComponents.length"
        },
        // { text: this.$t("table.status"), value: "status" },
        { text: this.$t("createdTs"), value: "createdTs" }, { text: this.$t("actions"), sortable: false, value: "actions" }];
      } else {
        this.headers = [{
          text: this.$t("name"),
          align: "left",
          value: "name"
        }, { text: this.$t("building"), value: "buildingName" }, {
          text: this.$t("buildingComponents"),
          value: "buildingComponents.length"
        }, { text: this.$t("createdTs"), value: "createdTs" }];
      }
    },
    getData: function getData() {
      var _this4 = this;

      this.progress = true;
      this.$http.getProjects(true).then(function (res) {
        _this4.projects = res.data;
        _this4.progress = false;
        _this4.retry = false;
      }).catch(function (error) {
        _this4.progress = false;
        _this4.retry = true;
        console.log(error.response.status);
      });
    }
  },
  created: function created() {
    this.getData();
    this.buildHeaders();
    this.makeBreadcrumb();
  }
});

/***/ }),
/* 307 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_Datatable__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Retry__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_EmptyList__ = __webpack_require__(43);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_DownloadLogbook__ = __webpack_require__(65);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  name: "ProjectsDetails",
  components: {
    retry: __WEBPACK_IMPORTED_MODULE_2__components_Retry__["a" /* default */],
    emptyList: __WEBPACK_IMPORTED_MODULE_3__components_EmptyList__["a" /* default */],
    dataTable: __WEBPACK_IMPORTED_MODULE_1__components_Datatable__["a" /* default */],
    downloadLogbook: __WEBPACK_IMPORTED_MODULE_4__components_DownloadLogbook__["a" /* default */]
  },
  data: function data() {
    return {
      progress: true,
      project: null,
      buildingComponents: [],
      headers: null,
      loading: false,
      search: "",
      sortDesc: false,
      sortBy: "name"
    };
  },

  methods: {
    downloadExcel: function downloadExcel(buildingcomponent) {
      var _this = this;

      this.loading = true;
      this.$http.downloadExcelExport(null, buildingcomponent.id, null).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", buildingcomponent.name + "_" + date.toLocaleDateString() + ".xlsx");
        document.body.appendChild(link);
        link.click();
        _this.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this.$noty.error(_this.$t("error"));
        _this.loading = false;
      });
    },
    downloadLogbook: function downloadLogbook(buildingcomponent, separated, withDocuments) {
      var _this2 = this;

      this.loading = true;
      this.$http.downloadLogbook(null, buildingcomponent.id, separated, withDocuments).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", buildingcomponent.name + "_" + date.toLocaleDateString() + ".zip");
        document.body.appendChild(link);
        link.click();
        _this2.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this2.$noty.error(_this2.$t("error"));
        _this2.loading = false;
      });
    },
    details: function details(item) {
      this.$router.push({
        name: "ArchivedBuildingComponentDetails",
        params: { id: item.id }
      });
    },
    buildHeaders: function buildHeaders() {
      if (this.$can("delete", "buildingComponents")) {
        this.headers = [{
          text: this.$t("name"),
          align: "left",
          value: "name"
        }, {
          text: this.$t("description"),
          align: "left",
          value: "description"
        }, { text: this.$t("blueprints"), value: "blueprintsCount" }, {
          text: this.$t("createdTs"),
          align: "left",
          value: "createdTs"
        }, { text: this.$t("actions"), sortable: false, value: "actions" }];
      } else {
        this.headers = [{
          text: this.$t("name"),
          align: "left",
          value: "name"
        }, {
          text: this.$t("description"),
          align: "left",
          value: "description"
        }, { text: this.$t("blueprints"), value: "blueprintsCount" }, {
          text: this.$t("createdTs"),
          align: "left",
          value: "createdTs"
        }];
      }
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("archivedProjects"),
        to: { name: "ArchivedProjects" }
      }, {
        name: this.project.name
      }];
    }
  },
  created: function created() {
    var _this3 = this;

    this.$store.state.previous = {
      name: "ArchivedProjects",
      id: null,
      breadcrumb: this.$t("archivedProjects")
    };
    this.$http.getProject(this.$route.params.id).then(function (res) {
      _this3.project = res.data;
      _this3.makeBreadcrumb();
    }).catch(function (err) {
      return console.log(err);
    });

    this.$http.getBuildingComponents(this.$route.params.id).then(function (res) {
      _this3.buildingComponents = res.data;
      _this3.progress = false;
    }).catch(function (err) {
      console.log(err);
      _this3.buildingComponents = [];
    });
    this.buildHeaders();
  }
});

/***/ }),
/* 308 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vuelidate___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vuelidate__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_pages_Blueprints_Blueprints__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Datatable__ = __webpack_require__(32);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//






/* harmony default export */ __webpack_exports__["a"] = ({
  name: "BuildingComponentsDetails",
  components: {
    blueprints: __WEBPACK_IMPORTED_MODULE_1__components_pages_Blueprints_Blueprints__["a" /* default */],
    dataTable: __WEBPACK_IMPORTED_MODULE_3__components_Datatable__["a" /* default */]
  },
  data: function data() {
    return {
      progress: true,
      buildingComponent: null,
      blueprints: [],
      headers: [],
      loading: false,
      response: false,
      dialog: false,
      readonlyblueprint: null,
      search: "",
      sortBy: "name",
      sortDesc: false
    };
  },

  computed: {},
  watch: {
    headers: function headers() {
      this.$forceUpdate();
    },
    blueprints: function blueprints(n, o) {
      if (n.length > 0) {
        if (this.blueprints.some(function (x) {
          return x.isLocked;
        })) {
          this.headers = [{
            text: this.$t("name"),
            align: "left",
            value: "name"
          }, {
            text: this.$t("description"),
            align: "left",
            value: "description"
          }, {
            text: this.$t("markers"),
            value: "markers.length"
          }, {
            text: this.$t("isEditing"),
            value: "lockedByUserName"
          }, {
            text: this.$t("editStart"),
            value: "lockedTs"
          }, { text: this.$t("actions"), sortable: false, value: "actions" }];
        } else {
          this.headers = [{
            text: this.$t("name"),
            align: "left",
            value: "name"
          }, {
            text: this.$t("description"),
            align: "left",
            value: "description"
          }, {
            text: this.$t("markers"),
            value: "markers.length"
          }, { text: this.$t("actions"), sortable: false, value: "actions"
            //{ text: this.$t("table.markUp"), sortable: false }
          }];
        }
      }
    }
  },
  methods: {
    downloadExcel: function downloadExcel(blueprint) {
      var _this = this;

      this.loading = true;
      this.$http.downloadExcelExport(null, null, blueprint.id).then(function (res) {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var link = document.createElement("a");
        link.href = url;
        var date = new Date();
        link.setAttribute("download", blueprint.name + "_" + date.toLocaleDateString() + ".xlsx");
        document.body.appendChild(link);
        link.click();
        _this.loading = false;
      }).catch(function (err) {
        console.log(err);
        _this.$noty.error(_this.$t("error"));
        _this.loading = false;
      });
    },
    blueprintDetails: function blueprintDetails(item) {
      this.$router.push({
        name: "ArchivedBlueprintsDetails",
        params: {
          id: item.id
        }
      });
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("archivedProjects"),
        to: { name: "ArchivedProjects" }
      }, {
        name: this.buildingComponent.project,
        to: {
          name: "ArchivedProjectDetails",
          params: { id: this.buildingComponent.projectId }
        }
      }, {
        name: this.buildingComponent.name
      }];
    },
    getData: function getData() {
      var _this2 = this;

      this.progress = true;
      this.$http.getBuildingComponent(this.$route.params.id).then(function (res) {
        _this2.buildingComponent = res.data;
        _this2.$store.state.previous = {
          name: "ArchivedProjectDetails",
          id: res.data.projectId,
          breadcrumb: _this2.$t("project")
        };
        _this2.makeBreadcrumb();
      }).catch(function (err) {
        return console.log(err);
      });

      this.$http.getBlueprints(this.$route.params.id).then(function (res) {
        _this2.blueprints = res.data;
        _this2.progress = false;
      }).catch(function (err) {
        return console.log(err);
      });
    }
  },
  created: function created() {
    this.getData();
  }
});

/***/ }),
/* 309 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuex__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Markers_List__ = __webpack_require__(207);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_ZoomMarkup__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_async__ = __webpack_require__(118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_async___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_async__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Markers_ScanQRCode__ = __webpack_require__(119);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__services_service_ihub_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_q__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_q__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//













var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_8__services_service_ihub_js__["a" /* serviceihub */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "blueprintsDetails",
  components: {
    markers: __WEBPACK_IMPORTED_MODULE_3__components_pages_Markers_List__["a" /* default */],
    zoomMarkup: __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_ZoomMarkup__["a" /* default */],
    scanQRCode: __WEBPACK_IMPORTED_MODULE_7__components_pages_Markers_ScanQRCode__["a" /* default */]
  },
  data: function data() {
    var _this = this;

    return {
      blueprint: null,
      loadingText: "",
      hideMarkup: false,
      dialog: false,
      uploadForm: false,
      attributeTypes: null,
      leadThroughTypes: null,
      insulationTypes: null,
      menu: false,
      valid: false,
      nameRules: [function (v) {
        return !!v || _this.$t("name") + " " + _this.$t("required");
      }],
      markers: [],
      image: null,
      connection: navigator.onLine,
      saveDialog: false,
      to: null,
      fullscreen: false
    };
  },

  computed: {
    markersui: function markersui() {
      return this.$store.getters.markersui;
    },
    isOffline: function isOffline() {
      return this.$store.state.isOffline;
    }
  },
  methods: {
    toggleFullscreen: function toggleFullscreen(f) {
      this.fullscreen = !f;
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("archivedProjects"),
        to: { name: "ArchivedProjects" }
      }, {
        name: this.blueprint.project,
        to: {
          name: "ArchivedProjectDetails",
          params: { id: this.blueprint.projectId }
        }
      }, {
        name: this.blueprint.buildingComponent,
        to: {
          name: "ArchivedBuildingComponentDetails",
          params: { id: this.blueprint.buildingComponentId }
        }
      }, {
        name: this.blueprint.name
      }];
    },
    response: function response(answer) {
      if (answer) {
        this.$refs.markup.$refs.markupFullscreen.update();
      }
      this.saveDialog = false;
      this.hasChanges = false;
      this.$router.push({
        name: this.to.name,
        params: this.to.params
      });
    },
    showMarkerDetails: function showMarkerDetails(marker) {

      this.$router.push({
        name: "ArchivedMarkerDetails",
        params: {
          id: marker.id
        }
      });
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
      var resBlueprint;
      return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this2.$http.getBlueprint(_this2.$route.params.id);

            case 2:
              resBlueprint = _context.sent;

              _this2.blueprint = resBlueprint.data;
              _this2.makeBreadcrumb();

              //backbutton
              _this2.$store.state.previous = {
                name: "ArchivedBuildingComponentDetails",
                id: _this2.blueprint.buildingComponentId,
                breadcrumb: _this2.$t("buildingComponent")
              };

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, _this2);
    }))();
  },
  created: function created() {},

  watch: {
    isOffline: function isOffline(n, o) {
      if (!n) this.dialog = false;
    },
    readonly: function readonly(n, o) {},
    blueprint: function blueprint(n, o) {}
  }
});

/***/ }),
/* 310 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(25);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__(26);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_AddQRCode__ = __webpack_require__(124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_ZoomPicture__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_Markers_MarkerXSolutions_List__ = __webpack_require__(83);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_pages_Markers_Reports__ = __webpack_require__(125);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_pages_Markers_ZoomMarkup__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__services_service_ihub_js__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_crypto__ = __webpack_require__(127);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_crypto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_crypto__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_q__ = __webpack_require__(46);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_q___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_q__);


//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//












var _serviceIhub = new __WEBPACK_IMPORTED_MODULE_9__services_service_ihub_js__["a" /* serviceihub */]();

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "markerDetails",
  components: {
    zoomPicture: __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_ZoomPicture__["a" /* default */],
    addQRCode: __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_AddQRCode__["a" /* default */],
    solutionsList: __WEBPACK_IMPORTED_MODULE_6__components_pages_Markers_MarkerXSolutions_List__["a" /* default */],
    zoomMarkup: __WEBPACK_IMPORTED_MODULE_8__components_pages_Markers_ZoomMarkup__["a" /* default */],
    reports: __WEBPACK_IMPORTED_MODULE_7__components_pages_Markers_Reports__["a" /* default */]
  },
  beforeRouteLeave: function beforeRouteLeave(to, from, next) {
    if (this.$store.state.hasChanges) {
      this.$store.state.hasChanges = false;
      next();
    } else {
      next();
    }
  },

  props: {
    markerid: String
    //marker: Object
  },
  data: function data() {
    return {
      admin: false,
      dialog: false,
      attachment: null,
      loaded: false,
      marker: null,
      menu: false,
      valid: false,
      blueprint: null,
      selectedFile: null,
      nameRules: [function (v) {
        return !!v || "Name is required";
      }],
      isLoading: false,
      search: null,
      readonly: false,
      saveDialog: false,
      to: null,
      loadingText: ""
    };
  },

  computed: {
    isOffline: function isOffline() {
      return this.$store.state.isOffline;
    },
    statusItems: function statusItems() {
      return [{
        id: "0",
        name: this.$t("broken"),
        icon: "priority_high",
        color: "red",
        disabled: false
      }, {
        id: "1",
        name: this.$t("inProcess"),
        icon: "priority_high",
        color: "orange",
        disabled: true
      }, {
        id: "2",
        name: this.$t("approved"),
        icon: "check_circle",
        color: "success",
        disabled: false
      }];
    }
  },
  methods: {
    openSolution: function openSolution(mxs) {
      this.$router.push({
        name: "ArchivedMarkerXSolutionDetails",
        params: {
          id: this.marker.id,
          markerXSolutionId: mxs.id,
          markerXSolution: mxs,
          marker: this.marker,
          blueprint: this.blueprint,
          readonly: true
        }
      });
    },
    makeBackButton: function makeBackButton() {
      this.$store.state.previous = {
        name: "ArchivedBlueprintsDetails",
        id: this.blueprint.id,
        breadcrumb: this.$t("blueprint")
      };
    },
    makeBreadcrumb: function makeBreadcrumb() {
      this.$store.state.breadcrumb = [{
        name: this.$t("archivedProjects"),
        to: { name: "ArchivedProjects" }
      }, {
        name: this.blueprint.project,
        to: {
          name: "ArchivedProjectDetails",
          params: { id: this.blueprint.projectId }
        }
      }, {
        name: this.blueprint.buildingComponent,
        to: {
          name: "ArchivedBuildingComponentDetails",
          params: { id: this.blueprint.buildingComponentId }
        }
      }, {
        name: this.blueprint.name,
        to: {
          name: "ArchivedBlueprintsDetails",
          params: { id: this.blueprint.id }
        }
      }, {
        name: this.$t("marker") + " " + this.marker.number + " " + (this.marker.label ? ' - ' + this.marker.label : '')
      }];
    },
    getProductSolutions: function getProductSolutions() {
      var _this = this;

      if (this.$store.state.productSolutions == null) {
        this.$http.getProductSolutions(true).then(function (res) {
          _this.$store.state.productSolutions = res.data;
        }).catch(function (err) {
          console.log(err);
        });
      }
    },
    getAllAttributesAndSaveInStore: function getAllAttributesAndSaveInStore() {
      var _this2 = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()( /*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var res;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(_this2.$store.state.allAttributes == null)) {
                  _context.next = 11;
                  break;
                }

                _context.prev = 1;
                _context.next = 4;
                return _this2.$http.getAttributes(false, true);

              case 4:
                res = _context.sent;

                _this2.$store.state.allAttributes = res.data;
                _context.next = 11;
                break;

              case 8:
                _context.prev = 8;
                _context.t0 = _context["catch"](1);

                console.log(_context.t0);

              case 11:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this2, [[1, 8]]);
      }))();
    }
  },
  watch: {
    marker: function marker(n, o) {
      if (n != null || n != undefined) {
        if (n.installerId == null) {
          this.marker.installerId = parseInt(__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem("auth")).contactId);
        }
      }
    },
    blueprint: function blueprint(n, o) {
      // if (n) {
      //   if (n.isLocked) {
      //     if (
      //       n.lockedByUserId ==
      //       parseInt(jwtdecode(localStorage.getItem("auth")).contactId)
      //     ) {
      //       this.readonly = false;
      //     } else {
      //       this.readonly = true;
      //     }
      //   } else {
      //     this.readonly = true;
      //   }
      // }
    },
    readonly: function readonly() {}
  },
  created: function created() {
    var _this3 = this;

    if (this.$store.state.isOffline) {
      alert("could not load marker, connect to internet");
      this.blueprint = this.$store.state.offline.offBlueprint;
      this.makeBackButton();
      // if (this.$route.params.saveMarker) {
      //   this.$nextTick(() => {
      //     this.updateMarker();
      //   });
      // }
    } else {
      this.getAllAttributesAndSaveInStore();
      this.$http.getMarker(this.$route.params.id).then(function (res) {
        _this3.marker = res.data;
        // this.$store.state.markers = [];
        _this3.$store.commit("AddAndSetUIelementsReadonly", res.data);
        _this3.$http.getBlueprint(_this3.marker.blueprintId).then(function (res) {
          _this3.blueprint = res.data;
          _this3.makeBackButton();
          _this3.makeBreadcrumb();
        }).catch(function (err) {
          return console.log(err);
        });
      });
      this.getProductSolutions();
    }
  }
});

/***/ }),
/* 311 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid__ = __webpack_require__(9);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_uuid___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_uuid__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Products__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_pages_Markers_AddAttachment__ = __webpack_require__(300);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_ZoomPicture__ = __webpack_require__(36);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_SolutionSelector_Index__ = __webpack_require__(302);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_pages_solutions_PIMSolutionDetails__ = __webpack_require__(143);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//







/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    products: __WEBPACK_IMPORTED_MODULE_2__components_Products__["a" /* default */],
    addAttachment: __WEBPACK_IMPORTED_MODULE_3__components_pages_Markers_AddAttachment__["a" /* default */],
    zoomPicture: __WEBPACK_IMPORTED_MODULE_4__components_pages_Markers_ZoomPicture__["a" /* default */],
    solutionSelector: __WEBPACK_IMPORTED_MODULE_5__components_pages_Markers_SolutionSelector_Index__["a" /* default */],
    pimSolutionDetails: __WEBPACK_IMPORTED_MODULE_6__components_pages_solutions_PIMSolutionDetails__["a" /* default */]
  },
  data: function data() {
    var _ref;

    return _ref = {
      list: false,
      attributesDialog: false,
      pimSolutionDialog: false,
      markerXSolution: null,
      marker: null,
      blueprint: null,
      readonly: false,
      active: null,
      attributes: [],
      isReady: false,
      dialog: false,
      img: null,
      showDelete: false,
      isShowing: false,
      unusedAttributes: null,
      options: {
        duration: 300,
        easing: "easeInOutCubic",
        offset: 0
      },
      dimensionDialog: false
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "attributesDialog", false), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "emptyImage", __webpack_require__(18)), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_ref, "valid", false), _ref;
  },

  methods: {
    deleteMarkerXSolution: function deleteMarkerXSolution(id) {
      var _this = this;

      if (this.marker.markerXSolutions.find(function (x) {
        return x.id == id;
      }).new) {
        this.marker.markerXSolutions = this.marker.markerXSolutions.filter(function (x) {
          return x.id != id;
        });
      } else {
        if (this.$store.state.isOffline) {
          var offForm = {
            deleteMarkerXSolution: id
          };
          this.$store.state.offForm.push(offForm);
        } else {
          this.$http.deleteMarkerXSolution(id).then(function (res) {
            _this.marker.markerXSolutions = _this.marker.markerXSolutions.filter(function (x) {
              return x.id != id;
            });
            _this.$store.commit("updateMarker", _this.marker);
            _this.$noty.success('<i class="fas fa-check"></i>');
          }).catch(function (err) {
            console.log(err);
            _this.$noty.error(_this.$t("error"));
          });
        }
      }

      this.$store.state.previous.params.deleteMarkerXSolution = this.marker;
      this.$router.push({
        name: this.$store.state.previous.name,
        params: this.$store.state.previous.params
      });
    },
    bindAttributeSelectbox: function bindAttributeSelectbox(attribute, textbox) {
      var _this2 = this;

      if (this.markerXSolution.solutionId) {
        if (textbox) {
          if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(function (x) {
            return x.qrLogAttributeId == attribute.id;
          })) {
            return this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
              return x.qrLogAttributeId == attribute.id;
            })[0].value;
          }
        } else {
          if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.length > 0 && this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(function (s) {
            return s.qrLogAttributeId == attribute.id;
          })) {
            return attribute.qrLogAttributeListValue.filter(function (s) {
              return s.id == _this2.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
                return x.qrLogAttributeId == attribute.id;
              })[0].qrLogAttributeListValueId;
            }).length > 0 ? attribute.qrLogAttributeListValue.filter(function (s) {
              return s.id == _this2.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
                return x.qrLogAttributeId == attribute.id;
              })[0].qrLogAttributeListValueId;
            })[0].id : null;
          }
        }

        // this.changeImage();
      }
    },
    attributeSelected: function attributeSelected(value, attribute) {
      var _this3 = this;

      if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(function (x) {
        return x.qrLogAttributeId == attribute.id;
      })) {
        this.markerXSolution.qrLogAttributeXMarkerXSolutions.forEach(function (qaxmsx, i) {
          if (attribute.id == qaxmsx.qrLogAttributeId) {
            if (value == undefined) {
              qaxmsx.value = null;
              qaxmsx.qrLogAttributeListValueId = null;
            } else {
              if (_this3.$validator.isUUID(value)) {
                qaxmsx.qrLogAttributeListValueId = value;
                return;
              } else {
                qaxmsx.value = value;
                return;
              }
            }
          }
        });
      } else {
        this.markerXSolution.qrLogAttributeXMarkerXSolutions.push({
          id: __WEBPACK_IMPORTED_MODULE_1_uuid___default.a.v4(),
          markerXSolutionsId: this.markerXSolution.id,
          qrLogAttributeId: attribute.id,
          qrLogAttributeListValueId: this.$validator.isUUID(value) ? value : null,
          value: !this.$validator.isUUID(value) ? value : null
        });
      }
      this.changeImage();
    },
    solutionSelectorSelectedSolution: function solutionSelectorSelectedSolution(event, markerXSolutionIndex) {
      var _this4 = this;

      this.markerXSolution.solutionId = event.solution.Id;

      this.markerXSolution.qrLogAttributeXMarkerXSolutions.forEach(function (qaxmxs, i) {
        _this4.$store.state.allAttributes.forEach(function (atr, o) {
          atr.qrLogAttributeListValue.forEach(function (listvalue) {
            event.taxonomies.forEach(function (taxId) {
              if (atr.qrLogAttributeListValue.some(function (x) {
                return x.id == taxId;
              })) {
                if (taxId == listvalue.id && qaxmxs.qrLogAttributeId == atr.id) {
                  _this4.markerXSolution.qrLogAttributeXMarkerXSolutions[i].qrLogAttributeListValueId = taxId;
                }
              }
            });
          });
        });
      });

      this.$refs.form.validate();
      this.changeImage();
    },
    required: function required(_required) {
      var _this5 = this;

      if (_required) {
        return [function (v) {
          return v != "00000000-0000-0000-0000-000000000000" || "" + _this5.$t("required");
        }, function (v) {
          return !!v || "" + _this5.$t("required");
        }];
      }
    },
    showRequiredMessage: function showRequiredMessage() {
      return this.$t("fillinrequiredfields");
    },
    attributesToString: function attributesToString(mxs) {
      var _this6 = this;

      var text = "";
      mxs.qrLogAttributeXMarkerXSolutions.forEach(function (x) {
        if (_this6.$store.state.allAttributes.some(function (f) {
          return f.id == x.qrLogAttributeId;
        })) {
          if (!x.value) {
            var attribute = _this6.$store.state.allAttributes.filter(function (f) {
              return f.id == x.qrLogAttributeId;
            })[0].qrLogAttributeListValue.find(function (z) {
              return z.id == x.qrLogAttributeListValueId;
            });
            if (attribute) {
              text += "<small class=\"subtitle-2\">" + _this6.$store.state.allAttributes.filter(function (f) {
                return f.id == x.qrLogAttributeId;
              })[0].code + "</small>: " + attribute.description + ", ";
            }
          } else {
            text += _this6.$store.state.allAttributes.filter(function (f) {
              return f.id == x.qrLogAttributeId;
            })[0].code + ": " + x.value + ", ";
          }
        }
      });
      // this.changeImage();
      return text;
    },
    dimensionsToString: function dimensionsToString(mxs) {
      var html = "";
      if (mxs.amount != undefined) {
        html += "<small class=\"subtitle-2\">" + this.$t("amount") + "</small>: " + mxs.amount + ",";
      }
      if (mxs.unit != undefined) {
        html += "<small class=\"subtitle-2\"> " + this.$t("unit") + "\n        </small>: " + mxs.unit + ",";
      }
      if (mxs.width != undefined) {
        html += "<small class=\"subtitle-2\"> " + this.$t("width") + "</small>: " + mxs.width + ",";
      }
      if (mxs.height != undefined) {
        html += "<small class=\"subtitle-2\">" + this.$t("height") + "</small>: " + mxs.height + ",";
      }
      if (mxs.length != undefined) {
        html += "<small class=\"subtitle-2\">" + this.$t("length") + "</small>: " + mxs.length + ",";
      }
      if (mxs.diameter != undefined) {
        html += this.$t("diameter") + ": " + mxs.diameter;
      }
      return html;
    },
    selected: function selected(solutionId, _selected) {
      this.marker.markerXSolutions.forEach(function (mxs) {
        if (mxs.solutionId == solutionId) {
          mxs.selectedProducts = _selected.reduce(function (res, x) {
            if (x.selected) {
              var someNewValue = {
                id: __WEBPACK_IMPORTED_MODULE_1_uuid___default.a.v4(),
                markerXSolutionsId: mxs.id,
                productId: x.id
              };
              res.push(someNewValue);
            }
            return res;
          }, []);
        }
      });
    },
    zoomPicture: function zoomPicture(img) {
      this.img = img;
      this.dialog = true;
    },
    deletePicture: function deletePicture(attachment) {
      this.markerXSolution.attachments = this.markerXSolution.attachments.filter(function (p) {
        return p.id != attachment.id;
      });
      this.$store.commit("updateMarker", this.marker);
    },
    addPicture: function addPicture(picture) {
      this.markerXSolution.attachments.unshift(picture);
      this.$store.commit("updateMarker", this.marker);
    },
    canDelete: function canDelete(date) {
      if (date.substring(0, 10) == new Date().toLocaleDateString("fr-CA"))
        //yyyy-MM-dd
        return true;else return false;
    },
    goBackToMarker: function goBackToMarker() {
      this.$router.push({
        name: "ArchivedMarkerDetails",
        params: { id: this.$route.params.id }
      });
    },
    saveSolution: function saveSolution() {
      this.$store.state.previous.params.saveMarker = true;
      this.$router.push({
        name: this.$store.state.previous.name,
        params: this.$store.state.previous.params
      });
    },
    makeBackButton: function makeBackButton() {
      this.$store.state.previous = {
        name: "ArchivedMarkerDetails",
        params: {
          id: this.markerXSolution.markerId,
          marker: this.$route.params.marker,
          blueprint: this.$route.params.blueprint
        },
        breadcrumb: this.$t("marker")
      };
    },
    changeImage: function changeImage() {
      var _this7 = this;

      if (this.markerXSolution.solutionId) {
        this.markerXSolution.product = this.$store.state.productSolutions.find(function (x) {
          return x.id == _this7.markerXSolution.solutionId;
        }).image;
      }

      //using form to check required attributes
      if (this.$refs.form) {
        // if (this.markerXSolution.attributesDialog == true) {
        this.$nextTick(function () {
          if (_this7.$refs.form.validate()) {
            _this7.markerXSolution.valid = false;
            _this7.$forceUpdate();
          } else {
            _this7.markerXSolution.valid = true;
            _this7.$forceUpdate();
          }
        });

        // }
        // else{
        if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
          return _this7.$store.state.allAttributes.filter(function (x) {
            return x.required;
          }).some(function (s) {
            return s.id == x.qrLogAttributeId;
          }) && (x.qrLogAttributeListValueId != null || x.value != null);
        })) {
          this.markerXSolution.valid = true;
        } else {
          this.markerXSolution.valid = false;
        }
        // }
      } else {
        // if (
        //   this.markerXSolution.qrLogAttributeXMarkerXSolutions.some(
        //     s =>
        //       s.qrLogAttributeId == x.id &&
        //       (s.qrLogAttributeListValueId != null || s.value != null)
        //   )
        // ) {
        //   console.log("1");
        //   this.markerXSolution.valid = false;
        // } else {
        //   console.log(2, this.markerXSolution);
        //   this.markerXSolution.valid = true;
        // }

        if (this.markerXSolution.qrLogAttributeXMarkerXSolutions.filter(function (x) {
          return _this7.$store.state.allAttributes.filter(function (x) {
            return x.required;
          }).some(function (s) {
            return s.id == x.qrLogAttributeId;
          }) && (x.qrLogAttributeListValueId != null || x.value != null);
        })) {
          this.markerXSolution.valid = true;
        } else {
          this.markerXSolution.valid = false;
        }
      }
    }
  },
  watch: {
    markerXSolution: function markerXSolution(n, o) {
      this.changeImage();
      try {
        n.qrLogAttributeXMarkerXSolutions.sort(function (a, b) {
          return a.qrLogAttribute.index > b.qrLogAttribute.index ? 1 : b.qrLogAttribute.index > a.qrLogAttribute.index ? -1 : 0;
        });
      } catch (error) {}
    }
  },
  created: function created() {
    if (this.$route.params.markerXSolution !== undefined && this.$route.params.marker !== undefined && this.$route.params.blueprint !== undefined) {
      this.markerXSolution = this.$route.params.markerXSolution;
      this.readonly = this.$route.params.readonly;
      this.isReady = true;
      this.marker = this.$route.params.marker;
      this.blueprint = this.$route.params.blueprint;
      this.makeBackButton();
      this.changeImage();
    } else {
      this.goBackToMarker();
    }
  }
});

/***/ }),
/* 312 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sha256__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sha256___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sha256__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      tab: null,
      validToken: false,
      show: false,
      loading: false,
      valid: false,
      newpwd: null,
      confirmpwd: null,
      credentials: {
        username: "",
        inputP: "",
        password: "",
        honeypot: ""
      }
    };
  },
  methods: {
    passwordRules: function passwordRules() {
      var _this = this;

      return [function (v) {
        return !!v || _this.$t("password") + " " + _this.$t("required");
      }];
    },
    encrypt: function encrypt() {
      this.credentials.password = __WEBPACK_IMPORTED_MODULE_0_sha256___default()(this.newpwd);
    },
    changePassword: function changePassword() {
      var _this2 = this;

      if (this.$refs.formpswd.validate()) {
        this.encrypt();
        this.$http.forgotPasswordReset(this.credentials.password, this.$route.query.token).then(function (res) {
          _this2.$router.push({ name: "Login" });
        }).catch(function (error) {
          _this2.$noty.error(_this2.$t("error"));
        });
      }
    }
  },
  created: function created() {
    var _this3 = this;

    this.$http.forgotPasswordChallengeCheck(this.$route.query.token).then(function (res) {
      _this3.validToken = true;
    }).catch(function (err) {
      console.log(err);
      _this3.$router.push({ name: "Login" });
    });
  }
});

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__services_service_oryx_js__ = __webpack_require__(89);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__settings_settings_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//





/* harmony default export */ __webpack_exports__["a"] = ({
  data: function data() {
    return {
      read: false,
      legalDocument: null
    };
  },

  methods: {
    acceptTermsOfService: function acceptTermsOfService() {
      var _this = this;

      this.$http.acceptTermsOfService().then(function (res) {
        localStorage.setItem("auth", res.data);
        _this.$router.push({
          name: "Projects"
        });
      }).catch(function (err) {
        console.log(err);
      });
    }
  },
  created: function created() {
    this.legalDocument = __WEBPACK_IMPORTED_MODULE_1__settings_settings_js__["a" /* default */].oryxUrlBaseUrl + "LegalAttachments/DownloadLegalAttachment?companyId=" + __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem("auth")).companyId;
  }
});

/***/ }),
/* 314 */,
/* 315 */,
/* 316 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
    name: "Loading"
});

/***/ }),
/* 317 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dialog: Boolean,
    text: String
  },
  data: function data() {
    return {};
  }
});

/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    object: String,
    id: String,
    icon: Boolean,
    button: Boolean,
    fk: String,
    small: Boolean,
    text: String,
    list_item: Boolean,
    color: {
      type: String,
      default: "error"
    },
    disabled: Boolean
  },
  data: function data() {
    return {
      dialog: false
    };
  },

  methods: {
    remove: function remove(id, fk) {
      var _this = this;

      switch (this.object) {
        case "project":
          this.$http.deleteProject(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "buildingComponent":
          this.$http.deleteBuildingComponents(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "blueprint":
          this.$http.deleteBlueprint(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "marker":
          // code block
          this.$http.deleteMarker(id).then(function (rs) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "attachment":
          // code block
          this.$http.deleteAttachment(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "attribute":
          // code block
          this.$http.deleteAttribute(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("deleteAttribute", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "attributeValue":
          // code block
          this.$http.deleteValues(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("deleteValue", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "solution":
          // code block
          break;
        case "solutionXproduct":
          if (fk !== "") {
            this.$http.deleteSolutionXproduct(id, fk).then(function (res) {
              _this.$noty.success('<i class="fas fa-check"></i>');
              _this.$emit("deleteSolutionXproduct", fk);
              _this.dialog = false;
            }).catch(function (err) {
              _this.$noty.error(_this.$t("error"));
              console.log(err);
            });
          }

          break;
        case "installer":
          // code block
          break;
        case "productAttachment":
          this.$http.deleteProductAttachment(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
          break;
        case "report":
          this.$http.deleteReport(id).then(function (res) {
            _this.$noty.success('<i class="fas fa-check"></i>');
            _this.$emit("delete", id);
            _this.dialog = false;
          }).catch(function (err) {
            _this.$noty.error(_this.$t("error"));
            console.log(err);
          });
        default:
          this.$emit("delete");
          this.dialog = false;
      }
      this.dialog = false;
    }
  }
});

/***/ }),
/* 319 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  name: "list-transition",
  props: {
    tag: String,
    height: {
      type: String,
      default: function _default() {
        return "3.6em";
      }
    }
  },
  data: function data() {
    return {};
  },

  methods: {
    beforeEnter: function beforeEnter(el) {
      el.style.opacity = 0;
      el.style.height = 0;
    },
    enter: function enter(el, done) {
      var delay = el.dataset.index * 150;
      var h = this.height;
      setTimeout(function () {
        Velocity(el, { opacity: 1, height: h }, { complete: done });
      }, delay);
    },
    leave: function leave(el, done) {
      var delay = el.dataset.index * 150;
      setTimeout(function () {
        Velocity(el, { opacity: 0, height: 0 }, { complete: done });
      }, delay);
    }
  }
});

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    dialog: Boolean
  },
  data: function data() {
    return {};
  },

  methods: {
    response: function response(answer) {
      this.$emit("response", answer);
      //this.dialog = false;
    }
  }
});

/***/ }),
/* 321 */,
/* 322 */,
/* 323 */,
/* 324 */,
/* 325 */,
/* 326 */,
/* 327 */,
/* 328 */,
/* 329 */,
/* 330 */,
/* 331 */,
/* 332 */,
/* 333 */,
/* 334 */,
/* 335 */,
/* 336 */,
/* 337 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__App__ = __webpack_require__(339);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__router__ = __webpack_require__(111);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__plugins_vuetify__ = __webpack_require__(740);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__settings_locales_js__ = __webpack_require__(742);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_vue_i18n__ = __webpack_require__(743);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__casl_vue__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__services_ability__ = __webpack_require__(745);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_Loading__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_LoadingDialog__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_AreYouSure__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ListTransition__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_SaveBeforeLeave__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_qrcode_reader__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_vue_qrcode_reader___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_vue_qrcode_reader__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_validator__ = __webpack_require__(762);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_validator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_validator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_konva__ = __webpack_require__(823);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_vue_konva___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_vue_konva__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_image_upload_resize__ = __webpack_require__(863);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_vue_image_upload_resize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_vue_image_upload_resize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__settings_settings_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuejs_noty__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_vuejs_noty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_vuejs_noty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__services_service_js__ = __webpack_require__(865);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_qs__ = __webpack_require__(281);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_qs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_20_qs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_js_toggle_button__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_vue_js_toggle_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_21_vue_js_toggle_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_hammerjs__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_hammerjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_hammerjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__store_store__ = __webpack_require__(146);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__registerServiceWorker__ = __webpack_require__(868);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.























//vuetify switch button does not work great on banner componenet

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_21_vue_js_toggle_button___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_18_vuejs_noty___default.a, {
	layout: 'bottomRight',
	theme: 'nest'
});



//Hammer is useful for touch gestures





//We can now access	 this package with this.$validator
//https://www.npmjs.com/package/validator
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype, '$validator', { value: __WEBPACK_IMPORTED_MODULE_14_validator___default.a });

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_13_vue_qrcode_reader___default.a);

//Global method
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].mixin({
	methods: {
		isUUID: function isUUID(uuid) {
			if (uuid != undefined) return __WEBPACK_IMPORTED_MODULE_14_validator___default.a.isUUID(uuid) && uuid != '00000000-0000-0000-0000-000000000000' && uuid != undefined;else return false;
		}
	}
});
//Anwar:creating custom directives
//swipeleft 
//We can use them like so: <tr v-swipeleft:swipeleft="(e)=>deleteMarker(e)"></tr>
//https://vuejs.org/v2/guide/custom-directive.html
//https://codepen.io/lisilinhart/pen/wxRQBo
//https://hammerjs.github.io/recognizer-swipe/

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive("swipeleft", {
	bind: function bind(el, binding) {
		if (typeof binding.value === "function") {
			var mc = new __WEBPACK_IMPORTED_MODULE_22_hammerjs___default.a(el);
			mc.get("swipeleft");
			mc.on("swipeleft", binding.value);
		}
	}
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive("swiperight", {
	bind: function bind(el, binding) {
		if (typeof binding.value === "function") {
			var mc = new __WEBPACK_IMPORTED_MODULE_22_hammerjs___default.a(el);
			mc.get("swiperight");
			mc.on("swiperight", binding.value);
		}
	}
});
//longpress
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].directive("press", {
	bind: function bind(el, binding) {
		if (typeof binding.value === "function") {
			var mc = new __WEBPACK_IMPORTED_MODULE_22_hammerjs___default.a(el);
			mc.get("press").set({ time: 2000 });
			mc.on("press", binding.value);
		}
	}
});

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$http = __WEBPACK_IMPORTED_MODULE_19__services_service_js__["a" /* default */];
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].prototype.$qs = __WEBPACK_IMPORTED_MODULE_20_qs___default.a;

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('Can', __WEBPACK_IMPORTED_MODULE_6__casl_vue__["a" /* Can */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('loading', __WEBPACK_IMPORTED_MODULE_8__components_Loading__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('loadingDialog', __WEBPACK_IMPORTED_MODULE_9__components_LoadingDialog__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('areyousure', __WEBPACK_IMPORTED_MODULE_10__components_AreYouSure__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('savebeforeleave', __WEBPACK_IMPORTED_MODULE_12__components_SaveBeforeLeave__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].component('list-transition', __WEBPACK_IMPORTED_MODULE_11__components_ListTransition__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_15_vue_konva___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_16_vue_image_upload_resize___default.a);

__WEBPACK_IMPORTED_MODULE_0_vue__["default"].config.productionTip = false;
var language = localStorage.getItem("language");
if (!language) language = "EN";
var i18n = new __WEBPACK_IMPORTED_MODULE_5_vue_i18n__["a" /* default */]({
	locale: language,
	fallbackLocale: 'EN',
	messages: __WEBPACK_IMPORTED_MODULE_4__settings_locales_js__["a" /* default */]
});
__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_6__casl_vue__["b" /* abilitiesPlugin */], __WEBPACK_IMPORTED_MODULE_7__services_ability__["a" /* default */]);
/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["default"]({
	el: '#app',
	store: __WEBPACK_IMPORTED_MODULE_23__store_store__["a" /* store */],
	router: __WEBPACK_IMPORTED_MODULE_2__router__["a" /* default */],
	vuetify: __WEBPACK_IMPORTED_MODULE_3__plugins_vuetify__["a" /* default */],
	i18n: i18n,
	//template: '<App/>',
	render: function render(h) {
		return h(__WEBPACK_IMPORTED_MODULE_1__App__["a" /* default */]);
	}
	//components: { App }
}).$mount('#app');

/***/ }),
/* 338 */,
/* 339 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__(152);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd5faa6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__(372);
function injectStyle (ssrContext) {
  __webpack_require__(340)
  __webpack_require__(342)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6dd5faa6_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 340 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 341 */,
/* 342 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/pattern.ad0335b.jpg";

/***/ }),
/* 344 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 345 */,
/* 346 */,
/* 347 */,
/* 348 */,
/* 349 */,
/* 350 */,
/* 351 */,
/* 352 */,
/* 353 */,
/* 354 */,
/* 355 */,
/* 356 */,
/* 357 */,
/* 358 */,
/* 359 */,
/* 360 */,
/* 361 */,
/* 362 */,
/* 363 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 364 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadStickers_vue__ = __webpack_require__(168);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf6942d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadStickers_vue__ = __webpack_require__(366);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_DownloadStickers_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_cf6942d4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_DownloadStickers_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"590"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"block":"","depressed":"","color":"secondary"}},on),[_c('v-icon',{attrs:{"small":""}},[_vm._v("save_alt")]),_vm._v("QR code stickers\n    ")],1)]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),(_vm.dialog && _vm.stickerTemplate)?_c('v-card',{staticClass:"container"},[_c('v-card-text',[_c('v-list',{attrs:{"subheader":"","two-line":"","flat":""}},[_c('v-subheader',[_vm._v("QR code stickers")]),_vm._v(" "),_c('v-list-item-group',{model:{value:(_vm.type),callback:function ($$v) {_vm.type=$$v},expression:"type"}},[_c('v-list-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
return [_c('v-list-item-action',[_c('v-checkbox',{attrs:{"color":"primary"},on:{"click":function($event){active = !active}},model:{value:(active),callback:function ($$v) {active=$$v},expression:"active"}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('withlogo')))]),_vm._v(" "),_c('v-list-item-subtitle',[_c('a',{on:{"click":function($event){_vm.dialog = false; _vm.$router.push({name: 'Profile'})}}},[_vm._v(_vm._s(_vm.$t('addyourownlogo')))])])],1)]}}],null,false,3594801590)}),_vm._v(" "),_c('v-list-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
return [_c('v-list-item-action',[_c('v-checkbox',{attrs:{"color":"primary"},on:{"click":function($event){active = !active}},model:{value:(active),callback:function ($$v) {active=$$v},expression:"active"}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('csv')))]),_vm._v(" "),_c('v-list-item-subtitle')],1)]}}],null,false,2188124047)}),_vm._v(" "),_c('v-list-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
return [_c('v-list-item-action',[_c('v-checkbox',{attrs:{"color":"primary"},on:{"click":function($event){active = !active}},model:{value:(active),callback:function ($$v) {active=$$v},expression:"active"}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('withoutlogo'))+" 35x35")]),_vm._v(" "),_c('v-list-item-subtitle')],1)]}}],null,false,843970397)}),_vm._v(" "),_c('v-list-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
return [_c('v-list-item-action',[_c('v-checkbox',{attrs:{"color":"primary"},on:{"click":function($event){active = !active}},model:{value:(active),callback:function ($$v) {active=$$v},expression:"active"}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t('withoutlogo'))+" 25x25")]),_vm._v(" "),_c('v-list-item-subtitle')],1)]}}],null,false,4172187837)})],1)],1),_vm._v(" "),_c('v-select',{attrs:{"outlined":"","dense":"","items":_vm.items,"label":_vm.$t('amount')},model:{value:(_vm.amount),callback:function ($$v) {_vm.amount=$$v},expression:"amount"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","block":"","disabled":_vm.amount == null,"depressed":""},on:{"click":function($event){return _vm.downloadStickers()}}},[_vm._v(_vm._s(_vm.$t('download')))])],1)],1):_vm._e(),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuperUser_vue__ = __webpack_require__(169);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e016e7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuperUser_vue__ = __webpack_require__(371);
function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SuperUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4e016e7e_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SuperUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 368 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 369 */,
/* 370 */,
/* 371 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","width":"700"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"flat":""}},[_c('v-card-title',[_vm._v(" Choose an account ")]),_vm._v(" "),_c('v-card-text',[_c('v-autocomplete',{staticClass:"mx-4",attrs:{"loading":_vm.loading,"items":_vm.items,"search-input":_vm.search,"cache-items":"","outlined":"","hide-no-data":"","hide-details":"","label":"Search customer","return-object":"","item-text":"Name"},on:{"update:searchInput":function($event){_vm.search=$event},"update:search-input":function($event){_vm.search=$event}},model:{value:(_vm.select),callback:function ($$v) {_vm.select=$$v},expression:"select"}}),_vm._v(" "),(_vm.select)?[_c('section',{staticClass:"pa-2"},[_c('div',[_c('label',[_vm._v("Customer:")]),_vm._v(" "+_vm._s(_vm.select.Customer))]),_vm._v(" "),_c('div',[_c('label',[_vm._v("License:")]),_vm._v(" "+_vm._s(_vm.select.License))]),_vm._v(" "),_c('div',[_c('label',[_vm._v("Profile:")]),_vm._v(" "+_vm._s(_vm.select.Profile))])])]:_vm._e()],2),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"loading":_vm.progress,"depressed":"","color":"primary","disabled":!_vm.select},on:{"click":_vm.login}},[_vm._v("\n        Login\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 372 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{directives:[{name:"resize",rawName:"v-resize",value:(_vm.onResize),expression:"onResize"}],staticClass:"transparent",attrs:{"id":"inspire"}},[(_vm.$store.state.loggedIn)?_c('v-navigation-drawer',{staticStyle:{"border":"0px"},attrs:{"app":""},scopedSlots:_vm._u([{key:"append",fn:function(){return [_c('div',{staticClass:"pa-2",staticStyle:{"margin-bottom":"110px"}},[_c('v-btn',{attrs:{"color":"primary","block":""},on:{"click":_vm.logout}},[_c('v-icon',{attrs:{"color":"white","small":"","large":""}},[_vm._v("exit_to_app")]),_vm._v("\n          "+_vm._s(_vm.$t('signout'))+"\n        ")],1)],1)]},proxy:true}],null,false,2582073251),model:{value:(_vm.drawer),callback:function ($$v) {_vm.drawer=$$v},expression:"drawer"}},[_c('v-list',{staticClass:"py-0",attrs:{"dense":"","nav":"","flat":""}},[_c('v-list-item-group',{attrs:{"mandatory":"","color":"secondary"},model:{value:(_vm.menuActive),callback:function ($$v) {_vm.menuActive=$$v},expression:"menuActive"}},[_c('v-list-item',{staticClass:"mb-0",attrs:{"two-line":"","to":"/Profile"}},[_c('v-list-item-avatar',[_c('v-icon',{attrs:{"color":"primary","large":""}},[_vm._v("account_circle")])],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(_vm.user))])],1),_vm._v(" "),_vm._l((_vm.items),function(item,i){return [(item.can)?[(item.sub)?[_c('v-list-group',{key:i,attrs:{"color":"primary"},scopedSlots:_vm._u([{key:"activator",fn:function(){return [_c('v-list-item-icon',[_c('v-badge',{attrs:{"overlap":"","value":item.notification,"content":item.notification,"color":item.color}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(item.icon))])],1)],1),_vm._v(" "),_c('v-list-item-title',[_vm._v(_vm._s(item.text))])]},proxy:true}],null,true)},[_vm._v(" "),_c('v-list-item-group',{attrs:{"mandatory":"","color":"secondary"},model:{value:(_vm.menuActive),callback:function ($$v) {_vm.menuActive=$$v},expression:"menuActive"}},[_vm._l((item.subgroups),function(subgroup,i){return [(subgroup.can)?_c('v-list-item',{key:i,staticClass:"ml-6 mb-0",attrs:{"to":{path: subgroup.name}}},[_c('v-list-item-icon',[_c('v-badge',{attrs:{"overlap":"","value":subgroup.notification,"content":subgroup.notification,"color":subgroup.color}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(subgroup.icon))])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(subgroup.text))])],1)],1):_vm._e()]})],2)],1)]:_c('v-list-item',{key:i,staticClass:"mb-0",attrs:{"to":{path: item.name}}},[_c('v-list-item-icon',[_c('v-badge',{attrs:{"overlap":"","value":item.notification,"content":item.notification,"color":item.color}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(item.icon))])],1)],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(item.text))])],1)],1)]:_vm._e()]})],2)],1),_vm._v(" "),_c('div',{staticClass:"pa-2"},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-btn',{staticClass:"mb-2",attrs:{"block":"","depressed":"","color":"success"},on:{"click":_vm.downloadExcel}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("save_alt")]),_vm._v("Download Excel\n        ")],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"download","a":"stickers"}},[_c('downloadStickers')],1)],1)],1):_vm._e(),_vm._v(" "),(_vm.$store.state.loggedIn)?_c('v-app-bar',{staticClass:"pa-0",attrs:{"dense":"","dark":"","color":_vm.$store.state.colors.primary,"flat":"","app":""}},[_c('router-view',{attrs:{"name":"header"},on:{"openDrawer":_vm.toggleDrawer}}),_vm._v(" "),(!_vm.$store.state.isOffline)?[_c('v-toolbar-title',[_c('router-link',{attrs:{"to":{ name: 'Projects' }}},[_c('a',{staticStyle:{"color":"white"}},[_c('img',{attrs:{"src":__webpack_require__(170),"width":"40","height":"40"}}),_vm._v(" "),(_vm.$vuetify.breakpoint.smAndUp)?[_vm._v("FIRELOG")]:_vm._e()],2)])],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.releaseNoteOverview)?_c('v-menu',{attrs:{"transition":"scale-transition","origin":"right top","left":"","close-on-content-click":false,"nudge-width":200,"max-height":"500","max-width":"500","offset-x":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"text":""},on:{"click":_vm.readReleaseNotes}},'v-btn',attrs,false),on),[_c('v-badge',{attrs:{"left":"","color":"error","value":_vm.releaseNoteOverview.count,"content":_vm.releaseNoteOverview.count,"overlap":""}},[_c('v-icon',{attrs:{"color":"white","small":""}},[_vm._v("fa-bell")])],1)],1)]}}],null,false,1641361286),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-card',{staticClass:"pa-2"},[_c('v-card-title',[_c('v-icon',{attrs:{"color":"secondary","large":"","left":""}},[_vm._v("fa-newspaper")]),_vm._v(" "),_c('span',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('whatsnew')))])],1),_vm._v(" "),_c('v-sheet',{staticClass:"overflow-auto",attrs:{"max-height":"400"}},_vm._l((_vm.releaseNoteOverview.releaseNotes),function(note,i){return _c('div',{key:i},[_c('div',{staticClass:"mb-1",attrs:{"outlined":""}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"title font-weight-light"},[_vm._v(_vm._s(note.title))]),_vm._v(" "),_c('small',[_vm._v(_vm._s(note.date))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.getDescription(note.description))}})])]),_vm._v(" "),_c('v-divider')],1)}),0)],1)],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"text-xs-center"},[_c('v-menu',{attrs:{"transition":"scale-transition","origin":"right top","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":""}},on),[[_vm._v(_vm._s(_vm.$i18n.locale))],_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',[_vm._v("language")])],2)]}}],null,false,4289009842)},[_vm._v(" "),_c('v-list',_vm._l((_vm.$store.state.languages),function(language,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.changeLanguage(language.code)}}},[_c('v-list-item-icon',[_vm._v(_vm._s(_vm.fromCodePoint(language.flag))+" "+_vm._s(language.name))])],1)}),1)],1)],1)]:_c('div',{staticClass:"amber--text mx-auto darken-2 text-center"},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.loadingText))])])],2):_vm._e(),_vm._v(" "),_c('v-content',[_c('div',{class:_vm.$vuetify.breakpoint.lgAndUp? 'pa-5':''},[_c('router-view',{attrs:{"name":"breadcrumb"}}),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath,attrs:{"name":"default"}})],1)]),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.$store.state.offlineSyncing),callback:function ($$v) {_vm.$set(_vm.$store.state, "offlineSyncing", $$v)},expression:"$store.state.offlineSyncing"}},[_c('v-card',{attrs:{"flat":"","color":"primary","dark":""}},[_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.loadingText)+"\n        "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1),_vm._v(" "),(_vm.isSuper)?_c('superUser',{attrs:{"dialog":true}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 373 */,
/* 374 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__(171);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed3b818e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__(408);
function injectStyle (ssrContext) {
  __webpack_require__(375)
  __webpack_require__(376)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-ed3b818e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ed3b818e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 375 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 376 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 377 */,
/* 378 */,
/* 379 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 380 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent","min-width":"300"}},[_c('v-form',{ref:"form",attrs:{"id":"log_in_form","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.login($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{staticClass:"white--text",attrs:{"filled":"","color":"primary","name":"email","rules":_vm.emailRules(),"label":_vm.$t('email'),"required":""},model:{value:(_vm.credentials.username),callback:function ($$v) {_vm.$set(_vm.credentials, "username", $$v)},expression:"credentials.username"}}),_vm._v(" "),_c('v-text-field',{attrs:{"filled":"","autocomplete":"new-password","color":"primary","type":_vm.show ? 'text' : 'password',"rules":_vm.passwordRules(),"label":_vm.$t('password'),"append-icon":_vm.show ? 'visibility' : 'visibility_off',"required":""},on:{"click:append":function($event){_vm.show = !_vm.show},"input":_vm.encrypt},model:{value:(_vm.credentials.inputP),callback:function ($$v) {_vm.$set(_vm.credentials, "inputP", $$v)},expression:"credentials.inputP"}}),_vm._v(" "),_c('v-text-field',{staticClass:"d-none",attrs:{"dense":"","outlined":"","color":"primary","id":"website","required":""},model:{value:(_vm.credentials.honeypot),callback:function ($$v) {_vm.$set(_vm.credentials, "honeypot", $$v)},expression:"credentials.honeypot"}}),_vm._v(" "),_c('v-btn',{staticClass:"mb-3",attrs:{"block":"","x-large":"","type":"submit","color":"primary","loading":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.login($event)}}},[_vm._v(_vm._s(_vm.$t('login')))]),_vm._v(" "),_c('div',{staticClass:"mb-3 text-center"},[_c('a',{on:{"click":function($event){return _vm.$emit('forgot')}}},[_vm._v(_vm._s(_vm.$t('forgotPassword')))])])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 381 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__ = __webpack_require__(174);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5360e508_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__ = __webpack_require__(404);
function injectStyle (ssrContext) {
  __webpack_require__(382)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5360e508"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Signup_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5360e508_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Signup_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 382 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 383 */,
/* 384 */,
/* 385 */,
/* 386 */,
/* 387 */,
/* 388 */,
/* 389 */,
/* 390 */,
/* 391 */,
/* 392 */,
/* 393 */,
/* 394 */,
/* 395 */,
/* 396 */,
/* 397 */,
/* 398 */,
/* 399 */,
/* 400 */,
/* 401 */,
/* 402 */,
/* 403 */,
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-expand-transition',[(_vm.registered)?_c('div',[_c('div',{staticClass:"text-center black--text"},[_c('v-icon',{attrs:{"color":"primary","x-large":""}},[_vm._v("fa-check-circle")]),_vm._v(" "),_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('demoRegistrationSuccessful')))]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(_vm.$t('contactYou')))])],1)]):_c('v-form',{ref:"form",staticClass:"text-center",attrs:{"id":"sign_up_form","lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.requestDemo($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"title primary--text mb-2"},[_vm._v(_vm._s(_vm.$t('requestTrialFourteenDays')))]),_vm._v(" "),_c('div',{staticClass:"wrapper_signup"},[_c('v-text-field',{staticClass:"wrapper_signup_firstname",attrs:{"dense":"","outlined":"","color":"primary","name":"firstname","rules":_vm.requiredRules(_vm.$t('firstname')),"label":_vm.$t('firstname'),"required":""},model:{value:(_vm.customer.firstname),callback:function ($$v) {_vm.$set(_vm.customer, "firstname", $$v)},expression:"customer.firstname"}}),_vm._v(" "),_c('v-text-field',{staticClass:"wrapper_signup_lastname",attrs:{"dense":"","outlined":"","color":"primary","name":"lastname","rules":_vm.requiredRules(_vm.$t('name')),"label":_vm.$t('name'),"required":""},model:{value:(_vm.customer.lastname),callback:function ($$v) {_vm.$set(_vm.customer, "lastname", $$v)},expression:"customer.lastname"}}),_vm._v(" "),_c('v-text-field',{staticClass:"wrapper_signup_customer",attrs:{"dense":"","outlined":"","color":"primary","name":"company","rules":_vm.requiredRules(_vm.$t('company')),"label":_vm.$t('company'),"required":""},model:{value:(_vm.customer.name),callback:function ($$v) {_vm.$set(_vm.customer, "name", $$v)},expression:"customer.name"}}),_vm._v(" "),_c('v-text-field',{staticClass:"wrapper_signup_street",attrs:{"dense":"","outlined":"","color":"primary","name":"street","rules":_vm.requiredRules(_vm.$t('street')),"label":_vm.$t('street'),"required":""},model:{value:(_vm.customer.street),callback:function ($$v) {_vm.$set(_vm.customer, "street", $$v)},expression:"customer.street"}}),_vm._v(" "),_c('v-text-field',{staticClass:"wrapper_signup_streetNr",attrs:{"dense":"","outlined":"","color":"primary","name":"streetNr","rules":_vm.requiredRules(_vm.$t('number')),"label":_vm.$t('number'),"required":""},model:{value:(_vm.customer.streetNr),callback:function ($$v) {_vm.$set(_vm.customer, "streetNr", $$v)},expression:"customer.streetNr"}}),_vm._v(" "),_c('v-text-field',{staticClass:"wrapper_signup_postalCode",attrs:{"dense":"","outlined":"","color":"primary","name":"postalCode","rules":_vm.requiredRules(_vm.$t('postalcode')),"label":_vm.$t('postalcode'),"required":""},model:{value:(_vm.customer.postalCode),callback:function ($$v) {_vm.$set(_vm.customer, "postalCode", $$v)},expression:"customer.postalCode"}}),_vm._v(" "),_c('v-text-field',{staticClass:"wrapper_signup_city",attrs:{"dense":"","outlined":"","color":"primary","name":"city","rules":_vm.requiredRules(_vm.$t('city')),"label":_vm.$t('city'),"required":""},model:{value:(_vm.customer.city),callback:function ($$v) {_vm.$set(_vm.customer, "city", $$v)},expression:"customer.city"}}),_vm._v(" "),_c('v-select',{staticClass:"wrapper_signup_country",attrs:{"dense":"","outlined":"","rules":_vm.requiredRules(_vm.$t('country')),"label":_vm.$t('country'),"color":"primary","items":_vm.countries,"item-value":"code","item-text":"name"},model:{value:(_vm.selectedCountry),callback:function ($$v) {_vm.selectedCountry=$$v},expression:"selectedCountry"}}),_vm._v(" "),_c('input',{attrs:{"type":"hidden","name":"country"},domProps:{"value":_vm.selectedCountry}}),_vm._v(" "),(_vm.selectedCountry && _vm.companies.filter(function (x) { return x.code == _vm.selectedCountry; }).length > 0)?[_c('div',{staticClass:"wrapper_signup_company pa-1"},[_c('div',{staticClass:"black--text"},[_vm._v(_vm._s(_vm.$t('chooseYourPartner')))]),_vm._v(" "),(_vm.selectedCountry && _vm.selectedCountry == 'DE')?_c('div',{staticClass:"black--text font-weight-light"},[_vm._v("Since 01/01/2021, Kiesewetter and Seidemann are called Isopartner Germany")]):_vm._e(),_vm._v(" "),_c('v-radio-group',{staticClass:"mb-0 mt-0",attrs:{"name":"partner","rules":_vm.requiredRules(_vm.$t('partner')),"row":""},model:{value:(_vm.selectedCompany),callback:function ($$v) {_vm.selectedCompany=$$v},expression:"selectedCompany"}},[_vm._l((_vm.companies.filter(function (x) { return x.code == _vm.selectedCountry; })),function(company,i){return _c('v-radio',{key:i,staticClass:"mb-0",attrs:{"label":company.name,"value":company.name}})}),_vm._v(" "),_c('v-radio',{staticClass:"mb-0",attrs:{"label":_vm.$t('noPartner'),"value":_vm.noPartner.name}})],2)],1)]:_vm._e(),_vm._v(" "),_c('v-text-field',{staticClass:"wrapper_signup_email",attrs:{"dense":"","outlined":"","color":"primary","name":"email","rules":_vm.emailRules(),"label":_vm.$t('email'),"required":""},model:{value:(_vm.customer.email),callback:function ($$v) {_vm.$set(_vm.customer, "email", $$v)},expression:"customer.email"}}),_vm._v(" "),_c('v-text-field',{staticClass:"wrapper_signup_phone",attrs:{"dense":"","outlined":"","color":"primary","name":"phone","rules":_vm.requiredRules(_vm.$t('mobile')),"label":_vm.$t('mobile'),"required":""},model:{value:(_vm.customer.phone),callback:function ($$v) {_vm.$set(_vm.customer, "phone", $$v)},expression:"customer.phone"}})],2),_vm._v(" "),_c('v-textarea',{staticClass:"wrapper_comments",attrs:{"dense":"","outlined":"","color":"primary","name":"comments","label":_vm.$t('comments')},model:{value:(_vm.customer.comments),callback:function ($$v) {_vm.$set(_vm.customer, "comments", $$v)},expression:"customer.comments"}}),_vm._v(" "),_c('v-text-field',{staticClass:"d-none",attrs:{"dense":"","outlined":"","color":"primary","id":"website","required":""},model:{value:(_vm.customer.honeypot),callback:function ($$v) {_vm.$set(_vm.customer, "honeypot", $$v)},expression:"customer.honeypot"}}),_vm._v(" "),_c('v-btn',{attrs:{"block":"","x-large":"","type":"submit","color":"primary","loading":_vm.loading}},[_vm._v(_vm._s(_vm.$t('requestTrial')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__ = __webpack_require__(181);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d5ad45a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__ = __webpack_require__(407);
function injectStyle (ssrContext) {
  __webpack_require__(406)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ForgotPassword_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2d5ad45a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ForgotPassword_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 406 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-sheet',{attrs:{"color":"transparent","min-width":"300"}},[_c('v-expand-transition',[(!_vm.checkEmail)?_c('v-form',{ref:"form",attrs:{"lazy-validation":""},on:{"submit":function($event){$event.preventDefault();return _vm.resetPassword($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"title primary--text mb-2 text-center"},[_vm._v(_vm._s(_vm.$t('resetPassword')))]),_vm._v(" "),_c('v-text-field',{staticClass:"white--text",attrs:{"filled":"","color":"primary","rules":_vm.emailRules(),"label":_vm.$t('loginEmail'),"required":""},model:{value:(_vm.credentials.email),callback:function ($$v) {_vm.$set(_vm.credentials, "email", $$v)},expression:"credentials.email"}}),_vm._v(" "),_c('v-text-field',{staticClass:"d-none",attrs:{"dense":"","outlined":"","color":"primary","id":"website","required":""},model:{value:(_vm.credentials.honeypot),callback:function ($$v) {_vm.$set(_vm.credentials, "honeypot", $$v)},expression:"credentials.honeypot"}}),_vm._v(" "),_c('v-btn',{staticClass:"mb-3",attrs:{"block":"","x-large":"","type":"submit","color":"primary","loading":_vm.loading},on:{"click":function($event){$event.preventDefault();return _vm.resetPassword($event)}}},[_vm._v(_vm._s(_vm.$t('resetPassword')))]),_vm._v(" "),_c('div',{staticClass:"mb-3 text-center"},[_c('a',{on:{"click":function($event){return _vm.$emit('login')}}},[_vm._v(_vm._s(_vm.$t('login')))])])],1):_c('div',[_c('div',{staticClass:"text-center black--text"},[_c('v-icon',{attrs:{"color":"primary","x-large":""}},[_vm._v("fa-check-circle")]),_vm._v(" "),_c('p',{staticClass:"mt-4"},[_vm._v(_vm._s(_vm.$t('checkInbox')))]),_vm._v(" "),_c('p',{},[_vm._v(_vm._s(_vm.$t('resetPasswordInstruction')))])],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{staticClass:"fill-height"},[_c('v-card',{staticClass:"d-flex mx-auto flex-wrap",staticStyle:{"margin-top":"2%"},attrs:{"tile":""}},[_c('v-sheet',{staticClass:"pa-5 white--text overflow-hidden flex-fill",attrs:{"tile":"","color":"rgb(0, 155, 217)","width":"auto"}},[_c('v-card-text',{staticClass:"headline text-center",attrs:{"mt-2":""}},[_c('img',{attrs:{"src":__webpack_require__(409)("./" + _vm.logo),"width":"235"}}),_vm._v(" "),_c('div'),_vm._v(" "),_c('v-menu',{attrs:{"transition":"scale-transition","origin":"right top","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"white--text",attrs:{"text":""}},on),[[_vm._v(_vm._s(_vm.$i18n.locale))],_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',[_vm._v("language")])],2)]}}])},[_vm._v(" "),_c('v-list',_vm._l((_vm.$store.state.languages),function(language,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.changeLanguage(language.code)}}},[_c('v-list-item-icon',[_vm._v(_vm._s(_vm.fromCodePoint(language.flag))+" "+_vm._s(language.name))])],1)}),1)],1)],1),_vm._v(" "),_c('p',{staticClass:"headline mt-2"},[_vm._v(_vm._s(_vm.$t('takealook')))]),_vm._v(" "),_c('v-list',{attrs:{"color":"transparent","nav":"","dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fa-check-circle")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"white--text text-wrap"},[_vm._v(_vm._s(_vm.$t('manufacturerIndepentent')))])],1)],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fa-check-circle")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"white--text text-wrap"},[_vm._v(_vm._s(_vm.$t('multiplesealsonmarker')))])],1)],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fa-check-circle")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"white--text text-wrap"},[_vm._v(_vm._s(_vm.$t('anydevice')))])],1)],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fa-check-circle")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"white--text text-wrap"},[_vm._v(_vm._s(_vm.$t('multilanguage')))])],1)],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("fa-check-circle")])],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticClass:"white--text text-wrap"},[_vm._v(_vm._s(_vm.$t('highlyCustomizable')))])],1)],1)],1)],1),_vm._v(" "),_c('v-sheet',{staticClass:"pa-3 mx-auto my-auto white--text overflow-hidden flex-fill",attrs:{"color":"transparent","max-width":"450","min-width":"300"}},[_c('transition',{attrs:{"name":"component-fade","mode":"out-in"}},[(!_vm.forgot)?_c('div',[_c('v-tabs',{attrs:{"hide-slider":"","grow":"","dark":""},model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tabs-slider'),_vm._v(" "),_c('v-tab',{attrs:{"active-class":"secondary","href":"#1"}},[_vm._v(_vm._s(_vm.$t('signup')))]),_vm._v(" "),_c('v-tab',{attrs:{"active-class":"secondary","href":"#2"}},[_vm._v(_vm._s(_vm.$t('login')))])],1),_vm._v(" "),_c('v-tabs-items',{staticClass:"transparent",model:{value:(_vm.tab),callback:function ($$v) {_vm.tab=$$v},expression:"tab"}},[_c('v-tab-item',{attrs:{"value":"1"}},[_c('div',{staticClass:"mt-2",attrs:{"color":"transparent"}},[_c('signup')],1)]),_vm._v(" "),_c('v-tab-item',{attrs:{"value":"2"}},[_c('div',{staticClass:"mt-6",attrs:{"color":"transparent"}},[_c('login',{on:{"forgot":function($event){_vm.forgot = true}}})],1)])],1)],1):_c('forgotPassword',{on:{"login":function($event){_vm.forgot = false}}})],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 409 */
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./android-chrome-192x192.png": 410,
	"./apple-touch-icon-114x114.png": 411,
	"./apple-touch-icon-120x120.png": 412,
	"./apple-touch-icon-144x144.png": 413,
	"./apple-touch-icon-152x152.png": 414,
	"./apple-touch-icon-180x180.png": 415,
	"./apple-touch-icon-57x57.png": 416,
	"./apple-touch-icon-72x72.png": 417,
	"./apple-touch-icon-76x76.png": 418,
	"./apple-touch-icon-ipad-76x76.png": 419,
	"./apple-touch-icon-ipad-retina-152x152.png": 420,
	"./apple-touch-icon-iphone-60x60.png": 421,
	"./apple-touch-icon-iphone-retina-120x120.png": 422,
	"./apple-touch-icon.png": 423,
	"./baseline-fullscreen-24px.svg": 182,
	"./bg.png": 344,
	"./blueprint_logo_low_opacity.png": 113,
	"./building-highlight.png": 424,
	"./building_logo_low_opacity.png": 183,
	"./buildings_logo_low_opacity.png": 184,
	"./empty.png": 18,
	"./favicon.ico": 425,
	"./firelogdemo.png": 426,
	"./ios-share-icon-15.jpg": 185,
	"./logo.ai": 427,
	"./logo.png": 110,
	"./logo.svg": 170,
	"./logo_with_text.png": 428,
	"./logo_with_text.svg": 429,
	"./pattern.jpg": 343,
	"./project.png": 430,
	"./sbklogo.jpg": 431
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 409;

/***/ }),
/* 410 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/android-chrome-192x192.bc575b0.png";

/***/ }),
/* 411 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apple-touch-icon-114x114.9fc249a.png";

/***/ }),
/* 412 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apple-touch-icon-120x120.8df8296.png";

/***/ }),
/* 413 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apple-touch-icon-144x144.d911b2b.png";

/***/ }),
/* 414 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apple-touch-icon-152x152.f1a4421.png";

/***/ }),
/* 415 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apple-touch-icon-180x180.d704d3d.png";

/***/ }),
/* 416 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 417 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 418 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 419 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEwAAABMCAYAAADHl1ErAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAAsSAAALEgHS3X78AAAbiklEQVR42tV8eXwc1ZXud6uqq/dF3VK39n21tWDL4B1jg/GKFxIMYZuxZ8AMQyYLgWEySV7e40cm25tAwpAhASdMcAAbDLGxsQEb8O4g25It2dZmqbV3S61Wd6u32u77o2V5t1qypPC+P7urbt371Tnnnu0WwUQiaSZgTgL63bzKqM/WatWVCWbjfEdiQllGmiM7K81hzUxzqFPsNtaWYIJOq4FBrwXLMAAAWVEwGAwjFI7A4/Wj2+2R2zpdUWdnz0B7p7vZ1ec97fUFDobD0eNiINgKq12ArxfoPTZhSyITMai+4G4QAiIIYopWo15kT7KuLMxJnzWttCBtelkRV1KQhZQkK0xGPQgZ3RQopfAHguju7cfZRidOnK6XTtY2dja0dBx19/Z/GI5E9/G8qptS0GDjx19twlTZC6HIMsvzfKHRoFuXn522dt5t5cV3zqtUT5taAFuCCcyQ9IwXFEWBx+vHybpG7D14PHrwr6fONbV2vh8YDG0RBKGBYVlZbP3sq0WYrmAxFEUhBCTfbDL8fWlRzkPLF83KWL5oFpOXnQaOZceVpOtBkmU0t3Zi176jyq59R9tr61s2+/yDf6SgTQzD0FDjJ397wnT5iwECq1bNP1RSkP3k15YvKLp32e0kI9U+anUbL1BK0d7lxraP9tP3dn1Rf7ax9ZVwVNgMiv5Q082RNuYV6QoWQxBEoub5WanJid9ftXjukg0PLFcV52WBYf42RF0JRaE41+zEprd3ids/ObSnq6fvJ1FBOMrzqjFL25h0xVi0BKAw6LWajbOmTXnx3556aMYTD69iU+y2v5lUXQuEECTZLFgwq4LNzkgudPd6l3i8flGWlTOapHxB8DRPLGG20pXgEnKgKDTVYja8cO+y2595/tl/tM69tQwcNz52qubseWzfexh2WwLMRv24jMlxLEryszBr+lSTfzC4sK3L5QhHhBOapPyAMaUEYXfD+BNmr1gFSZagKEpxqsP28saHV9//3D8/pEpLThyXRQHAviPV+Pbzr2DLzi9Q1+hEaWE2HIkJ4za+LcGEebeVcwzDTG9q7ZgSCIZOEII+U+oUBF3140eYvWIVQuEoFEWpyMlI+f0zTz64aOND9xC9TjsuC6lraMUf3t2D//vau6g/3wEKoKWtG1+eaoCsKLAlmGAxGcblWRo1j9tuKSFms7HgXJOzsn/AXyVKssuSPjUu0kYkLLFsJURRgkKVipyMlN8+988Pz37o3sVQcdxNTVwUJTQ5O7Fl5348//JmvLf7ILy+QbAMA4KY/enp9WLfkZOoOlUPhmFgMuhh0Gtv2pdjWRblJXlIMBkz6upbKgb8gSpKqcuQUozQCOo5ooW2Tl0OQZSKczJSNj331MOz71+1aDh0GS0OVtVi3+GT8AwE4PYMoK6hFe3dvZAUBcwNNgtFUaBW88hISUJpYTasZiMciQlYMr8SlWWFYyZOVhS8s30ffvrym0da2rs38CruXH/drhuTfUOySldAEKW0FLvt5WeffHDRQ2sXj5kshVK8+If38dIfP0D1mWbUt7TDFwgBBJftrBzLojA3Hb5ACLIsgxACQsiQRx/AmSYnTtY144tjp6DTqHD3vEpgjDszQwimFmZDp9VkVNc15voCwS8MKcWBsLvx+vdc74/EspWIRASDxWT40YYHVix7cO3im1MFGnMoGULAsgw4lr2mvyZKEu6cMw3f3rAWJoMOlNKLk2UIOJYFyzIghECSlbHPZ3hMBg+uXYwND6xYZjEZfhSJCIbEspWjIyyp/B70nT5LNBp+w8rFcx994pHVhFfdnM2KFwqliEQFPPPYOqxePAfKJYRNFHgVhyceWU1WLp77qEbDb+g7fZYkld8TP2GKQqEvzJszo7zome8+tk4zXjvU9UCvIIVXqaDmVZhXWQo1r5pwwgDAYjLgu4+t08woL3pGX5g3R1Gu/aKuIiyx/B6EI1FbmiPxuX96dE16QU76xBEFQKfVwGox4sIECYCMlJhvl2A2gGPZSZEyACjIScc/PbomPc2R+Fw4ErUlXkPKLiPMccsqzKssh1ajfnj1knlLly2cNbEzpBS8isMzj92HOZVTIMkyyopycOec6QBi2QdCCKxm4w130fHEsoWzsHrJvKVajfrheZXlcNyy6tqE2StWQaHAnv3HCqcUZj2xft1ybuLVgUAUJcyaNgX/uvF+ZKU58OzG+1GclwEA6PX4sGBmOR5/YPmkkAUAal6F9euWc1MKs57Ys/9YoUJj3FxFGKVAb30LYzEZ1n99+R3FxflZEz45SilsCSYkmA2YWpCF57/zd1i24Nbh/6KCiGceuw9ZaQ7Iys3viPGiOD8LX19+R7HFZFjfW9/CXGoRhgkjBNCmO0rKinMfXLN0/lhdm1FBoQpuqyhCenISkqxm3LtkHgBgMBQGpRRJNjMKs9Ng1GvBqzhMjiWLcbFm6XyUFec+qE13lFzKBQPERM5dsx0mg37dyrvmZGamOSZ8UpRSWM1G3Lf8dvAqDoQQCKKE17fsRs3Z82AYBoU56WBZBuUluSgvzgVVJosyIDPNgeV3zs406nXr3DXbh9VyWML4nEXp+dlpa5bccdukTEhRKOZUTsWC28oBSkEIQXt3LzZt3Q2vLwAAyE53QK3mkZOejO/8w9dg0Glw+YY5sQQuWzgTBTnpa/icRcOuAmOvWAVCCLQa9aL5MyuK87PTJuThhAAateqy6HX61HxoNWpQxCTO4/UhHBFw+MQZbP/0CD45cGK4HjD7lhIU52VAoUO2jABqNT/msCge5GenYf7MimKtRr2IEAJ7xaqYhLmcnbwjMWHFnXOn86MJfxQa/zsmhMBmMV12w6XRQyQqoOp0IxLMBrz5wV48/ZNXceJMLKajlMJqMSItOXFYLVmGQXKSbeQ5KhRnm9vR3tM3asIYhsGdc6fzjsSEFS5nJw8MqaTKbMwtzM2YVTElf1QDHnOH8evTXnQEpbiIS7SaL2ZmCXD4+Bn0+wIghODwiTPY+tF+dLs98PoC6HR50NDSiVAkCkIIulwetHW5QRgCSiksJgOmT73xfDtdHvz8tfdw/3d+hpqz50dNGABUTMlHYW7GLJXZmAsAjIrjoNWoK6eVFqQmWs2jGswblfGDL3uxZk8HXq71oick3fD6+TNKkZeVCllRwDIM9h2pxn/89i34B0PYsfcovqypR5/XD4ZhwAyRJEkyAoMhvPDKWzh1rgUsw0BRKBbMLMeM66R2fIEQ3tz+Ge779k/x45f/jCZnN4CYpPoCwVGtMdFqxrTSglStRl2p4jhwnce3IWvmffMqy4q40RYwzDwLDUtwoi+Cuv4o3mn24+8KzVidbYRde3XmKCcjBWsXz8GvNm2DJMsQJQl/2LoHWrUahAAqFTccV7IsA0eiBY2tnfjg40PYums/lCFfzGoxYt2KBdBpNZeNL4gSDlTV4b8278SnR6oRDEdhMmhRnJuBjh4PvvezTQCAXzy7Ie7KFiEElWVFXILZOM95bOtmDmnzrclJ1tKxOKomnoGOY+CNKpApcMQVwfHeKN5o8OGxEgvuyTLAqr5IHMsyeOrR1TjT1Ia/fHoYHMtCECW8/D9/gdGgA8MQyPJFG3WmsQ3f+NZP4PYMQFHoUEpHxn3Lb8fS22cMj6soFHVNTrz69m5s2X0Q/b4AHDYLZlUUwZGYALdnAP/nlbfR3duPtXfNHvU+UZyfheQka6kzdZ6VY1kmKyPVnpdst4544yFnP055IpiVZkKuWQ0Lz8CmYdEZlCBTgCGATCmOuCKo9rjwpwY/1heZsTRDD5smRpzFZMDGb6zAmSYnzrd1gxACWVHgHbJlFyArCjpcfcPp6gt/zZ9RikfW3DWcIu90efDGB/uw6b1P0OnyICs1CbfPmAqdVo3mth58tL8KvkAIDENg1GthNGjR3N6DmnMtSHPYMKuiaMR1J9utyEiz53556lwmp1Grc7LSky0mw8glrTZ/FM9UeWGs8aPYxKIsgcdcK4sigwadEaA1IMITVaDIFBGJYl9nEEfdYcxxaPHEFAsWp+thVDFYMLMcL/3oSTzxg5fQ1uUGx7LXrGdeGnBLkoyy4hz85sdPoSA7Df7BEN7/9Ah+++ddaHR2oSArFfOml0CUZNQ2OnG+3QVBFKHVqJGebEOC2QitWoVGZxdWPP6/0dPnxS+eXR8XYSaDHllpyQlatTqX02r44sw0Bx+PmBbZjdBwPvSKBG6Pgv19YRhYIFlDkKlnsSCRBSUc+kQC56AEd0SBX1TwSUcQR11hLEjVYX2RGYvT9Zg/owz/+vj9+M9N78HZ6brhcxlCMGtaCb7/5DeQlebAx4dO4r8270RtoxMFWam4b+k8uPt9OHD8DHp6vSAMgdmgg5o3Qc2rEI4IaOvqRTgShSjJAGLmwW61jLxoxFy9zDQHr9XwxRzHslkpdmtc5TY9A+ioCB/hY/4IIQhToDkMNIUkcJBgUQHJaoICowplRgZRqNAdUdAZUrCnPYgvukK4K12Px0ssuG/NXbi1rABP//T3OPDl6VjF6JI3d2EDWH33XLzwvfXo8wbw9M9ex8kzzUhPTsSSedPR5OzC9n1/hS8QhFqtgl6nAcMwiERF+AdDECV5aJyYWl8w9hpeBYsp/kJxit3KciybxWm1GoctIT53wqxm4NBx6AwA7JUBKSGgAPolwCMCdYMCtAyQwAnINKhQYaBQWVToF4GavjAe3x/BLIcW/1iSjP/13fV49Y1t+PRwDXyDQTBDRQ9HYgK+tnQ+Vt01B9s+PoKjNfUw6LSYmp+JmnOt+PjQSUSiAhiGAcexEAQRYUUApRSUXgwCrlR3Sin0Og2M+vjrqrYEM7RajYPTa9UWnVYd102Jeg2yLDoc94evG5IQXPiLIEqBbpGgs18GRyh0REKylkGyCrBoOHQPBPHjYxHMTjHjoac2Yt7sKvzqd2+jo6cPlWWFePyBFTAZ9dh7tAb+wTAIITh4og6tnW5IkjxUlKGQJBkS5MvncQMTQymg16ph0uviJkynVUOv1Zg5nU5jibeCzbEEFoiIxTdx+jGISSMFQZASNAZjv3FEQIKKwMxK+GunjPN9DOZkleJH338KQVc3UpOT0OOJ2aW6RidONbTC1TcwREas9EbHmLqmoNBpRydhep0WOp3GwjEMQ+KPHwkyDRwYIsV5/dW44C/KYNArAm6RoDksQ8PIONbbj0qHBdN1FLu3fYzaRie63B4Ew1EwQySNCyigHyVhDMOAYQjLYZQ9YiV2I7hzEYxH/pNceDghiFAgLLPY1SVgd30jyN5jAKVgGDLm4vGNYLMYx9RxxCiKIiujSP9aeQJeGbuEjUQgSwgIQy680Ql5DhAjjGXjfxGyLEOWFYkJhSLewWB4FIQxMKnIhKbuJqM+lJhgAjuK3ttgKIxQKOJlBkNhbzAUP2EZFi0cBjUmMVs8IbBZTKN6McFQBMFwxMeEI4Krz+uL+0Y9z8FMJEx0engiwTAEVsvoqvl9Xh/CkWgPI0lya7fLE7dR4kjMk///FRSx2qPVbBzVfd0ujyRJcisTjkTPOjtdQrw+jYpjMNUxuod9pUAp1KMMixRK0dLeLYTCkbNMJCq0tHW6+gb8g3HeTmDXsGAmsbA63lDzKiSMosHG5x9ER3dvX1QQWxhFktrbOl3N3S5P3AMkqig0DL3aihEyoVWc8QClgFo1OsK6XR60dbrOK5LUztCugz53n/d0XUNL3APkWnUwqa+oRCsKSF83iM8DYCjyJePvcI4DZTAatIg3fgaAuoYWuPu81bTroI9JrVyLAf/ggeOnG8R4HVi7Xg0Do1yxUVKoqg+A3/bf4Hb9CVzVPjA9TkASYq+VYb8S0kcpkGAyQK2Kr9FGURQcP90gDPgHD6ZWrgUnywrCkejJ6trGNlefNy/FPnKtj2cAK6ug6Yr2MkUSkc5T2OBDU1U9wlWfgVjtUOzpoImpUJIzoZhtAK8eIpsCk9T7NUwYKBLMBvB8fB2Vrj4vqmsb28ORaLVWowYHAJJnwNnU2nno+KmGvJV3zR5xECPPIteqw7FB4fLJKBQpdht+9cMn8dqW3ZAlCe/u2g+pxwmAQNbooSRngiSmQE7PA01MBdWOz2mPUTA2Kgk7fqoBTa2dhyTPgBMWU0xEknIzJbfHu2PvwaqIKI3skvEqDmk6DrhShUmsqfdMUxvCkSiyM5JBWAYgsUzqtGwHSkkAmpOfg//wj1Btfx1sc+2kqipFrLMxnjhSlCTsPVgVcXu8O5JyMyUAYNw120EIEIkK+w9V1Z462+iM68E2VgZLrq1OZUU5SLFboVGrcSEyJIRgzd1z8cN/eQQb1i3D03+/GqZAL+DpmTSygFguP9Fiiuvas41OHKqqPRWJCvsJAdw12y8aoRS7zd3S1vXezr1H4vJhC6xaqK96SwSCIGHHvqOoa3Civds9nOSjAHp6vWjrciMQDKOytBB6vRaTE2pfBMcysFlGdrwpBXbuPUJb2rq22m0W94XfGSDGXEQQMBgKv7f782ONTa0dIw6YlaCHmlzti3EciyXzZ6AwJz12PugSPkxGHSwmA9KTE8GruFgj8CRvnBzLxkVYU2sHdn9+rHEwFH5flGW4a7ZfJAyIGezqPZuazzW1vbH1w8+VkVwMPUNhwOX2jmUIzjW3Y/2zv8BnR6vR0d17WRq5taMHja2dqD57Hs5O15hTzGMFRUwlbQk3VklFUbD1w8+Vc01tb1Tv2dR8aSPf8N7ae2oH5t8LBILhzR/sOfD1JXfcOq2y7PpFTquGQ7KBR4fv8goSpRTOTjdAgHPN7WCYi6nljBQ7inLSAVAY9Vook50johS8auQ48mRdIz7Yc6DGPxjaPP/ep9B7asfVhAEX0h5GZ1NLx29ef2vnK8V5mZrrFUhsBjXSDDy+HIhetcsxQy1JJpMeKo6FLxCEKMr49R/fB8MwyMlIhkbNT/pRZwrAbNBBf0UTy6UIhsJ4/a2dkaaWjt9YLUanLF9ejbrMaruqt0MUJUQF8d2PPju2bdtH+687MEMILLjUD7t88YqioLQwG6//9Gk8sHIhli64FXabBYIo4lxzO37yylvweP2TeuSZUgqTQQed5vph0baP9uOjz45tiwriu6IowVW9/fqEATHV1GrUAbfH+/Pfbd7RUF3XdM2BCSHIs2hi6kgpSNAHyqoAlosVdYcOLSyYWY5Fs2/Biz94AnfNmw5FoRfVdLIjJQoY9dePI6vrmvC7zTsa3B7vz7UadeBSVbwuYUBMpZKslprac+df+OWrbwdcfd5rPqA4yQhmKNAm4SCoKQFyVhEURyaoyQqJ4RAWZRAC8LwKk3XA67p8DUmY/hoS5urz4pevvh2oPXf+hSSrpeZ65uKahPWe2oFgOAJBkt7Ze6DqlRdf2yKFwpGrrrNwFBoqQaIUYlI6xMo7IC5YA3HuCtDpt+OkoMM3X9+Dw04POgbC8EflmL2jQzHkJNh8SmOtU/LQUUG7zQzuihcXCkfw4mtbpL0Hql4RJOmdYDiCa0kXcIMDpiFXA4ypJXIoHD1x3tmVyXFsWWV5Ebk0pLBqOBSbOFgZGSylCEkUUV4L0ZAAmpKJsD0Lp4MEp91BfHy8Hqc6PBAVxDIXDAuiyFDS86Ck5WGYPUJAPD0gzXUYC6OxvgoKWVHAMAyMei2KstOwcFY5NnxtMR5ccTvsNsvw9YIo4bf/8wF97a2dbw/4B3+gUfODntMfXnf8Ea2IrXQFooKYkWK3/fe3/uG+5Y89uBL8FWeQKKXoCwpo8UdxpDOALz0CTvZF0BUl8MsAJQwgS+CiITBeNxh3B0hgAIzHBTmzAHLZbFB+aOciDEhDNciedwA6crqJUho77UZjPpbJoEN6ciLKCrNQOTUf06fkIS8zGXar5ar4URBE/P7PH+Kl17fu6nZ7nlDzqnZP7c4bPm9Eo8KyLFhWae92e7750utbCYBljz10z2X2iBCCJIMaSQY1bks1QZBk9IZE1PYGcbw3giM9IZwLMOhk9Ijq8kFT88FKUTD+fjD9LpDAAGhiSlypngsEURoLc8wGPTJSElFakIXK0nxMK8lFflYqbBbjDW2mIEoXyPqo2+35Jsuy7fHUKePap+wVqxAVREiSnJPqsP1m48Orlm98ZDUxxNHEQimFICto80VQ6wnjUOcgTnpFnB0Q4ZVZRGmMcAZ0qG3gcgm7SBAFx7Iw6rXISrVjSn4Gbi0rxC3FOSjIToXNYoIqztL/YCiMV//0F/rqm9t3dbk83+Q4tkXNq4bDn5sm7ALMJUshy0q61WJ6Yd09C7/xncfWqVIdo//Qhz8iwumPoqpnEMf7ojjmCqMtAvQLChSGA+qrwex5CywhMBt1SHckoqwoG9On5KFyah5yM5KRZLWAG0Wp/wK6XH341e+3iFt2fPZW/4D/31mW6fCd3R33/aMizF6xCpGoAFlWLHqd5rsL50z7l+9tfMBcWV40ZgdUVhR4wyIa+sM40RvGoe4Q2hqbke86g1un5qPiggSZjVDdhFtCKcXxU/X45atv+z47fPLXwVDkP1mWGdCo+bgka0yEXYCxaAkkSeZ5Fbe2pCD7hxseWD513T2LxuVbOaKsICzK0HJM3Co2EnyBILbs2IdNb++qO9vY+rwgSu9zHCsE6veMeqwxzUjwNMOQXCT7er11/cHQvqqael3D+faCRKuZT7HbRtUVc9WEGAI1x45Li5MoSjh6og7/8fKbg29s3f1mS0f3twc9vi8MJoPsPxe/Gl6Kmw5ONHl3gQA6nudWZmekfGvlnXNuu3/VIm5KQdaoumPGE7Is40yjE+9s3yd9uPfwX1vbu18SBOlDCoQizZ/e1NjjEs2pshciwWSCf3DQodNp1uVnp2+4c+70KfcsnstXTMkfVQ3wZhAKR1Fzpgk7Pjkk7D104kxTa8emUCiyxWQwuLx+P8bjW4jjGv7qC+8GyzBEEMVUrUa9IiPFvu7WiuJbF86dbpo1bQoyUu1XOb03C0EQ0d7lxtGTZ/DZoRP+L2vOfdne7d4SjkR38ipVl6woNNgwfl/bnJB8AZOxAIoggKg4k1ajmWm1GJdnpSffUVqUWzC9rEBXWpRLstIdsCWYwatUcefFFIVCEEV4vD44O1yorT9PT5xuDNXWn290dvR83j8Q2BWORI5RUfIzPA+l/YtxX9vEJ1hslUDER1hrmp1Xq6Ya9bo5tgTzLSkOW0mqw+bISkvWJydZ1TarmRh0WpgMuuFNQ5YV+AdDGAyF4en30Z7e/qiz0xXsdvV1d7k89R6vrzoQDB0WomKd3N/phsZM4Tk+ocuZ9No9yVoIKopqAFZezadoeD6HYZkUjZpP0mnUJo2GT2AYhgUARVHkSETwhiJRfyQq9Cqy0h0RhBYhKnQD6CcqVZQ6x+8brV9Jwq4PGwBKAPMlTRiUAj4ZIBSIv7toIvH/ANZ5hRDlMTfRAAAAJXRFWHRkYXRlOmNyZWF0ZQAyMDIwLTAyLTE0VDEwOjU5OjM2KzAxOjAwbhHUhQAAACV0RVh0ZGF0ZTptb2RpZnkAMjAyMC0wMi0xNFQxMDo1OTozNiswMTowMB9MbDkAAABGdEVYdHNvZnR3YXJlAEltYWdlTWFnaWNrIDYuNi45LTcgMjAxNy0wMy0xNCBRMTYgaHR0cDovL3d3dy5pbWFnZW1hZ2ljay5vcmfCDC5CAAAAGHRFWHRUaHVtYjo6RG9jdW1lbnQ6OlBhZ2VzADGn/7svAAAAGHRFWHRUaHVtYjo6SW1hZ2U6OmhlaWdodAAxODT/eObxAAAAF3RFWHRUaHVtYjo6SW1hZ2U6OldpZHRoADE3Odr91Q4AAAAZdEVYdFRodW1iOjpNaW1ldHlwZQBpbWFnZS9wbmc/slZOAAAAF3RFWHRUaHVtYjo6TVRpbWUAMTU4MTY3NDM3NgFvdlYAAAAPdEVYdFRodW1iOjpTaXplADBCQpSiPuwAAAAgdEVYdFRodW1iOjpVUkkAZmlsZTovLy90bXAvcGhwYnpGUzRuDbm/RgAAAABJRU5ErkJggg=="

/***/ }),
/* 420 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apple-touch-icon-ipad-retina-152x152.31ea78f.png";

/***/ }),
/* 421 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 422 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/apple-touch-icon-iphone-retina-120x120.5199b12.png";

/***/ }),
/* 423 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/building-highlight.857a533.png";

/***/ }),
/* 425 */
/***/ (function(module, exports) {

throw new Error("Module parse failed: Unexpected character '\u0000' (1:0)\nYou may need an appropriate loader to handle this file type.\n(Source code omitted for this binary file)");

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/firelogdemo.b25b5b5.png";

/***/ }),
/* 427 */
/***/ (function(module, exports) {

throw new Error("Module parse failed: Unexpected token (1:0)\nYou may need an appropriate loader to handle this file type.\n(Source code omitted for this binary file)");

/***/ }),
/* 428 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/logo_with_text.b4873f0.png";

/***/ }),
/* 429 */
/***/ (function(module, exports) {

module.exports = "data:image/svg+xml;base64,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"

/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/project.b03f74a.png";

/***/ }),
/* 431 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/img/sbklogo.8d8a61a.jpg";

/***/ }),
/* 432 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(186);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14817068_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(450);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14817068_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 433 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 434 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_c('v-icon',{staticClass:"mr-3",attrs:{"x-large":""}},[_vm._v("cloud_off")]),_vm._v(_vm._s(_vm.$t('networkIssues'))+"\r\n    ")],1),_vm._v(" "),_c('v-card-subtitle',[_vm._v(_vm._s(_vm.$t('checkConnectionAndTryAgain')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","text":""},on:{"click":_vm.retry}},[_vm._v(_vm._s(_vm.$t('retry')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 435 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 436 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',{staticClass:"container"},[_c('v-img',{staticClass:"ma-auto",attrs:{"contain":_vm.fit,"src":_vm.image,"height":"300","width":"300","aspect-ratio":"1"}},[_c('div',{staticClass:"text-center background__image d-flex"},[_c('div',{staticClass:"ma-auto"},[_c('p',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"font-weight-light"},[_vm._v(_vm._s(_vm.description))]),_vm._v(" "),_vm._t("action")],2)])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 437 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProject_vue__ = __webpack_require__(189);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fe22e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddProject_vue__ = __webpack_require__(441);
function injectStyle (ssrContext) {
  __webpack_require__(438)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14fe22e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 438 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 439 */,
/* 440 */,
/* 441 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"depressed":"","color":"secondary","small":""}},on),[_vm._v(_vm._s(_vm.$t('newProject')))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("project")))]),_vm._v(" "),_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("address")))]),_vm._v(" "),_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("contact")))]),_vm._v(" "),_c('v-tab-item',[_c('v-divider'),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"d-flex flex-wrap justify-content-center container"},[_c('div',{staticClass:"flex-fill"},[_c('v-text-field',{attrs:{"outlined":"","dense":"","rules":_vm.rules(_vm.$t('building')),"counter":"512","required":"","label":_vm.$t('name')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"rules":_vm.rules(_vm.$t('building')),"required":"","outlined":"","counter":"512","dense":"","label":_vm.$t('building')},model:{value:(_vm.buildingName),callback:function ($$v) {_vm.buildingName=$$v},expression:"buildingName"}})],1),_vm._v(" "),_c('div',{staticClass:"flex-fill d-flex"},[_c('image-uploader',{staticClass:"mx-auto my-auto",staticStyle:{"min-width":"245px"},attrs:{"preview":false,"className":['fileinput', { 'fileinput--loaded': _vm.hasImage }],"capture":"environment","debug":1,"quality":0.8,"accept":".jpg, .png","autoRotate":true,"outputFormat":"verbose"},on:{"input":_vm.setImage,"onUpload":function($event){_vm.loading = true},"onComplete":function($event){_vm.loading= false}}},[_c('label',{attrs:{"slot":"upload-label","for":"fileInput"},slot:"upload-label"},[_c('div',{staticClass:"mx-auto my-auto text-center"},[(!_vm.image)?_c('v-icon',{attrs:{"large":""}},[_vm._v("add_photo_alternate")]):[_c('v-img',{attrs:{"height":"245","width":"245","aspect-ratio":"1","src":(_vm.image == null) ? _vm.emptyImage : _vm.image}}),_vm._v(" "),_c('a',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('changeImage')))])]],2)])])],1)])])],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-divider'),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('street')},model:{value:(_vm.street),callback:function ($$v) {_vm.street=$$v},expression:"street"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('number')},model:{value:(_vm.no),callback:function ($$v) {_vm.no=$$v},expression:"no"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('postalcode')},model:{value:(_vm.postalcode),callback:function ($$v) {_vm.postalcode=$$v},expression:"postalcode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('city')},model:{value:(_vm.city),callback:function ($$v) {_vm.city=$$v},expression:"city"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('country')},model:{value:(_vm.country),callback:function ($$v) {_vm.country=$$v},expression:"country"}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-divider'),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('name')},model:{value:(_vm.contactName),callback:function ($$v) {_vm.contactName=$$v},expression:"contactName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('contactFunction')},model:{value:(_vm.contactFunction),callback:function ($$v) {_vm.contactFunction=$$v},expression:"contactFunction"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('mobile')},model:{value:(_vm.mobile),callback:function ($$v) {_vm.mobile=$$v},expression:"mobile"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('email')},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"text":"","color":"primary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 442 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 443 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.$store.state.grid && _vm.$vuetify.breakpoint.mdAndUp)?_c('v-data-table',{attrs:{"headers":_vm.headers,"loading":_vm.progress,"items":_vm.items,"hide-default-footer":"","search":_vm.search,"page":_vm.page,"items-per-page":_vm.itemsPerPage},on:{"update:page":function($event){_vm.page=$event},"click:row":_vm.onClickItem},scopedSlots:_vm._u([{key:"top",fn:function(){return [_c('v-toolbar',{staticClass:"mb-1",attrs:{"elevation":"1","dark":"","dense":"","color":"secondary darken-3"}},[_c('v-text-field',{attrs:{"clearable":"","flat":"","solo-inverted":"","hide-details":"","prepend-inner-icon":"search","label":_vm.$t('search')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.$store.state.grid = true}}},[_c('v-icon',[_vm._v("fa-table")])],1)],1)]},proxy:true},{key:"item.openMarkers",fn:function(ref){
var item = ref.item;
return [_vm._t("itemOpenMarkers",null,{"item":item})]}},{key:"item.actions",fn:function(ref){
var item = ref.item;
return [_vm._t("itemAction",null,{"item":item})]}},{key:"no-data",fn:function(){return [_vm._t("empty")]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticClass:"d-flex flex-wrap justify-end pa-2"},[_c('v-pagination',{attrs:{"length":_vm.pageCount},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}),_vm._v(" "),_c('span',{staticClass:"pt-2"},[_vm._v(_vm._s(_vm.$t('itemsPerPage')))]),_vm._v(" "),_c('v-menu',{attrs:{"transition":"scale-transition","origin":"right top","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"ml-2",attrs:{"dark":"","text":"","color":"primary"}},on),[_vm._v("\n              "+_vm._s(_vm.itemsPerPage)+"\n              "),_c('v-icon',[_vm._v("mdi-chevron-down")])],1)]}}],null,false,3290870765)},[_vm._v(" "),_c('v-list',_vm._l(([1,5,10,15,30, 50]),function(number,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.changeItemsPerPage(number)}}},[_c('v-list-item-title',[_vm._v(_vm._s(number))])],1)}),1)],1)],1)]},proxy:true},{key:"no-results",fn:function(){return [_c('v-icon',{staticClass:"mr-3",attrs:{"color":"secondary","small":""}},[_vm._v("fa-search")]),_vm._v("\n      "+_vm._s(_vm.$t('noresults'))+"\n    ")]},proxy:true}],null,true)},[_vm._v(" "),_c('v-slide-y-transition',{staticClass:"py-0",attrs:{"group":"","tag":"tbody"}})],1):_vm._e(),_vm._v(" "),(!_vm.$vuetify.breakpoint.mdAndUp || _vm.$store.state.grid)?_c('v-data-iterator',{attrs:{"items":_vm.items,"search":_vm.search,"hide-default-footer":"","items-per-page":_vm.itemsPerPage,"loading":_vm.progress,"page":_vm.page},on:{"update:itemsPerPage":function($event){_vm.itemsPerPage=$event},"update:items-per-page":function($event){_vm.itemsPerPage=$event},"page-count":function($event){_vm.pageCount = $event}},scopedSlots:_vm._u([{key:"header",fn:function(){return [_c('v-toolbar',{staticClass:"mb-1",attrs:{"elevation":"1","dark":"","dense":"","color":"secondary darken-3"}},[_c('v-text-field',{attrs:{"clearable":"","flat":"","solo-inverted":"","hide-details":"","prepend-inner-icon":"search","label":_vm.$t('search')},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),(_vm.$vuetify.breakpoint.mdAndUp)?[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){_vm.$store.state.grid = false}}},[_c('v-icon',[_vm._v("fa-list")])],1)]:_vm._e()],2)]},proxy:true},{key:"default",fn:function(props){return [_c('v-row',_vm._l((props.items),function(item,i){return _c('v-col',{key:i,attrs:{"cols":"12","sm":"6","md":"4","lg":"3"}},[_c('v-card',{attrs:{"elevation":"","height":"100%"}},[_vm._t("cardContent",null,{"item":item})],2)],1)}),1)]}},{key:"loading",fn:function(){return [_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1)]},proxy:true},{key:"no-data",fn:function(){return [_vm._t("empty")]},proxy:true},{key:"no-results",fn:function(){return [_c('div',{staticClass:"d-flex justify-center pa-2"},[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"secondary","small":""}},[_vm._v("fa-search")]),_vm._v("\n        "+_vm._s(_vm.$t('noresults'))+"\n      ")],1)]},proxy:true},{key:"footer",fn:function(){return [_c('div',{staticClass:"d-flex flex-wrap justify-end pa-2"},[_c('v-pagination',{attrs:{"length":_vm.pageCount},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}),_vm._v(" "),_c('span',{staticClass:"pt-2"},[_vm._v(_vm._s(_vm.$t('itemsPerPage')))]),_vm._v(" "),_c('v-menu',{attrs:{"transition":"scale-transition","origin":"right top","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"ml-2",attrs:{"dark":"","text":"","color":"primary"}},on),[_vm._v("\n              "+_vm._s(_vm.itemsPerPage)+"\n              "),_c('v-icon',[_vm._v("mdi-chevron-down")])],1)]}}],null,false,3290870765)},[_vm._v(" "),_c('v-list',_vm._l(([1,5,10,15,30,50]),function(number,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.changeItemsPerPage(number)}}},[_c('v-list-item-title',[_vm._v(_vm._s(number))])],1)}),1)],1)],1)]},proxy:true}],null,true)}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 444 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"400"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_vm._t("activator",null,{"on":on})]}}],null,true),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),(_vm.dialog)?_c('v-card',{staticClass:"container"},[_c('v-card-title',[_vm._v(_vm._s(_vm.$t('downloadLogbook')))]),_vm._v(" "),_c('v-card-text',[_c('v-checkbox',{attrs:{"persistent-hint":"","disabled":"","hint":_vm.$t('downloadlogbookasaWordFile'),"input-value":"true","label":_vm.$t('Word .docx')}}),_vm._v(" "),_c('v-badge',{attrs:{"value":_vm.$can('download','separated') ? 0 : 'Pro/Expert',"content":_vm.$can('download','separated') ? 0 : 'Pro/Expert',"bordered":"","overlap":""}},[_c('v-checkbox',{attrs:{"persistent-hint":"","hint":_vm.$t('blueprintSeparatedHint'),"disabled":!_vm.$can('download','separated'),"label":_vm.$t('blueprintSeparated')},model:{value:(_vm.blueprintSeparated),callback:function ($$v) {_vm.blueprintSeparated=$$v},expression:"blueprintSeparated"}})],1),_vm._v(" "),_c('v-badge',{attrs:{"value":_vm.$can('download','includeCertificates') ? 0 : 'Pro/Expert',"content":_vm.$can('download','includeCertificates') ? 0 : 'Pro/Expert',"bordered":"","overlap":""}},[_c('v-checkbox',{attrs:{"persistent-hint":"","hint":_vm.$t('withDocumentsHint'),"disabled":!_vm.$can('download','includeCertificates'),"label":_vm.$t('withDocuments')},model:{value:(_vm.withDocuments),callback:function ($$v) {_vm.withDocuments=$$v},expression:"withDocuments"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","block":"","depressed":""},on:{"click":function($event){return _vm.downloadLogbook()}}},[_vm._v(_vm._s(_vm.$t('download')))])],1)],1):_vm._e(),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 445 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstallPWA_vue__ = __webpack_require__(194);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169ca7d9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstallPWA_vue__ = __webpack_require__(447);
function injectStyle (ssrContext) {
  __webpack_require__(446)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-169ca7d9"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstallPWA_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_169ca7d9_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstallPWA_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 446 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 447 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-alert',{staticClass:"mx-3",attrs:{"id":"popup","color":"secondary","dismissible":"","prominent":"","dark":""}},[_vm._v("\n"+_vm._s(_vm.$t('installPWA'))),_c('img',{attrs:{"width":"25","height":"25","src":__webpack_require__(185)}}),_vm._v(" "+_vm._s(_vm.$t('addToHomeScreen'))+"\n")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 448 */,
/* 449 */,
/* 450 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("projects")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"projects"}},[_c('addProject',{on:{"add-project":_vm.addProject}})],1),_vm._v(" "),_c('can',{attrs:{"I":"read","a":"archivedProjects"}},[_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"ml-3",attrs:{"color":"white","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.showArchivedProjects()}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("archive")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("archivedProjects")))])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container' : ''},[_c('dataTable',{attrs:{"items":_vm.projects,"progress":_vm.progress,"headers":_vm.headers},on:{"clickItem":_vm.projectDetails},scopedSlots:_vm._u([{key:"itemAction",fn:function(ref){
var item = ref.item;
return [_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("download")))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"download","a":"logbook"}},[_c('downloadLogbook',{on:{"download":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.downloadLogbook.apply(void 0, [ item ].concat( args ));
}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("import_contacts")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("download")))])],1)]}}],null,true)})],1),_vm._v(" "),_c('can',{attrs:{"I":"archive","a":"projects"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.archiveProject(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-archive")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("archive")))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"projects"}},[_c('areyousure',{attrs:{"list_item":"","id":item.id,"object":"project"},on:{"delete":_vm.deleteProject}})],1)],1)],1)],1)]}},{key:"cardContent",fn:function(ref){
var item = ref.item;
return [_c('v-subheader',{staticClass:"subheading primary lighten-3 white--text font-weight-bold"},[_c('a',{staticClass:"white--text",attrs:{"href":"#"},on:{"click":function($event){return _vm.projectDetails(item)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("download")))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"download","a":"logbook"}},[_c('downloadLogbook',{on:{"download":function () {
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.downloadLogbook.apply(void 0, [ item ].concat( args ));
}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("import_contacts")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("download")))])],1)]}}],null,true)})],1),_vm._v(" "),_c('can',{attrs:{"I":"archive","a":"projects"}},[_c('v-list-item',{on:{"click":function($event){return _vm.archiveProject(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-archive")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("archive")))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"projects"}},[_c('areyousure',{attrs:{"list_item":"","id":item.id,"object":"project"},on:{"delete":_vm.deleteProject}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pointer",on:{"click":function($event){return _vm.projectDetails(item)}}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("building"))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.buildingName))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("buildingComponents"))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.buildingComponents.length))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t("createdTs"))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.createdTs))])],1)],1)],1)]}},{key:"empty",fn:function(){return [(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getData()}}}):_c('emptyList',{attrs:{"image":__webpack_require__(184),"title":_vm.$t('noProjects')},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('can',{attrs:{"I":"create","a":"projects"}},[_c('addProject',{on:{"add-project":_vm.addProject}})],1)]},proxy:true}])})]},proxy:true}])})],1),_vm._v(" "),(_vm.showInstall)?_c('installPWA'):_vm._e(),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 451 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsDetails_vue__ = __webpack_require__(195);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2974f112_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsDetails_vue__ = __webpack_require__(458);
function injectStyle (ssrContext) {
  __webpack_require__(452)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2974f112"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2974f112_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 452 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 453 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBuildingComponent_vue__ = __webpack_require__(196);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330a0ffd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBuildingComponent_vue__ = __webpack_require__(454);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddBuildingComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_330a0ffd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddBuildingComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 454 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"depressed":"","color":"secondary","small":""}},on),[_vm._v(_vm._s(_vm.$t("newBuildingComponent")))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"ripple":""}},[_vm._v(_vm._s(_vm.$t("newBuildingComponent")))]),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","rules":_vm.rules(_vm.$t('name')),"counter":"512","required":"","placeholder":_vm.$t('blockA'),"label":_vm.$t('name')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","label":_vm.$t('description')},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t("close")))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t("save")))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 455 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProject_vue__ = __webpack_require__(197);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4a7323a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProject_vue__ = __webpack_require__(457);
function injectStyle (ssrContext) {
  __webpack_require__(456)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditProject_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a4a7323a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditProject_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 456 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 457 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"750px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"depressed":"","color":"secondary","small":""}},on),[_vm._v(_vm._s(_vm.$t("projectDetails")))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("project")))]),_vm._v(" "),_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("address")))]),_vm._v(" "),_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("contact")))]),_vm._v(" "),_c('v-tab-item',[_c('v-divider'),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"d-flex flex-wrap justify-content-center container"},[_c('div',{staticClass:"flex-fill"},[_c('v-text-field',{attrs:{"outlined":"","dense":"","rules":_vm.nameRules(),"required":"","label":_vm.$t('name')},model:{value:(_vm.project.name),callback:function ($$v) {_vm.$set(_vm.project, "name", $$v)},expression:"project.name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","rules":_vm.buildingRules(),"required":"","label":_vm.$t('building')},model:{value:(_vm.project.buildingName),callback:function ($$v) {_vm.$set(_vm.project, "buildingName", $$v)},expression:"project.buildingName"}})],1),_vm._v(" "),_c('div',{staticClass:"flex-fill d-flex"},[_c('image-uploader',{staticClass:"mx-auto my-auto",staticStyle:{"min-width":"245px"},attrs:{"preview":false,"className":['fileinput', { 'fileinput--loaded': _vm.hasImage }],"capture":"environment","debug":1,"quality":0.8,"accept":".jpg, .png","autoRotate":true,"outputFormat":"verbose"},on:{"input":_vm.setImage,"onUpload":function($event){_vm.loading = true},"onComplete":function($event){_vm.loading= false}}},[_c('label',{attrs:{"slot":"upload-label","for":"fileInput"},slot:"upload-label"},[_c('div',{staticClass:"mx-auto my-auto text-center"},[(!_vm.project.image)?_c('v-icon',{attrs:{"large":""}},[_vm._v("add_photo_alternate")]):[_c('v-img',{attrs:{"height":"245","width":"245","aspect-ratio":"1","src":(_vm.project.image == null) ? _vm.emptyImage : _vm.project.image}}),_vm._v(" "),_c('a',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('changeImage')))])]],2)])])],1)])])],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-divider'),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('street')},model:{value:(_vm.project.street),callback:function ($$v) {_vm.$set(_vm.project, "street", $$v)},expression:"project.street"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('number')},model:{value:(_vm.project.no),callback:function ($$v) {_vm.$set(_vm.project, "no", $$v)},expression:"project.no"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('postalcode')},model:{value:(_vm.project.postalCode),callback:function ($$v) {_vm.$set(_vm.project, "postalCode", $$v)},expression:"project.postalCode"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('city')},model:{value:(_vm.project.city),callback:function ($$v) {_vm.$set(_vm.project, "city", $$v)},expression:"project.city"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('country')},model:{value:(_vm.project.country),callback:function ($$v) {_vm.$set(_vm.project, "country", $$v)},expression:"project.country"}})],1)],1)],1),_vm._v(" "),_c('v-tab-item',[_c('v-divider'),_vm._v(" "),_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('name')},model:{value:(_vm.project.contactName),callback:function ($$v) {_vm.$set(_vm.project, "contactName", $$v)},expression:"project.contactName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('contactFunction')},model:{value:(_vm.project.contactFunction),callback:function ($$v) {_vm.$set(_vm.project, "contactFunction", $$v)},expression:"project.contactFunction"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('mobile')},model:{value:(_vm.project.mobile),callback:function ($$v) {_vm.$set(_vm.project, "mobile", $$v)},expression:"project.mobile"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","label":_vm.$t('email')},model:{value:(_vm.project.email),callback:function ($$v) {_vm.$set(_vm.project, "email", $$v)},expression:"project.email"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 458 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.project)?_c('v-toolbar',{staticClass:"sticky",attrs:{"elevation":"1","dark":"","dense":"","color":"#296C9A","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.project.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"projects"}},[_c('editProject',{attrs:{"project":_vm.project},on:{"edit":_vm.editProject}})],1)],1):_vm._e(),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('v-toolbar',{staticClass:"mt-3",attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('buildingComponents')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"buildingComponents"}},[_c('addBuildingComponent',{on:{"add-buildingComponent":_vm.add}})],1)],1),_vm._v(" "),_c('dataTable',{attrs:{"items":_vm.buildingComponents,"progress":_vm.progress,"headers":_vm.headers},on:{"clickItem":_vm.details},scopedSlots:_vm._u([{key:"itemAction",fn:function(ref){
var item = ref.item;
return [_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"download","a":"logbook"}},[_c('downloadLogbook',{on:{"download":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.downloadLogbook.apply(void 0, [ item ].concat( args ));
}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("import_contacts")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)]}}],null,true)})],1),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"buildingComponents"}},[_c('areyousure',{attrs:{"list_item":"","id":item.id,"object":"buildingComponent"},on:{"delete":_vm.remove}})],1)],1)],1)],1)]}},{key:"cardContent",fn:function(ref){
var item = ref.item;
return [_c('v-subheader',{staticClass:"subheading primary lighten-3 white--text font-weight-bold"},[_c('a',{staticClass:"white--text",attrs:{"href":"#"},on:{"click":function($event){return _vm.details(item)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"download","a":"logbook"}},[_c('downloadLogbook',{on:{"download":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.downloadLogbook.apply(void 0, [ item ].concat( args ));
}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("import_contacts")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)]}}],null,true)})],1),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"buildingComponents"}},[_c('areyousure',{attrs:{"list_item":"","id":item.id,"object":"buildingComponent"},on:{"delete":_vm.remove}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pointer",on:{"click":function($event){return _vm.details(item)}}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('description'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.description))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('blueprints'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.blueprintsCount))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('createdTs'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.createdTs))])],1)],1)],1)]}},{key:"empty",fn:function(){return [(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getData()}}}):_c('emptyList',{attrs:{"image":__webpack_require__(183),"title":_vm.$t('noBuildingComponents')},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('can',{attrs:{"I":"create","a":"buildingComponents"}},[_c('addBuildingComponent',{on:{"add-buildingComponent":_vm.add}})],1)]},proxy:true}])})]},proxy:true}])})],1),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 459 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuildingComponentsDetails_vue__ = __webpack_require__(198);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42974518_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuildingComponentsDetails_vue__ = __webpack_require__(465);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuildingComponentsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_42974518_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuildingComponentsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 460 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"depressed":"","color":"secondary","small":""}},on),[_vm._v(_vm._s(_vm.$t("newBlueprint")))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"ripple":""}},[_vm._v(_vm._s(_vm.$t("newBlueprint")))]),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","rules":_vm.rules(_vm.$t('name')),"required":"","counter":"512","placeholder":_vm.$t('firstFloor'),"label":_vm.$t('name')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","label":_vm.$t('description')},model:{value:(_vm.description),callback:function ($$v) {_vm.description=$$v},expression:"description"}}),_vm._v(" "),_c('v-menu',{ref:"menu1",attrs:{"transition":"scale-transition","origin":"right top","offset-y":"","close-on-content-click":false,"nudge-right":40,"lazy":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"outlined":"","dense":"","readonly":"","label":_vm.$t('deadline'),"persistent-hint":"","prepend-icon":"event"},model:{value:(_vm.deadline),callback:function ($$v) {_vm.deadline=$$v},expression:"deadline"}},on))]}}]),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},model:{value:(_vm.deadline),callback:function ($$v) {_vm.deadline=$$v},expression:"deadline"}})],1),_vm._v(" "),_c('v-select',{attrs:{"menu-props":{ bottom: true, offsetY: true },"outlined":"","dense":"","items":_vm.allInstallers,"label":_vm.$t('installer'),"chips":"","item-value":"id","item-text":"fullName","multiple":"","return-object":""},model:{value:(_vm.installers),callback:function ($$v) {_vm.installers=$$v},expression:"installers"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t("close")))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t("save")))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 461 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('AddBlueprint',{on:{"add-blueprint":_vm.addBlueprint}}),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("blueprints")))]),_vm._v(" "),_c('v-data-table',{staticClass:"elevation-1",attrs:{"headers":_vm.headers,"items":_vm.blueprints,"rows-per-page-items":_vm.$store.state.rows},scopedSlots:_vm._u([{key:"items",fn:function(props){return [_c('td',{on:{"click":function($event){return _vm.blueprintDetails(props.item.id)}}},[_vm._v(_vm._s(props.item.name))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.blueprintDetails(props.item.id)}}},[_vm._v(_vm._s(props.item.description))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.blueprintDetails(props.item.id)}}},[_vm._v(_vm._s(props.item.markerName))]),_vm._v(" "),_c('td',{on:{"click":function($event){return _vm.blueprintDetails(props.item.id)}}},[_vm._v(_vm._s(props.item.order))]),_vm._v(" "),_c('td',[_c('v-icon',{on:{"click":function($event){return _vm.deleteBlueprint(props.item.id)}}},[_vm._v("delete")])],1)]}}])})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 462 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBuildingComponent_vue__ = __webpack_require__(203);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a84fda2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBuildingComponent_vue__ = __webpack_require__(464);
function injectStyle (ssrContext) {
  __webpack_require__(463)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditBuildingComponent_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3a84fda2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditBuildingComponent_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 463 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 464 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"depressed":"","color":"secondary","small":""}},on),[_vm._v(_vm._s(_vm.$t("buildingComponentDetails")))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("edit"))+" "+_vm._s(_vm.$t("buildingComponent")))]),_vm._v(" "),_c('v-tab-item',[_c('v-divider'),_vm._v(" "),_c('v-card',{staticClass:"mt-5 container",attrs:{"flat":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","rules":_vm.nameRules(),"required":"","label":_vm.$t('name')},model:{value:(_vm.buildingComponent.name),callback:function ($$v) {_vm.$set(_vm.buildingComponent, "name", $$v)},expression:"buildingComponent.name"}}),_vm._v(" "),_c('v-textarea',{attrs:{"outlined":"","dense":"","required":"","label":_vm.$t('description')},model:{value:(_vm.buildingComponent.description),callback:function ($$v) {_vm.$set(_vm.buildingComponent, "description", $$v)},expression:"buildingComponent.description"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 465 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.buildingComponent)?_c('div',[_c('v-toolbar',{staticClass:"sticky-toolbar-breadcrumb",attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[(_vm.buildingComponent)?_c('v-toolbar-title',[_vm._v(_vm._s(_vm.buildingComponent.name))]):_vm._e(),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('editBuildingComponent',{attrs:{"buildingComponent":_vm.buildingComponent},on:{"edit":_vm.editBuildingComponent}})],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('v-toolbar',{staticClass:"mt-3",attrs:{"elevation":"1","dense":"","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('blueprints')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"blueprints"}},[_c('addBlueprint',{on:{"add-blueprint":_vm.addBlueprint}})],1)],1),_vm._v(" "),_c('dataTable',{attrs:{"items":_vm.blueprints,"progress":_vm.progress,"headers":_vm.headers},on:{"clickItem":_vm.blueprintDetails},scopedSlots:_vm._u([{key:"itemAction",fn:function(ref){
var item = ref.item;
return [((_vm.$can('delete', 'projects') && !item.isLocked) || (!_vm.$can('delete', 'projects')))?_c('v-btn',{staticClass:"ml-3 mr-2",attrs:{"color":"primary","disabled":!_vm.$can('delete', 'projects') && item.isLocked,"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.editBlueprint(item)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-edit")])],1):_vm._e(),_vm._v(" "),(_vm.$can('delete', 'projects') && item.isLocked)?_c('v-btn',{staticClass:"ml-3 mr-2",attrs:{"color":"primary","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.breakLock(item)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-lock")])],1):_vm._e(),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"blueprints"}},[_c('areyousure',{attrs:{"list_item":"","id":item.id,"object":"blueprint"},on:{"delete":_vm.deleteBlueprint}})],1)],1)],1)],1)]}},{key:"cardContent",fn:function(ref){
var item = ref.item;
return [_c('v-subheader',{staticClass:"primary lighten-3 white--text font-weight-bold"},[_c('a',{staticClass:"white--text",attrs:{"href":"#"},on:{"click":function($event){return _vm.blueprintDetails(item)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flat":""}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"blueprints"}},[_c('areyousure',{attrs:{"list_item":"","id":item.id,"object":"blueprint"},on:{"delete":_vm.deleteBlueprint}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pointer",on:{"click":function($event){return _vm.blueprintDetails(item)}}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('description'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold text-truncate"},[_vm._v(_vm._s(item.description))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('markers'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.markers.length))])],1),_vm._v(" "),(item.isLocked)?_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('isEditing'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.lockedByUserName))])],1):_vm._e(),_vm._v(" "),(item.isLocked)?_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('editStart'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.lockedTs))])],1):_vm._e(),_vm._v(" "),(_vm.$can('delete', 'projects') && item.isLocked)?_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('breakLock'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold",on:{"click":function($event){$event.stopPropagation();return _vm.breakLock(item)}}},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                    "+_vm._s(_vm.$t('break'))+"\n                    "),_c('i',{staticClass:"fa fa-lock ml-2"})])])],1):_vm._e()],1)],1)]}},{key:"empty",fn:function(){return [(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getData()}}}):_c('emptyList',{attrs:{"fit":"","image":__webpack_require__(113),"title":_vm.$t('noBlueprints')},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('can',{attrs:{"I":"create","a":"blueprints"}},[_c('addBlueprint',{on:{"add-blueprint":_vm.addBlueprint}})],1)]},proxy:true}],null,false,529748404)})]},proxy:true}],null,false,2252573141)}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('warning')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('continuereadonly')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":"","autofocus":""},on:{"click":function($event){return _vm.responseReadonly(false)}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.responseReadonly(true)}}},[_vm._v(_vm._s(_vm.$t('yes')))])],1)],1)],1)],1),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1):_c('div',[_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1)],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 466 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlueprintsDetails_vue__ = __webpack_require__(204);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64353650_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlueprintsDetails_vue__ = __webpack_require__(487);
function injectStyle (ssrContext) {
  __webpack_require__(467)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-64353650"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlueprintsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_64353650_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlueprintsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 467 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 468 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 469 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-snackbar',{attrs:{"multi-line":"","vertical":"","timeout":9999999999,"value":true,"bottom":"","color":"highlight"},on:{"input":_vm.close}},[_vm._v("\n    "+_vm._s(((_vm.blueprint.lockedByUserName) + " " + (this.$t("blueprintLockedSince")) + " " + (_vm.blueprint.lockedTs)))+"\n    "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-1",attrs:{"color":"white","small":"","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('v-btn',{attrs:{"outlined":"","color":"white"},on:{"click":_vm.takeover}},[_vm._v(_vm._s(_vm.$t('takeOver')))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 470 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 471 */,
/* 472 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-row',{attrs:{"wrap":""}},[(!_vm.blueprintPage)?_c('v-col',{staticClass:"d-flex child-flex",attrs:{"lg":"6","xs":"12","sm":"12","cols":"12"}},[_c('v-card',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"text-center justify-center d-flex pa-5 body-1 font-weight-light",attrs:{"disabled":_vm.$store.state.isOffline,"outlined":"","height":"350px"},on:{"click":_vm.noBlueprint}},[_c('div',{staticClass:"d-flex justify-center"},[_c('div',{staticClass:"my-auto"},[_c('v-icon',{attrs:{"x-large":"","color":"primary"}},[_vm._v("grid_off")]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.$t("noBlueprint")))])],1)])])],1):_vm._e(),_vm._v(" "),_c('v-col',{attrs:{"lg":_vm.blueprintPage ? '12' : 6,"xs":"12","sm":"12","cols":"12"}},[_c('label',{staticClass:"flex-fill",attrs:{"slot":"upload-label","for":_vm.loading ? '':'file'},slot:"upload-label"},[_c('v-card',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"text-center pa-5 body-1 font-weight-light",staticStyle:{"cursor":"pointer"},attrs:{"disabled":_vm.readonly || _vm.$store.state.isOffline,"outlined":"","height":"350px"}},[_c('v-form',{ref:"form",staticClass:"center",attrs:{"lazy-validation":""}},[_c('div',{staticClass:"text-center"},[_c('v-icon',{attrs:{"color":"primary","large":""}},[_vm._v("add_photo_alternate")]),_vm._v(" "),(_vm.uploadReady)?_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"accept":_vm.$can('upload','pdf') ? '.jpg, .png, .pdf' : '.jpg, .png,',"type":"file","id":"file"},on:{"change":_vm.onFileChanged}}):_vm._e(),_vm._v(" "),_c('div',[_c('v-badge',{attrs:{"value":_vm.$can('upload','pdf') ? 0 : '.pdf Pro/Expert license',"content":_vm.$can('upload','pdf') ? 0 : '.pdf Pro/Expert license'}},[_c('div',[_vm._v(_vm._s(_vm.$t("uploadBlueprintFile")))])])],1)],1)])],1)],1)])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"290"},model:{value:(_vm.showPageSelector),callback:function ($$v) {_vm.showPageSelector=$$v},expression:"showPageSelector"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('selectYourPage')))]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"type":"telephone","filled":""},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","depressed":""},on:{"click":function($event){_vm.showPageSelector = false;_vm.uploadFile()}}},[_vm._v(_vm._s(_vm.$t('upload')))])],1)],1)],1),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 473 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 474 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 475 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 476 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{style:(_vm.$store.state.isMobile?'margin-bottom: 100px': ''),attrs:{"loading":_vm.loading,"outlined":""}},[_c('v-toolbar',{staticClass:"pl-0",attrs:{"dense":"","flat":"","color":"transparant"}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t("markers")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px","height":"180px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("priority_high")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_broken')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"orange"}},[_vm._v("priority_high")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_inProcess')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check_circle")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_approved')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("priority_high")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_new')))])],1)],1)],1)],1),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","offset-y":"","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flat":"","width":"200px","height":"180px"}},[_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":4},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("select_all")]),_vm._v("\n               "+_vm._s(_vm.$t('showAll'))+"\n             ")],1)],2),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":0},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("priority_high")]),_vm._v("\n               "+_vm._s(_vm.$t('broken'))+"\n             ")],1)],2),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":1},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"orange"}},[_vm._v("priority_high")]),_vm._v("\n               "+_vm._s(_vm.$t('inProcess'))+"\n             ")],1)],2),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":2},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check_circle")]),_vm._v("\n               "+_vm._s(_vm.$t('approved'))+"\n             ")],1)],2),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":3},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("priority_high")]),_vm._v("\n               "+_vm._s(_vm.$t('new'))+"\n             ")],1)],2)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-text-field',{attrs:{"clearable":"","flat":"","dense":"","solo":"","hide-details":"","prepend-inner-icon":"search","label":_vm.$t('search')},on:{"click:clear":function($event){_vm.search = ''}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.filteredItems),function(marker,i){return [_c('v-card',{key:i,class:{'active-row': (marker.draggable)},style:({ display: _vm.filterMarkers(marker) }),on:{"click":function($event){return _vm.select(marker,i)},"dblclick":function($event){return _vm.markerDetails(marker)}}},[_c('v-card-title',{staticClass:"py-2"},[_vm._v(_vm._s(marker.number)+" "),(marker.label)?[_vm._v(" - "+_vm._s(marker.label))]:_vm._e()],2),_vm._v(" "),_c('v-card-text',{staticClass:"py-0"},[_c('p',{staticClass:"caption mb-0"},[(marker.date)?[_vm._v(_vm._s(_vm.$t('applicationDate'))+" "+_vm._s(marker.date))]:_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(marker.installer)?[_vm._v(_vm._s(_vm.$t('modifiedBy'))+" "+_vm._s(marker.installer.firstname)+" "+_vm._s(marker.installer.name)+"\n               "+_vm._s(marker.modifiedTs)+"\n               ")]:_vm._e()],2),_vm._v(" "),_c('p',{staticClass:"caption mb-0 text-truncate"},[_vm._v(_vm._s(marker.comments))])]),_vm._v(" "),_c('v-card-actions',[(marker.qrId)?[_c('v-chip',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"secondary"}},[_vm._v("fa-qrcode")]),_vm._v(" "),(_vm.$vuetify.breakpoint.mdAndUp)?[_vm._v(_vm._s(_vm.$t('linked')))]:_vm._e()],2)]:[_c('v-chip',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"error"}},[_vm._v("fa-qrcode")]),_vm._v(" "),(_vm.$vuetify.breakpoint.mdAndUp)?[_vm._v(_vm._s(_vm.$t('notLinked')))]:_vm._e()],2)],_vm._v(" "),_c('v-chip',[_c('v-icon',{attrs:{"color":marker.status == 0? 'red' :
                    marker.status == 1  ? 'orange':
                     marker.status == 2? 'success': 'primary'}},[_vm._v(_vm._s(marker.status == 2 ? 'check_circle' : marker.status === 1 ? 'priority_high': 'priority_high'))]),_vm._v("\n             "+_vm._s(marker.status == 0 ? _vm.$t('broken') : marker.status == 2 ? _vm.$t('approved') : marker.status == 1 ? _vm.$t('inProcess') : _vm.$t('new'))+"\n           ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","text":""},on:{"click":function($event){return _vm.markerDetails(marker)}}},[_vm._v(_vm._s(_vm.$t('open')))])],2),_vm._v(" "),_c('v-divider')],1)]}),_vm._v(" "),(_vm.$store.state.markersReadonly.length == 0)?_c('v-card',{attrs:{"disabled":"","flat":""}},[(_vm.$store.state.drawable)?[_c('p',{staticClass:"text-center pa-5 body-1 font-weight-light"},[_c('span',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("info")]),_vm._v("\n             "+_vm._s(_vm.$t('draw'))+"\n           ")],1)])]:_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"text-center pa-5 body-1 font-weight-light"},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"x-large":"","color":"primary"}},[_vm._v("add_circle_outline")])],1)],1)],2):_vm._e()],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 477 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 478 */,
/* 479 */,
/* 480 */,
/* 481 */,
/* 482 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarkUpFullScreen_vue__ = __webpack_require__(212);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a58ccce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarkUpFullScreen_vue__ = __webpack_require__(484);
function injectStyle (ssrContext) {
  __webpack_require__(483)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4a58ccce"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MarkUpFullScreen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a58ccce_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MarkUpFullScreen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 483 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 484 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.blueprint.blueprintFile.content)?_c('div',{attrs:{"flat":""}},[_c('div',{style:({ display: _vm.fullscreen || !_vm.$store.state.isMobile ? 'block': 'none'})},[_c('v-toolbar',{attrs:{"dense":"","dark":"","flat":"","color":"#3a5973"}},[(_vm.fullscreen)?_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.fullscreen = !_vm.fullscreen}}},[_c('v-icon',[_vm._v("mdi-close")])],1):_vm._e(),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("blueprint")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.detailPage && !_vm.readonly  && _vm.$store.state.markers.length == 0)?_c('v-toolbar-items',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [(!_vm.$store.state.isOffline)?_c('v-btn',_vm._g({attrs:{"text":""},on:{"click":_vm.deleteBlueprintFile}},on),[_c('v-icon',[_vm._v("fa-trash-alt")])],1):_vm._e()]}}],null,false,653355554)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('deleteBlueprintImage')))])])],1):_vm._e(),_vm._v(" "),_c('v-toolbar-items',[(!_vm.fullscreen)?_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.fullscreen = !_vm.fullscreen}}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({},on),[_c('v-icon',[_vm._v("settings_overscan")])],1)]}}],null,false,2195988244)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('fullscreen')))])])],1):_vm._e()],1),_vm._v(" "),_c('can',{attrs:{"i":"update","a":"blueprints"}},[(!_vm.$store.state.isMobile && !_vm.$store.state.isOffline && !_vm.fullscreen && !_vm.detailPage && (_vm.$store.state.markers.length > 0 || _vm.$store.state.markersReadonly.length > 0))?_c('v-toolbar-items',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"small":"","icon":"","color":"white","text":""}},on),[_c('downloadLogbook',{on:{"download":_vm.generateLogbook},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"small":"","icon":"","color":"white","text":""}},on),[_c('v-icon',[_vm._v("import_contacts")])],1)]}}],null,true)})],1)]}}],null,false,3695895823)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('downloadLogbook')))])])],1):_vm._e()],1),_vm._v(" "),(!_vm.detailPage && !_vm.readonly  && _vm.$store.state.markers.length > 0)?_c('v-toolbar-items',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":""},on:{"click":_vm.update}},on),[(!_vm.$store.state.hasChanges)?_c('v-icon',[_vm._v("save")]):_c('v-badge',{attrs:{"color":"orange"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('v-icon',{attrs:{"dark":"","small":""}},[_vm._v("priority_high")])]},proxy:true}],null,true)},[_vm._v(" "),_c('v-icon',[_vm._v("save")])],1)],1)]}}],null,false,3884107359)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('saveMarkerPosition')))])])],1):_vm._e(),_vm._v(" "),(!_vm.detailPage && !_vm.readonly)?_c('v-toolbar-items',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.$store.state.drawable = !_vm.$store.state.drawable}}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":_vm.$store.state.drawable ? 'secondary' : 'white'}},on),[_vm._v("fa-edit")])]}}],null,false,718134717)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('newMarker')))])])],1)],1):_vm._e(),_vm._v(" "),(!_vm.readonly && !_vm.markerDetailView)?_c('v-toolbar-items',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.moveMarker = !_vm.moveMarker}}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',_vm._g({},on),[_c('v-icon',{attrs:{"color":_vm.moveMarker ? 'secondary' : 'white'}},[_vm._v("fa-arrows-alt")])],1)]}}],null,false,2430140337)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('moveMarker')))])])],1)],1):_vm._e()],1),_vm._v(" "),_c('v-sheet',{ref:"markup-wrapper",staticClass:"overflow-hidden",attrs:{"tile":"","max-height":_vm.fullscreen ? '100%' :700}},[_c('v-stage',{ref:"stageFullscreen2",staticClass:"blueprint",class:{'fit_blueprint': (!_vm.fullscreen)},attrs:{"config":_vm.stageSize},on:{"touchstart":_vm.disableSwipeTogoBack,"touchend":_vm.pinchEnd,"touchmove":_vm.pinch}},[_c('v-layer',{ref:"layer2",attrs:{"config":_vm.layerSize}},[_c('v-image',{attrs:{"config":{
                    image: _vm.image,
                  }},on:{"click":_vm.unSelect,"touchend":_vm.handleTouchEnd,"mousedown":_vm.handleTouchMove,"mouseup":_vm.handleTouchEnd,"touchmove":_vm.handleTouchMove}}),_vm._v(" "),_vm._l((_vm.markers),function(marker){return _c('v-group',{key:marker.id,ref:"group",refInFor:true,attrs:{"config":{
            visible: _vm.groupConfig.visible,
          }}},[_c('v-rect',{attrs:{"config":{
              id:marker.id,
                    x: marker.xRect,
                    y: marker.yRect,
                    width: 10,
                    height: 10,
                    stroke: 'rgba(76, 175, 80, 0)',
                    strokeWidth: 25,
                    fill: _vm.color(marker),
                    draggable: _vm.moveMarker,
                     dragBoundFunc: function (pos){
                       return _vm.dragBound(pos)
                     }                
                  }},on:{"dragmove":_vm.adjustPoint,"dragend":_vm.updatePosition}}),_vm._v(" "),_c('v-line',{attrs:{"config":{
                    points: [marker.xStartLine, marker.yStartLine, marker.xEndLine, marker.yEndLine],
                    stroke: _vm.color(marker),
                  }}}),_vm._v(" "),_c('v-circle',{attrs:{"config":{
                    x: marker.xCircle,
                    y: marker.yCircle,
                    radius: 20,
                    width: 35,
                    height: 35,
                    fill: _vm.color(marker),
                    stroke: _vm.color(marker),
                    strokeWidth: 8,
                  }}}),_vm._v(" "),_c('v-circle',{attrs:{"config":{
                    x: marker.xCircle,
                    y: marker.yCircle,
                    radius: 20,
                    width: 35,
                    height: 35,
                    fill: _vm.color(marker),
                    stroke: _vm.color(marker),
                    strokeWidth: 8,
                  }}}),_vm._v(" "),(marker.label && marker.label !== '')?[_c('v-rect',{attrs:{"config":{
              id:marker.id,
                    x: marker.xLabel -60,
                    y: marker.yLabel +30,
                    width: 160,
                    height: 25,
                    stroke: 'rgba(76, 175, 80, 0)',
                    strokeWidth: 10,
                    fill: _vm.color(marker),
                    draggable: _vm.moveMarker,
                     dragBoundFunc: function (pos){
                       return _vm.dragBound(pos)
                     }                
                  }},on:{"dragmove":_vm.adjustText,"dragend":_vm.updatePosition,"dbltap":function($event){return _vm.showDetails(marker)},"dblclick":function($event){return _vm.showDetails(marker)}}}),_vm._v(" "),_c('v-text',{attrs:{"config":{
              id:marker.id,
                    x: marker.xLabel -60,
                    y: marker.yLabel +35,
                    text: marker.label,
                    draggable: _vm.moveMarker,
                    fontSize: 16,
                    fontStyle: 'bold',
                    fill: '#FFFF',
                    wrap: 'char',
                    width: 160,
                    height: 25,
                    align: 'center',
                     dragBoundFunc: function (pos){
                       return _vm.dragBound(pos)
                     }
                  }},on:{"dragmove":_vm.adjustText,"dragend":_vm.updatePosition,"dbltap":function($event){return _vm.showDetails(marker)},"dblclick":function($event){return _vm.showDetails(marker)}}})]:_vm._e(),_vm._v(" "),_c('v-text',{attrs:{"config":{
              id:marker.id,
                    x: marker.xLabel,
                    y: marker.yLabel,
                    text: marker.text,
                    draggable: _vm.moveMarker,
                    fontSize: 16,
                    fontStyle: 'bold',
                    fill: '#FFFF',
                    wrap: 'char',
                    width: 35,
                    height: 35,
                    align: 'center',
                     dragBoundFunc: function (pos){
                       return _vm.dragBound(pos)
                     }
                  }},on:{"dragmove":_vm.adjustText,"dragend":_vm.updatePosition,"dbltap":function($event){return _vm.showDetails(marker)},"dblclick":function($event){return _vm.showDetails(marker)}}})],2)})],2),_vm._v(" "),_c('v-layer',[(_vm.isZoomed)?_c('v-image',{ref:"icon",attrs:{"config":{
                    image: _vm.icon,
                    width: 50,
                    height: 50,
                  }},on:{"click":function($event){return _vm.resetView()},"touchstart":function($event){return _vm.resetView()},"mouseover":_vm.pointer,"mouseleave":_vm.defaultCursor}}):_vm._e()],1)],1)],1)],1),_vm._v(" "),(_vm.$store.state.isMobile)?_c('div',{staticClass:"d-flex"},[_c('v-btn',{staticClass:"mx-auto",attrs:{"small":"","rounded":"","color":"secondary"},on:{"click":function($event){_vm.fullscreen = !_vm.fullscreen}}},[_vm._v(_vm._s(_vm.$t('showBlueprintImage')))])],1):_vm._e(),_vm._v(" "),_c('loadingDialog',{attrs:{"text":_vm.loadingText,"dialog":_vm.loading}})],1):_c('uploadBlueprint',{attrs:{"blueprintId":_vm.blueprint.id,"readonly":_vm.readonly,"blueprintPage":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 485 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('ZoomImage',{staticStyle:{"z-index":"102"},attrs:{"pose":_vm.pose}},[_c('markupFullscreen',{ref:"markupFullscreen",attrs:{"readonly":_vm.readonly,"detailPage":_vm.detailPage,"blueprint":_vm.blueprint},on:{"fullscreen":_vm.toggleZoom,"showMarkerDetails":_vm.showMarkerDetails}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 486 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(tltip){return [_c('div',_vm._g({},tltip.on),[_c('v-btn',_vm._g({staticClass:"mr-2",attrs:{"small":"","icon":"","color":"white"}},on),[_c('v-icon',[_vm._v("fa-qrcode")])],1)],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("scanQRCode")))])])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),(_vm.dialog)?_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("scanQRCode")))]),_vm._v(" "),_c('v-tab-item',[_c('qrcode-stream',{on:{"decode":_vm.onDecode}})],1)],1)],1):_vm._e(),_vm._v(" "),[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.warning),callback:function ($$v) {_vm.warning=$$v},expression:"warning"}},[_c('v-card',[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v(_vm._s(_vm.$t('warning')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('qrcodeNotLinked')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.warning = false}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 487 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{class:_vm.$store.state.isOffline ?'sticky' :'sticky-toolbar-breadcrumb',attrs:{"flat":"","dark":"","color":"highlight","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.blueprint != null ? _vm.blueprint.name: ''))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.uploadForm)?[_c('scanQRCode',{on:{"showMarkerDetails":_vm.showMarkerDetails}}),_vm._v(" "),(_vm.$can('update','markers'))?_c('v-btn',{attrs:{"small":"","depressed":"","color":"secondary"},on:{"click":_vm.lockBlueprint}},[_vm._v(_vm._s(_vm.$t('edit')))]):_vm._e()]:_vm._e()],2),_vm._v(" "),(_vm.blueprint)?_c('div',{staticClass:"orange darken-1 text-center"},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.$t("inReadOnly")))])]):_vm._e(),_vm._v(" "),_c('v-expand-transition',[(_vm.showLockedMessage)?_c('isLocked',{attrs:{"blueprint":_vm.blueprint},on:{"close":function($event){_vm.showLockedMessage = false}}}):_vm._e()],1),_vm._v(" "),(_vm.blueprint)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"lg5":"","xs12":""}},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-card',[_c('v-container',[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","disabled":"","rules":_vm.nameRules,"required":"","label":_vm.$t('name')},model:{value:(_vm.blueprint.name),callback:function ($$v) {_vm.$set(_vm.blueprint, "name", $$v)},expression:"blueprint.name"}}),_vm._v(" "),_c('v-menu',{ref:"menu1",attrs:{"transition":"scale-transition","origin":"right top","offset-y":"","close-on-content-click":false,"nudge-right":40,"lazy":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"outlined":"","dense":"","disabled":"","label":_vm.$t('deadline'),"persistent-hint":"","prepend-icon":"event"},model:{value:(_vm.blueprint.deadline),callback:function ($$v) {_vm.$set(_vm.blueprint, "deadline", $$v)},expression:"blueprint.deadline"}},on))]}}],null,false,1643847591),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},model:{value:(_vm.blueprint.deadline),callback:function ($$v) {_vm.$set(_vm.blueprint, "deadline", $$v)},expression:"blueprint.deadline"}})],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('v-layout',[_c('v-select',{attrs:{"outlined":"","dense":"","disabled":"","items":_vm.blueprint.allInstallers,"label":_vm.$t('installer'),"chips":"","item-value":"id","item-text":"fullName","multiple":"","return-object":""},model:{value:(_vm.blueprint.installers),callback:function ($$v) {_vm.$set(_vm.blueprint, "installers", $$v)},expression:"blueprint.installers"}})],1)],1),_vm._v(" "),_c('v-textarea',{attrs:{"outlined":"","disabled":"","label":_vm.$t('description')},model:{value:(_vm.blueprint.description),callback:function ($$v) {_vm.$set(_vm.blueprint, "description", $$v)},expression:"blueprint.description"}})],1)],1)],1)],1),_vm._v(" "),_c('markers',{staticClass:"mb-6 mt-3",attrs:{"blueprintFile":_vm.blueprint.blueprintFile,"markers":_vm.markers},on:{"showMarkerDetails":_vm.showMarkerDetails}})],1)],1),_vm._v(" "),((_vm.blueprint.blueprintFile && !_vm.blueprint.blueprintFile.content) || !_vm.$store.state.isMobile)?_c('v-flex',{attrs:{"lg7":"","xs12":""}},[_c('v-container',{class:_vm.fullscreen ? 'sticky-blueprint': 'sticky-blueprint-fullscreen'},[_c('zoomMarkup',{ref:"markup",attrs:{"readonly":true,"blueprint":_vm.blueprint},on:{"fullscreen":_vm.toggleFullscreen,"showMarkerDetails":_vm.showMarkerDetails}})],1)],1):_vm._e()],1):_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1),_vm._v(" "),_c('v-dialog',{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"flat":"","color":"primary","dark":""}},[_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.loadingText)+"\n        ")])],1)],1),_vm._v(" "),(_vm.blueprint && _vm.blueprint.blueprintFile && _vm.blueprint.blueprintFile.content && _vm.$store.state.isMobile)?_c('div',{staticClass:"floating-button",attrs:{"outlined":"","color":"primary"}},[_c('zoomMarkup',{ref:"markup",attrs:{"readonly":true,"blueprint":_vm.blueprint},on:{"showMarkerDetails":_vm.showMarkerDetails}})],1):_vm._e(),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog},on:{"response":_vm.response}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 488 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlueprintsDetails_vue__ = __webpack_require__(215);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26360dc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlueprintsDetails_vue__ = __webpack_require__(505);
function injectStyle (ssrContext) {
  __webpack_require__(489)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-26360dc6"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlueprintsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_26360dc6_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlueprintsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 489 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__ = __webpack_require__(216);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d20243_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__ = __webpack_require__(504);
function injectStyle (ssrContext) {
  __webpack_require__(491)
  __webpack_require__(492)
  __webpack_require__(493)
  __webpack_require__(494)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-01d20243"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_List_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_01d20243_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_List_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 491 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 492 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 493 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 494 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 495 */,
/* 496 */,
/* 497 */,
/* 498 */,
/* 499 */,
/* 500 */,
/* 501 */,
/* 502 */,
/* 503 */,
/* 504 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{style:(_vm.$store.state.isMobile?'margin-bottom: 100px': ''),attrs:{"loading":_vm.loading,"outlined":""}},[_c('v-toolbar',{staticClass:"pl-0",attrs:{"dense":"","flat":"","color":"transparant"}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t("markers")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.blueprintFile.content)?_c('v-btn',{attrs:{"color":"primary","dark":"","small":"","icon":""},on:{"click":_vm.addMarker}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),(_vm.$store.state.isMobile && _vm.blueprintFile.content)?_c('v-btn',{attrs:{"color":"primary","dark":"","small":"","icon":""},on:{"click":_vm.openBlueprint}},[_c('v-icon',[_vm._v("add")])],1):_vm._e(),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px","height":"180px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("priority_high")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_broken')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"orange"}},[_vm._v("priority_high")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_inProcess')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check_circle")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_approved')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("priority_high")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_new')))])],1)],1)],1)],1),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flat":"","width":"200px","height":"180px"}},[_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":4},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("select_all")]),_vm._v("\n              "+_vm._s(_vm.$t('showAll'))+"\n            ")],1)],2),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":0},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("priority_high")]),_vm._v("\n              "+_vm._s(_vm.$t('broken'))+"\n            ")],1)],2),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":1},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"orange"}},[_vm._v("priority_high")]),_vm._v("\n              "+_vm._s(_vm.$t('inProcess'))+"\n            ")],1)],2),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":2},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check_circle")]),_vm._v("\n              "+_vm._s(_vm.$t('approved'))+"\n            ")],1)],2),_vm._v(" "),_c('v-checkbox',{staticClass:"ml-2 mt-0",attrs:{"hide-details":true,"value":3},model:{value:(_vm.markerStatus),callback:function ($$v) {_vm.markerStatus=$$v},expression:"markerStatus"}},[_c('template',{slot:"label"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("priority_high")]),_vm._v("\n              "+_vm._s(_vm.$t('new'))+"\n            ")],1)],2)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-text-field',{attrs:{"clearable":"","flat":"","dense":"","solo":"","hide-details":"","prepend-inner-icon":"search","label":_vm.$t('search')},on:{"click:clear":function($event){_vm.search = ''}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('swipe-list',{attrs:{"items":_vm.filteredItems,"item-key":"id"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('v-card',{staticClass:"v-card card-content",class:{'active-row': (item.draggable)},style:({ display: _vm.filterMarkers(item) }),on:{"dblclick":function($event){return _vm.markerDetails(item)},"click":function($event){return _vm.select(item)}}},[_c('v-card-title',{staticClass:"py-2"},[_vm._v("\n            "+_vm._s(item.number)+"\n            "),(item.label)?[_vm._v("- "+_vm._s(item.label))]:_vm._e()],2),_vm._v(" "),_c('v-card-text',{staticClass:"py-0"},[_c('p',{staticClass:"caption mb-0"},[(item.date)?[_vm._v(_vm._s(_vm.$t('applicationDate'))+" "+_vm._s(item.date))]:_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(item.installer)?[_vm._v(_vm._s(_vm.$t('modifiedBy'))+" "+_vm._s(item.installer.firstname)+" "+_vm._s(item.installer.name)+"\n              "+_vm._s(item.modifiedTs)+"\n              ")]:_vm._e()],2),_vm._v(" "),_c('p',{staticClass:"caption mb-0 text-truncate"},[_vm._v(_vm._s(item.comments))])]),_vm._v(" "),_c('v-card-actions',[(item.qrId)?[_c('v-chip',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"secondary"}},[_vm._v("fa-qrcode")]),_vm._v(" "),(_vm.$vuetify.breakpoint.mdAndUp)?[_vm._v(_vm._s(_vm.$t('linked')))]:_vm._e()],2)]:[_c('v-chip',[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"error"}},[_vm._v("fa-qrcode")]),_vm._v(" "),(_vm.$vuetify.breakpoint.mdAndUp)?[_vm._v(_vm._s(_vm.$t('notLinked')))]:_vm._e()],2)],_vm._v(" "),_c('v-chip',[_c('v-icon',{attrs:{"color":item.status == 0? 'red' :
                   item.status == 1  ? 'orange':
                    item.status == 2? 'success': 'primary'}},[_vm._v(_vm._s(item.status == 2 ? 'check_circle' : item.status === 1 ? 'priority_high': 'priority_high'))]),_vm._v("\n              "+_vm._s(item.status == 0 ? _vm.$t('broken') : item.status == 2 ? _vm.$t('approved') : item.status == 1 ? _vm.$t('inProcess') : _vm.$t('new'))+"\n            ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","text":""},on:{"click":function($event){return _vm.markerDetails(item)}}},[_vm._v(_vm._s(_vm.$t('open')))])],2),_vm._v(" "),_c('v-divider')],1)]}},(_vm.$can('delete','markers') && !_vm.$store.state.isOffline)?{key:"right",fn:function(ref){
                    var item = ref.item;
return [_c('div',{staticClass:"swipeout-action red",attrs:{"title":"remove"}},[_c('areyousure',{attrs:{"icon":true,"color":"white","id":item.id,"object":"marker"},on:{"delete":_vm.deleteMarker}})],1)]}}:null],null,true)}),_vm._v(" "),(_vm.$store.state.markers.length == 0)?_c('v-card',{attrs:{"flat":""}},[(_vm.$store.state.drawable)?[_c('p',{staticClass:"text-center pa-5 body-1 font-weight-light"},[_c('span',[_vm._v("\n            "+_vm._s(_vm.$t('draw'))+"\n          ")])])]:_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"text-center pa-5 body-1 font-weight-light",on:{"click":function($event){_vm.blueprintFile.content ?_vm.setDrawable() : _vm.addMarker()}}},[_c('v-btn',{attrs:{"icon":""}},[_c('v-icon',{attrs:{"x-large":"","color":"primary"}},[_vm._v("add_circle_outline")])],1)],1)],2):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 505 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{class:_vm.$store.state.isOffline ?'sticky' :'sticky-toolbar-breadcrumb',attrs:{"elevation":"1","dark":"","color":"highlight","flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.blueprint != null ? _vm.blueprint.name: ''))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.uploadForm)?[_c('scanQRCode',{on:{"showMarkerDetails":_vm.showMarkerDetails}}),_vm._v(" "),(!_vm.$store.state.isOffline)?[_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('v-btn',{staticClass:"ml-3",attrs:{"small":"","depressed":"","dark":"","color":"secondary"},on:{"click":_vm.updateBlueprint}},[_vm._v(_vm._s(_vm.$t('save')))])],1)]:_vm._e()]:_vm._e()],2),_vm._v(" "),(_vm.$store.state.readyForOffline && _vm.$store.state.allAttributes && _vm.$store.state.productSolutions)?_c('v-sheet',{staticClass:"text-center white--text",attrs:{"tile":"","flat":"","color":"green"}},[(!_vm.$store.state.isOffline)?[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("done")]),_vm._v(" "+_vm._s(_vm.$t('readyForOffline'))+"\n    ")]:[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("cached")]),_vm._v(" "+_vm._s(_vm.$t('goOnline'))+"\n    ")]],2):_vm._e(),_vm._v(" "),(_vm.uploadForm)?_c('uploadBlueprint',{attrs:{"blueprintId":_vm.blueprint.id}}):[(_vm.blueprint)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"lg5":"","xs12":""}},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-card',[_c('v-container',[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","disabled":_vm.$store.state.isOffline,"rules":_vm.nameRules,"required":"","label":_vm.$t('name')},model:{value:(_vm.blueprint.name),callback:function ($$v) {_vm.$set(_vm.blueprint, "name", $$v)},expression:"blueprint.name"}}),_vm._v(" "),_c('v-menu',{ref:"menu1",attrs:{"transition":"scale-transition","origin":"right top","offset-y":"","close-on-content-click":false,"nudge-right":40,"lazy":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"outlined":"","dense":"","disabled":_vm.$store.state.isOffline,"readonly":"","label":_vm.$t('deadline'),"persistent-hint":"","prepend-icon":"event"},model:{value:(_vm.blueprint.deadline),callback:function ($$v) {_vm.$set(_vm.blueprint, "deadline", $$v)},expression:"blueprint.deadline"}},on))]}}],null,false,3424792320),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},model:{value:(_vm.blueprint.deadline),callback:function ($$v) {_vm.$set(_vm.blueprint, "deadline", $$v)},expression:"blueprint.deadline"}})],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('v-layout',[_c('v-select',{attrs:{"outlined":"","menu-props":{ bottom: true, offsetY: true },"dense":"","disabled":_vm.$store.state.isOffline,"items":_vm.blueprint.allInstallers,"label":_vm.$t('installer'),"chips":"","item-value":"id","item-text":"fullName","multiple":"","return-object":""},model:{value:(_vm.blueprint.installers),callback:function ($$v) {_vm.$set(_vm.blueprint, "installers", $$v)},expression:"blueprint.installers"}})],1)],1),_vm._v(" "),_c('v-textarea',{attrs:{"outlined":"","label":_vm.$t('description')},model:{value:(_vm.blueprint.description),callback:function ($$v) {_vm.$set(_vm.blueprint, "description", $$v)},expression:"blueprint.description"}})],1)],1)],1)],1),_vm._v(" "),_c('markers',{staticClass:"mb-6 mt-3",attrs:{"blueprintFile":_vm.blueprint.blueprintFile,"markers":_vm.markers},on:{"showMarkerDetails":_vm.showMarkerDetails}})],1)],1),_vm._v(" "),((_vm.blueprint.blueprintFile && !_vm.blueprint.blueprintFile.content) || !_vm.$store.state.isMobile)?_c('v-flex',{attrs:{"lg7":"","xs12":""}},[_c('v-container',{class:_vm.fullscreen ? 'sticky-blueprint': 'sticky-blueprint-fullscreen'},[_c('zoomMarkup',{ref:"markup",attrs:{"blueprint":_vm.blueprint},on:{"fullscreen":_vm.toggleFullscreen,"showMarkerDetails":_vm.showMarkerDetails}})],1)],1):_vm._e()],1):_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1),_vm._v(" "),_c('v-dialog',{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"flat":"","color":"primary","dark":""}},[_c('v-card-text',[_vm._v("\n          "+_vm._s(_vm.loadingText)+"\n          "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)],_vm._v(" "),(_vm.blueprint && _vm.blueprint.blueprintFile && _vm.blueprint.blueprintFile.content && _vm.$store.state.isMobile)?_c('div',{staticClass:"floating-button",attrs:{"outlined":"","color":"primary"}},[_c('zoomMarkup',{ref:"markup",attrs:{"blueprint":_vm.blueprint},on:{"showMarkerDetails":_vm.showMarkerDetails}})],1):_vm._e(),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog},on:{"response":_vm.response}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 506 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(220);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1edb56_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(512);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5a1edb56_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 507 */,
/* 508 */,
/* 509 */,
/* 510 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAttribute_vue__ = __webpack_require__(223);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_924d0ab4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAttribute_vue__ = __webpack_require__(511);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddAttribute_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_924d0ab4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddAttribute_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 511 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"mr-3",attrs:{"depressed":"","color":"secondary","small":""}},on),[_vm._v(_vm._s(_vm.$t('newAttribute')))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("newAttribute")))]),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"required":"","outlined":"","dense":"","rules":_vm.rules(),"counter":"512","label":_vm.$t('name')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-select',{attrs:{"menu-props":{ bottom: true, offsetY: true },"outlined":"","dense":"","items":_vm.attributeClasses,"item-text":"name","item-value":"id","label":_vm.$t('class'),"return-masked-value":""},model:{value:(_vm.classId),callback:function ($$v) {_vm.classId=$$v},expression:"classId"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.add}},[_vm._v(_vm._s(_vm.$t('add')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 512 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"dark":"","color":"highlight","flat":"","dense":"","outlined":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('attributes')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-badge',{attrs:{"left":"","color":"error","icon":"priority_high","overlap":""}},[_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flat":"","width":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("drag_handle")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_drag_attribute')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-asterisk")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_star_attribute')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"red"}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_delete_attribute')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',{attrs:{"color":"secondary"}},[_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("content_copy")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_clone_attribute')))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("refresh")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_sync_attribute')))])],1)],1)],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"settings"}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({staticClass:"mr-2",attrs:{"color":"white","text":"","icon":""},on:{"click":_vm.syncAttributes}},'v-btn',attrs,false),on),[_c('v-icon',[_vm._v("refresh")])],1)]}}])},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('info_sync_attribute')))])]),_vm._v(" "),_c('addAttribute',{attrs:{"attributeClasses":_vm.attributeClasses,"index":Math.max.apply(Math, this.attributes.map(function(o) { return o.index; })) + 1},on:{"add":_vm.addAttribute}}),_vm._v(" "),(_vm.edit)?_c('v-btn',{attrs:{"small":"","depressed":"","color":"success"},on:{"click":_vm.update}},[_vm._v(_vm._s(_vm.$t("save")))]):_vm._e(),_vm._v(" "),_c('v-btn',{staticClass:"ml-1",attrs:{"small":"","depressed":"","color":_vm.edit ? 'disabled': 'primary'},on:{"click":function($event){_vm.edit = !_vm.edit}}},[_vm._v(_vm._s(_vm.edit ? _vm.$t("cancel"): _vm.$t("edit")))])],1)],1),_vm._v(" "),_c('v-container',[_c('v-card',[_c('v-data-table',{directives:[{name:"sortable-list",rawName:"v-sortable-list"}],attrs:{"flat":"","show-expand":"","headers":_vm.headers,"expanded":_vm.expanded,"single-expand":"","items":_vm.attributes,"item-key":"id","footer-props":{
  'items-per-page-options': [-1]
},"loading":_vm.loading,"mobile-breakpoint":0},on:{"update:expanded":function($event){_vm.expanded=$event},"sorted":_vm.saveOrder},scopedSlots:_vm._u([{key:"item",fn:function(props){return [_c('tr',{key:props.item.id,staticClass:"sortableRow"},[_c('td',{staticClass:"px-1",staticStyle:{"width":"0.1%"}},[_c('v-btn',{staticClass:"sortHandle",staticStyle:{"cursor":"move"},attrs:{"disabled":!_vm.edit,"color":"primary","icon":""}},[_c('v-icon',[_vm._v("drag_handle")])],1)],1),_vm._v(" "),_c('td',[(_vm.edit)?_c('v-text-field',{staticClass:"mt-6",attrs:{"dense":"","outlined":"","placeholder":props.item.codeFallback},model:{value:(props.item.code),callback:function ($$v) {_vm.$set(props.item, "code", $$v)},expression:"props.item.code"}},[[_vm._v(_vm._s(props.item.code))]],2):[(props.item.code === null)?[_vm._v(_vm._s(props.item.codeFallback))]:[_vm._v(_vm._s(props.item.code))],_vm._v(" "),(props.item.isOriginatedByPim)?[_vm._v("*")]:_vm._e()]],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(props.item.qrLogAttributeClass.name))]),_vm._v(" "),_c('td',[_c('v-switch',{attrs:{"color":"primary","disabled":!_vm.edit},on:{"click:append":function($event){props.item.visible = !props.item.visible}},model:{value:(props.item.visible),callback:function ($$v) {_vm.$set(props.item, "visible", $$v)},expression:"props.item.visible"}})],1),_vm._v(" "),_c('td',[_c('v-switch',{attrs:{"color":"primary","disabled":!_vm.edit},on:{"click:append":function($event){props.item.required = !props.item.required}},model:{value:(props.item.required),callback:function ($$v) {_vm.$set(props.item, "required", $$v)},expression:"props.item.required"}})],1),_vm._v(" "),_c('td',[_c('v-btn',{attrs:{"icon":"","color":"secondary"},on:{"click":function($event){_vm.selectedAttribute = props.item; _vm.cloneDialog = true}}},[_c('v-icon',[_vm._v("content_copy")])],1)],1),_vm._v(" "),_c('td',[(props.item.canDelete && !props.item.IsOriginatedByPim)?_c('areyousure',{attrs:{"disabled":!_vm.edit,"id":props.item.id,"object":"attribute"},on:{"deleteAttribute":_vm.deleteAttribute}}):_vm._e()],1),_vm._v(" "),_c('td',[(props.item.qrLogAttributeClass.code == 'list')?_c('v-btn',{attrs:{"icon":""},on:{"click":function($event){return _vm.showValues(props.item, props.item.qrLogAttributeClass.code)}}},[_c('v-icon',[_vm._v("keyboard_arrow_right")])],1):_vm._e()],1)])]}},{key:"expanded-item",fn:function(ref){
var headers = ref.headers;
return [_c('td',{attrs:{"colspan":headers.length + 1}},[(_vm.expanded != null && _vm.expanded.length > 0)?_c('v-container',{staticClass:"active-row active-row-right",attrs:{"fluid":""}},[_c('v-toolbar',{staticClass:"pl-0",attrs:{"dense":"","flat":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t("values")))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.attributeValues),function(value){return _c('div',{key:value.id},[_c('v-list-item',[_c('v-list-item-content',[(_vm.edit && value.qrLogAttributeListValueGlobalRefId === null  && value.canDelete)?_c('v-text-field',{attrs:{"dense":"","outlined":"","placeholder":value.descriptionFallback},model:{value:(value.description),callback:function ($$v) {_vm.$set(value, "description", $$v)},expression:"value.description"}},[[_vm._v(_vm._s(value.description))]],2):[(value.description == null)?[_vm._v(_vm._s(value.descriptionFallback))]:[_vm._v(_vm._s(value.description))]],_vm._v(" "),(value.qrLogAttributeListValueGlobalRefId !== null)?[_vm._v("*")]:_vm._e()],2),_vm._v(" "),_c('v-list-item-action',{staticClass:"align-end"},[(value.qrLogAttributeListValueGlobalRefId === null && value.canDelete)?_c('areyousure',{attrs:{"disabled":!_vm.edit,"id":value.id,"icon":true,"object":"attributeValue"},on:{"deleteValue":_vm.deleteValue}}):_vm._e(),_vm._v(" "),_c('v-checkbox',{staticClass:"mr-5",attrs:{"label":_vm.$t('active'),"disabled":!_vm.edit},on:{"change":function($event){return _vm.putQrlogAttributeListValue(value)}},model:{value:(value.isActive),callback:function ($$v) {_vm.$set(value, "isActive", $$v)},expression:"value.isActive"}})],1)],1),_vm._v(" "),_c('v-divider')],1)}),_vm._v(" "),_c('v-list-item',[_c('v-text-field',{staticClass:"mt-6",attrs:{"dense":"","outlined":"","label":_vm.$t('value')},model:{value:(_vm.newAttributeValue),callback:function ($$v) {_vm.newAttributeValue=$$v},expression:"newAttributeValue"}}),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"settings"}},[_c('v-btn',{staticClass:"ml-1",attrs:{"small":"","depressed":"","disabled":!_vm.newAttributeValue && _vm.newAttributeValue === '',"color":"primary"},on:{"click":function($event){return _vm.saveValue(_vm.attributeId)}}},[_vm._v(_vm._s(_vm.$t('add')))])],1)],1)],2):_vm._e()],1)]}}])}),_vm._v(" "),(_vm.selectedAttribute)?_c('v-dialog',{attrs:{"max-width":"350"},model:{value:(_vm.cloneDialog),callback:function ($$v) {_vm.cloneDialog=$$v},expression:"cloneDialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.selectedAttribute.code))]),_vm._v(" "),_c('v-card-text',[_c('p',[_vm._v(_vm._s(_vm.$t('cloneAttributeWithValues')))]),_vm._v(" "),_c('v-form',{ref:"cloneForm"},[_c('v-text-field',{attrs:{"filled":"","dense":"","rules":[function (v){ return !!v; },function (v) { return v.trim() != _vm.selectedAttribute.code.trim(); }],"label":_vm.$t('giveADifferentName')},model:{value:(_vm.clonedAttributeName),callback:function ($$v) {_vm.clonedAttributeName=$$v},expression:"clonedAttributeName"}})],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"grey darken-1","text":""},on:{"click":function($event){_vm.cloneDialog = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","depressed":""},on:{"click":_vm.clone}},[_vm._v(_vm._s(_vm.$t('clone')))])],1)],1)],1):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 513 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(224);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06e834d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(541);
function injectStyle (ssrContext) {
  __webpack_require__(514)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-06e834d4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_06e834d4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 514 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 515 */,
/* 516 */,
/* 517 */,
/* 518 */,
/* 519 */,
/* 520 */,
/* 521 */,
/* 522 */,
/* 523 */,
/* 524 */,
/* 525 */,
/* 526 */,
/* 527 */,
/* 528 */,
/* 529 */,
/* 530 */,
/* 531 */,
/* 532 */,
/* 533 */,
/* 534 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__ = __webpack_require__(228);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1755f65c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__ = __webpack_require__(535);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1755f65c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"small":"","depressed":"","color":"secondary"}},on),[_vm._v(_vm._s(_vm.$t('newUser')))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("user")))]),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","rules":_vm.nameRules(),"label":_vm.$t('firstname')},model:{value:(_vm.firstname),callback:function ($$v) {_vm.firstname=$$v},expression:"firstname"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","rules":_vm.nameRules(),"label":_vm.$t('name')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-select',{attrs:{"rules":_vm.profileRules(),"items":_vm.profiles,"item-value":"LicenseXProfileId","outlined":"","dense":"","item-text":"Name","label":_vm.$t('profile')},model:{value:(_vm.profile),callback:function ($$v) {_vm.profile=$$v},expression:"profile"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","rules":_vm.emailRules(),"browser-autocomplete":"new-password","autocomplete":"new-password","label":_vm.$t('contactEmail'),"persistent-hint":"","hint":_vm.$t('contactEmailHint')},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","rules":_vm.emailRules(),"browser-autocomplete":"new-password","autocomplete":"new-password","label":_vm.$t('loginEmail'),"persistent-hint":"","hint":_vm.$t('loginEmailHint')},model:{value:(_vm.login),callback:function ($$v) {_vm.login=$$v},expression:"login"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","browser-autocomplete":"new-password","autocomplete":"new-password","type":_vm.show ? 'text' : 'password',"rules":_vm.passwordRules(),"label":_vm.$t('password'),"append-icon":_vm.show ? 'visibility' : 'visibility_off',"required":""},on:{"click:append":function($event){_vm.show = !_vm.show},"input":_vm.encrypt},model:{value:(_vm.inputP),callback:function ($$v) {_vm.inputP=$$v},expression:"inputP"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__ = __webpack_require__(229);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b8fb900_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__ = __webpack_require__(537);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EditUser_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b8fb900_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EditUser_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 537 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-icon',_vm._g({attrs:{"color":"white","small":""}},on),[_vm._v("fa-edit")])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("edit"))+" "+_vm._s(_vm.$t("user")))]),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","rules":_vm.nameRules(),"label":_vm.$t('firstname')},model:{value:(_vm.editedUser.Firstname),callback:function ($$v) {_vm.$set(_vm.editedUser, "Firstname", $$v)},expression:"editedUser.Firstname"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","rules":_vm.nameRules(),"label":_vm.$t('name')},model:{value:(_vm.editedUser.Name),callback:function ($$v) {_vm.$set(_vm.editedUser, "Name", $$v)},expression:"editedUser.Name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","persistent-hint":"","hint":_vm.$t('contactEmailHint'),"rules":_vm.emailRules(),"browser-autocomplete":"new-password","autocomplete":"new-password","label":_vm.$t('contactEmail')},model:{value:(_vm.editedUser.Email),callback:function ($$v) {_vm.$set(_vm.editedUser, "Email", $$v)},expression:"editedUser.Email"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","required":"","rules":_vm.emailRules(),"browser-autocomplete":"new-password","autocomplete":"new-password","label":_vm.$t('loginEmail'),"persistent-hint":"","hint":_vm.$t('loginEmailHint')},model:{value:(_vm.editedUser.Login),callback:function ($$v) {_vm.$set(_vm.editedUser, "Login", $$v)},expression:"editedUser.Login"}}),_vm._v(" "),_c('v-text-field',{attrs:{"outlined":"","dense":"","browser-autocomplete":"new-password","autocomplete":"new-password","type":_vm.show ? 'text' : 'password',"label":_vm.$t('changePassword'),"append-icon":_vm.show ? 'visibility' : 'visibility_off',"required":""},on:{"click:append":function($event){_vm.show = !_vm.show},"input":_vm.encrypt},model:{value:(_vm.inputP),callback:function ($$v) {_vm.inputP=$$v},expression:"inputP"}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 538 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserManager_vue__ = __webpack_require__(230);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32a413dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserManager_vue__ = __webpack_require__(540);
function injectStyle (ssrContext) {
  __webpack_require__(539)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UserManager_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_32a413dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UserManager_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 539 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 540 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return undefined}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),(_vm.selectedUser)?_c('v-card',{staticClass:"bg-grey",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":_vm.closeDialog}},[_c('v-icon',[_vm._v("mdi-close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.selectedUser.Firstname)+" "+_vm._s(_vm.selectedUser.Name))])],1),_vm._v(" "),_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-center"},[_c('div',{staticClass:"subtitle-1 ma-1"},[_vm._v(_vm._s(_vm.$t('manageUsers')))])]),_vm._v(" "),_c('div',{staticClass:"d-flex flex-wrap"},[_c('v-card',{staticClass:"ma-1 pa-3",attrs:{"disabled":_vm.disabled,"loading":_vm.disabled,"tile":"","outlined":""}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('projects')))]),_vm._v(" "),_c('div',[_c('v-text-field',{attrs:{"clearable":"","flat":"","solo-inverted":"","hide-details":"","color":"white","prepend-inner-icon":"search","label":_vm.$t('search')},on:{"click:clear":function($event){_vm.searchProjects = ''}},model:{value:(_vm.searchProjects),callback:function ($$v) {_vm.searchProjects=$$v},expression:"searchProjects"}})],1),_vm._v(" "),_c('div',{key:_vm.searchProjects},_vm._l((_vm.filteredProjects),function(project,i){return _c('div',{key:i,staticClass:"d-flex"},[_c('v-list-item',{class:_vm.selectedProject ?  project.id == _vm.selectedProject.id  ? 'pink--text' : '':'',scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-list-item-action',[_c('v-checkbox',{attrs:{"multiple":"","value":project.id,"color":"primary"},on:{"change":_vm.updateUsers},model:{value:(_vm.selectedProjects),callback:function ($$v) {_vm.selectedProjects=$$v},expression:"selectedProjects"}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(project.name))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(project.buildingName))])],1)]}}],null,true)}),_vm._v(" "),_c('div',{staticClass:"pa-5"},[_c('v-icon',{attrs:{"color":_vm.selectedProject ?  project.id == _vm.selectedProject.id  ? 'secondary' : '':''},on:{"click":function($event){_vm.selectedProject = project}}},[_vm._v("fa-arrow-right")])],1)],1)}),0)]),_vm._v(" "),(_vm.selectedProject)?_c('v-card',{staticClass:"ma-1 pa-3",attrs:{"disabled":_vm.disabled,"loading":_vm.disabled,"tile":"","outlined":""}},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.$t('buildingComponents')))]),_vm._v(" "),_c('div',[_c('v-text-field',{attrs:{"clearable":"","flat":"","solo-inverted":"","hide-details":"","color":"white","prepend-inner-icon":"search","label":_vm.$t('search')},on:{"click:clear":function($event){_vm.searchBuildingComponents = ''}},model:{value:(_vm.searchBuildingComponents),callback:function ($$v) {_vm.searchBuildingComponents=$$v},expression:"searchBuildingComponents"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.filteredBuildingComponents),function(bc,i){return _c('div',{key:i,staticClass:"d-flex"},[_c('v-list-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-list-item-action',[_c('v-checkbox',{attrs:{"value":bc.id,"color":"primary"},on:{"change":_vm.updateUsersComponents},model:{value:(_vm.selectedBuildingComponents),callback:function ($$v) {_vm.selectedBuildingComponents=$$v},expression:"selectedBuildingComponents"}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(bc.name))])],1)]}}],null,true)}),_vm._v(" "),_c('div',{staticClass:"pa-5"},[_c('v-icon',{attrs:{"color":_vm.selectedBuildingComponent ?  bc.id == _vm.selectedBuildingComponent.id  ? 'secondary' : '':''},on:{"click":function($event){_vm.selectedBuildingComponent = bc}}},[_vm._v("fa-arrow-right")])],1)],1)})],2):_vm._e(),_vm._v(" "),(_vm.selectedBuildingComponent)?_c('v-card',{staticClass:"ma-1 pa-3",attrs:{"disabled":_vm.disabled,"loading":_vm.disabled,"tile":"","outlined":""}},[_c('div',{staticClass:"title"},[_vm._v("\n            "+_vm._s(_vm.$t('blueprints'))+"\n            ")]),_vm._v(" "),_c('div',[_c('v-text-field',{attrs:{"clearable":"","flat":"","solo-inverted":"","hide-details":"","color":"white","prepend-inner-icon":"search","label":_vm.$t('search')},on:{"click:clear":function($event){_vm.searchBlueprints = ''}},model:{value:(_vm.searchBlueprints),callback:function ($$v) {_vm.searchBlueprints=$$v},expression:"searchBlueprints"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.filteredBlueprints),function(blueprint,i){return _c('div',{key:i,staticClass:"d-flex"},[_c('v-list-item',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
var active = ref.active;
var toggle = ref.toggle;
return [_c('v-list-item-action',[_c('v-checkbox',{attrs:{"value":blueprint.id,"color":"primary"},on:{"change":_vm.updateUsersBlueprints},model:{value:(_vm.selectedBlueprints),callback:function ($$v) {_vm.selectedBlueprints=$$v},expression:"selectedBlueprints"}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(blueprint.name))]),_vm._v(" "),_c('v-list-item-subtitle')],1)]}}],null,true)})],1)})],2):_vm._e()],1)])],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 541 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"color":"highlight","dark":"","flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('users')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}})],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_firelog_solutions')))])],1)],1)],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"settings"}},[_c('addInstaller',{attrs:{"profiles":_vm.profiles},on:{"add-installer":_vm.addInstaller}})],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"settings"}},[_c('v-btn',{staticClass:"ml-2",attrs:{"depressed":"","small":"","disabled":!_vm.valid,"color":"primary"},on:{"click":_vm.update}},[_vm._v(_vm._s(_vm.$t("save")))])],1)],1),_vm._v(" "),_c('v-container',[(_vm.usersGroupedByProfile && _vm.profiles)?_c('div',{attrs:{"disabled":!_vm.$can('update', 'installers')}},[_c('v-row',_vm._l((_vm.profiles),function(profile,index){return _c('v-col',{key:index,attrs:{"cols":"sm","sm":48 /(_vm.profiles.length + 1),"md":24/(_vm.profiles.length + 1),"lg":12 /(_vm.profiles.length + 1)}},[_c('v-card',{staticClass:"pa-2",class:_vm.usersGroupedByProfile[profile.Id].length > profile.Limit ? 'redborder': '',attrs:{"width":"100%","outlined":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t(((profile.Id) + "profile"))))]),_vm._v(" "),_c('v-list',{staticClass:"overflow-auto",attrs:{"width":"100%","dense":"","max-height":"700"}},[(_vm.usersGroupedByProfile[profile.Id])?[_c('draggable',{attrs:{"sort":false,"id":profile.Id,"move":_vm.changeUserProfile,"options":{group:'people'}},model:{value:(_vm.usersGroupedByProfile[profile.Id]),callback:function ($$v) {_vm.$set(_vm.usersGroupedByProfile, profile.Id, $$v)},expression:"usersGroupedByProfile[profile.Id]"}},[_c('transition-group',{staticClass:"profile-list",attrs:{"tag":"div","name":"list"}},[_vm._l((_vm.usersGroupedByProfile[profile.Id]),function(item){return [_c('div',{key:item.Id},[_c('v-col',{attrs:{"cols":"sm","sm":"12"}},[_c('v-card',{staticClass:"white--text pa-1",staticStyle:{"width":"100%"},attrs:{"color":"primary","outined":"","label":"","pill":""}},[_c('v-card-title',{staticClass:"pa-1 body-2"},[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("person")]),_vm._v(" "),_c('span',[_vm._v(_vm._s(((item.Firstname) + " " + (item.Name))))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(index !== 0)?_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"white"},on:{"click":function($event){return _vm.selectUser(index, item)}}},[_vm._v("fa-sliders-h")]):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"installersPassword"}},[_c('editUser',{attrs:{"user":item}})],1)],1),_vm._v(" "),_c('div',[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("f")]),_vm._v(" "),_c('small',[_vm._v(_vm._s(item.Login))])],1)],1)],1)],1)]})],2)],1)]:_vm._e()],2),_vm._v(" "),_c('v-layout',[_c('v-spacer'),_vm._v(" "),_c('p',{staticClass:"overline",class:_vm.usersGroupedByProfile[profile.Id].length > profile.Limit ? 'error--text': ''},[_vm._v(_vm._s(((_vm.usersGroupedByProfile[profile.Id].length) + "/" + (profile.Limit))))])],1)],1)],1)}),1)],1):_vm._e(),_vm._v(" "),_c('userManager',{attrs:{"selectedUser":_vm.selectedUser,"dialog":_vm.dialog},on:{"close":function($event){_vm.dialog = false}}})],1),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog},on:{"response":_vm.response}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 542 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb6dee4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BadRequest_vue__ = __webpack_require__(543);
var normalizeComponent = __webpack_require__(0)
/* script */
var __vue_script__ = null
/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __WEBPACK_IMPORTED_MODULE_0__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2eb6dee4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BadRequest_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 543 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"ma-auto text-center",attrs:{"flat":""}},[_c('p',{staticClass:"display-1 font-weight-bold"},[_vm._v("Something went wrong!")]),_vm._v(" "),_c('p',{staticClass:"subtitle-1 font-weight-bold"},[_vm._v("Check your internet connection, or please reload the page.")])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 544 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__(231);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203473a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__(639);
function injectStyle (ssrContext) {
  __webpack_require__(545)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_203473a8_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 545 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 546 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(tltip){return [_c('div',_vm._g({},tltip.on),[_c('v-btn',_vm._g({attrs:{"small":"","icon":"","color":"primary"}},on),[(_vm.marker.qrId)?_c('v-icon',{attrs:{"color":"secondary"}},[_vm._v("fa-qrcode")]):_c('v-icon',{attrs:{"color":"error"}},[_vm._v("fa-qrcode")])],1)],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t("addQRCode")))])])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),(_vm.dialog)?_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("addQRCode")))]),_vm._v(" "),_c('v-tab-item',[_c('qrcode-stream',{on:{"decode":_vm.onDecode}})],1)],1)],1):_vm._e(),_vm._v(" "),[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.warning),callback:function ($$v) {_vm.warning=$$v},expression:"warning"}},[_c('v-card',[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v(_vm._s(_vm.$t('overrideQRId')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('overrideQRId')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.warning = false}}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.getMarkerByQRId(_vm.qrId)}}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)],1)],_vm._v(" "),[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.warning2),callback:function ($$v) {_vm.warning2=$$v},expression:"warning2"}},[_c('v-card',[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v(_vm._s(_vm.$t('qrIdExists')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('qrIdExists')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.warning2 = false}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1)],_vm._v(" "),[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.warning4),callback:function ($$v) {_vm.warning4=$$v},expression:"warning4"}},[_c('v-card',[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v(_vm._s(_vm.$t('cached')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('cached')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.warning4 = false}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1)],_vm._v(" "),[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.warning3),callback:function ($$v) {_vm.warning3=$$v},expression:"warning3"}},[_c('v-card',[_c('v-alert',{attrs:{"value":true,"type":"warning"}},[_vm._v(_vm._s(_vm.$t('sameCode')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('sameCode')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.warning3 = false}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1)],_vm._v(" "),[_c('v-layout',{attrs:{"row":"","justify-center":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.success),callback:function ($$v) {_vm.success=$$v},expression:"success"}},[_c('v-card',[_c('v-alert',{attrs:{"value":true,"type":"success"}},[_vm._v(_vm._s(_vm.$t('success')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('success')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.success = false}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1)]],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 547 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 548 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{style:({ width: _vm.imageWidth + 'px', height: _vm.imageHeight + 'px' }),on:{"click":[function($event){$event.stopPropagation();},_vm.toggleZoom]}},[_c('Frame',{staticClass:"frame",attrs:{"pose":_vm.pose},on:{"click":function($event){$event.stopPropagation();}}}),_vm._v(" "),_c('ZoomImage',{staticClass:"zoomedImage",attrs:{"pose":_vm.pose,"src":_vm.src}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 549 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 550 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 551 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 552 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.isReady)?_c('v-card',{attrs:{"outlined":""}},[_c('v-toolbar',{staticClass:"pl-0",attrs:{"dense":"","flat":"","color":"transparant"}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t("solutionsList")))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"markers"}},[(_vm.marker.markerXSolutions.length > 0 && !_vm.readonly)?_c('v-btn',{attrs:{"color":"primary","dark":"","small":"","icon":""},on:{"click":_vm.addSolution}},[_c('v-icon',[_vm._v("add")])],1):_vm._e()],1),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}],null,false,3437787158)},[_vm._v(" "),_c('v-sheet',{attrs:{"flat":""}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("add")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_solutions_list')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('swipe-list',{ref:"list",staticClass:"card",attrs:{"items":_vm.markerXSolutions,"item-key":"id"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('v-card',{staticClass:"v-card card-content",on:{"dblclick":function($event){return _vm.solutionDetails(item)}}},[_c('v-list-item-title',{staticClass:"pl-5 pt-2"},[(_vm.$store.state.productSolutions.find(function (x) { return x.id == item.solutionId; }))?[_vm._v("\n              "+_vm._s(((_vm.marker.number) + "." + (index+1) + " " + (_vm.$store.state.productSolutions.find(function (x) { return x.id == item.solutionId; }).name)))+"\n            ")]:[_vm._v(_vm._s(_vm.$t('chooseSolution')))]],2),_vm._v(" "),_c('v-card-actions',{staticClass:"pl-5"},[_c('v-chip',[_c('v-icon',{attrs:{"color":item.isApproved === 1 && !item.valid ? 'red' :
                   item.isApproved === 0 && !item.valid ? 'orange':
                    item.isApproved === 2? 'success': 'primary'}},[_vm._v(_vm._s(item.isApproved === 2 ? 'check_circle' : item.isApproved === 1 ? 'priority_high': 'priority_high'))]),_vm._v("\n              "+_vm._s(item.isApproved == 1 ? _vm.$t('broken') : item.isApproved == 2 ? _vm.$t('approved') : item.isApproved == 0 ? _vm.$t('inProcess') : _vm.$t('new'))+"\n            ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","text":""},on:{"click":function($event){return _vm.solutionDetails(item)}}},[_vm._v(_vm._s(_vm.$t('open')))])],1),_vm._v(" "),_c('v-divider')],1)]}},(_vm.$can('delete','markers') && !_vm.readonly && !_vm.$store.state.isOffline)?{key:"right",fn:function(ref){
                    var item = ref.item;
return [_c('div',{staticClass:"swipeout-action red",attrs:{"title":"remove"}},[(!_vm.readonly)?_c('areyousure',{attrs:{"icon":true,"color":"white"},on:{"delete":function($event){return _vm.deleteMarkerXSolution(item.id)}}}):_vm._e()],1)]}}:null],null,true)}),_vm._v(" "),(_vm.marker.markerXSolutions.length == 0)?_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"d-flex",staticStyle:{"height":"50px"},attrs:{"disabled":_vm.readonly},on:{"click":_vm.addSolution}},[_c('div',{staticClass:"mx-auto my-auto"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("add_circle_outline")])],1)]):_vm._e()],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 553 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"350"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('div',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_vm._t("action")],2)]}}],null,true),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.headline ? _vm.headline : _vm.$t('warning')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.message ? _vm.message : _vm.$t('areYouSure')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"text":"","autofocus":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.cancelbuttonText))]),_vm._v(" "),_c('v-btn',{attrs:{"large":"","depressed":"","color":"secondary"},on:{"click":function($event){return _vm.remove(_vm.id,_vm.fk)}}},[_vm._v(_vm._s(_vm.actionButtonText))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},scopedSlots:_vm._u([(_vm.marker.reports.length > 0)?{key:"activator",fn:function(ref){return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){_vm.dialog = true}}},'v-btn',attrs,false),on),[(_vm.marker.reports.length > 0)?_c('v-badge',{attrs:{"overlap":"","color":"primary"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_vm._v(_vm._s(_vm.marker.reports.length))]},proxy:true}],null,true)},[_vm._v(" "),_c('v-icon',{attrs:{"color":_vm.marker.reports.length > 0 ? 'error': ''}},[_vm._v("report_problem")])],1):_vm._e()],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('reports')))])])]}}:null],null,true),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',{staticClass:"bg-grey",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v("Reports")]),_vm._v(" "),_c('div',{staticClass:"flex-grow-1"})],1),_vm._v(" "),_c('v-container',{staticClass:"pa-2 mx-auto",staticStyle:{"max-width":"960px"},attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.marker.reports),function(report,i){return _c('v-col',{key:i,attrs:{"sm12":"","md6":"","cols":"12"}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',{staticClass:"overline"},[_c('v-spacer')],1),_vm._v(" "),_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"125","color":"grey"}},[_c('v-img',{attrs:{"src":report.image}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('name'))+" & "+_vm._s(_vm.$t('company'))+":")]),_vm._v("\n                  "+_vm._s(report.name)+" "+_vm._s(report.company)+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('email'))+"/"+_vm._s(_vm.$t('phone'))+":")]),_vm._v("\n                  "+_vm._s(report.email)+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('date'))+":")]),_vm._v("\n                  "+_vm._s(report.date)+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('comment'))+":")]),_vm._v("\n                  "+_vm._s(report.comment)+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('solution'))+":")]),_vm._v(" "),(report.markerXSolutionId)?[_vm._v("\n                    "+_vm._s(report.markerXSolution)+"\n                  ")]:[_c('span',{staticClass:"font-weight-bold red--text"},[_vm._v(_vm._s(_vm.$t('chooseSolution')))])]],2)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"pl-0",attrs:{"dense":"","flat":"","color":"transparant"}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t("solutionsList")))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_vm._l((_vm.marker.markerXSolutions),function(item,index){return _c('v-card',{key:index,staticClass:"v-card card-content mb-1"},[_c('v-list-item-title',{staticClass:"pl-5 pt-2"},[(_vm.$store.state.productSolutions.find(function (x) { return x.id == item.solutionId; }))?[_vm._v("\n                  "+_vm._s(((_vm.marker.number) + "." + (index+1) + " " + (_vm.$store.state.productSolutions.find(function (x) { return x.id == item.solutionId; }).name)))+"\n                ")]:_vm._e()],2),_vm._v(" "),_c('v-card-actions',{staticClass:"pl-5 d-flex flex-wrap"},[_c('v-chip',[_c('v-icon',{attrs:{"color":item.isApproved === 1 && !item.valid ? 'red' :
                   item.isApproved === 0 && !item.valid ? 'orange':
                    item.isApproved === 2? 'success': 'primary'}},[_vm._v(_vm._s(item.isApproved === 2 ? 'check_circle' : item.isApproved === 1 ? 'priority_high': 'priority_high'))]),_vm._v("\n                  "+_vm._s(item.isApproved == 1 ? _vm.$t('broken') : item.isApproved == 2 ? _vm.$t('approved') : item.isApproved == 0 ? _vm.$t('inProcess') : _vm.$t('new'))+"\n                ")],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(report.markerXSolutionId != item.id)?_c('v-btn',{attrs:{"color":"secondary","text":""},on:{"click":function($event){return _vm.addToThisSolution(report,item)}}},[_vm._v(_vm._s(_vm.$t('addReportToThisSolution')))]):_vm._e()],1),_vm._v(" "),_c('v-divider')],1)}),_vm._v(" "),_c('v-card-actions',{staticClass:"mt-4"},[_c('v-spacer'),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"blueprints"}},[_c('areyousure2',{attrs:{"cancelbuttonText":_vm.$t('cancel'),"actionButtonText":_vm.$t('ignore'),"id":report.id,"object":"report","message":_vm.$t('areyousureyouwanttoignorethis')},on:{"delete":function($event){return _vm.deleteReport(report)}},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('v-btn',{staticClass:"mr-2",attrs:{"text":"","color":"orange","depressed":""}},[_vm._v(_vm._s(_vm.$t('ignore')))])]},proxy:true}],null,true)})],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","depressed":"","color":"secondary"},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],2)],1)}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 555 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},scopedSlots:_vm._u([(_vm.marker.archivedReports.length > 0)?{key:"activator",fn:function(ref){return [_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-btn',_vm._g(_vm._b({attrs:{"icon":""},on:{"click":function($event){_vm.dialog = true}}},'v-btn',attrs,false),on),[(_vm.marker.archivedReports.length > 0)?_c('v-badge',{attrs:{"overlap":"","color":"primary"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_vm._v(_vm._s(_vm.marker.archivedReports.length))]},proxy:true}],null,true)},[_vm._v(" "),_c('v-icon',{attrs:{"color":_vm.marker.archivedReports.length > 0 ? '': ''}},[_vm._v("history")])],1):_vm._e()],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('archivedReports')))])])]}}:null],null,true),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',{staticClass:"bg-grey",attrs:{"tile":""}},[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('archivedReports')))])],1),_vm._v(" "),_c('v-container',{staticClass:"pa-2 mx-auto",staticStyle:{"max-width":"960px"},attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.marker.archivedReports),function(report,i){return _c('v-col',{key:i,attrs:{"sm12":"","md6":"","cols":"12"}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"125","color":"grey"}},[_c('v-img',{attrs:{"src":report.image}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('name'))+" & "+_vm._s(_vm.$t('company'))+":")]),_vm._v("\n                  "+_vm._s(report.name)+" "+_vm._s(report.company)+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('email'))+"/"+_vm._s(_vm.$t('phone'))+":")]),_vm._v("\n                  "+_vm._s(report.email)+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('date'))+":")]),_vm._v("\n                  "+_vm._s(report.date)+"\n                ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('comment'))+":")]),_vm._v("\n                  "+_vm._s(report.comment)+"\n                ")])],1)],1),_vm._v(" "),_c('v-card-actions',[(report.markerXSolutionId)?_c('v-select',{staticStyle:{"width":"100%"},attrs:{"dense":"","outlined":"","readonly":"","items":_vm.marker.markerXSolutions,"item-text":"solution.name","item-value":"id"},model:{value:(report.markerXSolutionId),callback:function ($$v) {_vm.$set(report, "markerXSolutionId", $$v)},expression:"report.markerXSolutionId"}}):_vm._e()],1)],1)],1)}),1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 556 */,
/* 557 */,
/* 558 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 559 */,
/* 560 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 561 */,
/* 562 */,
/* 563 */,
/* 564 */,
/* 565 */,
/* 566 */,
/* 567 */,
/* 568 */,
/* 569 */,
/* 570 */,
/* 571 */,
/* 572 */,
/* 573 */,
/* 574 */,
/* 575 */,
/* 576 */,
/* 577 */,
/* 578 */,
/* 579 */,
/* 580 */,
/* 581 */,
/* 582 */,
/* 583 */,
/* 584 */,
/* 585 */,
/* 586 */,
/* 587 */,
/* 588 */,
/* 589 */,
/* 590 */,
/* 591 */,
/* 592 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 593 */
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),
/* 594 */
/***/ (function(module, exports) {

module.exports = {"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}

/***/ }),
/* 595 */,
/* 596 */,
/* 597 */,
/* 598 */
/***/ (function(module, exports) {

module.exports = {"_args":[["elliptic@6.4.1","C:\\Users\\bart\\source\\repos\\QRLog\\QRLog.UI\\qrlog.ui"]],"_development":true,"_from":"elliptic@6.4.1","_id":"elliptic@6.4.1","_inBundle":false,"_integrity":"sha512-BsXLz5sqX8OHcsh7CqBMztyXARmGQ3LWPtGjJi6DiJHq5C/qvi9P3OqgswKSDftbu8+IoI/QDTAm2fFnQ9SZSQ==","_location":"/elliptic","_phantomChildren":{},"_requested":{"type":"version","registry":true,"raw":"elliptic@6.4.1","name":"elliptic","escapedName":"elliptic","rawSpec":"6.4.1","saveSpec":null,"fetchSpec":"6.4.1"},"_requiredBy":["/browserify-sign","/create-ecdh"],"_resolved":"https://registry.npmjs.org/elliptic/-/elliptic-6.4.1.tgz","_spec":"6.4.1","_where":"C:\\Users\\bart\\source\\repos\\QRLog\\QRLog.UI\\qrlog.ui","author":{"name":"Fedor Indutny","email":"fedor@indutny.com"},"bugs":{"url":"https://github.com/indutny/elliptic/issues"},"dependencies":{"bn.js":"^4.4.0","brorand":"^1.0.1","hash.js":"^1.0.0","hmac-drbg":"^1.0.0","inherits":"^2.0.1","minimalistic-assert":"^1.0.0","minimalistic-crypto-utils":"^1.0.0"},"description":"EC cryptography","devDependencies":{"brfs":"^1.4.3","coveralls":"^2.11.3","grunt":"^0.4.5","grunt-browserify":"^5.0.0","grunt-cli":"^1.2.0","grunt-contrib-connect":"^1.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^1.0.1","grunt-mocha-istanbul":"^3.0.1","grunt-saucelabs":"^8.6.2","istanbul":"^0.4.2","jscs":"^2.9.0","jshint":"^2.6.0","mocha":"^2.1.0"},"files":["lib"],"homepage":"https://github.com/indutny/elliptic","keywords":["EC","Elliptic","curve","Cryptography"],"license":"MIT","main":"lib/elliptic.js","name":"elliptic","repository":{"type":"git","url":"git+ssh://git@github.com/indutny/elliptic.git"},"scripts":{"jscs":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","jshint":"jscs benchmarks/*.js lib/*.js lib/**/*.js lib/**/**/*.js test/index.js","lint":"npm run jscs && npm run jshint","test":"npm run lint && npm run unit","unit":"istanbul test _mocha --reporter=spec test/index.js","version":"grunt dist && git add dist/"},"version":"6.4.1"}

/***/ }),
/* 599 */,
/* 600 */,
/* 601 */,
/* 602 */,
/* 603 */,
/* 604 */,
/* 605 */,
/* 606 */,
/* 607 */,
/* 608 */,
/* 609 */,
/* 610 */,
/* 611 */,
/* 612 */,
/* 613 */,
/* 614 */,
/* 615 */,
/* 616 */,
/* 617 */,
/* 618 */,
/* 619 */,
/* 620 */,
/* 621 */,
/* 622 */,
/* 623 */,
/* 624 */,
/* 625 */,
/* 626 */,
/* 627 */,
/* 628 */,
/* 629 */,
/* 630 */,
/* 631 */
/***/ (function(module, exports) {

module.exports = {"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}

/***/ }),
/* 632 */,
/* 633 */,
/* 634 */,
/* 635 */,
/* 636 */,
/* 637 */,
/* 638 */,
/* 639 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.marker)?[_c('v-toolbar',{class:_vm.$store.state.isOffline ? 'sticky' : 'sticky-toolbar-breadcrumb',attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("marker"))+" "+_vm._s(_vm.marker !== null ? _vm.marker.number : "")+"\n        "+_vm._s(_vm.marker.label ? (" - " + (_vm.marker.label)) : ""))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[[_c('archivedReports',{attrs:{"marker":_vm.marker}})]],2),_vm._v(" "),(_vm.marker.reports.length > 0)?_c('v-toolbar-items',[_c('v-btn',{staticClass:"mr-2",attrs:{"icon":"","disabled":""}},[_c('v-badge',{attrs:{"overlap":"","content":_vm.marker.reports.length,"color":"primary"}},[_c('v-icon',{attrs:{"color":"error"}},[_vm._v("report_problem")])],1)],1)],1):_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"markers"}},[_c('v-btn',{attrs:{"small":"","depressed":"","color":"secondary"},on:{"click":_vm.lockBlueprint}},[_vm._v(_vm._s(_vm.$t("edit")))])],1)],1),_vm._v(" "),_c('div',{staticClass:"orange darken-1 text-center"},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.$t("inReadOnly")))])]),_vm._v(" "),_c('v-expand-transition',[(_vm.showLockedMessage)?_c('isLocked',{attrs:{"blueprint":_vm.blueprint},on:{"close":function($event){_vm.showLockedMessage = false}}}):_vm._e()],1),_vm._v(" "),(_vm.marker && _vm.blueprint && _vm.$store.state.productSolutions)?_c('v-layout',{staticClass:"mb-5",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"lg7":"","xs12":""}},[_c('v-container',[_c('v-form',{ref:"form",staticClass:"compact-form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-menu',{ref:"menu1",attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"nudge-right":40,"lazy":"","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"outlined":"","dense":"","disabled":"","label":_vm.$t('applicationDate'),"persistent-hint":"","prepend-icon":"event"},model:{value:(_vm.marker.date),callback:function ($$v) {_vm.$set(_vm.marker, "date", $$v)},expression:"marker.date"}},on))]}}],null,false,1633152336),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},model:{value:(_vm.marker.date),callback:function ($$v) {_vm.$set(_vm.marker, "date", $$v)},expression:"marker.date"}})],1),_vm._v(" "),(_vm.marker.installer != null)?[_c('small',{staticClass:"v-label theme--light"},[_c('p',{staticClass:"mb-0 text-sm-left"},[_vm._v(_vm._s(_vm.$t("installer")))])]),_vm._v(" "),_c('p',{staticClass:"text-sm-left"},[_vm._v("\n                    "+_vm._s(_vm.marker.installer.firstname)+"\n                    "+_vm._s(_vm.marker.installer.name)+"\n                  ")])]:_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"value":_vm.marker.status,"outlined":"","dense":"","menu-props":{ bottom: true, offsetY: true },"disabled":"","label":_vm.$t('status'),"item-value":"id","items":_vm.statusItems},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('v-icon',{attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")]}},{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('v-icon',{attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")]}}],null,false,25981884)})],2)],1),_vm._v(" "),_c('div',{staticClass:"mb-3 mt-3"},[_c('transition',{attrs:{"name":"flip","mode":"out-in"}},[_c('solutionsList',{key:"'s'",attrs:{"readonly":"","marker":_vm.marker,"blueprint":_vm.blueprint},on:{"open":_vm.openSolution}})],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-textarea',{attrs:{"disabled":"","outlined":"","label":_vm.$t('comments')},model:{value:(_vm.marker.comments),callback:function ($$v) {_vm.$set(_vm.marker, "comments", $$v)},expression:"marker.comments"}})],1)],1)],1)],1)],1),_vm._v(" "),(!_vm.$store.state.isMobile)?_c('v-flex',{attrs:{"lg5":"","xs12":""}},[_c('v-container',[_c('zoomMarkup',{attrs:{"readonly":"","detailPage":true,"blueprint":_vm.blueprint}})],1)],1):_vm._e()],1):_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1),_vm._v(" "),(
        _vm.blueprint && _vm.blueprint.blueprintFile.content && _vm.$store.state.isMobile
      )?_c('div',{staticClass:"floating-button",attrs:{"outlined":"","color":"primary"}},[_c('zoomMarkup',{ref:"markup",attrs:{"detailPage":true,"readonly":"","blueprint":_vm.blueprint}})],1):_vm._e(),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog}})]:_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 640 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__(274);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f513ae7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__(642);
function injectStyle (ssrContext) {
  __webpack_require__(641)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f513ae7_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.marker)?[_c('v-toolbar',{class:_vm.$store.state.isOffline ?'sticky' :'sticky-toolbar-breadcrumb',attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("marker"))+" "+_vm._s(_vm.marker !== null ? _vm.marker.number : '')+" "+_vm._s(_vm.marker.label ? (" - " + (_vm.marker.label)):''))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),[_c('v-toolbar-items',[[_c('archivedReports',{attrs:{"marker":_vm.marker}})]],2),_vm._v(" "),_c('v-toolbar-items',[(!_vm.$store.state.isOffline)?[_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('reports',{attrs:{"marker":_vm.marker},on:{"updateMarker":_vm.updateMarker}})],1)]:_vm._e()],2),_vm._v(" "),_c('v-toolbar-items',[_c('can',{attrs:{"I":"update","a":"markers"}},[[_c('addQRCode',{attrs:{"marker":_vm.marker},on:{"updateMarker":_vm.updateMarker}})]],2)],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"markers"}},[[_c('v-btn',{staticClass:"ml-2",attrs:{"depressed":"","small":"","color":"secondary"},on:{"click":_vm.updateMarker}},[(!_vm.$store.state.hasChanges)?[_vm._v(_vm._s(_vm.$t('save')))]:_c('v-badge',{attrs:{"color":"orange"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('v-icon',{attrs:{"dark":"","small":""}},[_vm._v("priority_high")])]},proxy:true}],null,false,2574017317)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('save')))])])],2)]],2),_vm._v(" "),(!_vm.$store.state.isOffline)?_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","offset-y":"","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("more_vert")])],1)]}}],null,false,3903213561)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"delete","a":"markers"}},[_c('areyousure',{attrs:{"list_item":"","id":_vm.marker.id,"object":"marker"},on:{"delete":_vm.deleteMarker}})],1)],1)],1)],1):_vm._e()]],2),_vm._v(" "),(_vm.$store.state.readyForOffline && _vm.$store.state.allAttributes && _vm.$store.state.productSolutions)?_c('v-sheet',{staticClass:"text-center white--text",attrs:{"tile":"","flat":"","color":"green"}},[(!_vm.$store.state.isOffline)?[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("done")]),_vm._v(" "+_vm._s(_vm.$t('readyForOffline'))+"\n    ")]:[_c('v-icon',{attrs:{"color":"white"}},[_vm._v("cached")]),_vm._v(" "+_vm._s(_vm.$t('goOnline'))+"\n    ")]],2):_vm._e(),_vm._v(" "),_c('v-expand-transition',[(_vm.showLockedMessage)?_c('isLocked',{attrs:{"blueprint":_vm.blueprint},on:{"close":function($event){_vm.showLockedMessage = false}}}):_vm._e()],1),_vm._v(" "),(_vm.marker && _vm.blueprint && _vm.$store.state.productSolutions)?_c('v-layout',{staticClass:"mb-5",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"lg7":"","xs12":""}},[_c('v-container',[_c('v-form',{ref:"form",staticClass:"compact-form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","rules":[function (v) { return v.length <= 20 || ''; }],"label":_vm.$t('markerLabel'),"maxlength":20,"counter":"20"},model:{value:(_vm.marker.label),callback:function ($$v) {_vm.$set(_vm.marker, "label", $$v)},expression:"marker.label"}}),_vm._v(" "),_c('v-menu',{ref:"menu1",attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"nudge-right":40,"lazy":"","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"outlined":"","dense":"","readonly":"","label":_vm.$t('applicationDate'),"persistent-hint":"","prepend-icon":"event"},model:{value:(_vm.marker.date),callback:function ($$v) {_vm.$set(_vm.marker, "date", $$v)},expression:"marker.date"}},on))]}}],null,false,116181830),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},model:{value:(_vm.marker.date),callback:function ($$v) {_vm.$set(_vm.marker, "date", $$v)},expression:"marker.date"}})],1),_vm._v(" "),(_vm.marker.installer != null)?[_c('small',{staticClass:"v-label theme--light"},[_c('p',{staticClass:"mb-0 text-sm-left"},[_vm._v(_vm._s(_vm.$t("installer")))])]),_vm._v(" "),_c('p',{staticClass:"text-sm-left"},[_vm._v(_vm._s(_vm.marker.installer.firstname)+" "+_vm._s(_vm.marker.installer.name))])]:_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"value":_vm.marker.status,"outlined":"","dense":"","menu-props":{ bottom: true, offsetY: true },"label":_vm.$t('status'),"item-value":"id","items":_vm.statusItems},on:{"change":_vm.changeStatusMarker},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('v-icon',{attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")]}},{key:"selection",fn:function(ref){
var item = ref.item;
var index = ref.index;
return [_c('v-icon',{attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")]}}],null,false,1917150908)})],2)],1),_vm._v(" "),_c('div',{staticClass:"mb-3 mt-3"},[_c('transition',{attrs:{"name":"flip","mode":"out-in"}},[_c('solutionsList',{key:"'s'",attrs:{"marker":_vm.marker,"blueprint":_vm.blueprint},on:{"addMarkerXSolution":_vm.addMarkerXSolution,"selected":_vm.selected,"open":_vm.openSolution}})],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-textarea',{attrs:{"outlined":"","label":_vm.$t('comments')},model:{value:(_vm.marker.comments),callback:function ($$v) {_vm.$set(_vm.marker, "comments", $$v)},expression:"marker.comments"}})],1)],1)],1)],1)],1),_vm._v(" "),(!_vm.$store.state.isMobile)?_c('v-flex',{attrs:{"lg5":"","xs12":""}},[_c('v-container',[_c('zoomMarkup',{attrs:{"detailPage":true,"blueprint":_vm.blueprint}})],1)],1):_vm._e()],1):_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1),_vm._v(" "),(_vm.blueprint && _vm.blueprint.blueprintFile.content  && _vm.$store.state.isMobile)?_c('div',{staticClass:"floating-button",attrs:{"outlined":"","color":"primary"}},[_c('zoomMarkup',{ref:"markup",attrs:{"detailPage":true,"blueprint":_vm.blueprint}})],1):_vm._e(),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog},on:{"response":_vm.response}})]:_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 643 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(275);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30975e97_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(664);
function injectStyle (ssrContext) {
  __webpack_require__(644)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_30975e97_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 644 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 645 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSolution_vue__ = __webpack_require__(276);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe3cb8e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSolution_vue__ = __webpack_require__(656);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AddSolution_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_fe3cb8e2_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AddSolution_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 646 */,
/* 647 */,
/* 648 */,
/* 649 */,
/* 650 */,
/* 651 */,
/* 652 */,
/* 653 */,
/* 654 */,
/* 655 */,
/* 656 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"depressed":"","color":"secondary","small":""}},on),[_vm._v(_vm._s(_vm.$t('newSolution')))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.$t("newSolution")))]),_vm._v(" "),_c('v-tab-item',[_c('v-card',{attrs:{"flat":""}},[_c('v-card-text',[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-text-field',{attrs:{"dense":"","required":"","outlined":"","rules":_vm.rules(_vm.$t('name')),"counter":512,"label":_vm.$t('enterTheNameOfYourCustomSolution')},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('yourProducts')))]),_vm._v(" "),_vm._l((_vm.products),function(item,index){return [_c('v-chip',{key:index,attrs:{"close":"","color":"bg-grey"},on:{"click:close":function($event){return _vm.remove(item.id)}}},[_vm._v(_vm._s(item.name))])]})],2),_vm._v(" "),_c('v-text-field',{staticClass:"mt-4",attrs:{"value":_vm.product,"outlined":"","dense":"","rules":_vm.counterRules,"counter":512,"item-text":"name","label":_vm.$t('enterTheNameOfYourProductAndClickThePlusSignToAddToTheList'),"append-icon":"add"},on:{"keyup":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.add($event)},"click:append":_vm.add},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}}),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('attachment')))]),_vm._v(" "),_vm._l((_vm.solutionAttachment),function(item,index){return [_c('v-chip',{key:index,attrs:{"close":"","color":"bg-grey"},on:{"click:close":function($event){return _vm.removeAttachment(index)}}},[_vm._v(_vm._s(item.name))])]})],2),_vm._v(" "),_c('v-list-item',[_c('label',{staticStyle:{"cursor":"pointer"},attrs:{"for":"file"}},[_c('v-icon',{directives:[{name:"ripple",rawName:"v-ripple"}]},[_vm._v("attach_file")]),_vm._v("\n                  "+_vm._s(_vm.file != null ? _vm.file.name : _vm.$t('chooseFile'))+"\n                ")],1),_vm._v(" "),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","id":"file"},on:{"change":_vm.changeAttachment}})])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 657 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PIMSolutions_vue__ = __webpack_require__(279);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed037c9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PIMSolutions_vue__ = __webpack_require__(663);
function injectStyle (ssrContext) {
  __webpack_require__(658)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PIMSolutions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2ed037c9_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PIMSolutions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 658 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 659 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 660 */,
/* 661 */,
/* 662 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('v-toolbar',{attrs:{"dark":"","color":"primary"}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){return _vm.$emit('close')}}},[_c('v-icon',[_vm._v("mdi-close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.name))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),(_vm.data)?[_c('v-container',[_c('div',{staticClass:"main_wrapper mt-5"},[_c('div',{staticClass:"main_description"},[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.$t('application')))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.Application)}}),_vm._v(" "),_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.$t('description')))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.Description)}}),_vm._v(" "),_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.$t('download')))]),_vm._v(" "),_vm._l((_vm.data.Attachments),function(attachment,i){return _c('div',{key:i},[_c('div',{staticClass:"option wrapper_content_attachment"},[_c('div',{staticClass:"option"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-file-alt")])],1),_vm._v(" "),_c('div',{staticClass:"subtitle-2 option"},[_c('a',{attrs:{"target":"_blank","href":attachment.Link}},[_vm._v(_vm._s(attachment.Category))])])]),_vm._v(" "),(i != _vm.data.Attachments.length -1)?_c('v-divider'):_vm._e()],1)})],2),_vm._v(" "),_c('div',{staticClass:"main_images"},[(_vm.data.Images && _vm.data.Images.length > 0)?[_c('zoomPicture',{attrs:{"src":_vm.data.Images[0],"imageHeight":"360"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"main_products"},[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.$t('products')))]),_vm._v(" "),_c('div',{staticClass:"scroll-container"},_vm._l((_vm.data.Products),function(product,i){return _c('div',{key:'p-'+i,staticClass:"text-truncate"},[_c('v-layout',{staticClass:"pa-2",attrs:{"column":""}},[_c('a',{attrs:{"target":"_blank","href":product.Link}},[_c('v-img',{attrs:{"gradient":"to bottom, rgba(0,0,0,.1), rgba(255,255,255,.5)","aspect-ratio":"1","width":"142","src":product.Image,"dark":""},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-layout',{attrs:{"fill-height":"","align-center":"","justify-center":"","ma-0":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}],null,true)},[_c('v-card-actions',{staticClass:"fill-height align-end gradient text-truncate"},[_c('span',{staticClass:"text-truncate d-inline-block"},[_vm._v(_vm._s(product.Name))])])],1)],1)])],1)}),0)])])])]:_c('v-container',{staticClass:"main_wrapper mt-5"},[(_vm.error)?_c('div',{staticClass:"title mt -6 text-center overline mx-auto"},[_vm._v(_vm._s(_vm.$t('error')))]):[_c('v-skeleton-loader',{attrs:{"type":"article"}}),_vm._v(" "),_c('v-skeleton-loader',{attrs:{"type":"image"}}),_vm._v(" "),_c('v-skeleton-loader',{attrs:{"type":"list-item-three-line"}}),_vm._v(" "),_c('v-skeleton-loader',{attrs:{"type":"list-item-three-line"}})]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 663 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky mt-5",attrs:{"color":"highlight","dark":"","dense":"","flat":""}},[_c('v-toolbar-title',[_vm._v("Firelog "+_vm._s(_vm.$t('solutions')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}})],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_firelog_solutions')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('v-toolbar',{attrs:{"elevation":"1","dark":"","dense":"","color":"secondary darken-3"}},[_c('v-text-field',{attrs:{"clearable":"","flat":"","solo-inverted":"","hide-details":"","prepend-inner-icon":"search","label":_vm.$t('search')},on:{"click:clear":function($event){_vm.search = ''}},model:{value:(_vm.search),callback:function ($$v) {_vm.search=$$v},expression:"search"}})],1),_vm._v(" "),_c('v-card',{attrs:{"outlined":"","loading":!_vm.items,"flat":""}},[_c('list-transition',{staticClass:"v-list--dense v-list--subheader",attrs:{"tag":"v-list"}},[_c('v-divider'),_vm._v(" "),_vm._l((_vm.filteredItems),function(item,i){return [_c('div',{key:i},[_c('v-list-item',{attrs:{"two-line":"","dense":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"40","mr-5":""}},[(item.image)?_c('v-img',{attrs:{"src":item.image}}):_c('img',{attrs:{"width":"40","src":__webpack_require__(18)}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-title',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-list-item-subtitle',[_c('a',{on:{"click":function($event){return _vm.openSolutionDetails(item)}}},[_vm._v(_vm._s(_vm.$t('viewSolution')))])])],1),_vm._v(" "),_c('v-list-item-action',[_c('v-checkbox',{staticClass:"mr-5",attrs:{"label":_vm.$t('active')},on:{"change":function($event){return _vm.hidePIMSolution(item)}},model:{value:(item.published),callback:function ($$v) {_vm.$set(item, "published", $$v)},expression:"item.published"}})],1)],1)],1)]})],2)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"fullscreen":"","transition":"slide-x-reverse-transition"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('pimSolutionDetails',{attrs:{"id":_vm.selectedSolutionId,"name":_vm.selectedSolutionName},on:{"close":function($event){_vm.dialog = false}}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 664 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"flat":"","dense":"","color":"highlight","dark":"","outlined":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('customsolutions')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}})],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_custom_solutions')))])],1)],1)],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"create","a":"solutions"}},[_c('addSolution',{on:{"add-solution":_vm.addSolution}})],1)],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('v-toolbar',{attrs:{"elevation":"1","dark":"","dense":"","color":"secondary darken-3"}},[_c('v-text-field',{attrs:{"clearable":"","flat":"","solo-inverted":"","hide-details":"","prepend-inner-icon":"search","label":_vm.$t('search')},on:{"click:clear":function($event){_vm.searchCustomeSolution = ''}},model:{value:(_vm.searchCustomeSolution),callback:function ($$v) {_vm.searchCustomeSolution=$$v},expression:"searchCustomeSolution"}})],1),_vm._v(" "),(_vm.items && _vm.items.length > 0)?_c('v-card',{attrs:{"outlined":"","flat":""}},[_c('list-transition',{staticClass:"v-list--dense v-list--subheader",attrs:{"tag":"v-list"}},[_c('v-divider'),_vm._v(" "),_vm._l((_vm.filteredItems),function(item,i){return [_c('v-list-item',{key:i,attrs:{"dense":""},on:{"click":function($event){return _vm.goToDetails(item)}}},[_c('v-divider'),_vm._v(" "),_c('v-list-item-avatar',{attrs:{"tile":"","size":"40","mr-5":""}},[(item.image)?_c('v-img',{attrs:{"src":item.image}}):_c('img',{attrs:{"width":"40","src":__webpack_require__(18)}})],1),_vm._v(" "),_c('v-list-item-title',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(item.name))])],1)]})],2)],1):(_vm.items != null && _vm.items.length === 0)?_c('emptyList',{attrs:{"title":_vm.$t('noCustomSolutions')},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('can',{attrs:{"I":"create","a":"solutions"}},[_c('addSolution',{on:{"add-solution":_vm.addSolution}})],1)]},proxy:true}])}):_vm._e(),_vm._v(" "),(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getCustomSolutions()}}}):_vm._e()],1),_vm._v(" "),_c('PIMSolutions')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 665 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SolutionDetail_vue__ = __webpack_require__(283);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_845dc3c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SolutionDetail_vue__ = __webpack_require__(668);
function injectStyle (ssrContext) {
  __webpack_require__(666)
  __webpack_require__(667)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-845dc3c2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SolutionDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_845dc3c2_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SolutionDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 666 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 667 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 668 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.solution)?[_c('v-toolbar',{staticClass:"sticky-toolbar-breadcrumb",attrs:{"dark":"","color":"highlight","flat":"","dense":"","outlined":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('solution'))+": "+_vm._s(_vm.solution.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}],null,false,3121901501)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}})],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_firelog_solutions')))])],1)],1)],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"solutions"}},[_c('v-btn',{attrs:{"color":"secondary","small":"","depressed":"","disabled":_vm.solution.name == ''},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-container',{staticClass:"wrapper",attrs:{"fluid":""}},[_c('div',{staticClass:"solution_name"},[_c('v-text-field',{attrs:{"outlined":"","dense":"","rules":_vm.nameRules,"label":_vm.$t('name'),"counter":50},model:{value:(_vm.solution.name),callback:function ($$v) {_vm.$set(_vm.solution, "name", $$v)},expression:"solution.name"}})],1),_vm._v(" "),_c('div',{staticClass:"solution_active"},[_c('v-checkbox',{attrs:{"color":"primary","label":_vm.$t('active')},model:{value:(_vm.solution.published),callback:function ($$v) {_vm.$set(_vm.solution, "published", $$v)},expression:"solution.published"}})],1),_vm._v(" "),_c('div',{staticClass:"solution_image mx-auto text-center"},[_c('image-uploader',{attrs:{"id":"iu1","preview":false,"capture":"environment","debug":1,"quality":0.8,"accept":".jpg, .png","autoRotate":true,"outputFormat":"verbose"},on:{"input":_vm.setSolutionImage}},[_c('label',{attrs:{"slot":"upload-label","for":"iu1"},slot:"upload-label"},[(_vm.solution.image)?[_c('v-img',{attrs:{"height":"145","width":"145","aspect-ratio":"1","src":(_vm.solution.image == null) ? _vm.emptyImage : _vm.solution.image}}),_vm._v(" "),_c('a',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('changeImage')))])]:_c('v-icon',{attrs:{"size":"150"}},[_vm._v("add_photo_alternate")])],2)])],1)])],1),_vm._v(" "),_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"sm","sm":"12"}},[_c('v-card',{attrs:{"outlined":"","flat":""}},[_c('v-toolbar',{staticClass:"pl-0",attrs:{"dense":"","flat":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t("attachment")))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('swipe-list',{attrs:{"items":_vm.solution.productAttachments,"item-key":"id"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('v-divider'),_vm._v(" "),_c('v-list-item',{key:item.id,attrs:{"dense":""}},[_c('v-list-item-title',{staticStyle:{"margin-left":"5px"}},[_c('a',{attrs:{"href":item.link}},[_vm._v(_vm._s(item.name))])])],1)]}},(_vm.$can('update','solutions'))?{key:"right",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"swipeout-action red",attrs:{"title":"remove"}},[_c('areyousure',{attrs:{"icon":true,"color":"white","id":item.id,"object":"productAttachment"},on:{"delete":_vm.deleteProductAttachment}})],1)]}}:null],null,true)}),_vm._v(" "),(_vm.$can('update','solutions'))?_c('v-form',{model:{value:(_vm.valid2),callback:function ($$v) {_vm.valid2=$$v},expression:"valid2"}},[_c('v-list-item',[_c('label',{staticStyle:{"cursor":"pointer"},attrs:{"for":"file"}},[_c('v-icon',{directives:[{name:"ripple",rawName:"v-ripple"}]},[_vm._v("attach_file")]),_vm._v("\n                  "+_vm._s(_vm.file != null ? _vm.file.name : _vm.$t('chooseFile'))+"\n                ")],1),_vm._v(" "),_c('input',{ref:"file",staticStyle:{"display":"none"},attrs:{"type":"file","id":"file"},on:{"change":_vm.changeAttachment}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"disabled":!_vm.file,"small":"","depressed":"","color":"secondary"},on:{"click":_vm.uploadAttachment}},[_vm._v(_vm._s(_vm.$t('add')))])],1)],1):_vm._e()],1)],1),_vm._v(" "),_c('v-col',{attrs:{"cols":"sm","sm":"12"}},[_c('v-card',{attrs:{"outlined":"","loading":!_vm.products,"flat":""}},[_c('v-toolbar',{staticClass:"pl-0",attrs:{"dense":"","flat":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t("products")))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('swipe-list',{ref:"list",staticClass:"card",attrs:{"items":_vm.products,"item-key":"id"},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var item = ref.item;
return [_c('v-divider'),_vm._v(" "),_c('v-list-item',{key:item.id,attrs:{"dense":""},on:{"dblclick":function($event){return _vm.goToProductDetails(item)}}},[_c('v-divider'),_vm._v(" "),_c('v-list-item-avatar',{attrs:{"tile":"","size":"40","mr-5":""}},[(item.image)?_c('v-img',{attrs:{"src":item.image}}):_c('img',{attrs:{"width":"40","src":__webpack_require__(18)}})],1),_vm._v(" "),_c('v-list-item-title',{staticStyle:{"margin-left":"5px"}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),(item.isPIM)?_c('v-list-item-action',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("lock")])],1):_vm._e(),_vm._v(" "),(!item.isPIM)?_c('v-list-item-action',[_c('v-icon',{attrs:{"color":"primary","small":""},on:{"click":function($event){$event.preventDefault();return _vm.goToProductDetails(item)}}},[_vm._v("fa-edit")])],1):_vm._e()],1)]}},(_vm.$can('update','solutions'))?{key:"right",fn:function(ref){
var item = ref.item;
return [_c('div',{staticClass:"swipeout-action red",attrs:{"title":"remove"}},[_c('areyousure',{attrs:{"icon":true,"color":"white","id":_vm.solution.id,"fk":item.id,"object":"solutionXproduct"},on:{"deleteSolutionXproduct":_vm.deleteProduct}})],1)]}}:null],null,true)}),_vm._v(" "),(_vm.$can('update','solutions'))?_c('v-form',{model:{value:(_vm.valid2),callback:function ($$v) {_vm.valid2=$$v},expression:"valid2"}},[_c('v-list-item',[_c('v-text-field',{attrs:{"append-outer-icon":"mdi-plus","outlined":"","dense":"","label":_vm.$t('addProduct')},on:{"click:append-outer":_vm.add},model:{value:(_vm.product),callback:function ($$v) {_vm.product=$$v},expression:"product"}})],1)],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog},on:{"response":function($event){return _vm.response($event,_vm.save)}}})]:_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 669 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetail_vue__ = __webpack_require__(284);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c036be4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetail_vue__ = __webpack_require__(671);
function injectStyle (ssrContext) {
  __webpack_require__(670)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0c036be4"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProductDetail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c036be4_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProductDetail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 670 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 671 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.product)?[_c('v-toolbar',{staticClass:"sticky-toolbar-breadcrumb",attrs:{"flat":"","color":"highlight","dark":"","dense":"","outlined":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('product'))+": "+_vm._s(_vm.product.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}],null,false,3121901501)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"white"}})],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_firelog_solutions')))])],1)],1)],1)],1),_vm._v(" "),(_vm.$can('update','solutions'))?_c('v-btn',{attrs:{"color":"secondary","small":"","depressed":"","disabled":_vm.product.name == ''},on:{"click":_vm.save}},[_vm._v(_vm._s(_vm.$t('save')))]):_vm._e()],1),_vm._v(" "),_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-container',{staticClass:"wrapper",attrs:{"fluid":""}},[_c('div',{staticClass:"solution_name"},[_c('v-text-field',{attrs:{"outlined":"","dense":"","rules":_vm.nameRules,"label":_vm.$t('name'),"counter":50},on:{"input":function($event){_vm.hasChanges =true}},model:{value:(_vm.product.name),callback:function ($$v) {_vm.$set(_vm.product, "name", $$v)},expression:"product.name"}})],1),_vm._v(" "),_c('div',{staticClass:"solution_active"},[_c('v-checkbox',{attrs:{"color":"primary","label":_vm.$t('active')},model:{value:(_vm.product.published),callback:function ($$v) {_vm.$set(_vm.product, "published", $$v)},expression:"product.published"}})],1),_vm._v(" "),_c('div',{staticClass:"solution_image mx-auto text-center"},[_c('image-uploader',{attrs:{"id":"iu1","preview":false,"capture":"environment","debug":1,"quality":0.8,"accept":".jpg, .png","autoRotate":true,"outputFormat":"verbose"},on:{"input":_vm.setSolutionImage}},[_c('label',{attrs:{"slot":"upload-label","for":"iu1"},slot:"upload-label"},[(_vm.product.image)?[_c('v-img',{attrs:{"height":"145","width":"145","aspect-ratio":"1","src":(_vm.product.image == null) ? _vm.emptyImage : _vm.product.image}}),_vm._v(" "),_c('a',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('changeImage')))])]:_c('v-icon',{attrs:{"size":"150"}},[_vm._v("add_photo_alternate")])],2)])],1)])],1)],1),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog},on:{"response":function($event){return _vm.response($event,_vm.save)}}})]:_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 672 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(285);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dbd5915_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(679);
function injectStyle (ssrContext) {
  __webpack_require__(673)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dbd5915_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 673 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 674 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solutions_vue__ = __webpack_require__(286);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070a4a75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Solutions_vue__ = __webpack_require__(678);
function injectStyle (ssrContext) {
  __webpack_require__(675)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-070a4a75"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Solutions_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_070a4a75_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Solutions_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 675 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 676 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 677 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',[(_vm.products && _vm.products.length > 0)?_c('v-flex',[_c('div',{staticClass:"text-center"},[_c('small',[_vm._v(_vm._s(_vm.$t('selectUsedProducts')))])]),_vm._v(" "),_c('div',{staticClass:"scroll-container",staticStyle:{"scroll-snap-type":"x mandatory"}},_vm._l((_vm.products),function(n,i){return _c('div',{key:'p-'+i,staticClass:"text-truncate"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-layout',_vm._g({staticClass:"pa-2",attrs:{"column":""},on:{"click":function($event){return _vm.select(n.id)}}},on),[_c('v-img',{attrs:{"gradient":"to bottom, rgba(0,0,0,.1), rgba(255,255,255,.5)","aspect-ratio":"1","width":"142","src":n.image ? ("" + (n.image)): _vm.emptyImage,"dark":""},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-layout',{attrs:{"fill-height":"","align-center":"","justify-center":"","ma-0":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}],null,true)},[_c('v-card-actions',{staticClass:"fill-height align-end gradient"},[_c('span',{staticClass:"text-truncate d-inline-block"},[_vm._v(_vm._s(n.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(n.selected ? "check_box" : "check_box_outline_blank"))])],1)],1)],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(n.name))])])],1)}),0)]):(_vm.empty)?_c('v-flex',[_c('div',{staticClass:"subtitle mx-auto text-center"},[_vm._v(_vm._s(_vm.$t('noproducts')))])]):(_vm.productSolutionId)?_c('v-flex',[_c('v-progress-linear',{attrs:{"indeterminate":"","color":"primary"}})],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 678 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{attrs:{"dense":"","flat":""}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t('solutions')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.markerXSolutions.length > 0)?_c('v-expansion-panels',{staticStyle:{"z-index":"unset"},model:{value:(_vm.active),callback:function ($$v) {_vm.active=$$v},expression:"active"}},_vm._l((_vm.markerXSolutions),function(markerXSolution,i){return _c('v-expansion-panel',{key:i,ref:'section-'+i,refInFor:true,attrs:{"lazy":""}},[_c('v-expansion-panel-header',{scopedSlots:_vm._u([{key:"actions",fn:function(){return [_c('v-icon',{attrs:{"color":markerXSolution.isApproved === 1 && !markerXSolution.valid ? 'red' :
                   markerXSolution.isApproved === 0 && !markerXSolution.valid ? 'orange':
                    markerXSolution.isApproved === 2? 'success': 'primary'}},[_vm._v(_vm._s(markerXSolution.isApproved === 2 ? 'check_circle' : markerXSolution.isApproved === 1 ? 'priority_high': 'priority_high'))])]},proxy:true}],null,true)},[_c('div',{staticClass:"subheading"},[_vm._v(_vm._s(markerXSolution.solution.name))])]),_vm._v(" "),_c('v-expansion-panel-content',{staticStyle:{"display":"block !important"}},[_c('div',{staticClass:"active-row"},[_c('v-divider'),_vm._v(" "),_c('v-list-item',{attrs:{"two-line":""}},[_c('v-list-item-title',{staticClass:"headline",staticStyle:{"overflow":"wrap"}},[_vm._v(_vm._s(markerXSolution.solution.name))]),_vm._v(" "),_c('v-list-item-avatar',{attrs:{"tile":"","size":"125"}},[_c('v-img',{attrs:{"aspect-ratio":"1","src":markerXSolution.product ? markerXSolution.product : _vm.emptyImage}})],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list',{attrs:{"subheader":"","three-line":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("details")))]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                    var on = ref.on;
return [_c('v-list-item-subtitle',_vm._g({domProps:{"innerHTML":_vm._s(_vm.attributesToString(markerXSolution))}},on))]}}],null,true)},[_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.attributesToString(markerXSolution))}})])],1)],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("dimensions")))]),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                    var on = ref.on;
return [_c('v-list-item-subtitle',_vm._g({domProps:{"innerHTML":_vm._s(_vm.dimensionsToString(markerXSolution))}},on))]}}],null,true)},[_vm._v(" "),_c('span',{domProps:{"innerHTML":_vm._s(_vm.dimensionsToString(markerXSolution))}})])],1)],1)],1),_vm._v(" "),_c('v-layout',[_c('v-flex',[(_vm.$store.state.isMobile)?_c('v-sheet',[_c('v-container',{staticClass:"myContainer",attrs:{"grid-list-sm":"","fluid":""}},_vm._l((markerXSolution.attachments),function(attachment,i){return _c('div',{key:'p-'+i,staticClass:"myColumn text-truncate"},[_c('v-hover',{scopedSlots:_vm._u([{key:"default",fn:function(ref){
                    var hover = ref.hover;
return [_c('div',[_c('v-card',{directives:[{name:"ripple",rawName:"v-ripple"}],attrs:{"flat":"","tile":""}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                    var on = ref.on;
return [_c('v-layout',_vm._g({staticClass:"pa-2",attrs:{"column":""},on:{"click":function($event){return _vm.select(_vm.n.id)}}},on),[_c('v-img',{staticClass:"white--text",attrs:{"gradient":"to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)","src":attachment.content,"aspect-ratio":"1","width":"142"},on:{"click":function($event){return _vm.zoomPicture(attachment.content)}},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}],null,true)},[_c('v-card-actions',{staticClass:"fill-height align-end gradient"},[_c('span',{staticClass:"text-truncate d-inline-block"},[_vm._v(_vm._s(attachment.createdTs.substring(0,10)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(attachment.approved)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check_circle")]):_c('v-icon',{attrs:{"color":"red"}},[_vm._v("priority_high")])],1)],1)],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(((attachment.createdBy) + " (" + (attachment.createdTs.substring(0,10)) + ")")))])])],1)],1)]}}],null,true)})],1)}),0)],1):_c('v-card',{attrs:{"flat":""}},[_c('v-container',{attrs:{"fluid":""}},[_c('v-slide-y-transition',{attrs:{"group":"","tag":"v-row"}},_vm._l((markerXSolution.attachments),function(attachment,n){return _c('v-col',{key:n,staticClass:"d-flex child-flex",attrs:{"cols":2}},[_c('v-card',{staticClass:"d-flex",attrs:{"flat":"","tile":""}},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                    var on = ref.on;
return [_c('v-layout',_vm._g({attrs:{"column":""}},on),[_c('v-card',{attrs:{"flat":"","tile":""}},[_c('v-img',{staticClass:"white--text",attrs:{"gradient":"to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)","src":attachment.content,"aspect-ratio":"1","width":"142"},on:{"click":function($event){return _vm.zoomPicture(attachment.content)}},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}],null,true)},[_c('v-card-actions',{staticClass:"fill-height align-end gradient"},[_c('span',{staticClass:"text-truncate d-inline-block"},[_vm._v(_vm._s(attachment.createdTs.substring(0,10)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(attachment.approved)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check_circle")]):_c('v-icon',{attrs:{"color":"red"}},[_vm._v("priority_high")])],1)],1)],1)],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(((attachment.createdBy) + " (" + (attachment.createdTs.substring(0,10)) + ")")))])])],1)],1)}),1)],1)],1)],1)],1)],1)])],1)}),1):_vm._e(),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
                    var on = ref.on;
return undefined}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('img',{attrs:{"src":_vm.img}})])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 679 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-container',{attrs:{"fluid":""}},[_c('v-card',{staticClass:"mx-auto",attrs:{"flat":"","max-width":"960"}},[_c('v-toolbar',{attrs:{"dense":"","flat":"","color":"transparent"}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.payload ? _vm.payload.marker.number : _vm.$t('marker'))+" "+_vm._s(_vm.payload && _vm.payload.marker.label ? (" - " + (_vm.payload.marker.label)):''))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-toolbar-items',[_c('v-menu',{attrs:{"transition":"scale-transition","origin":"right top","offset-y":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"text":""}},on),[[_vm._v(_vm._s(_vm.$i18n.locale))],_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-icon',[_vm._v("language")])],2)]}}])},[_vm._v(" "),_c('v-list',_vm._l((_vm.$store.state.languages),function(language,index){return _c('v-list-item',{key:index,on:{"click":function($event){return _vm.changeLanguage(language.code)}}},[_c('v-list-item-icon',[_vm._v(_vm._s(_vm.fromCodePoint(language.flag))+" "+_vm._s(language.name))])],1)}),1)],1)],1),_vm._v(" "),_c('v-toolbar-items',[_c('v-btn',{attrs:{"text":""},on:{"click":function($event){_vm.loginDialog = true}}},[_vm._v(_vm._s(_vm.$t('login')))])],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mx-auto",attrs:{"outlined":""}},[(_vm.payload)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('small',{staticClass:"v-label theme--light"},[_c('p',{staticClass:"mb-0 text-sm-left"},[_vm._v(_vm._s(_vm.$t("date")))])]),_vm._v(" "),_c('p',{staticClass:"text-sm-left"},[_vm._v(_vm._s(_vm.payload.marker.date))]),_vm._v(" "),_c('small',{staticClass:"v-label theme--light"},[_c('p',{staticClass:"mb-0 text-sm-left"},[_vm._v(_vm._s(_vm.$t("comments")))])]),_vm._v(" "),_c('p',{staticClass:"text-sm-left"},[_vm._v(_vm._s(_vm.payload.marker.comments))]),_vm._v(" "),(_vm.payload.marker.installer != null)?[_c('small',{staticClass:"v-label theme--light"},[_c('p',{staticClass:"mb-0 text-sm-left"},[_vm._v(_vm._s(_vm.$t("installer")))])]),_vm._v(" "),_c('p',{staticClass:"text-sm-left"},[_vm._v(_vm._s(_vm.payload.marker.installer.firstname)+" "+_vm._s(_vm.payload.marker.installer.name))])]:_vm._e(),_vm._v(" "),(_vm.customer)?[_c('small',{staticClass:"v-label theme--light"},[_c('p',{staticClass:"mb-0 text-sm-left"},[_vm._v(_vm._s(_vm.$t("company")))])]),_vm._v(" "),_c('p',{staticClass:"text-sm-left"},[_vm._v(_vm._s(_vm.customer.Name))]),_vm._v(" "),_c('small',{staticClass:"v-label theme--light"},[_c('p',{staticClass:"mb-0 text-sm-left"},[_vm._v(_vm._s(_vm.$t("website")))])]),_vm._v(" "),_c('p',{staticClass:"text-sm-left"},[_vm._v(_vm._s(_vm.customer.Website))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"border1 mb-2"},[_c('transition',{attrs:{"name":"flip","mode":"out-in"}},[_c('solutions',{key:"'s'",attrs:{"allAttributes":_vm.payload.attributes,"marker":_vm.payload.marker}})],1)],1),_vm._v(" "),(!_vm.reported)?_c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"12"}},[_c('v-btn',{attrs:{"block":"","color":"error","dark":""},on:{"click":function($event){_vm.dialog = true}}},[_vm._v(_vm._s(_vm.$t('report')))])],1)],1):_vm._e()],2)],1)],1):_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1),_vm._v(" "),(_vm.reports.length > 0)?_c('v-card',{attrs:{"outlined":""}},[_c('v-toolbar',{staticClass:"pl-0",attrs:{"dense":"","flat":"","color":"transparant"}},[_c('v-subheader',[_vm._v(_vm._s(_vm.$t("report")))])],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('list-transition',{staticClass:"list v-list--three-line pa-0",attrs:{"height":"88","tag":"v-list"}},_vm._l((_vm.reports),function(report,i){return _c('div',{key:i},[_c('v-divider'),_vm._v(" "),_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"125","color":"grey"}},[_c('v-img',{attrs:{"src":report.image}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-subtitle',[_vm._v(_vm._s(report.name)+" "+_vm._s(report.company))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(report.email))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(report.date))]),_vm._v(" "),_c('v-list-item-subtitle',[_vm._v(_vm._s(report.comment))])],1)],1)],1)}),0)],1):_vm._e()],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.loginDialog),callback:function ($$v) {_vm.loginDialog=$$v},expression:"loginDialog"}},[_c('v-card',[_c('v-container',[_c('login'),_vm._v(" "),_c('a',{on:{"click":function($event){_vm.loginDialog = false}}},[_vm._v(_vm._s(_vm.$t('noLogin')))])],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.addReport($event)}},model:{value:(_vm.validForm),callback:function ($$v) {_vm.validForm=$$v},expression:"validForm"}},[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('report')))])]),_vm._v(" "),_c('v-card-text',{staticClass:"overflow-auto",staticStyle:{"max-height":"500px"}},[_c('v-container',[_c('v-text-field',{attrs:{"dense":"","outlined":"","rules":_vm.rules(_vm.$t('name')),"label":"Full name"},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","rules":_vm.rules(_vm.$t('company')),"label":"Company"},model:{value:(_vm.company),callback:function ($$v) {_vm.company=$$v},expression:"company"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","rules":_vm.rules(((_vm.$t('email')) + " / " + (_vm.$t('phone')))),"label":((_vm.$t('email')) + " / " + (_vm.$t('phone')))},model:{value:(_vm.email),callback:function ($$v) {_vm.email=$$v},expression:"email"}}),_vm._v(" "),_c('v-textarea',{attrs:{"dense":"","outlined":"","label":"Comment"},model:{value:(_vm.comment),callback:function ($$v) {_vm.comment=$$v},expression:"comment"}}),_vm._v(" "),_c('div',{staticClass:"text-center"},[_c('image-uploader',{attrs:{"preview":false,"className":['fileinput', { 'fileinput--loaded': _vm.hasImage }],"capture":"environment","debug":1,"quality":0.8,"accept":".jpg, .png","autoRotate":false,"outputFormat":"verbose"},on:{"input":_vm.setImage}},[_c('label',{attrs:{"slot":"upload-label","for":"fileInput"},slot:"upload-label"},[_c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"mx-auto text-center"},[(!_vm.image)?_c('v-icon',{attrs:{"large":""}},[_vm._v("add_photo_alternate")]):[_c('v-img',{attrs:{"src":_vm.image,"aspect-ratio":"1","contain":"","width":"200"}}),_vm._v(" "),_c('a',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('changeImage')))])]],2)])])])],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('div',{staticClass:"flex-grow-1"}),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"blue darken-1","type":"submit","text":"","disabled":!_vm.image},on:{"click":function($event){$event.preventDefault();return _vm.addReport($event)}}},[_vm._v(_vm._s(_vm.$t('send')))])],1)],1)],1)],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 680 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__ = __webpack_require__(288);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7cf3c1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__ = __webpack_require__(688);
function injectStyle (ssrContext) {
  __webpack_require__(681)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-6c7cf3c1"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Profile_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6c7cf3c1_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Profile_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 681 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 682 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__ = __webpack_require__(289);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b9eefea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__ = __webpack_require__(687);
function injectStyle (ssrContext) {
  __webpack_require__(683)
  __webpack_require__(684)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2b9eefea"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Customer_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b9eefea_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Customer_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 683 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 684 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 685 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 686 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getLicenseInfo()}}}):_c('v-card',[_c('v-card-title',[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"primary"}},[_vm._v("fa-id-badge")]),_vm._v("\n      "+_vm._s(_vm.$t('license'))+": "+_vm._s(_vm.licnese)+"\n    ")],1),_vm._v(" "),_c('v-card-title',[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"primary"}},[_vm._v("fa-hdd")]),_vm._v("\n      "+_vm._s(_vm.$t('storage'))+"\n    ")],1),_vm._v(" "),_c('v-card-text',[_c('v-progress-linear',{staticStyle:{"width":"100%"},attrs:{"color":_vm.usedStorageInPercentage < 50 ? 'primary': _vm.usedStorageInPercentage > 50 && _vm.usedStorageInPercentage < 75 ? 'orange' : 'red',"height":"20","value":_vm.usedStorageInPercentage},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var value = ref.value;
return [(value >= 100)?_c('strong',{staticClass:"white--text"},[_vm._v(_vm._s(Math.ceil(value))+"% ("+_vm._s(Math.ceil(_vm.usedStorage))+" MB / "+_vm._s(_vm.storageLimit)+" MB)")]):_c('strong',[_vm._v(_vm._s(Math.ceil(value))+"% ("+_vm._s(Math.ceil(_vm.usedStorage))+" MB / "+_vm._s(_vm.storageLimit)+" MB)")])]}}])})],1),_vm._v(" "),_c('v-expand-transition',[(_vm.$can('update','customers') && !_vm.hasRequested)?_c('div',[_c('div',{staticClass:"container black--text d-flex flex-wrap justify-space-around"},[_c('div',{staticClass:"subtitle-1 ma-1"},[_vm._v(_vm._s(_vm.$t('chooseHowMuchStorageYouWantToAdd')))]),_vm._v(" "),_c('div',[_c('v-list',[_c('v-list-item-group',{staticClass:"d-flex",class:_vm.$vuetify.breakpoint.lgAndUp ? '' : 'flex-wrap',attrs:{"color":"primary"},model:{value:(_vm.selectedUpgradeStorage),callback:function ($$v) {_vm.selectedUpgradeStorage=$$v},expression:"selectedUpgradeStorage"}},_vm._l((_vm.storageUpgrades.filter(function (x) { return ((x.amount + _vm.storageLimit) <= _vm.customerLimit); })),function(item,i){return _c('v-list-item',{key:i,staticClass:"pa-0 ma-1"},[_c('v-card',{staticClass:"v-card-border",attrs:{"elevation":"0","width":"100%","tile":""}},[_c('v-card-title',{class:item.color ? 'secondary white--text' : 'blue-grey lighten-5'},[_c('v-icon',{staticClass:"mr-2",attrs:{"color":item.color ? 'white' : '',"large":""}},[_vm._v("fa-hdd")]),_vm._v(" "),_c('span',[_vm._v("+"+_vm._s(item.amount / 1000)+" GB")])],1),_vm._v(" "),_c('v-sheet',{staticClass:" ma-6",attrs:{"tile":"","color":"transparent","width":"300"}},[_c('div',{staticClass:"d-none display-1 font-weight-thin"},[_vm._v("\n                        + "+_vm._s(item.price)+"\n                        "),_c('div',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.$t('perMonth')))])])])],1)],1)}),1)],1)],1)]),_vm._v(" "),_c('v-divider'),_vm._v(" "),(_vm.selectedUpgradeStorage != null)?_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('areyousure2',{attrs:{"headline":_vm.selectedUpgradeStorage != null ?
            ((_vm.$t('storage')) + ": +" + (_vm.storageUpgrades[_vm.selectedUpgradeStorage].amount / 1000) + " GB"): '',"message":'  ',"cancelbuttonText":_vm.$t('cancel'),"actionButtonText":_vm.$t('addStorage')},on:{"delete":_vm.upgradeStorage},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('v-btn',{attrs:{"disabled":_vm.selectedUpgradeStorage == null,"color":"secondary","depressed":""}},[_vm._v(_vm._s(_vm.$t('addStorage')))])]},proxy:true}],null,false,3267716020)})],1):_vm._e()],1):_vm._e()])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 687 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.loading)?_c('v-skeleton-loader',{attrs:{"type":"list-item-avatar-three-line, article, article"}}):(!_vm.retry)?_c('v-card',[_c('v-card-title',[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"primary"}},[_vm._v("fa-building")]),_vm._v("\n      "+_vm._s(_vm.customer.Name)+"\n    ")],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"300px","overflow":"auto"}},[_c('div',{staticClass:"d-flex flex-wrap"},[_c('div',{staticClass:"mr-6"},[_c('image-uploader',{attrs:{"id":"iu1","preview":false,"capture":"environment","quality":1,"accept":".jpg, .png","autoRotate":true,"outputFormat":"verbose"},on:{"input":_vm.setCustomerLogo}},[_c('label',{attrs:{"slot":"upload-label","for":"iu1"},slot:"upload-label"},[(_vm.customer.Logo)?[_c('v-img',{attrs:{"max-width":"200","max-height":"250","contain":"","src":(_vm.customer.Logo == null) ? _vm.emptyImage : _vm.customer.Logo}}),_vm._v(" "),_c('a',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('changeLogo')))])]:[_c('v-card',_vm._g({staticClass:"ma-2 bg-grey",attrs:{"width":"150","outlined":"","height":"150"}},_vm.on),[_c('v-container',{staticStyle:{"width":"142px"},attrs:{"fill-height":""}},[_c('div',{staticClass:"mx-auto text-center"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("add_photo_alternate")]),_vm._v(" "),_c('a',{staticClass:"primary--text"},[_vm._v(_vm._s(_vm.$t('logo')))])],1)])],1)]],2)])],1),_vm._v(" "),_c('div',{staticClass:"mt-3"},[_c('p',[_vm._v("\n          "+_vm._s(_vm.customer.InvoiceAddress.Street)+" "+_vm._s(_vm.customer.InvoiceAddress.StreetNumber)+" "+_vm._s(_vm.customer.InvoiceAddress.StreetBox)+"\n          "),_c('br'),_vm._v("\n          "+_vm._s(_vm.customer.InvoiceAddress.Zipcode)+" "+_vm._s(_vm.customer.InvoiceAddress.City)+"\n          "),_c('br'),_vm._v("\n          "+_vm._s(_vm.customer.InvoiceAddress.Country)+"\n          "),_c('br'),_vm._v("\n          "+_vm._s(_vm.customer.Phone)+"\n          "),_c('br'),_vm._v(" "),_c('br'),_vm._v("\n          "+_vm._s(_vm.customer.Web)+"\n        ")])])])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"depressed":"","color":"secondary"},on:{"click":_vm.saveCustomer}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1):_c('retry',{on:{"retry":function($event){return _vm.getCustomer()}}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 688 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('div',{staticClass:"wrapper_grid",class:_vm.$vuetify.breakpoint.mdAndUp ? 'container':'container'},[_c('div',{staticClass:"wrapper_grid_profile"},[_c('v-form',{ref:"form",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',{attrs:{"width":"100%","outlined":!_vm.$store.state.isMobile,"flat":_vm.$store.state.isMobile}},[_c('v-card-title',[_c('v-icon',{staticClass:"mr-3",attrs:{"color":"primary"}},[_vm._v("fa-user-circle")]),_vm._v("\n    "+_vm._s(_vm.$t('profile'))+"\n  ")],1),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"300px"}},[_c('v-text-field',{attrs:{"dense":"","outlined":"","rules":[function () { return !!_vm.firstName || ''; }],"label":_vm.$t('firstname'),"required":""},model:{value:(_vm.firstName),callback:function ($$v) {_vm.firstName=$$v},expression:"firstName"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","rules":[function () { return !!_vm.name || ''; }],"label":_vm.$t('name'),"required":""},model:{value:(_vm.name),callback:function ($$v) {_vm.name=$$v},expression:"name"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","rules":_vm.emailRules(),"label":_vm.$t('contactEmail'),"persistent-hint":"","hint":_vm.$t('contactEmailHint'),"required":""},model:{value:(_vm.contactEmail),callback:function ($$v) {_vm.contactEmail=$$v},expression:"contactEmail"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","rules":_vm.emailRules(),"label":_vm.$t('loginEmail'),"persistent-hint":"","hint":_vm.$t('loginEmailHint'),"required":""},model:{value:(_vm.login),callback:function ($$v) {_vm.login=$$v},expression:"login"}}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"600px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('a',_vm._g({},on),[_vm._v(_vm._s(_vm.$t('changePassword')))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-form',{ref:"formpswd",on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.validpswd),callback:function ($$v) {_vm.validpswd=$$v},expression:"validpswd"}},[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('changePassword')))])]),_vm._v(" "),_c('v-card-text',[_c('v-container',{attrs:{"grid-list-md":""}},[_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"dense":"","outlined":"","type":"password","rules":[function () { return !!_vm.currentpwd || ''; }],"label":_vm.$t('currentPassword'),"required":""},model:{value:(_vm.currentpwd),callback:function ($$v) {_vm.currentpwd=$$v},expression:"currentpwd"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"dense":"","outlined":"","type":"password","rules":[function () { return !!_vm.newpwd || ''; }, function () { return (this$1.newpwd !== this$1.currentpwd) || 'Password must be new'; }, function () { return ( /(?=.{8,})/.test(this$1.newpwd) || 'password weak'); }],"label":_vm.$t('newPassword'),"required":""},model:{value:(_vm.newpwd),callback:function ($$v) {_vm.newpwd=$$v},expression:"newpwd"}})],1),_vm._v(" "),_c('v-flex',{attrs:{"xs12":""}},[_c('v-text-field',{attrs:{"dense":"","outlined":"","type":"password","rules":[function () { return !!_vm.confirmpwd || ''; }, function () { return (this$1.newpwd === this$1.confirmpwd) || 'Password must match'; }],"label":_vm.$t('confirmPassword'),"required":""},model:{value:(_vm.confirmpwd),callback:function ($$v) {_vm.confirmpwd=$$v},expression:"confirmpwd"}})],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.$t("cancel")))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.changePassword}},[_vm._v(_vm._s(_vm.$t("save")))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"secondary","depressed":""},on:{"click":_vm.submit}},[_vm._v(_vm._s(_vm.$t("save")))])],1)],1)],1)],1),_vm._v(" "),_c('div',{staticClass:"wrapper_grid_customer"},[(_vm.$can('update','customers'))?_c('customer'):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"wrapper_grid_storage"},[_c('storage',{})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 689 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__ = __webpack_require__(292);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036df2a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__ = __webpack_require__(690);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Error_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_036df2a4_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Error_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-card',{staticClass:"ma-auto text-center",attrs:{"flat":""}},[_c('p',{staticClass:"display-1 font-weight-bold"},[_vm._v(_vm._s(_vm.title))]),_vm._v(" "),_c('p',{staticClass:"subtitle-1 font-weight-bold"},[_vm._v(_vm._s(_vm.message))])])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(293);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e52b83a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(692);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1e52b83a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"dense":"","color":"highlight","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('myTodos')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('dataTable',{attrs:{"items":_vm.todo,"progress":_vm.progress,"headers":_vm.headers},on:{"clickItem":_vm.editBlueprint},scopedSlots:_vm._u([{key:"itemOpenMarkers",fn:function(ref){
var item = ref.item;
return [_c('v-chip',{attrs:{"color":item.markers == 0 ? 'success' : 'primary',"dark":""}},[_vm._v(_vm._s(item.markers)+" "+_vm._s(_vm.$t('markers')))])]}},{key:"itemAction",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"color":"primary","disabled":item.isLocked,"icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.editBlueprint(item)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-edit")])],1)]}},{key:"cardContent",fn:function(ref){
var item = ref.item;
return [_c('v-subheader',{staticClass:"primary lighten-3 white--text font-weight-bold"},[_c('a',{staticClass:"white--text",attrs:{"href":"#"},on:{"click":function($event){return _vm.editBlueprint(item)}}},[_vm._v(_vm._s(item.blueprint))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pointer",on:{"click":function($event){return _vm.editBlueprint(item)}}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('project'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold text-truncate"},[_vm._v(_vm._s(item.project))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('buildingComponent'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.buildingComponent))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('todo'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_c('div',[_c('v-chip',{attrs:{"color":item.markers == 0 ? 'success' : 'primary',"dark":""}},[_vm._v(_vm._s(item.markers)+" "+_vm._s(_vm.$t('markers')))])],1)])],1),_vm._v(" "),(item.isLocked)?_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('isEditing'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.lockedByUserName))])],1):_vm._e(),_vm._v(" "),(item.isLocked)?_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('editStart'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.lockedTs))])],1):_vm._e()],1)],1)]}},{key:"empty",fn:function(){return [(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getData()}}}):_c('emptyList',{attrs:{"fit":"","image":__webpack_require__(113),"title":_vm.$t('noBlueprints')},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('can',{attrs:{"I":"create","a":"blueprints"}},[_c('addBlueprint',{on:{"add-blueprint":_vm.addBlueprint}})],1)]},proxy:true}])})]},proxy:true}])})],1),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return undefined}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('warning')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('continuereadonly')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":"","autofocus":""},on:{"click":function($event){return _vm.responseReadonly(false)}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.responseReadonly(true)}}},[_vm._v(_vm._s(_vm.$t('yes')))])],1)],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstallersTodos_vue__ = __webpack_require__(294);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a69220c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstallersTodos_vue__ = __webpack_require__(695);
function injectStyle (ssrContext) {
  __webpack_require__(694)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a69220c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_InstallersTodos_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a69220c_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_InstallersTodos_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 694 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"dense":"","color":"highlight","dark":"","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('todosForInstallers')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('div',{staticClass:"wrapper"},_vm._l((_vm.items),function(item,i){return _c('v-card',{key:i,staticClass:"box",attrs:{"tile":""}},[_c('v-card-title',[_vm._v(_vm._s(item.installer))]),_vm._v(" "),_c('div',{ref:"todo",refInFor:true,staticClass:"content",class:_vm.isOverFlow(item,i)  ? 'content' : item.active ? 'content_active': ''},[_c('v-list',_vm._l((item.todos),function(t,i){return _c('v-list-item',{key:i},[_c('v-list-item-content',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('div',_vm._g(_vm._b({domProps:{"textContent":_vm._s(t.breadCrumb)},on:{"click":function($event){return _vm.blueprintDetails(t)}}},'div',attrs,false),on)),_vm._v(" "),(t.deadline)?_c('div',[_c('small',[_vm._v(_vm._s(_vm.$t('deadline'))+": "+_vm._s(t.deadline))])]):_vm._e()]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(t.breadCrumb))])])],1),_vm._v(" "),_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_c('v-list-item-icon',_vm._g(_vm._b({},'v-list-item-icon',attrs,false),on),[_c('v-badge',{attrs:{"color":"primary","content":t.count}})],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(t.count)+" "+_vm._s(_vm.$t('todos')))])])],1)}),1)],1),_vm._v(" "),(item.isOverflowing)?_c('div',{staticClass:"collapsible d-flex justify-center",class:item.active ? 'active': '',on:{"click":function($event){return _vm.collapse(item)}}},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v(_vm._s(item.active ? 'fa-chevron-up': 'fa-chevron-down'))])],1):_vm._e()],1)}),1)])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 696 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(295);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5edb2418_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(697);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5edb2418_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 697 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"color":"highlight","dark":"","dense":"","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('reports')))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}])},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("report_problem")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_firelog_solutions')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-container',{staticClass:"pa-2",attrs:{"fluid":""}},[_c('v-row',_vm._l((_vm.reports),function(report,i){return _c('v-col',{key:i,attrs:{"sm12":"","md4":""}},[_c('v-card',{attrs:{"outlined":"","color":""},on:{"click":function($event){return _vm.markerDetails(report)}}},[_c('v-list-item',{staticClass:"pa-0",attrs:{"three-line":""}},[_c('v-list-item-avatar',{staticClass:"ml-0 mt-0 mb-0",attrs:{"tile":"","size":"170","color":"grey"}},[_c('v-img',{attrs:{"src":report.image}})],1),_vm._v(" "),_c('v-list-item-content',[_c('div',{staticClass:"overline mb-4"},[_vm._v(_vm._s(report.marker.project)+" > "+_vm._s(report.marker.buildingComponent)+" > "+_vm._s(report.marker.blueprint))]),_vm._v(" "),_c('v-list-item-title',{staticClass:"headline mb-1"},[_vm._v(_vm._s(((_vm.$t('marker')) + ": " + (report.marker.number) + " "))+" "+_vm._s(report.marker.label ? (" - " + (report.marker.label)):''))]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('name'))+" & "+_vm._s(_vm.$t('company'))+":")]),_vm._v(" "+_vm._s(report.name)+" "+_vm._s(report.company))]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('email'))+"/"+_vm._s(_vm.$t('phone'))+":")]),_vm._v(_vm._s(report.email))]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('date'))+":")]),_vm._v(_vm._s(report.date))]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('comment'))+":")]),_vm._v(_vm._s(report.comment))])],1)],1)],1)],1)}),1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 698 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oldReports_vue__ = __webpack_require__(296);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3180fb6b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_oldReports_vue__ = __webpack_require__(699);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_oldReports_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3180fb6b_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_oldReports_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 699 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('archivedReports')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('dataTable',{attrs:{"items":_vm.items,"progress":_vm.progress,"headers":_vm.headers},on:{"clickItem":_vm.goToMarker},scopedSlots:_vm._u([{key:"cardContent",fn:function(ref){
var item = ref.item;
return [_c('v-subheader',{staticClass:"subheading primary lighten-3 white--text font-weight-bold"},[_c('a',{staticClass:"white--text",attrs:{"href":"#"},on:{"click":function($event){return _vm.goToMarker(item)}}},[_vm._v(_vm._s(item.project)+" > "+_vm._s(item.buildingComponent)+" > "+_vm._s(item.blueprint)+" > "+_vm._s(item.marker))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pointer",on:{"click":function($event){return _vm.goToMarker(item)}}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('name'))+" & "+_vm._s(_vm.$t('company'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.name)+" "+_vm._s(item.company))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('email'))+"/ "+_vm._s(_vm.$t('phone'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.email))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('createdTs'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.dateFormated))])],1)],1)],1)]}},{key:"empty",fn:function(){return [(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getData()}}}):_vm._e()]},proxy:true}])})],1),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackButton_vue__ = __webpack_require__(297);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cb70600_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__ = __webpack_require__(701);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BackButton_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3cb70600_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BackButton_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mr-3"},[(!_vm.$store.state.isOffline)?_c('div',[_c('v-btn',{attrs:{"icon":""},on:{"click":_vm.openDrawer}},[_c('v-icon',[_vm._v("$menu")])],1),_vm._v(" "),(_vm.$store.state.previous != null)?_c('v-btn',{attrs:{"icon":"","color":"white"},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("fa-arrow-left")])],1):_vm._e()],1):(_vm.$store.state.previous.name != 'BuildingComponentDetails')?_c('div',[(_vm.$store.state.previous != null)?_c('v-btn',{attrs:{"icon":"","color":"white"},on:{"click":_vm.goBack}},[_c('v-icon',[_vm._v("fa-arrow-left")])],1):_vm._e()],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(298);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c89b76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(704);
function injectStyle (ssrContext) {
  __webpack_require__(703)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-17c89b76"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17c89b76_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 703 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 704 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"dark":"","color":"highlight","flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('help')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('v-container',[(_vm.items)?_c('div',{staticClass:"wrapper"},[_vm._l((_vm.items),function(helpvm,i){return _c('v-card',{key:i,staticClass:"box",attrs:{"outlined":""}},[_c('v-card-title',[_vm._v(_vm._s(helpvm.name))]),_vm._v(" "),_c('v-card-text',{ref:"helpvm",refInFor:true,staticClass:"content",class:_vm.isOverFlow(helpvm,i)  ? 'content' : helpvm.active ? 'content_active': '',domProps:{"innerHTML":_vm._s(helpvm.description)}}),_vm._v(" "),(helpvm.isOverflowing)?_c('v-icon',{staticClass:"collapsible",class:helpvm.active ? 'active': '',attrs:{"color":"primary"},on:{"click":function($event){return _vm.collapse(helpvm)}}},[_vm._v(_vm._s(helpvm.active ? 'fa-chevron-up': 'fa-chevron-down'))]):_vm._e(),_vm._v(" "),_c('v-container',[_c('ul',_vm._l((helpvm.documents),function(document,i){return _c('li',{key:i},[_c('v-chip',{staticClass:"ma-2",attrs:{"outlined":"","color":"primary","label":""}},[_c('v-icon',{attrs:{"color":"primary","small":"","left":""}},[_vm._v("fa-file")]),_vm._v(" "),_c('a',{attrs:{"target":"_blank","href":document.link}},[_vm._v(_vm._s(document.fileName))])],1)],1)}),0)])],1)}),_vm._v(" "),_c('p',{directives:[{name:"show",rawName:"v-show",value:(_vm.items.length === 0),expression:"items.length === 0"}]},[_vm._v(_vm._s(_vm.$t('noresults')))])],2):_vm._e()])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 705 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__(299);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_105a1c1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__(714);
function injectStyle (ssrContext) {
  __webpack_require__(706)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-105a1c1e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_105a1c1e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 706 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 707 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 708 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"max-width":"500px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-card',_vm._g({staticClass:"ma-2 bg-grey",attrs:{"outlined":"","height":"142"}},on),[_c('v-container',{staticStyle:{"width":"142px"},attrs:{"fill-height":"","fluid":""}},[_c('v-layout',[_c('v-icon',{staticClass:"mx-auto",attrs:{"color":"primary"}},[_vm._v("add_a_photo")])],1)],1)],1)]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),(_vm.dialog)?_c('v-card',[_c('v-tabs',{attrs:{"fixed-tabs":""}},[_c('v-tab',{attrs:{"left":"","ripple":""}},[_vm._v(_vm._s(_vm.$t("camera")))]),_vm._v(" "),_c('v-tab-item',[_c('v-layout',{staticClass:"container",attrs:{"column":""}},[_c('v-form',{ref:"form",attrs:{"lazy-validation":""},model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('div',{staticClass:"text-center"},[_c('input',{attrs:{"accept":".jpg, .png","type":"file","id":"fileInput"},on:{"change":_vm.setImage2}}),_vm._v(" "),_c('label',{attrs:{"for":"fileInput"}},[_c('div',[_c('canvas',{directives:[{name:"show",rawName:"v-show",value:(_vm.image),expression:"image"}],ref:"prev",staticClass:"d-none"}),_vm._v(" "),(_vm.image)?_c('v-img',{attrs:{"contain":"","height":"350","src":_vm.image}}):_vm._e(),_vm._v(" "),(!_vm.image)?_c('v-icon',{attrs:{"large":"","color":"primary"}},[_vm._v("add_a_photo")]):_c('a',{staticClass:"primary--text mt-2"},[_vm._v(_vm._s(_vm.$t('changeImage')))])],1)]),_vm._v(" "),_c('v-btn',{directives:[{name:"show",rawName:"v-show",value:(_vm.image),expression:"image"}],staticClass:"mt-2",attrs:{"color":"primary","icon":""},on:{"click":_vm.rotate}},[_c('v-icon',[_vm._v("crop_rotate")])],1)],1),_vm._v(" "),(_vm.loading)?_c('loading'):_vm._e(),_vm._v(" "),_c('v-radio-group',{staticClass:"justify-center",attrs:{"row":""},model:{value:(_vm.approved),callback:function ($$v) {_vm.approved=$$v},expression:"approved"}},[_c('v-radio',{attrs:{"color":"primary","label":_vm.$t('approved'),"value":true}}),_vm._v(" "),_c('v-radio',{attrs:{"color":"primary","label":_vm.$t('broken'),"value":false}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.close}},[_vm._v(_vm._s(_vm.$t('close')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","disabled":_vm.image == null || _vm.approved == null ? true: false,"text":""},on:{"click":_vm.onUpload}},[_vm._v(_vm._s(_vm.$t('add')))])],1)],1):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 709 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 710 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__ = __webpack_require__(304);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137e2cd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__ = __webpack_require__(712);
function injectStyle (ssrContext) {
  __webpack_require__(711)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-137e2cd8"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Detail_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_137e2cd8_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Detail_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 711 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.data)?[_c('v-toolbar',{staticClass:"sticky_solutionSelector",attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.data.Name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{staticClass:"mr-2",attrs:{"small":"","depressed":"","outlined":"","color":"secondary"},on:{"click":function($event){return _vm.useInMarker()}}},[_vm._v(_vm._s(_vm.$t('usethisinmarker')))]),_vm._v(" "),_c('v-btn',{attrs:{"outlined":"","small":"","depressed":""},on:{"click":_vm.backToSolutionList}},[_c('v-icon',{staticClass:"mr-2",attrs:{"small":"","color":"primary"}},[_vm._v("fa-arrow-left")])],1)],1),_vm._v(" "),_c('div',{staticClass:"main_wrapper mt-5"},[_c('div',{staticClass:"main_taxonomies"},_vm._l((_vm.data.SelectedTaxonomies),function(selectedTax,i){return _c('div',{key:i},[(selectedTax)?[_c('div',{staticClass:"option wrapper_content_taxonomy"},[_c('div',{staticClass:"option"},[(selectedTax.Image)?_c('v-img',{attrs:{"height":"70","width":"70","src":selectedTax.Image}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"subtitle-1 option"},[_vm._v(_vm._s(((_vm.$t('step')) + " " + (i + 1) + ": "))+_vm._s(selectedTax.Title)+"\n                "),_c('div',{staticClass:"caption font-weight-medium"},[_vm._v(_vm._s(selectedTax.Name))]),_vm._v(" "),_c('div',{staticClass:"caption",domProps:{"innerHTML":_vm._s(selectedTax.Description)}})])]),_vm._v(" "),(i != _vm.data.SelectedTaxonomies.length -1)?_c('v-divider'):_vm._e()]:_vm._e()],2)}),0),_vm._v(" "),_c('div',{staticClass:"main_images"},[(_vm.data.Images && _vm.data.Images.length > 0)?[_c('zoomPicture',{attrs:{"src":_vm.data.Images[0],"imageHeight":"360"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"main_attachments"},[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.$t('download')))]),_vm._v(" "),_vm._l((_vm.data.Attachments),function(attachment,i){return _c('div',{key:i},[_c('div',{staticClass:"option wrapper_content_attachment"},[_c('div',{staticClass:"option"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-file-alt")])],1),_vm._v(" "),_c('div',{staticClass:"subtitle-2 option"},[_c('a',{attrs:{"target":"_blank","href":attachment.Link}},[_vm._v(_vm._s(attachment.Category))])])]),_vm._v(" "),(i != _vm.data.Attachments.length -1)?_c('v-divider'):_vm._e()],1)})],2),_vm._v(" "),_c('div',{staticClass:"main_products"},[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.$t('products')))]),_vm._v(" "),_c('div',{staticClass:"scroll-container"},_vm._l((_vm.data.Products),function(product,i){return _c('div',{key:'p-'+i,staticClass:"text-truncate"},[_c('v-layout',{staticClass:"pa-2",attrs:{"column":""}},[_c('a',{attrs:{"target":"_blank","href":product.Link}},[_c('v-img',{attrs:{"gradient":"to bottom, rgba(0,0,0,.1), rgba(255,255,255,.5)","aspect-ratio":"1","width":"142","src":product.Image,"dark":""},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-layout',{attrs:{"fill-height":"","align-center":"","justify-center":"","ma-0":""}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}],null,true)},[_c('v-card-actions',{staticClass:"fill-height align-end gradient text-truncate"},[_c('span',{staticClass:"text-truncate d-inline-block"},[_vm._v(_vm._s(product.Name))])])],1)],1)])],1)}),0)]),_vm._v(" "),_c('div',{staticClass:"main_description"},[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.$t('description')))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.Description)}})]),_vm._v(" "),_c('div',{staticClass:"main_application"},[_c('div',{staticClass:"subtitle-2"},[_vm._v(_vm._s(_vm.$t('application')))]),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.data.Application)}})])])]:_c('v-container',{staticClass:"main_wrapper mt-5"},[(_vm.error)?_c('div',{staticClass:"title mt -6 text-center overline mx-auto"},[_vm._v(_vm._s(_vm.$t('error')))]):[_c('v-skeleton-loader',{attrs:{"type":"article"}}),_vm._v(" "),_c('v-skeleton-loader',{attrs:{"type":"image"}}),_vm._v(" "),_c('v-skeleton-loader',{attrs:{"type":"list-item-three-line"}}),_vm._v(" "),_c('v-skeleton-loader',{attrs:{"type":"list-item-three-line"}})]],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"fullscreen":"","hide-overlay":"","transition":"dialog-bottom-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({staticClass:"white",attrs:{"rounded":"","elevation":"3","outlined":"","color":"primary","x-large":"","disabled":_vm.$store.state.isOffline}},on),[_vm._v(_vm._s(_vm.$t('findInSolutionSelector')))])]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',{attrs:{"tile":"","disabled":_vm.loading}},[_c('v-toolbar',{staticClass:"sticky_solutionSelector",attrs:{"color":"primary","dark":"","flat":"","dense":""}},[_c('v-btn',{attrs:{"icon":"","dark":""},on:{"click":function($event){_vm.dialog = false}}},[_c('v-icon',[_vm._v("mdi-close")])],1),_vm._v(" "),_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('solutionselector')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',{staticClass:"container"},[(_vm.data)?_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.selectedSolutionId == null),expression:"selectedSolutionId == null"}]},[_c('v-toolbar',{attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.data.Solutions ? ("" + (_vm.$t('selectsolution'))) : ((_vm.$t('step')) + " " + (_vm.data.Step) + ": " + (_vm.data.Title))))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(_vm.data.Selected.length > 0)?[_c('v-btn',{staticClass:"mr-2",attrs:{"outlined":"","depressed":"","small":""},on:{"click":function($event){_vm.prevStep(_vm.getPreviousStepIndex())}}},[_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v("fa-arrow-left")])],1),_vm._v(" "),_c('v-btn',{attrs:{"small":"","outlined":"","depressed":""},on:{"click":function($event){return _vm.reset()}}},[_c('v-icon',{attrs:{"color":"primary","small":""}},[_vm._v("fa-redo")])],1)]:_vm._e()],2),_vm._v(" "),_c('p',[_vm._l((_vm.selectedTaxonomies),function(step,i){return [(step)?[_c('span',{key:i},[_c('a',{on:{"click":function($event){return _vm.prevStep(i)}}},[_vm._v(_vm._s(step))]),_vm._v("  /  \n              ")])]:_vm._e()]})],2),_vm._v(" "),_c('v-progress-linear',{attrs:{"color":"blue darken-2"},on:{"click":function($event){$event.stopPropagation();}},model:{value:(_vm.data.Selected.length/6*100),callback:function ($$v) {_vm.$set(_vm.data.Selected, "length/6*100", $$v)},expression:"data.Selected.length/6*100"}}),_vm._v(" "),(_vm.data.Options)?_c('div',[_c('div',{staticClass:"wrapper_options mt-3"},_vm._l((_vm.data.Options.filter(function (x) { return x !== null; })),function(tax,i){return _c('v-skeleton-loader',{key:i,attrs:{"loading":_vm.loading,"height":"94","type":"list-item-avatar-three-line"}},[(tax !== null)?[(_vm.data.Options)?_c('v-card',{staticClass:"option wrapper_content_taxonomy",attrs:{"outlined":""},on:{"click":function($event){return _vm.steps(tax.Id,tax.Name)}}},[_c('div',{staticClass:"option image"},[_c('v-img',{attrs:{"aspect-ratio":"1","contain":"","height":"175","src":tax.Image}})],1),_vm._v(" "),_c('div',{staticClass:"subtitle-1 font-weight-bold option"},[_vm._v(_vm._s(tax.Name))])]):_vm._e()]:_vm._e()],2)}),1)]):(_vm.data.Solutions && _vm.data.Solutions.length > 0)?_c('div',[_c('div',{staticClass:"wrapper_solutions mt-3"},_vm._l((_vm.data.Solutions),function(solution,i){return _c('v-card',{key:i,staticClass:"wrapper_content_solution",attrs:{"outlined":""}},[_c('v-img',{attrs:{"contain":"","src":solution.Link,"height":"360px"}}),_vm._v(" "),_c('div',{staticClass:"subtitle-1 font-weight-bold solution"},[_vm._v(_vm._s(solution.Name))]),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"small":"","depressed":"","outlined":"","color":"primary"},on:{"click":function($event){return _vm.selectedSolution(solution)}}},[_vm._v(_vm._s(_vm.$t('viewMore')))]),_vm._v(" "),_c('v-btn',{attrs:{"small":"","depressed":"","outlined":"","color":"secondary"},on:{"click":function($event){return _vm.useInMarker(solution,_vm.data.Selected )}}},[_vm._v(_vm._s(_vm.$t('usethisinmarker')))])],1)],1)}),1)]):_c('div',{staticClass:"title mt-6 text-center overline mx-auto"},[_vm._v(_vm._s(_vm.$t('noresults')))])],1):_vm._e(),_vm._v(" "),(_vm.selectedSolutionId)?_c('selectedSolutionComponent',{attrs:{"id":_vm.selectedSolutionId,"taxId":_vm.tax263415Id},on:{"back":function($event){_vm.selectedSolutionId = null},"useInMarkerFromDetails":_vm.useInMarkerFromDetails}}):_vm._e()],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.markerXSolution)?_c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[_c('v-toolbar-title',[_vm._v("\n      "+_vm._s(_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; })
      ? ("" + (_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; }).name))
      : _vm.markerXSolution.solutionId ? _vm.markerXSolution.solution.name : _vm.$t('chooseSolution'))+"\n    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.readonly)?[_c('can',{attrs:{"I":"update","a":"markers"}},[(!_vm.readonly)?[_c('v-btn',{staticClass:"ml-2",attrs:{"depressed":"","small":"","color":"secondary"},on:{"click":_vm.saveSolution}},[(!_vm.$store.state.hasChanges)?[_vm._v(_vm._s(_vm.$t('save')))]:_c('v-badge',{attrs:{"color":"orange"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('v-icon',{attrs:{"dark":"","small":""}},[_vm._v("priority_high")])]},proxy:true}],null,false,2574017317)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('save')))])])],2)]:_vm._e()],2)]:[_c('can',{attrs:{"I":"update","a":"markers"}},[_c('v-btn',{attrs:{"small":"","depressed":"","color":"secondary"},on:{"click":_vm.lockBlueprint}},[_vm._v(_vm._s(_vm.$t('edit')))])],1)],_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"markers"}},[(!_vm.$store.state.isOffline && !_vm.readonly)?_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","offset-y":"","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("more_vert")])],1)]}}],null,false,3903213561)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"delete","a":"markers"}},[_c('areyousure',{attrs:{"list_item":""},on:{"delete":function($event){return _vm.deleteMarkerXSolution(_vm.markerXSolution.id)}}})],1)],1)],1)],1):_vm._e()],1)],2),_vm._v(" "),(_vm.readonly)?_c('div',{staticClass:"orange darken-1 text-center"},[_c('span',{staticClass:"white--text"},[_vm._v(_vm._s(_vm.$t("inReadOnly")))])]):_vm._e(),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[(!_vm.markerXSolution.solutionId && _vm.$store.state.productSolutions.find(function (x) { return x.id != _vm.markerXSolution.solutionId; }))?_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': '',attrs:{"fluid":""}},[_c('v-row',{attrs:{"wrap":""}},[_c('v-expand-transition',[_c('v-col',[_c('v-card',{staticClass:"container"},[(_vm.$vuetify.breakpoint.lgAndUp)?_c('v-autocomplete',{staticClass:"mt-3",attrs:{"disabled":_vm.readonly,"items":_vm.$store.state.productSolutions,"item-value":"id","item-text":"name","label":_vm.$t('useDropdown'),"clearable":true,"dense":true,"outlined":"","return-masked-value":""},on:{"change":function($event){_vm.changeImage();_vm.list=false}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [[_vm._v(_vm._s(data.item.name))]]}},{key:"item",fn:function(data){return [_c('v-list-item-avatar',{attrs:{"tile":""}},[_c('v-img',{attrs:{"src":data.item.image ? data.item.image : _vm.emptyImage}})],1),_vm._v(" "),[_vm._v(_vm._s(data.item.name))]]}}],null,false,4161885767),model:{value:(_vm.markerXSolution.solutionId),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "solutionId", $$v)},expression:"markerXSolution.solutionId"}}):_c('v-select',{staticClass:"mt-3",attrs:{"menu-props":{ bottom: true, offsetY: true },"disabled":_vm.readonly,"items":_vm.$store.state.productSolutions,"item-value":"id","item-text":"name","label":_vm.$t('useDropdown'),"dense":true,"outlined":"","return-masked-value":""},on:{"change":function($event){_vm.changeImage();_vm.list=false}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [[_vm._v(_vm._s(data.item.name))]]}},{key:"item",fn:function(data){return [_c('v-list-item-avatar',{attrs:{"tile":""}},[_c('v-img',{attrs:{"src":data.item.image ? data.item.image : _vm.emptyImage}})],1),_vm._v(" "),[_vm._v(_vm._s(data.item.name))]]}}],null,false,4161885767),model:{value:(_vm.markerXSolution.solutionId),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "solutionId", $$v)},expression:"markerXSolution.solutionId"}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-expand-transition',[(_vm.markerXSolution.solutionId)?_c('div',[[_c('v-card',{staticClass:"d-flex",attrs:{"tile":""}},[_c('div',{},[_c('v-img',{attrs:{"aspect-ratio":"1","width":"142","src":_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; }).image}})],1),_vm._v(" "),_c('div',{staticClass:"flex-wrap align-self-end"},[_c('div',{staticClass:"d-inline-flex flex-wrap"},[(!_vm.readonly)?_c('div',{staticClass:"flex-wrap"},[_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","small":"","color":"accent"},on:{"click":function($event){_vm.markerXSolution.solutionId = null}}},[_vm._v("\n                    "+_vm._s(_vm.$t('changeSolution'))+"\n                  ")])],1):_vm._e(),_vm._v(" "),(_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; }).isPIM)?_c('div',{staticClass:"solutionSelector flex-wrap"},[_c('v-dialog',{attrs:{"fullscreen":"","transition":"slide-x-reverse-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [(!_vm.$store.state.isOffline)?_c('v-btn',_vm._g({staticClass:"ma-2",attrs:{"small":"","depressed":"","color":"accent"}},on),[_vm._v(_vm._s(_vm.$t('viewSolution')))]):_vm._e()]}}],null,false,3924403442),model:{value:(_vm.pimSolutionDialog),callback:function ($$v) {_vm.pimSolutionDialog=$$v},expression:"pimSolutionDialog"}},[_vm._v(" "),_c('pimSolutionDetails',{attrs:{"id":_vm.markerXSolution.solutionId,"name":_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; }).name},on:{"close":function($event){_vm.pimSolutionDialog = false}}})],1)],1):_vm._e()])])])],_vm._v(" "),[_c('v-card',{staticClass:"mt-3 mb-3"},[_c('v-container',[_c('transition',{attrs:{"name":"flip","mode":"out-in"}},[(!_vm.$store.state.isOffline)?_c('products',{attrs:{"productSolutionId":_vm.markerXSolution.solutionId,"selectedProducts":_vm.markerXSolution.selectedProducts,"readonly":_vm.readonly},on:{"selected":_vm.selected}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-list',{attrs:{"subheader":"","three-line":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("properties")))]),_vm._v(" "),_c('v-list-item-subtitle',{class:_vm.markerXSolution.valid ?'orange--text':'',domProps:{"innerHTML":_vm._s(_vm.markerXSolution.valid? _vm.showRequiredMessage() : _vm.attributesToString(_vm.markerXSolution))}})],1),_vm._v(" "),(!_vm.readonly)?_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":_vm.markerXSolution.valid?  'orange':'primary'},on:{"click":function($event){_vm.attributesDialog = true;}}},[_vm._v("fa-edit")])],1):_vm._e()],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("dimensions")))]),_vm._v(" "),_c('v-list-item-subtitle',{domProps:{"innerHTML":_vm._s(_vm.dimensionsToString(_vm.markerXSolution))}})],1),_vm._v(" "),(!_vm.readonly)?_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){_vm.markerXSolution.dimensionDialog = true}}},[_vm._v("fa-edit")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":""}}),_vm._v(" "),_c('v-card',{staticClass:"mt-3 mb-3"},[_c('v-container',[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('pictures')))]),_vm._v(" "),_c('div',{staticClass:"scroll-container",staticStyle:{"scroll-snap-type":"x"}},[(!_vm.readonly)?_c('addAttachment',{attrs:{"markerXSolution":_vm.markerXSolution},on:{"add-picture":_vm.addPicture}}):_vm._e(),_vm._v(" "),_vm._l((_vm.markerXSolution.attachments),function(attachment,i){return _c('div',{key:'p-'+i,staticClass:"text-truncate"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('div',_vm._g({staticClass:"pa-2"},on),[_c('v-img',{staticClass:"white--text",style:(attachment.new ? 'border: 4px solid #009bd9':''),attrs:{"gradient":"to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)","src":attachment.content,"aspect-ratio":"1","width":"142"},on:{"click":function($event){return _vm.zoomPicture(attachment.content)}},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}],null,true)},[_c('v-card-actions',{staticClass:"fill-height align-end gradient"},[_c('span',{staticClass:"text-truncate d-inline-block"},[_vm._v(_vm._s(attachment.createdTs.substring(0,10)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(attachment.approved)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check_circle")]):_c('v-icon',{attrs:{"color":"red"}},[_vm._v("priority_high")]),_vm._v(" "),((_vm.canDelete(attachment.createdTs) && attachment.new))?_c('v-icon',{attrs:{"color":"red","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.deletePicture(attachment)}}},[_vm._v("delete")]):((_vm.canDelete(attachment.createdTs) && !_vm.readonly && !_vm.$store.state.isOffline) || (_vm.$can('delete','blueprints') && !_vm.readonly && !_vm.$store.state.isOffline))?_c('areyousure',{attrs:{"icon":"","id":attachment.id,"object":"attachment"},on:{"delete":function($event){return _vm.deletePicture(attachment)}}}):_vm._e()],1)],1)],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(((attachment.createdBy) + " (" + (attachment.createdTs.substring(0,10)) + ")")))])])],1)})],2)])],1)],1)],1),_vm._v(" "),_c('v-card',{staticClass:"mt-3 mb-3"},[_c('v-container',[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('newReports')))]),_vm._v(" "),_c('div',{staticClass:"scroll-container",staticStyle:{"scroll-snap-type":"x"}},_vm._l((_vm.marker.reports),function(report,i){return _c('div',{key:'p-'+i,staticClass:"text-truncate"},[_c('v-card',{staticClass:"ma-1 text-start",attrs:{"elevation":"2","width":"500"}},[_c('v-list-item',{attrs:{"three-line":""}},[_c('v-list-item-avatar',{attrs:{"tile":"","size":"125","color":"grey"}},[_c('v-img',{staticClass:"white--text",attrs:{"gradient":"to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)","src":report.image,"aspect-ratio":"1","width":"142"},on:{"click":function($event){return _vm.zoomPicture(report.image)}}})],1),_vm._v(" "),_c('v-list-item-content',[_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('name'))+" & "+_vm._s(_vm.$t('company'))+":")]),_vm._v("\n                              "+_vm._s(report.name)+" "+_vm._s(report.company)+"\n                            ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('email'))+"/"+_vm._s(_vm.$t('phone'))+":")]),_vm._v("\n                              "+_vm._s(report.email)+"\n                            ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('date'))+":")]),_vm._v("\n                              "+_vm._s(report.date)+"\n                            ")]),_vm._v(" "),_c('v-list-item-subtitle',[_c('b',{staticClass:"mr-2"},[_vm._v(_vm._s(_vm.$t('comment'))+":")]),_vm._v("\n                              "+_vm._s(report.comment)+"\n                            ")])],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"blueprints"}},[_c('areyousure2',{attrs:{"cancelbuttonText":_vm.$t('cancel'),"actionButtonText":_vm.$t('ignore'),"id":report.id,"object":"report","message":_vm.$t('areyousureyouwanttoignorethis')},on:{"delete":function($event){return _vm.deleteReport(report)}},scopedSlots:_vm._u([{key:"action",fn:function(){return [_c('v-btn',{staticClass:"mr-2",attrs:{"text":"","color":"orange","depressed":""}},[_vm._v(_vm._s(_vm.$t('ignore')))])]},proxy:true}],null,true)})],1),_vm._v(" "),_c('v-btn',{attrs:{"dark":"","depressed":"","color":"secondary"},on:{"click":function($event){return _vm.addReport(report)}}},[_vm._v(_vm._s(_vm.$t('addReportToThisSolution')))])],1)],1)],1)}),0)])],1)],1)],1)]],2):_vm._e()]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('img',{attrs:{"src":_vm.img}})]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.attributesDialog),callback:function ($$v) {_vm.attributesDialog=$$v},expression:"attributesDialog"}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("\n            "+_vm._s(_vm.$t('properties'))+"\n            "),_c('v-spacer')],1),_vm._v(" "),_c('v-card-text',[_vm._l((_vm.$store.state.allAttributes.filter(function (x) { return x.visible; })),function(attribute,i){return [(attribute.qrLogAttributeClass.code == 'list')?_c('div',{key:i},[_c('v-select',{staticClass:"attributeSelectBoxes",attrs:{"menu-props":{ bottom: true, offsetY: true },"value":_vm.bindAttributeSelectbox(attribute),"items":attribute.qrLogAttributeListValue.filter(function (x) { return x.isActive; }),"item-value":"id","label":attribute.code,"clearable":true,"dense":"","outlined":"","hint":attribute.required ? _vm.$t('required'): '',"persistent-hint":"","validate-on-blur":"","required":attribute.required,"rules":_vm.required(attribute.required),"return-masked-value":""},on:{"change":function($event){return _vm.attributeSelected($event, attribute)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.description == null)?[_vm._v(_vm._s(data.item.descriptionFallback))]:[_vm._v(_vm._s(data.item.description))]]}},{key:"item",fn:function(data){return [(data.item.description == null)?[_vm._v(_vm._s(data.item.descriptionFallback))]:[_vm._v(_vm._s(data.item.description))]]}}],null,true)})],1):_c('div',{key:i},[_c('v-text-field',{attrs:{"required":attribute.required,"rules":_vm.required(attribute.required),"hint":attribute.required ? _vm.$t('required'): '',"validate-on-blur":"","persistent-hint":"","dense":"","value":_vm.bindAttributeSelectbox(attribute,true),"outlined":"","label":attribute.code},on:{"change":function($event){return _vm.attributeSelected($event, attribute)}}})],1)]})],2),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.attributesDialog = false;_vm.changeImage()}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.markerXSolution.dimensionDialog),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "dimensionDialog", $$v)},expression:"markerXSolution.dimensionDialog"}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("\n          "+_vm._s(_vm.$t('dimensions'))+"\n          ")]),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"dense":"","outlined":"","type":"number","autocomplete":"new-password","label":_vm.$t('amount')},model:{value:(_vm.markerXSolution.amount),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "amount", $$v)},expression:"markerXSolution.amount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","autocomplete":"new-password","label":_vm.$t('unit'),"box":""},model:{value:(_vm.markerXSolution.unit),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "unit", $$v)},expression:"markerXSolution.unit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.$t('width'),"type":"number","autocomplete":"new-password"},model:{value:(_vm.markerXSolution.width),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "width", $$v)},expression:"markerXSolution.width"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.$t('height'),"type":"number","autocomplete":"new-password"},model:{value:(_vm.markerXSolution.height),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "height", $$v)},expression:"markerXSolution.height"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.$t('length'),"type":"number","autocomplete":"new-password"},model:{value:(_vm.markerXSolution.length),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "length", $$v)},expression:"markerXSolution.length"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.$t('diameter'),"type":"number","autocomplete":"new-password"},model:{value:(_vm.markerXSolution.diameter),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "diameter", $$v)},expression:"markerXSolution.diameter"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.markerXSolution.dimensionDialog = false}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog},on:{"response":_vm.response}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__ = __webpack_require__(305);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e65d8e5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__ = __webpack_require__(717);
function injectStyle (ssrContext) {
  __webpack_require__(716)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-5e65d8e5"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Breadcrumb_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5e65d8e5_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Breadcrumb_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 716 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 717 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$store.state.isOffline && _vm.breadcrumb)?_c('ul',{staticClass:"v-breadcrumbs sticky-breadcrumb px-2 py-2"},_vm._l((_vm.breadcrumb),function(bc,i){return _c('li',{key:i,staticClass:"v-breadcrums__item"},[(i != _vm.breadcrumb.length  - 1)?[_c('small',[_c('a',{on:{"click":function($event){return _vm.$router.push(bc.to)}}},[_vm._v(_vm._s(bc.name))]),_vm._v(" / ")])]:[_c('small',[_vm._v(_vm._s(bc.name))])]],2)}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 718 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchivedProjects_vue__ = __webpack_require__(306);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca3490c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArchivedProjects_vue__ = __webpack_require__(719);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ArchivedProjects_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4ca3490c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ArchivedProjects_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 719 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('archivedProjects')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('dataTable',{attrs:{"items":_vm.projects,"progress":_vm.progress,"headers":_vm.headers},on:{"clickItem":_vm.projectDetails},scopedSlots:_vm._u([{key:"itemAction",fn:function(ref){
var item = ref.item;
return [_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"download","a":"logbook"}},[_c('downloadLogbook',{on:{"download":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.downloadLogbook.apply(void 0, [ item ].concat( args ));
}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("import_contacts")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)]}}],null,true)})],1),_vm._v(" "),_c('can',{attrs:{"I":"archive","a":"projects"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.restoreProject(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-undo")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('restore')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"projects"}},[_c('areyousure',{attrs:{"list_item":"","id":item.id,"object":"project"},on:{"delete":_vm.deleteProject}})],1)],1)],1)],1)]}},{key:"cardContent",fn:function(ref){
var item = ref.item;
return [_c('v-subheader',{staticClass:"subheading primary lighten-3 white--text font-weight-bold"},[_c('a',{staticClass:"white--text",attrs:{"href":"#"},on:{"click":function($event){return _vm.projectDetails(item)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"download","a":"logbook"}},[_c('downloadLogbook',{on:{"download":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.downloadLogbook.apply(void 0, [ item ].concat( args ));
}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("import_contacts")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)]}}],null,true)})],1),_vm._v(" "),_c('can',{attrs:{"I":"archive","a":"projects"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.restoreProject(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-undo")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('restore')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"projects"}},[_c('areyousure',{attrs:{"list_item":"","id":item.id,"object":"project"},on:{"delete":_vm.deleteProject}})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pointer",on:{"click":function($event){return _vm.projectDetails(item)}}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('building'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.buildingName))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('buildingComponents'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.buildingComponents.length))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('createdTs'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.createdTs))])],1)],1)],1)]}},{key:"empty",fn:function(){return [(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getData()}}}):_c('emptyList',{attrs:{"title":_vm.$t('noArchivedProjects')}})]},proxy:true}])})],1),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsDetails_vue__ = __webpack_require__(307);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7f1c89_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsDetails_vue__ = __webpack_require__(722);
function injectStyle (ssrContext) {
  __webpack_require__(721)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3f7f1c89"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ProjectsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3f7f1c89_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ProjectsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 721 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 722 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.project)?_c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"elevation":"1","dark":"","dense":"","color":"#296C9A","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.project.name))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('v-card',{attrs:{"tile":""}},[_c('v-expansion-panels',{staticClass:"flat elevation-0",attrs:{"active-class":"flat elevation-0"}},[_c('v-expansion-panel',{staticClass:"flat elevation-0",attrs:{"active-class":"flat elevation-0"}},[_c('v-expansion-panel-header',[_vm._v("Project detail")]),_vm._v(" "),_c('v-expansion-panel-content',[_c('v-divider'),_vm._v(" "),_c('v-container',[_c('div',{staticClass:"headline"},[_vm._v(_vm._s(_vm.project.buildingName))]),_vm._v(" "),_c('div',{staticClass:"project_container"},[_c('div',{staticClass:"contact_container"},[_c('v-container',[_c('v-subheader',{staticClass:"pa-0"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("account_circle")]),_vm._v("\n                      "+_vm._s(_vm.$t('contact'))+"\n                    ")],1),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.project.contactName)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.project.mobile)}}),_vm._v(" "),_c('div',{domProps:{"innerHTML":_vm._s(_vm.project.email)}})],1)],1),_vm._v(" "),_c('div',{staticClass:"address_container"},[_c('v-container',[_c('v-subheader',{staticClass:"pa-0"},[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("house")]),_vm._v("\n                      "+_vm._s(_vm.$t('address'))+"\n                    ")],1),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.project.street)+" "+_vm._s(_vm.project.no))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.project.postalCode)+" "+_vm._s(_vm.project.city))]),_vm._v(" "),_c('div',[_vm._v(_vm._s(_vm.project.country))])],1)],1),_vm._v(" "),_c('div',{staticClass:"image_container"},[(_vm.project.image)?_c('img',{attrs:{"src":_vm.project.image}}):_vm._e()])])])],1)],1)],1)],1),_vm._v(" "),_c('v-toolbar',{staticClass:"mt-3",attrs:{"flat":"","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('buildingComponents')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('dataTable',{attrs:{"items":_vm.buildingComponents,"progress":_vm.progress,"headers":_vm.headers},on:{"clickItem":_vm.details},scopedSlots:_vm._u([{key:"itemAction",fn:function(ref){
var item = ref.item;
return [_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"download","a":"logbook"}},[_c('downloadLogbook',{on:{"download":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.downloadLogbook.apply(void 0, [ item ].concat( args ));
}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("import_contacts")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)]}}],null,true)})],1)],1)],1)],1)]}},{key:"cardContent",fn:function(ref){
var item = ref.item;
return [_c('v-subheader',{staticClass:"subheading primary lighten-3 white--text font-weight-bold"},[_c('a',{staticClass:"white--text",attrs:{"href":"#"},on:{"click":function($event){return _vm.details(item)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flat":""}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1),_vm._v(" "),_c('can',{attrs:{"I":"download","a":"logbook"}},[_c('downloadLogbook',{on:{"download":function (){
	var args = [], len = arguments.length;
	while ( len-- ) args[ len ] = arguments[ len ];

	return _vm.downloadLogbook.apply(void 0, [ item ].concat( args ));
}},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-list-item',_vm._g({},on),[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("import_contacts")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)]}}],null,true)})],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pointer",on:{"click":function($event){return _vm.details(item)}}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('description'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.description))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('blueprints'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.blueprintsCount))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('createdTs'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.createdTs))])],1)],1)],1)]}},{key:"empty",fn:function(){return [(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getData()}}}):_c('emptyList',{attrs:{"title":_vm.$t('noBuildingComponents')}})]},proxy:true}],null,false,4271174619)})],1),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 723 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuildingComponentsDetails_vue__ = __webpack_require__(308);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3127a0dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuildingComponentsDetails_vue__ = __webpack_require__(724);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BuildingComponentsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3127a0dc_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BuildingComponentsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 724 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.buildingComponent)?_c('div',[_c('v-toolbar',{staticClass:"sticky-toolbar-breadcrumb",attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[(_vm.buildingComponent)?_c('v-toolbar-title',[_vm._v(_vm._s(_vm.buildingComponent.name))]):_vm._e(),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[_c('v-card',{staticClass:"mb-3 mt-3"},[_c('v-container',[_c('div',{staticClass:"subheader"},[_vm._v(_vm._s(_vm.$t("description")))]),_vm._v(" "),_c('p',{staticClass:"body-1"},[_vm._v(_vm._s(_vm.buildingComponent.description))])])],1),_vm._v(" "),_c('v-toolbar',{attrs:{"elevation":"1","dense":"","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t('blueprints')))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),_c('dataTable',{attrs:{"items":_vm.blueprints,"progress":_vm.progress,"headers":_vm.headers},on:{"clickItem":_vm.blueprintDetails},scopedSlots:_vm._u([{key:"itemAction",fn:function(ref){
var item = ref.item;
return [_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1)],1)],1)],1)]}},{key:"cardContent",fn:function(ref){
var item = ref.item;
return [_c('v-subheader',{staticClass:"primary lighten-3 white--text font-weight-bold"},[_c('a',{staticClass:"white--text",attrs:{"href":"#"},on:{"click":function($event){return _vm.blueprintDetails(item)}}},[_vm._v(_vm._s(item.name))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":[function($event){$event.preventDefault();},function($event){$event.stopPropagation();}]}},on),[_c('v-icon',[_vm._v("mdi-dots-vertical")])],1)]}}],null,true)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"300px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"download","a":"excel"}},[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();return _vm.downloadExcel(item)}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"success"}},[_vm._v("fa-file-excel")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('download')))])],1)],1)],1)],1)],1)],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('div',{directives:[{name:"ripple",rawName:"v-ripple"}],staticClass:"pointer",on:{"click":function($event){return _vm.blueprintDetails(item)}}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('description'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold text-truncate"},[_vm._v(_vm._s(item.description))])],1),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('markers'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.markers.length))])],1),_vm._v(" "),(item.isLocked)?_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('isEditing'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.lockedByUserName))])],1):_vm._e(),_vm._v(" "),(item.isLocked)?_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('editStart'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold"},[_vm._v(_vm._s(item.lockedTs))])],1):_vm._e(),_vm._v(" "),(_vm.$can('delete', 'projects') && item.isLocked)?_c('v-list-item',[_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('breakLock'))+":")]),_vm._v(" "),_c('v-list-item-content',{staticClass:"align-end font-weight-bold",on:{"click":function($event){$event.stopPropagation();return _vm.breakLock(item)}}},[_c('a',{attrs:{"href":"#"}},[_vm._v("\n                  "+_vm._s(_vm.$t('break'))+"\n                  "),_c('i',{staticClass:"fa fa-lock ml-2"})])])],1):_vm._e()],1)],1)]}},{key:"empty",fn:function(){return [(_vm.retry)?_c('retry',{on:{"retry":function($event){return _vm.getData()}}}):_c('emptyList',{attrs:{"title":_vm.$t('noBlueprints')}})]},proxy:true}],null,false,3772472074)}),_vm._v(" "),_c('v-dialog',{attrs:{"persistent":"","max-width":"290"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('warning')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('continuereadonly')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":"","autofocus":""},on:{"click":function($event){return _vm.responseReadonly(false)}}},[_vm._v(_vm._s(_vm.$t('no')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.responseReadonly(true)}}},[_vm._v(_vm._s(_vm.$t('yes')))])],1)],1)],1)],1),_vm._v(" "),_c('loadingDialog',{attrs:{"dialog":_vm.loading}})],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 725 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlueprintsDetails_vue__ = __webpack_require__(309);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd33952_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlueprintsDetails_vue__ = __webpack_require__(727);
function injectStyle (ssrContext) {
  __webpack_require__(726)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dd33952"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_BlueprintsDetails_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dd33952_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_BlueprintsDetails_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 726 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 727 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-toolbar',{class:_vm.$store.state.isOffline ?'sticky' :'sticky-toolbar-breadcrumb',attrs:{"flat":"","dark":"","color":"highlight","dense":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.blueprint != null ? _vm.blueprint.name: ''))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),(_vm.blueprint)?_c('v-layout',{attrs:{"wrap":""}},[_c('v-flex',{attrs:{"lg5":"","xs12":""}},[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-card',[_c('v-container',[_c('v-form',{model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('v-text-field',{attrs:{"outlined":"","dense":"","disabled":"","rules":_vm.nameRules,"required":"","label":_vm.$t('name')},model:{value:(_vm.blueprint.name),callback:function ($$v) {_vm.$set(_vm.blueprint, "name", $$v)},expression:"blueprint.name"}}),_vm._v(" "),_c('v-menu',{ref:"menu1",attrs:{"transition":"scale-transition","origin":"right top","offset-y":"","close-on-content-click":false,"nudge-right":40,"lazy":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"outlined":"","dense":"","disabled":"","label":_vm.$t('deadline'),"persistent-hint":"","prepend-icon":"event"},model:{value:(_vm.blueprint.deadline),callback:function ($$v) {_vm.$set(_vm.blueprint, "deadline", $$v)},expression:"blueprint.deadline"}},on))]}}],null,false,1643847591),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},model:{value:(_vm.blueprint.deadline),callback:function ($$v) {_vm.$set(_vm.blueprint, "deadline", $$v)},expression:"blueprint.deadline"}})],1),_vm._v(" "),_c('can',{attrs:{"I":"update","a":"blueprints"}},[_c('v-layout',[_c('v-select',{attrs:{"outlined":"","dense":"","disabled":"","items":_vm.blueprint.allInstallers,"label":_vm.$t('installer'),"chips":"","item-value":"id","item-text":"fullName","multiple":"","return-object":""},model:{value:(_vm.blueprint.installers),callback:function ($$v) {_vm.$set(_vm.blueprint, "installers", $$v)},expression:"blueprint.installers"}})],1)],1),_vm._v(" "),_c('v-textarea',{attrs:{"outlined":"","disabled":"","label":_vm.$t('description')},model:{value:(_vm.blueprint.description),callback:function ($$v) {_vm.$set(_vm.blueprint, "description", $$v)},expression:"blueprint.description"}})],1)],1)],1)],1),_vm._v(" "),_c('markers',{staticClass:"mb-6 mt-3",attrs:{"blueprintFile":_vm.blueprint.blueprintFile,"markers":_vm.markers},on:{"showMarkerDetails":_vm.showMarkerDetails}})],1)],1),_vm._v(" "),((_vm.blueprint.blueprintFile && !_vm.blueprint.blueprintFile.content) || !_vm.$store.state.isMobile)?_c('v-flex',{attrs:{"lg7":"","xs12":""}},[_c('v-container',{class:_vm.fullscreen ? 'sticky-blueprint': 'sticky-blueprint-fullscreen'},[_c('zoomMarkup',{ref:"markup",attrs:{"readonly":true,"blueprint":_vm.blueprint},on:{"fullscreen":_vm.toggleFullscreen,"showMarkerDetails":_vm.showMarkerDetails}})],1)],1):_vm._e()],1):_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1),_vm._v(" "),_c('v-dialog',{attrs:{"hide-overlay":"","persistent":"","width":"300"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"flat":"","color":"primary","dark":""}},[_c('v-card-text',[_vm._v("\n        "+_vm._s(_vm.loadingText)+"\n        ")])],1)],1),_vm._v(" "),(_vm.blueprint && _vm.blueprint.blueprintFile && _vm.blueprint.blueprintFile.content && _vm.$store.state.isMobile)?_c('div',{staticClass:"floating-button",attrs:{"outlined":"","color":"primary"}},[_c('zoomMarkup',{ref:"markup",attrs:{"readonly":true,"blueprint":_vm.blueprint},on:{"showMarkerDetails":_vm.showMarkerDetails}})],1):_vm._e(),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog},on:{"response":_vm.response}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 728 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__(310);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4c55cbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__(730);
function injectStyle (ssrContext) {
  __webpack_require__(729)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c4c55cbe_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 729 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 730 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.marker)?[_c('v-toolbar',{class:_vm.$store.state.isOffline ?'sticky' :'sticky-toolbar-breadcrumb',attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[_c('v-toolbar-title',[_vm._v(_vm._s(_vm.$t("marker"))+" "+_vm._s(_vm.marker !== null ? _vm.marker.number : '')+" "+_vm._s(_vm.marker.label ? (" - " + (_vm.marker.label)):''))]),_vm._v(" "),_c('v-spacer')],1),_vm._v(" "),(_vm.marker && _vm.blueprint && _vm.$store.state.productSolutions)?_c('v-layout',{staticClass:"mb-5",attrs:{"wrap":""}},[_c('v-flex',{attrs:{"lg7":"","xs12":""}},[_c('v-container',[_c('v-form',{ref:"form",staticClass:"compact-form",model:{value:(_vm.valid),callback:function ($$v) {_vm.valid=$$v},expression:"valid"}},[_c('v-card',[_c('v-container',{attrs:{"grid-list-md":"","text-xs-center":""}},[_c('v-menu',{ref:"menu1",attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"nudge-right":40,"lazy":"","offset-y":"","full-width":"","max-width":"290px","min-width":"290px"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [_c('v-text-field',_vm._g({attrs:{"outlined":"","dense":"","disabled":"","label":_vm.$t('applicationDate'),"persistent-hint":"","prepend-icon":"event"},model:{value:(_vm.marker.date),callback:function ($$v) {_vm.$set(_vm.marker, "date", $$v)},expression:"marker.date"}},on))]}}],null,false,1633152336),model:{value:(_vm.menu),callback:function ($$v) {_vm.menu=$$v},expression:"menu"}},[_vm._v(" "),_c('v-date-picker',{attrs:{"no-title":""},model:{value:(_vm.marker.date),callback:function ($$v) {_vm.$set(_vm.marker, "date", $$v)},expression:"marker.date"}})],1),_vm._v(" "),(_vm.marker.installer != null)?[_c('small',{staticClass:"v-label theme--light"},[_c('p',{staticClass:"mb-0 text-sm-left"},[_vm._v(_vm._s(_vm.$t("installer")))])]),_vm._v(" "),_c('p',{staticClass:"text-sm-left"},[_vm._v(_vm._s(_vm.marker.installer.firstname)+" "+_vm._s(_vm.marker.installer.name))])]:_vm._e(),_vm._v(" "),_c('v-select',{attrs:{"value":_vm.marker.status,"outlined":"","dense":"","menu-props":{ bottom: true, offsetY: true },"disabled":"","label":_vm.$t('status'),"item-value":"id","items":_vm.statusItems},scopedSlots:_vm._u([{key:"item",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")]}},{key:"selection",fn:function(ref){
var item = ref.item;
return [_c('v-icon',{attrs:{"color":item.color}},[_vm._v(_vm._s(item.icon))]),_vm._v("\n                    "+_vm._s(item.name)+"\n                  ")]}}],null,false,1238905180)})],2)],1),_vm._v(" "),_c('div',{staticClass:"mb-3 mt-3"},[_c('transition',{attrs:{"name":"flip","mode":"out-in"}},[_c('solutionsList',{key:"'s'",attrs:{"readonly":"","marker":_vm.marker,"blueprint":_vm.blueprint},on:{"open":_vm.openSolution}})],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-textarea',{attrs:{"disabled":"","outlined":"","label":_vm.$t('comments')},model:{value:(_vm.marker.comments),callback:function ($$v) {_vm.$set(_vm.marker, "comments", $$v)},expression:"marker.comments"}})],1)],1)],1)],1)],1),_vm._v(" "),(!_vm.$store.state.isMobile)?_c('v-flex',{attrs:{"lg5":"","xs12":""}},[_c('v-container',[_c('zoomMarkup',{attrs:{"readonly":"","detailPage":true,"blueprint":_vm.blueprint}})],1)],1):_vm._e()],1):_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1),_vm._v(" "),(_vm.blueprint && _vm.blueprint.blueprintFile.content  && _vm.$store.state.isMobile)?_c('div',{staticClass:"floating-button",attrs:{"outlined":"","color":"primary"}},[_c('zoomMarkup',{ref:"markup",attrs:{"detailPage":true,"readonly":"","blueprint":_vm.blueprint}})],1):_vm._e(),_vm._v(" "),_c('savebeforeleave',{attrs:{"dialog":_vm.saveDialog}})]:_c('v-container',{attrs:{"fill-height":""}},[_c('loading')],1)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 731 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__ = __webpack_require__(311);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dffd62e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__ = __webpack_require__(733);
function injectStyle (ssrContext) {
  __webpack_require__(732)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-4dffd62e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Details_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4dffd62e_hasScoped_true_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Details_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 732 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.markerXSolution)?_c('div',[_c('v-toolbar',{staticClass:"sticky",attrs:{"elevation":"1","dark":"","dense":"","color":"highlight","flat":""}},[_c('v-toolbar-title',[_vm._v("\n      "+_vm._s(_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; })
      ? ("" + (_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; }).name))
      : _vm.markerXSolution.solutionId ? _vm.markerXSolution.solution.name : _vm.$t('chooseSolution'))+"\n    ")]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(!_vm.readonly)?[_c('can',{attrs:{"I":"update","a":"markers"}},[(!_vm.readonly)?[_c('v-btn',{staticClass:"ml-2",attrs:{"depressed":"","small":"","color":"secondary"},on:{"click":_vm.saveSolution}},[(!_vm.$store.state.hasChanges)?[_vm._v(_vm._s(_vm.$t('save')))]:_c('v-badge',{attrs:{"color":"orange"},scopedSlots:_vm._u([{key:"badge",fn:function(){return [_c('v-icon',{attrs:{"dark":"","small":""}},[_vm._v("priority_high")])]},proxy:true}],null,false,2574017317)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.$t('save')))])])],2)]:_vm._e()],2)]:_vm._e(),_vm._v(" "),_c('can',{attrs:{"I":"delete","a":"markers"}},[(!_vm.$store.state.isOffline && !_vm.readonly)?_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","offset-y":"","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"white","icon":""}},on),[_c('v-icon',[_vm._v("more_vert")])],1)]}}],null,false,3903213561)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('can',{attrs:{"I":"delete","a":"markers"}},[_c('areyousure',{attrs:{"list_item":""},on:{"delete":function($event){return _vm.deleteMarkerXSolution(_vm.markerXSolution.id)}}})],1)],1)],1)],1):_vm._e()],1)],2),_vm._v(" "),_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': ''},[(!_vm.markerXSolution.solutionId && _vm.$store.state.productSolutions.find(function (x) { return x.id != _vm.markerXSolution.solutionId; }))?_c('div',{class:!_vm.$vuetify.breakpoint.lgAndUp ? 'container': '',attrs:{"fluid":""}},[_c('v-row',{attrs:{"wrap":""}},[_c('v-col',{staticClass:"d-flex child-flex",attrs:{"lg":"6","xs":"12","sm":"12","cols":"12"}},[(!_vm.readonly)?_c('solutionSelector',{on:{"selectedSolution":function($event){return _vm.solutionSelectorSelectedSolution($event,_vm.i)}}}):_vm._e()],1),_vm._v(" "),_c('v-col',{staticClass:"d-flex child-flex",attrs:{"lg":"6","xs":"12","sm":"12","cols":"12"}},[_c('v-btn',{staticClass:"white",attrs:{"x-large":"","rounded":"","elevation":"3","outlined":"","color":"secondary"},on:{"click":function($event){_vm.list = true}}},[_vm._v(_vm._s(_vm.$t('findInList')))])],1),_vm._v(" "),_c('v-expand-transition',[_c('v-col',{directives:[{name:"show",rawName:"v-show",value:(_vm.list),expression:"list"}]},[_c('v-card',{staticClass:"container"},[(_vm.$vuetify.breakpoint.lgAndUp)?_c('v-autocomplete',{staticClass:"mt-3",attrs:{"disabled":_vm.readonly,"items":_vm.$store.state.productSolutions,"item-value":"id","item-text":"name","label":_vm.$t('useDropdown'),"clearable":true,"dense":true,"outlined":"","return-masked-value":""},on:{"change":function($event){_vm.changeImage();_vm.list=false}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [[_vm._v(_vm._s(data.item.name))]]}},{key:"item",fn:function(data){return [_c('v-list-item-avatar',{attrs:{"tile":""}},[_c('v-img',{attrs:{"src":data.item.image ? data.item.image : _vm.emptyImage}})],1),_vm._v(" "),[_vm._v(_vm._s(data.item.name))]]}}],null,false,4161885767),model:{value:(_vm.markerXSolution.solutionId),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "solutionId", $$v)},expression:"markerXSolution.solutionId"}}):_c('v-select',{staticClass:"mt-3",attrs:{"menu-props":{ bottom: true, offsetY: true },"disabled":_vm.readonly,"items":_vm.$store.state.productSolutions,"item-value":"id","item-text":"name","label":_vm.$t('useDropdown'),"dense":true,"outlined":"","return-masked-value":""},on:{"change":function($event){_vm.changeImage();_vm.list=false}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [[_vm._v(_vm._s(data.item.name))]]}},{key:"item",fn:function(data){return [_c('v-list-item-avatar',{attrs:{"tile":""}},[_c('v-img',{attrs:{"src":data.item.image ? data.item.image : _vm.emptyImage}})],1),_vm._v(" "),[_vm._v(_vm._s(data.item.name))]]}}],null,false,4161885767),model:{value:(_vm.markerXSolution.solutionId),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "solutionId", $$v)},expression:"markerXSolution.solutionId"}})],1)],1)],1)],1)],1):_vm._e(),_vm._v(" "),_c('v-expand-transition',[(_vm.markerXSolution.solutionId)?_c('div',[[_c('v-card',{staticClass:"d-flex",attrs:{"tile":""}},[_c('div',{},[_c('v-img',{attrs:{"aspect-ratio":"1","width":"142","src":_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; }).image}})],1),_vm._v(" "),_c('div',{staticClass:"flex-wrap align-self-end"},[_c('div',{staticClass:"d-inline-flex flex-wrap"},[(!_vm.readonly)?_c('div',{staticClass:"flex-wrap"},[_c('v-btn',{staticClass:"ma-2",attrs:{"depressed":"","small":"","color":"accent"},on:{"click":function($event){_vm.markerXSolution.solutionId = null}}},[_vm._v("\n                    "+_vm._s(_vm.$t('changeSolution'))+"\n                  ")])],1):_vm._e(),_vm._v(" "),(_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; }).isPIM)?_c('div',{staticClass:"solutionSelector flex-wrap"},[_c('v-dialog',{attrs:{"fullscreen":"","transition":"slide-x-reverse-transition"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [(!_vm.$store.state.isOffline)?_c('v-btn',_vm._g({staticClass:"ma-2",attrs:{"small":"","depressed":"","color":"accent"}},on),[_vm._v(_vm._s(_vm.$t('viewSolution')))]):_vm._e()]}}],null,false,3924403442),model:{value:(_vm.pimSolutionDialog),callback:function ($$v) {_vm.pimSolutionDialog=$$v},expression:"pimSolutionDialog"}},[_vm._v(" "),_c('pimSolutionDetails',{attrs:{"id":_vm.markerXSolution.solutionId,"name":_vm.$store.state.productSolutions.find(function (x) { return x.id == _vm.markerXSolution.solutionId; }).name},on:{"close":function($event){_vm.pimSolutionDialog = false}}})],1)],1):_vm._e()])])])],_vm._v(" "),[_c('v-card',{staticClass:"mt-3 mb-3"},[_c('v-container',[_c('transition',{attrs:{"name":"flip","mode":"out-in"}},[(!_vm.$store.state.isOffline)?_c('products',{attrs:{"productSolutionId":_vm.markerXSolution.solutionId,"selectedProducts":_vm.markerXSolution.selectedProducts,"readonly":_vm.readonly},on:{"selected":_vm.selected}}):_vm._e()],1)],1)],1),_vm._v(" "),_c('v-card',[_c('v-container',[_c('v-list',{attrs:{"subheader":"","three-line":""}},[_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("details")))]),_vm._v(" "),_c('v-list-item-subtitle',{class:_vm.markerXSolution.valid ?'orange--text':'',domProps:{"innerHTML":_vm._s(_vm.markerXSolution.valid? _vm.showRequiredMessage() : _vm.attributesToString(_vm.markerXSolution))}})],1),_vm._v(" "),(!_vm.readonly)?_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":_vm.markerXSolution.valid?  'orange':'primary'},on:{"click":function($event){_vm.attributesDialog = true;}}},[_vm._v("fa-edit")])],1):_vm._e()],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-list-item',[_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.$t("dimensions")))]),_vm._v(" "),_c('v-list-item-subtitle',{domProps:{"innerHTML":_vm._s(_vm.dimensionsToString(_vm.markerXSolution))}})],1),_vm._v(" "),(!_vm.readonly)?_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"},on:{"click":function($event){_vm.markerXSolution.dimensionDialog = true}}},[_vm._v("fa-edit")])],1):_vm._e()],1)],1)],1)],1),_vm._v(" "),_c('v-layout',{attrs:{"align-center":"","justify-center":""}}),_vm._v(" "),_c('v-card',{staticClass:"mt-3 mb-3"},[_c('v-container',[_c('v-layout',[_c('v-flex',[_c('div',{staticClass:"subtitle-1"},[_vm._v(_vm._s(_vm.$t('pictures')))]),_vm._v(" "),_c('div',{staticClass:"scroll-container",staticStyle:{"scroll-snap-type":"x"}},[(!_vm.readonly)?_c('addAttachment',{attrs:{"markerXSolution":_vm.markerXSolution},on:{"add-picture":_vm.addPicture}}):_vm._e(),_vm._v(" "),_vm._l((_vm.markerXSolution.attachments),function(attachment,i){return _c('div',{key:'p-'+i,staticClass:"text-truncate"},[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('div',_vm._g({staticClass:"pa-2"},on),[_c('v-img',{staticClass:"white--text",attrs:{"gradient":"to bottom, rgba(0,0,0,.1), rgba(0,0,0,.5)","src":attachment.content,"aspect-ratio":"1","width":"142"},on:{"click":function($event){return _vm.zoomPicture(attachment.content)}},scopedSlots:_vm._u([{key:"placeholder",fn:function(){return [_c('v-row',{staticClass:"fill-height ma-0",attrs:{"align":"center","justify":"center"}},[_c('v-progress-circular',{attrs:{"indeterminate":"","color":"grey lighten-5"}})],1)]},proxy:true}],null,true)},[_c('v-card-actions',{staticClass:"fill-height align-end gradient"},[_c('span',{staticClass:"text-truncate d-inline-block"},[_vm._v(_vm._s(attachment.createdTs.substring(0,10)))]),_vm._v(" "),_c('v-spacer'),_vm._v(" "),(attachment.approved)?_c('v-icon',{attrs:{"color":"success"}},[_vm._v("check_circle")]):_c('v-icon',{attrs:{"color":"red"}},[_vm._v("priority_high")]),_vm._v(" "),(_vm.canDelete(attachment.createdTs) && attachment.new)?_c('v-icon',{attrs:{"color":"red","icon":""},on:{"click":function($event){$event.stopPropagation();return _vm.deletePicture(attachment)}}},[_vm._v("delete")]):(_vm.canDelete(attachment.createdTs) && !_vm.readonly && !_vm.$store.state.isOffline)?_c('areyousure',{attrs:{"icon":"","id":attachment.id,"object":"attachment"},on:{"delete":function($event){return _vm.deletePicture(attachment)}}}):_vm._e()],1)],1)],1)]}}],null,true)},[_vm._v(" "),_c('span',[_vm._v(_vm._s(((attachment.createdBy) + " (" + (attachment.createdTs.substring(0,10)) + ")")))])])],1)})],2)])],1)],1)],1)]],2):_vm._e()]),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('img',{attrs:{"src":_vm.img}})]),_vm._v(" "),_c('v-form',{ref:"form",attrs:{"lazy-validation":""}},[_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.attributesDialog),callback:function ($$v) {_vm.attributesDialog=$$v},expression:"attributesDialog"}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("\n            "+_vm._s(_vm.$t('details'))+"\n            "),_c('v-spacer'),_vm._v(" "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""},on:{"click":_vm.changeImage}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}],null,false,3286728946)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-list")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_attributes')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_vm._l((_vm.$store.state.allAttributes.filter(function (x) { return x.visible; })),function(attribute,i){return [(attribute.qrLogAttributeClass.code == 'list')?_c('div',{key:i},[_c('v-select',{staticClass:"attributeSelectBoxes",attrs:{"menu-props":{ bottom: true, offsetY: true },"value":_vm.bindAttributeSelectbox(attribute),"items":attribute.qrLogAttributeListValue,"item-value":"id","label":attribute.code,"clearable":true,"dense":"","outlined":"","hint":attribute.required ? _vm.$t('required'): '',"persistent-hint":"","validate-on-blur":"","required":attribute.required,"rules":_vm.required(attribute.required),"return-masked-value":""},on:{"change":function($event){return _vm.attributeSelected($event, attribute)}},scopedSlots:_vm._u([{key:"selection",fn:function(data){return [(data.item.description == null)?[_vm._v(_vm._s(data.item.descriptionFallback))]:[_vm._v(_vm._s(data.item.description))]]}},{key:"item",fn:function(data){return [(data.item.description == null)?[_vm._v(_vm._s(data.item.descriptionFallback))]:[_vm._v(_vm._s(data.item.description))]]}}],null,true)})],1):_c('div',{key:i},[_c('v-text-field',{attrs:{"required":attribute.required,"rules":_vm.required(attribute.required),"hint":attribute.required ? _vm.$t('required'): '',"validate-on-blur":"","persistent-hint":"","dense":"","value":_vm.bindAttributeSelectbox(attribute,true),"outlined":"","label":attribute.code},on:{"change":function($event){return _vm.attributeSelected($event, attribute)}}})],1)]})],2),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.attributesDialog = false;_vm.changeImage()}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1),_vm._v(" "),_c('v-dialog',{attrs:{"max-width":"500px"},model:{value:(_vm.markerXSolution.dimensionDialog),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "dimensionDialog", $$v)},expression:"markerXSolution.dimensionDialog"}},[_c('v-card',{attrs:{"outlined":""}},[_c('v-card-title',[_vm._v("\n          "+_vm._s(_vm.$t('dimensions'))+"\n          "),_c('v-menu',{staticClass:"white",staticStyle:{"z-index":"10"},attrs:{"transition":"scale-transition","origin":"right top","close-on-content-click":false,"bottom":"","left":""},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
      var on = ref.on;
return [_c('v-btn',_vm._g({attrs:{"color":"primary","icon":""}},on),[_c('v-icon',[_vm._v("fa-info-circle")])],1)]}}],null,false,3437787158)},[_vm._v(" "),_c('v-sheet',{attrs:{"flatwidth":"600px"}},[_c('v-list',{attrs:{"dense":""}},[_c('v-list-item',[_c('v-list-item-icon',[_c('v-icon',{attrs:{"color":"primary"}},[_vm._v("fa-list")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('info_dimensions')))])],1)],1)],1)],1)],1),_vm._v(" "),_c('v-card-text',[_c('v-text-field',{attrs:{"dense":"","outlined":"","type":"number","label":_vm.$t('amount')},model:{value:(_vm.markerXSolution.amount),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "amount", $$v)},expression:"markerXSolution.amount"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.$t('unit'),"box":""},model:{value:(_vm.markerXSolution.unit),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "unit", $$v)},expression:"markerXSolution.unit"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.$t('width'),"type":"number"},model:{value:(_vm.markerXSolution.width),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "width", $$v)},expression:"markerXSolution.width"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.$t('height'),"type":"number"},model:{value:(_vm.markerXSolution.height),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "height", $$v)},expression:"markerXSolution.height"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.$t('length'),"type":"number"},model:{value:(_vm.markerXSolution.length),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "length", $$v)},expression:"markerXSolution.length"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","label":_vm.$t('diameter'),"type":"number"},model:{value:(_vm.markerXSolution.diameter),callback:function ($$v) {_vm.$set(_vm.markerXSolution, "diameter", $$v)},expression:"markerXSolution.diameter"}})],1),_vm._v(" "),_c('v-card-actions',[_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){_vm.markerXSolution.dimensionDialog = false}}},[_vm._v(_vm._s(_vm.$t('close')))])],1)],1)],1)],1)],1):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__ = __webpack_require__(312);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c847ae2a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__ = __webpack_require__(736);
function injectStyle (ssrContext) {
  __webpack_require__(735)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PasswordReset_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c847ae2a_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PasswordReset_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 735 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-content',[_c('v-container',{staticClass:"fill-height"},[(_vm.validToken)?_c('v-card',{staticClass:"d-flex mx-auto flex-wrap",staticStyle:{"margin-top":"2%"},attrs:{"flat":"","min-width":"360","tile":""}},[_c('v-form',{ref:"formpswd",staticStyle:{"width":"100%"},on:{"submit":function($event){$event.preventDefault();return _vm.submit($event)}},model:{value:(_vm.validpswd),callback:function ($$v) {_vm.validpswd=$$v},expression:"validpswd"}},[_c('v-card-title',[_c('img',{staticClass:"mr-3",attrs:{"width":"55","height":"55","src":__webpack_require__(110)}}),_vm._v(" "),_c('span',{staticClass:"title font-weight-light"},[_vm._v("FIRELOG")])]),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-title',[_c('span',{staticClass:"title font-weight-bold"},[_vm._v(_vm._s(_vm.$t('resetPassword')))])]),_vm._v(" "),_c('div',{staticClass:"container"},[_c('v-text-field',{attrs:{"dense":"","outlined":"","type":"password","rules":[function () { return !!_vm.newpwd || ''; }, function () { return (this$1.newpwd !== this$1.currentpwd) || 'Password must be new'; }, function () { return ( /(?=.{8,})/.test(this$1.newpwd) || 'password weak'); }],"label":_vm.$t('newPassword'),"required":""},model:{value:(_vm.newpwd),callback:function ($$v) {_vm.newpwd=$$v},expression:"newpwd"}}),_vm._v(" "),_c('v-text-field',{attrs:{"dense":"","outlined":"","type":"password","rules":[function () { return !!_vm.confirmpwd || ''; }, function () { return (this$1.newpwd === this$1.confirmpwd) || ''; }],"label":_vm.$t('confirmPassword'),"required":""},model:{value:(_vm.confirmpwd),callback:function ($$v) {_vm.confirmpwd=$$v},expression:"confirmpwd"}})],1),_vm._v(" "),_c('v-divider'),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":_vm.changePassword}},[_vm._v(_vm._s(_vm.$t("save")))])],1)],1)],1):_vm._e()],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 737 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__(313);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f5cf83c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__(739);
function injectStyle (ssrContext) {
  __webpack_require__(738)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9f5cf83c_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 738 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-card',[_c('v-card-title',[_c('span',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('termsOfService')))])]),_vm._v(" "),_c('v-card-text',{staticStyle:{"height":"500px"}},[_c('iframe',{staticStyle:{"height":"500px"},attrs:{"width":"100%","src":_vm.legalDocument}}),_vm._v(" "),_c('div',{attrs:{"id":"example1"}})]),_vm._v(" "),_c('v-card-actions',[_c('v-checkbox',{attrs:{"label":_vm.$t('readAndAccepted'),"required":""},model:{value:(_vm.read),callback:function ($$v) {_vm.read=$$v},expression:"read"}}),_vm._v(" "),_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"x-large":"","depressed":"","color":"green darken-1 white--text","disabled":!_vm.read},on:{"click":_vm.acceptTermsOfService}},[_vm._v(_vm._s(_vm.$t('agree')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 740 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(741);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);



__WEBPACK_IMPORTED_MODULE_0_vue__["default"].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vuetify___default.a({
    icons: {
        iconfont: 'mdi'
    },
    theme: {
        themes: {
            light: {
                primary: '#0a3051',
                secondary: '#009bd9',
                highlight: "#296C9A",
                searchbar: "#005087",
                accent: '#85c9f0',
                error: '#f44336',
                success: '#176e4b',
                warning: '#a16c21'
            }
        }
    }
}));

/***/ }),
/* 741 */,
/* 742 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(44);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);


var _EN, _NL, _DE, _NN;

var locales = {
    EN: (_EN = {
        name: "Name",
        building: "Building name",
        description: "Description",
        order: "Order",
        status: "Status",
        actions: "Actions",
        marker: "Marker",
        markerName: "Marker name",
        buildingComponent: "BuildingComponent",
        buildingComponents: "BuildingComponents",
        createdTs: "Creation date",
        blueprints: "Blueprints",
        markers: "Markers",
        markUp: "Manage markers on blueprint",
        values: "Values",
        inUse: "In Use",
        firstname: "First name"
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "building", "Building name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "marker", "Marker name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "description", "Description"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "street", "Street"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "number", "No."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "postalcode", "Postcal code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "city", "City"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "country", "Country"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "mobile", "Mobile"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "email", "Email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "applicationDate", "Application date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "date", "Date"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "order", "Order"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "class", "Class"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "attribute", "Attribute"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "attributes", "Attributes"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "value", "value"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "installer", "Installer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "solution", "Solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "solutions", "Solutions"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "username", "Username"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "password", "Password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "uploadBlueprintFile", "Upload blueprint file with minimum resolution 640x480 (.jpg , .pdf file)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "comments", "Comments"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "products", "Products"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "approved", "Approved"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "broken", "Broken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "dimensions", "Dimensions"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "width", "Width (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "height", "Height (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "length", "Wall  thickness (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "diameter", "Diameter (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "unit", "Unit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "amount", "Amount"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "details", "Details"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "required", "is required"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "invalid", "is invalid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "warning", "Warning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "qrIdExists", "Error"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "success", "Success"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "cached", "Offline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "saveChanges", "Save changes?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "overrideQRId", "This service penetration is already linked with a qr code.Do you want to assign it with a new qr code?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "qrIdExists", "This qr code can not be applied. A different service penetration uses this qr code!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "success", "This qr code is successfully linked with this service penetration!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "areYouSure", "Are you sure you want to delete this?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "cached", "This services penetration will be linked once you go online"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "unsaved", "Changes were made. Do you want to save changes?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "yes", "Yes"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "no", "No"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "currentPassword", "Current password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newPassword", "New password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "confirmPassword", "Confirm password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "changePassword", "Change password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "active", "Active"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noBlueprint", "I currently don't have a blueprint"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "deadline", "Deadline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newProject", "New Project"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newBuildingComponent", "New Building Component"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newBlueprint", "New Blueprint"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "save", "Save"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "add", "Add"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "close", "Close"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "login", "Sign in"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newInstaller", "Add installer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "addPicture", "Add picture"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newSolution", "Add solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "addQRCode", "Link QR code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "offline", "Offline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "addMarkers", "Add Markers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "cancel", "Cancel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "download", "download"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "edit", "Edit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "addProduct", "Add product"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "home", "Home"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "projects", "Projects"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "buildingComponents", "Building Components"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "blueprints", "Blueprints"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "markers", "Markers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "project", "Project"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "buildingComponent", "Building Component"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "blueprint", "Blueprint"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "marker", "Marker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "address", "Address"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "contact", "Contact"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "settings", "Settings"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "back", "Back"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "installer", "Installer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "users", "Users"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "camera", "Camera"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "solutions", "Solutions"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "solution", "Solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "products", "Products"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "product", "Product"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "todo", "To-do"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "todos", "To-dos"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "myTodos", "My to-dos"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "todosForInstallers", "to-dos for installers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "userNotFound", "The password you entered is incorrect."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "selectSolution", "Please select a solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "success", "Success"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "error", "Something went wrong"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "cached", "Changes will be saved once you are online"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "unsaved", "Changes were made, don't forget to save before you leave."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "offlineUsers", "is working offline on blueprint: "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "notOnline", "Connection lost. Please connect to the internet"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "inReadOnly", "Currently in readonly mode. Click edit to make changes."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newSolution", "New Solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "chooseSolution", "Choose a solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "draw", "Draw on the blueprint to create a marker!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "wait1", "Loading... This may take a few moments..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "wait2", "Preparing Final Form"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "deadline", "Deadline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "reports", "Reports"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "archivedReports", "Old reports"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "qrcodeNotLinked", "This qr code is not yet linked, or is linked with markers not on this blueprint."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "scanQRCode", "Scan a linked QR code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "attachment", "Attachment"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "isEditing", "Is editing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "editStart", "Started editing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noaccess", "No access"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "fillinrequiredfields", "Fill in the required fields"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "withlogo", "With logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "withoutlogo", "Without logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "search", "Search"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "chooseFile", "Choose file (5MB max)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "continuereadonly", "Someone is working on this blueprint. Do you still want to visit the page without having the ability to edit?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "blueprintLocked", "is busy editing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "blueprintLockedSince", "is busy editing since"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "takeOver", "Take over"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "customsolutions", "Custom solutions"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noproducts", "No products"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "addpicture", "Add picture"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "help", "Help"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noresults", "No results"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "signout", "Sign out"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "viewMore", "View more"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "usethisinmarker", "Use this in marker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "addyourownlogo", "add you own logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "delete", 'delete'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "step", 'Step'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "application", 'Application'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "solutionselector", 'Solution Selector'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "selectsolution", 'Select Solution'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "inProcess", 'In process'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "solutionsList", "Solutions list"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "deleteSolution", "Delete solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "selectUsedProducts", "Select used products"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "showAll", "Show all"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "new", "New"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "useSolutionSelector", 'Find solution using the solution selector'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "orUseDropdown", 'Or find it in the list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "useDropdown", 'Find solution in the list'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_broken", "Markers with their latest image with status broken uploaded. Meaning that the penetration seals are broken."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_inProcess", "Markers that have no images, but some details and information are filled in."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_approved", "Markers that have the penetration seal installed correctly."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_new", "Newly created markers, markers with no info filled in or no images uploaded."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_solutions_list", "You can have multiple penetration seals (solutions) in one marker point."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_attributes", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_dimensions", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_marker_details", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_solution_details", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_custom_solutions", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_firelog_solutions", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_attributes", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "showBlueprintImage", "Show Blueprint Image"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "changeImage", "change image"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newAttribute", "New Attribute"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "enterTheNameOfYourCustomSolution", "Enter the name of your custom solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "yourProducts", "List of your products"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "enterTheNameOfYourProductAndClickThePlusSignToAddToTheList", "Enter the name of your product and click the plus sign to add to the list."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "changeSolution", "change solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "viewSolution", "View solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "notLinked", "Not linked with QR code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "linked", "Linked with QR code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "open", "Open"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "archive", "archive"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "restore", "restore"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "archivedProjects", "Archived Projects"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "pictures", "Pictures"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "discard", "discard"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "findInList", "Search in list"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "findInSolutionSelector", "Search in Solution Selector"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "uploadBlueprintImage", "Upload"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "networkIssues", "Network issue"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "checkConnectionAndTryAgain", "Check your connection and try again"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "retry", 'Retry'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noBlueprints", 'No blueprints'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noProjects", 'No projects'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noBuildingComponents", 'No building components'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noArchivedProjects", 'No archived projects'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noCustomSolutions", 'No custom solutions'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "projectDetails", "Project info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "buildingComponentDetails", "Building info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "user", "user"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newUser", "new user"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "breakLock", "lock"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "changeLogo", "change logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "vat", "VAT number"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "requestTrial", "Request a free trial"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "freeDemo", "Free Trial"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "company", "Company"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "demoRegistrationSuccessful", "Trial request received"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "requestReceived", "Request received"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "contactYou", "Thanks for your interest in Firelog. A representative will be in touch shortly to schedule your interactive demo."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "firstFloor", "example: First floor"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "blockA", "example: Block A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "takealook", "All-in-one software for Fire-resistant sealing registration & reporting"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "manufacturerIndepentent", "Independent from any Manufacturer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "multiplesealsonmarker", "Less administration, better focus on workload, faster documenting your fire protection sealings of a building"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "anydevice", "All functionality available on any device (PC, Tablet, smartphone both IOS & Android supported)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "multilanguage", "Highly Customizable tailored to the customer needs"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "highlyCustomizable", "Easy, fast & always accessible"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "requestADemo", "Request a demo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "signup", "Sign up"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "activeProjects", "Active projects"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "profile", "Profile"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "license", "License"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "storage", "Storage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "chooseYourPartner", "Choose your partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "partner", "partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noPartner", "No partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "requestTrialFourteenDays", "Register for a 14-days free trial account"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "itemsPerPage", "Items per page"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "belgium", "Belgium"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "unitedKingdom", "United Kingdom"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "germany", "Germany"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "austria", "Austria"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "romania", "Romania"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "sweden", "Sweden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "hungary", "Hungary"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "netherlands", "Netherlands"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "norway", "Norway"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "switzerland", "Switzerland"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "spain", "Spain"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "downloadLogbook", "Download logbook"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "saveMarkerPosition", "Save markers position"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newMarker", "Add new marker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "fullscreen", "Fullscreen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "noLogin", "I don't have an account"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "report", "Report a problem"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "send", "Send"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "checkInbox", "Check your inbox."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "resetPasswordInstruction", "You will receive an email with further instructions."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "resetPassword", "Reset password"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "forgotPassword", "Forgot password?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "areyouSureYouWantToUpgrade", "Are you sure you want to add AMOUNT GB for PRICE per month?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "perMonth", "Per month"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "chooseHowMuchStorageYouWantToAdd", "Choose how much storage you want to add. Notice: You can have up to 40 GB storage in total. Want more? Please contact us."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "addStorage", "Add storage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "manageUsers", "Select which projects, building components and blueprints this person can access."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "properties", "Properties"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "termsOfService", "Terms of Services"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "readAndAccepted", "I have read and accepted the Terms of Use and Privacy Policy."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "agree", "Agree"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "contactFunction", "Function"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "contactEmail", "Contact email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "contactEmailHint", "We will contact you on this email address."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "loginEmail", "Login email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "loginEmailHint", "Email address which you can log in with."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "loginAlreadyExist", "Login email is already been used."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "whatsnew", "What's new"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "deleteBlueprintImage", "Delete blueprint image"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, '7profile', "Admin"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, '8profile', "Read-only"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, '14profile', "Installer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, '15profile', "No access"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "clone", "Clone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "cloneAttributeWithValues", "Clone this attribute with underlying values?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "giveADifferentName", "Enter a different name than the original"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "ignore", "Ignore"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "areyousureyouwanttoignorethis", "Are you sure you want to ignore this?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "addReportToThisSolution", "Add report to this solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_delete_attribute", "You can delete attributes or values if you have made them yourself and if they haven't been used yet on a marker."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_clone_attribute", "You can clone attributes with their underlying values so that you don't have to create new ones."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_sync_attribute", "This will sync the standard firelog attributes and values. It is recommended to this once in a while."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_drag_attribute", "You can change the order by holdclicking and draging it to the correct position."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "info_star_attribute", "Standard attributes and values from Firelog"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "newReports", "New reports"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "moveMarker", "Move markers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "markerLabel", "Custom marker name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "blueprintSeparated", "Blueprint image separated"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "blueprintSeparatedHint", "Get your blueprint image with markers separated in high quality (.jpg)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "withDocuments", "Include documents"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "withDocumentsHint", "Certificates, data sheets,... This can take more time"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "selectYourPage", "Select your page"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "downloadlogbookasaWordFile", "Download logbook as a Word file"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "takingSnapshot", "Taking a snapshot of blueprint image"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "modifiedBy", "Modified by"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "installPWA", "Install Firelog on your device: tap on "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "addToHomeScreen", "and then Add to homescreen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "readyForOffline", "Ready for offline, turn off your wifi/4g to work offline and turn it back on once you are done."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_EN, "goOnline", "Don't forget to connect to the internet to save your changes. Don't refresh or close the app."), _EN),
    NL: (_NL = {
        building: "Naam gebouw",
        description: "Beschrijving",
        order: "Volgorde",
        status: "Status",
        actions: "Acties",
        marker: "Marker",
        markerName: "Markernaam",
        buildingComponent: "Bouwdeel",
        buildingComponents: "Bouwdelen",
        createdTs: "Aanmaakdatum",
        blueprints: "Bouwplannen",
        markers: "Markers",
        markUp: "Beheer markers op bouwplan",
        values: "Waarden",
        inUse: "In gebruik",
        name: "Naam",
        firstname: "Voornaam"
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "building", "Naam gebouw"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "marker", "Markernaam"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "street", "Straat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "number", "nummer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "postalcode", "Postcode"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "city", "Stad"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "country", "Land"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "mobile", "GSM"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "email", "Email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "applicationDate", "Applicatie datum"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "date", "Datum"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "order", "Volgorde"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "class", "Klasse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "attribute", "Attribuut"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "attributes", "Attributen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "installer", "Monteur"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "users", "Gebruikers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "solution", "Oplossing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "solutions", "Oplossingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "username", "Gebruikersnaam"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "password", "Wachtwoord"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "uploadBlueprintFile", "Upload bouwplan afbeelding met minimum resolution 640x480 (.jpg .pdf bestand)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "comments", "Commentaar"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "products", "Producten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "approved", "Goedgekeurd"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "broken", "Gebroken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "dimensions", "Afmetingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "width", "Breedte (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "height", "Hoogte (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "length", "Wanddikte (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "diameter", "Diameter (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "unit", "Eenheid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "amount", "Aantal"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "details", "Gegevens"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "required", "is vereist."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "warning", "Opgelet"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "qrIdExists", "Error"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "success", "Voltooid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "cached", "Geen verbinding"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "saveChanges", "Wijzigingen opslaan?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "overrideQRId", "Deze doorvoering is al gelinkt met een qr code. Wil je een nieuwe toevoegen?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "qrIdExists", "Deze qr code is al gelinkt met een andere doorvoering!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "success", "Qr code is succesvol gelinkt!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "areYouSure", "Ben je zeker dat je dit wil verwijderen?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "cached", "Deze doorvoering zal worden opgeslagen eens je online verbonden bent."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "unsaved", "Er zijn wijzigingen aangebracht. Wilt u de wijzigingen opslaan?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "yes", "Ja"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "no", "Neen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "currentPassword", "Huidig wachtwoord"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newPassword", "Nieuw wachtwoord"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "confirmPassword", "Wachtwoord bevestigen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "changePassword", "Wachtwoord wijzigen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "active", "Actief"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noBlueprint", "Voorlopig heb ik geen bouwplan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "deadline", "Deadline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newProject", "Nieuw Project"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newBuildingComponent", "Nieuw Bouwdeel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newBlueprint", "Nieuw Bouwplan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "save", "Opslaan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "add", "Toevoegen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "close", "Sluiten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "login", "Aanmelden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "addPicture", "Voeg foto toe"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newInstaller", "Monteur aanmaken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newSolution", "Oplossing Aanmaken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "addQRCode", "Link QR code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "offline", "Offline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "addMarkers", "Markers toevoegen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "cancel", "Annuleren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "download", "downloaden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "edit", "Bewerken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "addProduct", "Product toevoegen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "home", "Home"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "projects", "Projecten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "buildingComponents", "Bouwdelen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "blueprints", "Bouwplannen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "markers", "Markers"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "project", "Project"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "buildingComponent", "Bouwdeel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "blueprint", "Bouwplan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "marker", "Marker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "address", "Adres"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "contact", "Contact"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "settings", "Instellingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "solutions", "Oplossingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "solution", "Oplossing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "products", "Producten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "product", "Product"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "todo", "Te doen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "todos", "Taken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "myTodos", "Mijn taken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "todosForInstallers", "Taken voor monteurs"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newSolution", "Nieuwe oplossing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "chooseSolution", "Kies een oplossing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "draw", "Teken op het bouwplan om een marker toe te voegen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "wait1", "Laden... Dit kan enkele momenten duren..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "wait2", "Preparing Final Form"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "userNotFound", "Het ingevoerde wachtwoord is onjuist"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "selectSolution", "Gelieve een oplossing te selecteren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "success", "Succes"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "error", "Error"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "cached", "Wijzigingen worden opgeslagen eens je online verbonden bent."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "unsaved", "Er zijn wijzigingen aangebracht, vergeet niet op te slaan voordat u vertrekt."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "offlineUsers", "werkt offline op bouwplan: "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "notOnline", "Maak verbinding met internet"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "inReadOnly", "Momenteel in readonly modus. klik op bewerken om wijzigingen aan te brengen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "deadline", "Deadline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "reports", "Meldingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "archivedReports", "Oude meldingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "scanQRCode", "Een gelinkte QR code scannen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "qrcodeNotLinked", "Deze qr code is nog niet gelinkt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "attachment", "Bijlage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "isEditing", "Bezig met bewerken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "editStart", "Begon met bewerken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noaccess", "Geen toegang"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "fillinrequiredfields", "Vul de verplichte velden in"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "withlogo", "Met logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "withoutlogo", "Zonder logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "search", "Zoeken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "chooseFile", "Kies bestand (5MB max)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "continuereadonly", "Iemand is bezig met bewerken op dit bouwplan. Wilt u de pagina nog steeds bezoeken zonder de mogelijkheid te hebben om te bewerken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "blueprintLocked", "is bezig met bewerken"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "blueprintLockedSince", "is bezig met bewerken sinds"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "takeOver", "Overnemen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "customsolutions", "Eigen oplossingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noproducts", "Geen producten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "addpicture", "Foto toevoegoen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "help", "Help"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noresults", "Geen resultaten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "signout", "Uitloggen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "viewMore", "Zie meer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "usethisinmarker", "Gebruik dit in marker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "addyourownlogo", "voeg uw eigen logo toe"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "delete", 'verwijderen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "step", 'Stap'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "application", 'Installatie instructies'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "solutionselector", 'Solution Selector'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "selectsolution", 'Kies een oplossing'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "inProcess", 'In bewerking'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "solutionsList", "Lijst oplossingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "deleteSolution", "Oplossing verwijderen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "selectUsedProducts", "Selecteer gebruikte producten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "showAll", "Toon alles"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "new", "Nieuw"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "useSolutionSelector", 'Zoek de juiste oplossing met behulp van de solution selector'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "orUseDropdown", 'Of zoek in de lijst'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "useDropdown", 'Selecteer de juiste oplossing in deze lijst'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_broken", "Marker die minstens 1 gebroken doorvoering heeft."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_inProcess", "Markeringen zonder afbeeldingen, maar sommige zaken zijn ingevuld."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_approved", "Doorvoeringen die correct zijn geïnstalleerd."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_new", "Nieuw gemaakte markers. Markers zonder ingevulde info en geen afbeeldingen geüpload."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_solutions_list", "U kunt meerdere doorvoeringen (oplossingen) op een marker hebben."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_attributes", ""), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "showBlueprintImage", "Bouwplan afbeelding openen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "changeImage", "afbeelding wijzigen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newAttribute", "Nieuw attribuut"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "enterTheNameOfYourCustomSolution", "Vul de naam van jouw oplossing in"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "yourProducts", "Lijst van jouw producten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "enterTheNameOfYourProductAndClickThePlusSignToAddToTheList", "Vul de naam van jouw product in and klik op het plustekentje om toe te voegen in de lijst"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "changeSolution", "oplossing wijzigen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "viewSolution", "oplossing weergeven"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "notLinked", "Niet gekoppeld met qr-code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "linked", "Gekoppeld met qr-code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "open", "Weergeven"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "archive", "archiveren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "restore", "herstellen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "archivedProjects", "Gearchiveerde projecten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "pictures", "Afbeeldingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "discard", "Annuleren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "findInList", "Zoek in lijst"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "findInSolutionSelector", "Zoek in Solution Selector"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "uploadBlueprintImage", "Uploaden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "networkIssues", "Netwerk probleem"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "checkConnectionAndTryAgain", "Controleer uw verbinding en probeer opnieuw"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "retry", 'opnieuw proberen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noBlueprints", 'Geen bouwplannen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noProjects", 'Geen projecten'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noBuildingComponents", 'Geen bouwdelen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noArchivedProjects", 'Geen gearchiveerde projecten'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noCustomSolutions", 'Geen eigen oplossingen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "projectDetails", "Project info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "buildingComponentDetails", "Bouwdeel info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "user", "gebruiker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newUser", "nieuwe gebruiker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "breakLock", "slot"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "changeLogo", "logo wijzigen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "vat", "BTW-nummer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "requestTrial", "Vraag gratis test toegang aan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "freeDemo", "Gratis proefperiode"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "company", "Bedrijf"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "firstFloor", "vb: Eerste verdieping"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "blockA", "vb: Block A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "demoRegistrationSuccessful", "Proefperiode-aanvraag ontvangen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "requestReceived", "Aanvraag ontvangen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "contactYou", "Bedankt voor uw interesse in Firelog. Binnenkort neemt een medewerker contact met u op om uw interactieve demo in te plannen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "takealook", "Zie hoe u brandwerende afdichtingen kunt registreren met Firelog"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "manufacturerIndepentent", "Onafhankelijk van alle fabrikanten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "multiplesealsonmarker", "Minder administratie, sneller documenteren van uw brandwerende afdichtingen van een gebouw"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "anydevice", "Beschikbaar op elk apparaat (pc, tablet, smartphone, zowel IOS als Android ondersteund)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "multilanguage", "Gemakkelijk en snel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "highlyCustomizable", "Eenvoudig instelbaar op maat van de klant"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "requestADemo", "Vraag een demo aan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "signup", "Inschrijven"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "activeProjects", "Actieve projecten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "profile", "Profiel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "license", "Licentie"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "storage", "Opslag"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "chooseYourPartner", "Bent u reeds klant bij één van onze partners? Gelieve aan te geven wat van toepassing is"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "partner", "partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noPartner", "Geen partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "requestTrialFourteenDays", "Registreer nu voor een gratis testtoegang van 14 dagen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "itemsPerPage", "Items per pagina"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "belgium", "België"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "unitedKingdom", "Verenigd Koninkrijk"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "germany", "Duitsland"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "austria", "Oostenrijk"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "romania", "Roemenië"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "sweden", "Zweden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "hungary", "Hongarije"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "netherlands", "Nederland"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "norway", "Noorwegen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "switzerland", "Zwitserland"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "spain", "Spanje"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "downloadLogbook", "Logboek downloaden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "saveMarkerPosition", "Markeerpositie opslaan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newMarker", "Nieuwe marker toevoegen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "fullscreen", "Volledig scherm"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "noLogin", "Ik heb geen account"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "report", "Probleem melden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "send", "Versturen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "checkInbox", "Controleer je inbox."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "resetPasswordInstruction", "Je zal een e-mail ontvangen met verdere instructies."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "resetPassword", "Wachtwoord resetten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "forgotPassword", "Wachtwoord vergeten?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "areyouSureYouWantToUpgrade", "Weet u zeker dat u AMOUNT GB voor PRICE per maand wilt toevoegen?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "perMonth", "Per maand"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "chooseHowMuchStorageYouWantToAdd", "Kies hoeveel opslagruimte je wilt toevoegen. Opmerking: u kunt in totaal maximaal 40 GB aan opslagruimte hebben. Wilt u meer? Gelieve ons te contacteren."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "addStorage", "Opslag toevoegen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "manageUsers", "Selecteer tot welke projecten, bouwdelen en bouwplannen deze persoon toegang heeft."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "properties", "Eigenschappen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "termsOfService", "Servicevoorwaarden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "readAndAccepted", "Ik heb de gebruiksvoorwaarden en het privacybeleid gelezen en geaccepteerd."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "agree", "Akkoord gaan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "contactFunction", "Fuctie"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "contactEmail", "Contact email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "contactEmailHint", "We nemen contact met u op via deze e-mail."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "loginEmail", "Login email"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "loginEmailHint", "Emailadres waarmee u kunt inloggen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "loginAlreadyExist", "E-mailadres voor inloggen is al gebruikt."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "whatsnew", "Wat is er nieuw"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "deleteBlueprintImage", "Bouwplan afbeelding verwijderen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, '7profile', "Admin"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, '8profile', "Alleen lezen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, '14profile', "Monteur"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, '15profile', "Geen toegang"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "clone", "Klonen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "cloneAttributeWithValues", "Kloon dit attribuut met onderliggende waarden?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "giveADifferentName", "Voer een andere naam in dan het origineel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "ignore", "Negeren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "areyousureyouwanttoignorethis", "Ben je zeker dat je dit wil negeren?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_delete_attribute", "U kunt attributen verwijderen als u ze zelf heeft gemaakt en als ze nog niet zijn gebruikt op een marker."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_clone_attribute", "U kunt attributen klonen met hun onderliggende waarden, zodat u niet handmatig nieuwe hoeft te maken."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_sync_attribute", "Hiermee worden de standaard attributen en waarden van firelog gesynchroniseerd. Het wordt aanbevolen om dit af en toe te doen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_drag_attribute", "U kunt de volgorde wijzigen door erop te klikken en deze naar de juiste positie te slepen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "info_star_attribute", "Standaardattributen en waarden van Firelog"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "newReports", "Nieuwe meldingen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "moveMarker", "Markers verplaatsen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "markerLabel", "Eigen marker naam"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "blueprintSeparated", "Bouwplan afbeelding gescheiden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "blueprintSeparatedHint", "Krijg uw bouwplan afbeelding met markeringen gescheiden in hoge kwaliteit (.jpg)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "withDocuments", "Met documenten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "withDocumentsHint", "Certificaten, data sheets, ... dit kan langer duren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "selectYourPage", "Selecteer pagina"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "downloadlogbookasaWordFile", "Logbook downloaden als Word document"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "takingSnapshot", "Momentopname nemen van bouwplan afbeelding"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "modifiedBy", "Aangepast door"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "installPWA", "Installeer Firelog op uw apparaat: klik op "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "addToHomeScreen", "en dan toevoegen aan Startscherm"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "readyForOffline", "Klaar voor offline, zet je wifi / 4g uit om offline te werken en zet hem weer aan als je klaar bent."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NL, "goOnline", "Vergeet niet om verbinding te maken met het internet om uw wijzigingen op te slaan. Vernieuw of sluit de app niet."), _NL),
    DE: (_DE = {
        name: "Name",
        building: "Gebäudename",
        description: "Beschreibung",
        order: "Reihenfolge",
        status: "Status",
        actions: "Tätigkeiten",
        marker: "Markierung",
        markerName: "Markierungsbezeichnung",
        buildingComponent: "Bauabschnitt",
        buildingComponents: "Bauabschnitte",
        createdTs: "Eingabedatum",
        blueprints: "Geschosse",
        markers: "Markierungen",
        markUp: "Markierung im Bauplan setzen",
        values: "Wert",
        inUse: "In Gebrauch"
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "name", "Name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "firstname", "Vorname"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "building", "Gebäudename"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "marker", "Markierungsbezeichnung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "description", "Beschreibung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "street", "Straße"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "number", "Nummer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "postalcode", "PLZ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "city", "Ort"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "country", "Land"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "mobile", "Handynummer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "email", "Emailadresse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "applicationDate", "Montagedatum"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "date", "Datum"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "order", "Reihenfolge"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "class", "Klasse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "attribute", "Eigenschaft"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "attributes", "Eigenschaften"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "value", "Wert"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "installer", "Monteur"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "solution", "Lösung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "solutions", "Lösungen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "username", "Benutzername"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "password", "Passwort"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "uploadBlueprintFile", "Hochladen von bauplan bild mit einer Mindestauflösung von 640 x 480 (.jpg .pdf Datei)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "comments", "Kommentare"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "products", "Produkte"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "approved", "Genehmigt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "broken", "Defekt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "dimensions", "Abmessungen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "width", "Breite (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "height", "Höhe (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "length", "Wanddicke (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "diameter", "Durchmesser (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "unit", "Einheit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "amount", "Menge"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "details", "Details"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "required", "vorgeschrieben"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "invalid", "ungültig"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "overrideQRId", "Achtung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "qrIdExists", "Dieser QR Code kann nicht genutzt werden. Eine andere Abschottung hat bereits diesen QR Code zugewiesen bekommen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "success", "Erfolgreich"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "saveChanges", "Änderungen sichern?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "overrideQRId", "Diese Abschottung ist bereits mit einem QR Code verknüpft. Möchten Sie der Abschottung einen neuen QR Code zuordnen?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "qrIdExists", "Dieser qr Code kann nicht genutzt werden. Eine andere Abschottung hat bereits diesen qr Code."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "success", "Der qr Code wurde erfolgreich mit der Abschottung verknüpft."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "areYouSure", "Sind Sie sicher das Sie diese Angabe löschen möchten?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "cached", "Diese Abschottung wird verknüft sobald sie wieder Online sind."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "unsaved", "Änderungen erfolgreich. Möchten Sie die Änderungen speichern?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "yes", "Ja"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "no", "Nein"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "currentPassword", "Aktuelles Passwort"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newPassword", "Neues Passwort"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "confirmPassword", "Passwort bestätigen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "changePassword", "Passwort ändern"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "active", "Activ"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noBlueprint", "Aktuell gibt es keine Baupläne."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "deadline", "Fertigstellungsdatum"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newProject", "Neues Projekt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newBuildingComponent", "Neuer Bauabschnitt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newBlueprint", "Neues Stockwerk/ Etage"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "save", "Speichern"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "add", "Ergänzen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "close", "Schließen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "login", "Einloggen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newInstaller", "Monteur hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "addPicture", "Bild hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newSolution", "Lösung hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "addQRCode", "Link QR code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "offline", "Offline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "addMarkers", "Marker hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "cancel", "Stornieren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "download", "Download"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "edit", "Bearbeiten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "addProduct", "Product hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "home", "Home"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "projects", "Projekte"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "buildingComponents", "Bauabschnitte"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "markers", "Markierung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "project", "Projekt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "buildingComponent", "Bauabschnitt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "blueprint", "Bauplan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "marker", "Markierung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "address", "Adresse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "contact", "Kontakt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "settings", "Einstellungen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "back", "Zurück"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "installer", "Monteur"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "users", "Benutzer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "camera", "Kamera"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "solutions", "Lösungen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "solution", "Lösung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "products", "Produkte"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "product", "Produkt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "userNotFound", "Das eigegebene Passwort ist nicht korrekt."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "selectSolution", "Bitte wählen Sie eine Lösung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "success", "Erfolgreicht"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "error", "Etwas ist schief gegangen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "cached", "Änderungen werden gespeichert sobald Sie Online sind. "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "unsaved", "Änderungen sind eingegeben, bitte vergessen Sie nicht diese zu speichern bevor Sie das Programm verlassen. "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "offlineUsers", "Arbeitet Offline am Bauplan: "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "notOnline", "Bitte verbinden Sie sich mit dem Internet"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "inReadOnly", "Derzeit schreibgeschützt. Klicken Sie auf Bearbeiten, um Änderungen vorzunehmen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newSolution", "Neue Lösung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "chooseSolution", "Wählen Sie eine Lösung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "draw", "Klicken Sie auf den Bauplan um den Marker zu setzen. "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "wait1", "Lädt... Dies kann einige Momente dauern ..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "wait2", "Finale Vorlage wird erstellt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "todo", "Zu machen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "todos", "Aufgaben"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "myTodos", "Mein aufgaben"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "todosForInstallers", "Aufgaben für Monteure"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "reports", "Meldungen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "archivedReports", "Alte meldungen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "qrcodeNotLinked", "Dieser QR Code ist nicht verknüpft oder mit Markierungen verbunden die sich nicht auf diesem Bauplan befinden. "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "scanQRCode", "Einen bereits verknüpften QR Code scannen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "attachment", "Anhang"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "isEditing", "in Bearbeitung"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "editStart", "Bearbeitung gestartet"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noaccess", "kein Zugang"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "fillinrequiredfields", "Füllen Sie die erforderlichen Felder aus"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "withlogo", "Mit logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "withoutlogo", "Ohne logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "search", "Suchen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "chooseFile", "Datei wählen (5MB max)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "continuereadonly", "Jemand bearbeitet diese Bauplan. Möchten Sie die Seite trotzdem besuchen, ohne die Möglichkeit zu haben, sie zu bearbeiten?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "blueprintLocked", "arbeitet an diese Blauplan"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "blueprintLockedSince", "arbeitet an diese Blauplan seit"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "takeOver", "Übernehmen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "customsolutions", "Eigene Lösungen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noproducts", "Keine Produkte"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "addpicture", "Bild hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "help", "Hilfe"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noresults", "Keine Ergebnisse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "signout", "Abmelden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "viewMore", "Mehr sehen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "usethisinmarker", "Benutze dies in marker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "addyourownlogo", "Fügen Sie Ihr eigenes Logo hinzu"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "delete", "Löschen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "step", 'Schritt'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "application", 'Installationsanleitung'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "solutionselector", 'Solution Selector'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "selectsolution", 'Wählen Sie eine Lösung'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "inProcess", 'In Bearbeitung'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "solutionsList", "Lösungsliste"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "deleteSolution", "Lösung löschen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "selectUsedProducts", "Gebrauchte Produkte auswählen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "showAll", "Zeige alles"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "new", "Neu"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "useSolutionSelector", 'Finden Sie die richtige Lösung mit dem solution selector'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "orUseDropdown", 'Oder durchsuchen Sie die Liste'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "useDropdown", 'Wählen Sie die richtige Lösung aus dieser Liste'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_broken", "Markierung, bei dem das System als „defekt“ bezeichnet  ist"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_inProcess", "Markierung mit z.T. fehlenden Informationen (z.B. ohne Bilder, einige Details sind jedoch ausgefüllt)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_approved", "Markierung, bei dem das System als „in Ordnung/genehmigt“ bezeichnet ist"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_new", "Neu erstellt Markierung, mit fehlenden Informationen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_solutions_list", "Sie können mehrere Penetrationsdichtungen (Lösungen) in einem Markierungspunkt haben."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "showBlueprintImage", "Bauplan anzeigen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "changeImage", "Bild ändern"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newAttribute", "Eigenschaft hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "enterTheNameOfYourCustomSolution", "Geben Sie den Namen Ihrer Lösung ein"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "yourProducts", "Liste Ihrer Produkte"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "enterTheNameOfYourProductAndClickThePlusSignToAddToTheList", "Geben Sie den Namen Ihres Produkts ein und klicken Sie auf das Pluszeichen, um es der Liste hinzuzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "changeSolution", "Lösung ändern"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "viewSolution", "Lösungsinfo anzeigen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "notLinked", "nicht mit qr code verknüpft"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "linked", "verknüpft mit qr code"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "open", "anzeigen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "archive", "archivieren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "restore", "wiederherstellen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "archivedProjects", "Archivierte Projekte"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "pictures", "Bilder"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "discard", "Verwerfen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "findInList", "in Liste suchen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "findInSolutionSelector", "in Solution Selector suchen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "uploadBlueprintImage", "Hochladen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "networkIssues", "Netzwerkproblem"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "checkConnectionAndTryAgain", "Überprüfen Sie Ihre Verbindung und Versuch es noch einmal"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "retry", 'Versuch es noch einmal'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noBlueprints", 'Keine geschosse '), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noProjects", 'Keine Projekte'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noBuildingComponents", 'Keine Bauabschnitte'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noArchivedProjects", 'Keine archivierten Projekte'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noCustomSolutions", 'Keine eigene Lösungen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "projectDetails", "Projekt info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "buildingComponentDetails", "Bauabschnitt info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "user", "benutzer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newUser", "neuer Benutzer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "breakLock", "sperren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "changeLogo", "logo ändern"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "vat", "Umsatzsteuer-Identifikationsnummer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "requestTrial", "Testzugang anfordern"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "freeDemo", "Kostenlose Demo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "company", "Firma"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "firstFloor", "Beispiel: erster Stock"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "blockA", "Beispiel: Block A."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "demoRegistrationSuccessful", "Demo-Anfrage erhalten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "requestReceived", "Anfrage erhalten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "contactYou", "Anmeldung erfolgreich. Sie erhalten parallel eine Bestätigungsmail auf Ihre angegeben E-Mailadresse."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "takealook", "Die smarte Software für Ihre Brandschutzdokumentation"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "manufacturerIndepentent", "Herstellerunabhängig"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "multiplesealsonmarker", "Integrierte Produktlösungen mit aktuellen Dokumenten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "anydevice", "Zugriff an jedem Ort, zu jeder Zeit, auf allen Endgeräten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "multilanguage", "Individuell organisiert"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "highlyCustomizable", "Einfach & Schnell"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "requestADemo", "Anfrage Firelog"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "signup", "Anmelden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "activeProjects", "Aktive Projekte"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "profile", "Profil"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "license", "Lizenz"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "storage", "Datenspeicher"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "chooseYourPartner", "Wählen Sie Ihren Partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "partner", "partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noPartner", "Kein partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "requestTrialFourteenDays", "Registrieren Sie sich für ein 14-tägiges kostenloses Testkonto"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "itemsPerPage", "Objekte pro Seite"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "belgium", "Belgien"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "unitedKingdom", "Vereinigtes Königreich"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "germany", "Deutschland"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "austria", "Österreich"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "romania", "Rumänien"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "sweden", "Schweden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "hungary", "Ungarn"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "netherlands", "Niederlande"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "norway", "Norwegen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "switzerland", "Schweiz"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "spain", "Spanien"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "downloadLogbook", "Logbuch herunterladen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "saveMarkerPosition", "Markierungsposition speichern"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newMarker", "Neuen Marker hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "fullscreen", "Vollbildschirm"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "noLogin", "Ich habe keinen Account"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "report", "Ein Problem melden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "send", "Senden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "checkInbox", "Überprüfen Sie Ihren Posteingang."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "resetPasswordInstruction", "Sie erhalten eine E-Mail mit weiteren Anweisungen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "resetPassword", "Passwort zurücksetzen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "forgotPassword", "Passwort vergessen?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "areyouSureYouWantToUpgrade", "Möchten Sie wirklich AMOUNT GB für PRICE pro Monat hinzufügen?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "perMonth", "pro Monat"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "chooseHowMuchStorageYouWantToAdd", "Wählen Sie aus, wie viel Speicher Sie hinzufügen möchten. Hinweis: Sie können insgesamt bis zu 40 GB Speicherplatz haben. Willst du mehr? Bitte kontaktieren Sie uns."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "addStorage", "Speicher hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "manageUsers", "Wählen Sie aus, auf welche Projekte, Bauteile und Baupläne diese Person zugreifen kann."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "properties", "Eigenschaften"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "termsOfService", "Nutzungsbedingungen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "readAndAccepted", "Ich habe die Nutzungsbedingungen und Datenschutzbestimmungen gelesen und akzeptiert."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "agree", "Zustimmen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "contactFunction", "Position des Kontaktes"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "contactEmail", "Kontakt E-mail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "contactEmailHint", "Wir werden Sie auf diese E-Mail kontaktieren."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "loginEmail", "Login E-Mail"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "loginEmailHint", "E-Mail-Adresse, mit der Sie sich anmelden können."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "loginAlreadyExist", "Login-E-Mail wurde bereits verwendet."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "whatsnew", "Was gibt's Neues"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "deleteBlueprintImage", "Bauplanbild löschen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, '7profile', "Administrator"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, '8profile', "Nur Lesezugriff"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, '14profile', "Monteur"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, '15profile', "kein Zugang"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "clone", "Klonen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "cloneAttributeWithValues", "Dieses Attribut mit zugrunde liegenden Werten klonen?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "giveADifferentName", "Geben Sie einen anderen Namen als das Original ein"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "ignore", "Ignorieren"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "areyousureyouwanttoignorethis", "Bist du sicher, dass du das ignorieren willst?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_delete_attribute", "Sie können Attribute oder Werte löschen, wenn Sie sie selbst erstellt haben und wenn sie noch nicht für eine Markierung verwendet wurden."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_clone_attribute", "Sie können Attribute mit ihren zugrunde liegenden Werten klonen, sodass Sie keine neuen manuell erstellen müssen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_sync_attribute", "Dadurch werden die Standard-Firelog-Attribute und -Werte synchronisiert. Es wird ab und zu empfohlen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_drag_attribute", "Sie können die Reihenfolge ändern, indem Sie die Maustaste gedrückt halten und an die richtige Position ziehen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "info_star_attribute", "Standardattribute und -werte aus Firelog"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "newReports", "neuer Meldungen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "moveMarker", "Markierungen verschieben"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "markerLabel", "Eigener Markierungsname"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "blueprintSeparated", "Bauplanbild getrennt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "blueprintSeparatedHint", "Bauplanbild mit Markierungen in hoher Qualität"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "withDocuments", "Mit Dokumenten"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "withDocumentsHint", "Zertifikate, Datenblätter, ... Das kann länger dauern"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "selectYourPage", "Wählen Sie Ihre Seite"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "downloadlogbookasaWordFile", "Logbuch als Word-Dokument herunterladen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "takingSnapshot", "Einen Schnappschuss vom Blaupausenbild machen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "modifiedBy", "Geändert durch"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "installPWA", "Firelog auf Ihrem Gerät installieren: Klicken Sie auf "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "addToHomeScreen", "und dann zum Startbildschirm hinzufügen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "readyForOffline", "Bereit für Offline, schalten Sie Ihr WLAN / 4G aus, um offline zu arbeiten, und schalten Sie es wieder ein, wenn Sie fertig sind."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_DE, "goOnline", "Vergessen Sie nicht, eine Verbindung zum Internet herzustellen, um Ihre Änderungen zu speichern. Aktualisieren oder schließen Sie die App nicht."), _DE),
    NN: (_NN = {
        name: "Navn",
        building: "Byggets navn",
        description: "Beskrivelse",
        order: "Ordre",
        status: "Status",
        actions: "Aktivitet",
        marker: "Markør",
        markerName: "Markør navn",
        class: 'Klasse',
        buildingComponent: "Byggkomponent",
        buildingComponents: "Byggkomponenter",
        createdTs: "Opprettelsesdato",
        markers: "Markør",
        markUp: "Markør brukes på plantegning",
        values: "Verdier",
        inUse: "I bruk",
        firstname: "Fornavn"
    }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "building", "Byggets navn"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "marker", "Markør name"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "description", "Beskrivelse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "street", "Gate"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "number", "nr"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "postalcode", "Postnr."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "city", "By"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "country", "Land"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "mobile", "Mobil"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "email", "E-post"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "applicationDate", "Applikasjonsdato"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "date", "Dato"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "attribute", "Egenskap"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "attributes", "Egenskaper"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "value", "Verdi"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "installer", "Installatør"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "solution", "Solution"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "solutions", "Løsninger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "username", "Brukernavn"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "password", "Passord"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "uploadBlueprintFile", "Last opp plantegning med minimum oppløsning 640x480 (.jpg .pdf fil)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "comments", "Kommentar"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "approved", "Godkjent"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "broken", "i stykker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "dimensions", "Dimensjon"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "width", "Bredde (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "height", "Høyde (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "length", "Veggtykkelse (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "diameter", "Diameter (mm)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "unit", "Enhet"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "amount", "Antall"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "details", "Detaljer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "required", "påkrevd"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "invalid", "ugyldig"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "overrideQRId", "Advarsel"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "qrIdExists", "Feil"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "success", "Vellykket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "cached", "Offline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "saveChanges", "Lagre endringer?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "overrideQRId", "Denne gjennomføringen er allerede knyttet til en QR-kode. Vil du tilordne den med en ny QR-Kode?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "qrIdExists", "QR-koden kan ikke brukes. En annen gjennomføring bruker QR-koden!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "success", "QR-koden er koblet opp med  gjenomføringen!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "areYouSure", "Er du sikker å slette?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "cached", "jennomføring vil kobles opp automatisk når du er online."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "unsaved", "Det ble gjort endringer. Vil du beholde endringene?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "yes", "Ja"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "no", "Nei"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "currentPassword", "Gjeldende passord"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newPassword", "Nytt passord"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "confirmPassword", "Bekreft passord"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "changePassword", "Endre passord"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "active", "Aktiv"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newProject", "Nytt prosjekt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newBuildingComponent", "Ny byggkomponent"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newBlueprint", "Ny plantegning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "save", "Lagre"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "add", "Legg til"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "close", "Lukk"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "login", "Logg inn"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newInstaller", "Legg til installatør"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "addPicture", "Legg til bildet"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newSolution", "Legg til løsning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "addQRCode", "Link QR Kode"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "offline", "Offline"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "addMarkers", "Legg til  markør"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "cancel", "Avbryt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "download", "Last ned"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "edit", "Rediger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "addProduct", "Legg til produkt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "home", "Hjem"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "projects", "Prosjekter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "blueprints", "Plantegninger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "project", "Prosjekt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "blueprint", "Plantegning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "marker", "Markør"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "address", "Adresse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "contact", "Kontakt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "settings", "Instillinger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "back", "Tilbake"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "installer", "Installatør"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "users", "Brukere"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "camera", "Kamera"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "solutions", "Løsninger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "solution", "Løsning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "products", "Produkte"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "product", "Produkt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "userNotFound", "Passordet du oppga er feil."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "selectSolution", "Velg en løsning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "success", "Vellykket"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "error", "Noe gikk galt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "cached", "Endringer lagres når du er online"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "unsaved", "Det ble gjort endringer, ikke glem å lagre før du avslutter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "offlineUsers", "fungerer offline på plantegning: "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "notOnline", "Vennligst koble til internett"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "inReadOnly", "for øyeblikket i readonly-modus. Klikk rediger for å gjøre endringer."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newSolution", "Ny løsning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "chooseSolution", "Velg løsning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "draw", "Trykk på plantegning for å lage en markør!"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "wait1", "Laster inn... Dette kan ta noen øyeblikk..."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "wait2", "Forbereder endelig skjema"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "todo", "å gjøre"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "todos", "Gjøremål"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "myTodos", "Min oppgave"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "todosForInstallers", "Dosering for installatører"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "reports", "Rapporter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "archivedReports", "Gamle rapporter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "qrcodeNotLinked", "This qr code is not yet linked, or is linked with markers not on this blueprint."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "scanQRCode", "skann en koblet qr-kode"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "attachment", "Feste"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "isEditing", "Is editing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "editStart", "Started editing"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noaccess", "Ingen adgang"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "fillinrequiredfields", "fyll ut de nødvendige feltene"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "withlogo", "Med logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "withoutlogo", "Uten logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "search", "Søk"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "chooseFile", "Velg Fil (5MB max)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "continuereadonly", "Noen jobber med denne plantegning. Vil du fremdeles besøke siden uten å kunne redigere?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "blueprintLocked", "er opptatt med å redigere"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "blueprintLockedSince", "er opptatt med å redigere siden"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "takeOver", "Overta"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "customsolutions", "tilpassede løsninger"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noproducts", "Ingen produkter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "addpicture", "Legg til bilde"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "help", "Hjelp"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noresults", "Ingen resultater"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "signout", "Logg ut"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "viewMore", "Ser mer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "usethisinmarker", "Bruke det i markør"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "addyourownlogo", "legg til din egen logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "delete", "slette"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "step", 'Skritt'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "application", 'Installasjonsinstruksjoner'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "solutionselector", 'Solution Selector'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "selectsolution", 'Velg en løsning'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "inProcess", 'Igang'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "solutionsList", "Løsningsliste"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "deleteSolution", "Slette løsning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "selectUsedProducts", "Velg brukte produkter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "showAll", "Ny"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "useSolutionSelector", 'Finn riktig løsning med solution selector'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "orUseDropdown", 'Eller søk i listen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "useDropdown", 'Velg riktig løsning fra denne listen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_broken", "Markers with their latest image with status broken uploaded. Meaning that the penetration seals are broken."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_inProcess", "Markers that have no images, but some details and information are filled in."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_approved", "Markers that have the penetration seal installed correctly."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_new", "Newly created markers, markers with no info filled in or no images uploaded."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_solutions_list", "You can have multiple penetration seals (solutions) in one marker point."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "showBlueprintImage", "Vis blåkopisbilde"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "changerImage", 'endre bilde'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newAttribute", "nytt attributt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "enterTheNameOfYourCustomSolution", "Skriv inn navnet på løsningen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "yourProducts", "Liste over produktene dine"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "enterTheNameOfYourProductAndClickThePlusSignToAddToTheList", "Skriv inn navnet på produktet og klikk på pluss-tegnet for å legge det til i listen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "changeSolution", "endre løsning"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "viewSolution", "vis løsningsinfo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "notLinked", "Ikke knyttet til qr-kode"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "linked", "Knyttet til qr-kode"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "open", "show"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "archive", "Arkiv"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "restore", "restaurere"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "archivedProjects", "Arkiverte prosjekter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "pictures", "Bilder"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "discard", "Forkast"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "findInList", "finn i listen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "findInSolutionSelector", "finn i Solution Selector"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "uploadBlueprintImage", "Laste opp"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "networkIssues", "nettverksproblem"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "checkConnectionAndTryAgain", "Sjekk forbindelsen din og prøv igjen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "retry", 'Prøv igjen'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noBlueprints", 'Ingen tegninger'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noProjects", 'Ingen prosjekter'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noBuildingComponents", 'Ingen Byggkomponenter'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noArchivedProjects", 'Ingen arkiverte prosjektere'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noCustomSolutions", 'Ingen tilpassede løsninger'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "projectDetails", "Projekt info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "buildingComponentDetails", "byggkomponent info"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "user", "bruker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newUser", "ny bruker"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "breakLock", "låse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "changeLogo", "endre logo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "vat", "MVA-nummer"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "requestTrial", "Be om en gratis prøveperiode"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "freeDemo", "Gratis demo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "company", "Bedrift"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "firstFloor", "eksempel: første etasje"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "blockA", "eksempel: blokk A"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "demoRegistrationSuccessful", "Demo-forespørsel mottatt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "requestReceived", "Forespørsel mottatt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "contactYou", "Takk for interessen din for Firelog. En representant vil ta kontakt om kort tid for å planlegge din interaktive demo."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "takealook", "Ta en titt på hvordan du kan registrere brannsikre tetninger hos Firelog"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "manufacturerIndepentent", "Installer på hvilken som helst enhet"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "multiplesealsonmarker", "Flere sel på en markør"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "anydevice", "Last ned prosjektet til et loggbokdokument"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "multilanguage", "Tilgjengelig på flere språk"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "highlyCustomizable", "Meget tilpassbar"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "requestADemo", "Be om en demo"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "signup", "Melde deg på"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "activeProjects", "Aktive Prosjekter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "profile", "Profil"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "license", "Tillatelse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "storage", "Oppbevaring"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "chooseYourPartner", "Velg din partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "partner", "partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noPartner", "Ingen partner"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "requestTrialFourteenDays", "Registrer deg for en 14-dagers gratis prøvekonto"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "itemsPerPage", "Varer per side"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "belgium", "Belgia"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "unitedKingdom", "Storbritannia"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "germany", "Tyskland"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "austria", "Østerrike"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "romania", "Romania"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "sweden", "Sverige"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "hungary", "Ungarn"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "netherlands", "Nederland"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "norway", "Norge"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "switzerland", "Schweiz"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "spain", "Spania"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "downloadLogbook", "Last ned loggbok"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "saveMarkerPosition", "Lagre markørposisjon"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newMarker", "Legg til ny markør"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "fullscreen", "Full skjerm"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "noLogin", "Jeg har ikke en konto"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "report", "Rapporter et problem"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "send", "Sende"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "checkInbox", "Sjekk innboksen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "resetPasswordInstruction", "Du vil motta en e-post med nærmere instruksjoner."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "resetPassword", "Tilbakestille passord"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "forgotPassword", "Glemt passord?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "areyouSureYouWantToUpgrade", "Er du sikker på at du vil legge til AMOUNT GB for PRICE per måned?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "perMonth", "per måned"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "chooseHowMuchStorageYouWantToAdd", "Velg hvor mye lagringsplass du vil legge til. Merk: Du kan ha opptil 40 GB lagringsplass totalt. Vil du ha mer? Værsåsnill kontakt oss."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "addStorage", "Legg til lagring"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "manageUsers", "Velg hvilke prosjekter, bygningskomponenter og tegninger denne personen har tilgang til."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "properties", "Egenskaper"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "termsOfService", "Servicevilkår"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "readAndAccepted", "Jeg har lest og godtatt vilkårene for bruk og personvern."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "agree", "Bli enige"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "contactFunction", "Funksjon"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "contactEmail", "Kontakt Epost"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "contactEmailHint", "Vi vil kontakte deg på denne e-postmeldingen."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "loginEmail", "Innloggingsadresse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "loginEmailHint", "E-postadresse som du kan logge inn med."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "loginAlreadyExist", "Påloggings-e-post er allerede brukt."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "whatsnew", "Hva er nytt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "deleteBlueprintImage", "Slette bygningsplanbilde"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, '7profile', "Administrator"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, '8profile', "Les bare"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, '14profile', "Montør"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, '15profile', "Ingen adgang"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "clone", "Klone"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "cloneAttributeWithValues", "Vil du klone dette attributtet med underliggende verdier?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "giveADifferentName", "Skriv inn et annet navn enn originalen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_star_attribute", "Standardattribute und -werte aus Firelog"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "ignore", "Overse"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "areyousureyouwanttoignorethis", "Er du sikker på at du vil ignorere dette?"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_delete_attribute", "Du kan slette attributter eller verdier hvis du har laget dem selv, og hvis de ikke har blitt brukt ennå på en markør."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_clone_attribute", "Du kan klone attributter med deres underliggende verdier, slik at du ikke trenger å lage nye manuelle"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_sync_attribute", "Dette vil synkronisere standard firelog-attributter og -verdier. Det anbefales dette en gang i blant."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_drag_attribute", "Du kan endre rekkefølgen ved å holde klikk og dra den til riktig posisjon."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "info_star_attribute", "Standard attributter og verdier fra Firelog"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "newReports", "Nye rapporter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "moveMarker", "Flytt markører"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "markerLabel", "Markør etikett"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "blueprintSeparated", "byggeplan bilde atskilt"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "blueprintSeparatedHint", "Få tegningsbildet ditt med markører skilt i høy kvalitet (.jpg)"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "withDocuments", "Inkluder sertifiseringsdokumenter"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "withDocumentsHint", "Sertifikater, datablad, ... Dette kan ta mer tid"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "selectYourPage", "Velg siden din"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "downloadlogbookasaWordFile", "Loggbok lastes ned som Word-dokument"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "takingSnapshot", "Einen Schnappschuss vom Blaupausenbild machen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "modifiedBy", "Endret av"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "installPWA", "Installer Firelog på enheten din: trykk på "), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "addToHomeScreen", "og deretter Legg til på startskjermen"), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "readyForOffline", "Klar for offline, slå av wifi / 4g for å jobbe offline og slå den på når du er ferdig."), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_NN, "goOnline", "Ikke glem å koble til internett for å lagre endringene. Ikke oppdater eller lukk appen."), _NN),
    SV: {
        "name": "Name",
        "building": "Byggnadens namn",
        "description": "Beskrivning",
        "order": "Order",
        "status": "Status",
        "actions": "Utförande",
        "marker": "Markör",
        "markerName": "Markörens namn",
        "buildingComponent": "Byggnadsdel",
        "buildingComponents": "Byggnadsdelar",
        "createdTs": "Skapat datum",
        "blueprints": "Ritningar",
        "markers": "Markörer",
        "markUp": "Hantera markörer på ritning",
        "values": "Värde",
        "inUse": " I bruk",
        "firstname": "Förnamn",
        "street": "Gata",
        "number": "Nummer",
        "postalcode": "Postnummer",
        "city": "Stad",
        "country": "Land",
        "mobile": "Mobil",
        "email": "E-post",
        "applicationDate": "Ansökningsdatum",
        "date": "Datum",
        "class": "Klass",
        "attribute": "Egenskap",
        "attributes": "Egenskaper",
        "value": "Värde",
        "installer": "Montör",
        "solution": "Lösning",
        "solutions": "Lösningar",
        "username": "Användarnamn",
        "password": "Lösenord",
        "uploadBlueprintFile": "Ladda upp ritning med minsta upplösning 640x480 (.jpg .pdf fil)",
        "comments": "Kommentarer",
        "products": "Produkter",
        "approved": "Godkänd",
        "broken": "Bruten",
        "dimensions": "Dimensioner",
        "width": "Bredd (mm)",
        "height": "Höjd (mm)",
        "length": "Längd (mm)",
        "diameter": "Diameter (mm)",
        "unit": "Enhet",
        "amount": "Belopp",
        "details": "Detaljer",
        "required": "Krävs",
        "invalid": " Ogiltigt",
        "warning": "Varning",
        "qrIdExists": "Denna QR-kod kan inte tillämpas. En annan brandgenomföring använder denna QR-kod!",
        "success": "Klart!",
        "cached": "Ändringar sparas när du är online",
        "saveChanges": "Spara ändring?",
        "overrideQRId": "Denna brandgenomföring är redan kopplad till en QR-kod. Vill du tilldela den med en ny QR-kod?",
        "areYouSure": "Är du säker på att du vill ta bort det här?",
        "unsaved": "Ändringar gjordes, glöm inte att spara innan du lämnar.",
        "yes": "Ja",
        "no": "Nej",
        "currentPassword": "Nuvarande lösenord",
        "newPassword": "Nytt lösenord",
        "confirmPassword": "Bekräfta lösenord",
        "changePassword": "Byta lösenord",
        "active": "Aktiv",
        "noBlueprint": "Jag har för nävarande ingen ritning",
        "deadline": "skall vara klart",
        "newProject": "Nytt projekt",
        "newBuildingComponent": "Ny byggnadsdel",
        "newBlueprint": "Ny ritning",
        "save": "Spara",
        "add": "Lägg till",
        "close": "Stäng",
        "login": "Logga in",
        "newInstaller": "Lägg till montör",
        "addPicture": "Lägg till bild",
        "newSolution": "Ny lösning",
        "addQRCode": "Lägg till QR-kod",
        "offline": "Offline",
        "addMarkers": "Lägg till markörer",
        "cancel": "Avbryt",
        "download": "Ladda ner",
        "edit": "Redigera",
        "addProduct": "Lägg till produkt",
        "home": "Hem",
        "projects": "Projekt",
        "project": "Projekt",
        "blueprint": "Ritning",
        "address": "Adress",
        "contact": "Kontakt",
        "settings": "Inställningar",
        "back": "Tillbaka",
        "users": "Användare",
        "camera": "Kamera",
        "product": "Produkt",
        "todo": "Att göra",
        "todos": "Att göra",
        "myTodos": "Mina Att göra",
        "todosForInstallers": "Att Göra för installatörer",
        "userNotFound": "User not found ",
        "selectSolution": "Välj en lösning",
        "error": "Något gick fel",
        "offlineUsers": "Arbetet med ritningen sker offline:",
        "notOnline": "Ingen anslutning ",
        "inReadOnly": "för närvarande i readonly-läge. Klicka på redigera för att göra ändringar.",
        "chooseSolution": "Välj en  lösning",
        "draw": "Markera på ritningen för att skapa en markering!",
        "wait1": "Laddar... Detta kan ta några ögonblick...",
        "wait2": "Förbereder slutlig utformning",
        "reports": "Rapporter",
        "archivedReports": "Arkiverade rapporter",
        "qrcodeNotLinked": "Denna QR kod är inte länkad, eller är länkad till en annan ritning.",
        "scanQRCode": "skanna en länkad qr-kod",
        "attachment": "bifoga",
        "isEditing": "Redigerar",
        "editStart": "Startar redigering ",
        "noaccess": "Ingen åtkomst",
        "fillinrequiredfields": "fyll i de obligatoriska fälten",
        "withlogo": "med logga",
        "withoutlogo": "Utan logga",
        "search": "Sök",
        "chooseFile": "Välj FIL (5MB max)",
        "continuereadonly": "Någon arbetar med denna ritning. Vill du fortfarande besöka sidan utan att kunna redigera?",
        "blueprintLocked": "Ritning låst för redigering",
        "blueprintLockedSince": "Ritningen är låst för redigering",
        "takeOver": "Ta över",
        "customsolutions": "Anpassade lösningar",
        "noproducts": "Inga produkter",
        "addpicture": "Lägg till bild",
        "help": "Hjälp",
        "noresults": "Inga resultat",
        "signout": "Logga ut",
        "viewMore": "Visa mer",
        "usethisinmarker": "Använd detta i markören",
        "addyourownlogo": "Lägg till din egen logga",
        "delete": "Radera",
        "step": "Steg",
        "application": "Monteringsanvisning ",
        "solutionselector": "Produktväljare ",
        "selectsolution": "Välj en lösning",
        "inProcess": "Pågående",
        "solutionsList": "Lista på lösningar",
        "deleteSolution": "Ta bort lösning",
        "selectUsedProducts": "Välj använda lösningar.",
        "showAll": "Visa allt",
        "new": "Ny",
        "useSolutionSelector": "Hitta rätt lösning med Produktväljaren ",
        "orUseDropdown": "Eller sök i rulllistan",
        "useDropdown": "Hitta rätt lösning från rull listan",
        "info_broken": " Markör med den status Ej färdig uppladdad. Betyder att tätningen ej är klar.",
        "info_inProcess": "Markören har ingen bild med detaljerad information finns",
        "info_approved": " Markörer som har brandtätningen monterad korrekt",
        "info_new": "Nyligen skapade markörer, markörer utan information och bild",
        "info_solutions_list": " Du kan ha flera olika brantätningar på en markör",
        "showBlueprintImage": "Visa ritning.",
        "changeImage": "ändra bild",
        "newAttribute": "Nya egenskaper",
        "enterTheNameOfYourCustomSolution": "Ange namnet på din lösning",
        "yourProducts": "Lista över dina produkter",
        "enterTheNameOfYourProductAndClickThePlusSignToAddToTheList": "Ange namnet på din produkt och klicka på plustecknet för att lägga till den i listan",
        "changeSolution": "ändra lösning",
        "viewSolution": "visa lösningsinfo",
        "notLinked": "Inte kopplad med qr-kod",
        "linked": "kopplad till qr-kod",
        "open": "öppna",
        "archive": "arkiv",
        "restore": "Återställ",
        "archivedProjects": "Arkiverade projekt",
        "pictures": "Bilder",
        "discard": "Kassera",
        "findInList": "hitta i listan",
        "findInSolutionSelector": "hitta i Solution Selector",
        "uploadBlueprintImage": "Ladda upp",
        "networkIssues": "nätverks problem",
        "checkConnectionAndTryAgain": "Kontrollera din anslutning och försök igen",
        "retry": "Försök igen",
        "noBlueprints": "Inga ritningar",
        "noProjects": "Inga projekt",
        "noBuildingComponents": "Inga Byggnadsdelar",
        "noArchivedProjects": "Inga arkiverade projekt",
        "noCustomSolutions": "Inga anpassade lösningar",
        "projectDetails": "Projekt info",
        "buildingComponentDetails": "byggnadsdel info",
        "user": "användare",
        "newUser": "ny användare",
        "breakLock": "låsa",
        "changeLogo": "ändra logga",
        "vat": "Momsregistreringsnummer",
        "requestTrial": "Begär en gratis provperiod",
        "freeDemo": "Gratis demo",
        "company": "Företag",
        "demoRegistrationSuccessful": "Demo begäran mottagen",
        "requestReceived": "Förfrågan mottagen",
        "contactYou": "Tack för ditt intresse för Firelog. En representant kommer att kontakta inom kort för att schemalägga din interaktiva demo.",
        "firstFloor": "exempel: första våningen",
        "blockA": "exempel: block A",
        "takealook": "Ta en titt på hur du kan registrera brandtätningar hos Firelog",
        "manufacturerIndepentent": "Installera på vilken enhet som helst",
        "multiplesealsonmarker": "Flera tätningar på en markör",
        "anydevice": "Ladda ner ditt projekt till ett loggbokdokument",
        "multilanguage": "Finns på flera språk",
        "highlyCustomizable": "Mycket anpassningsbara",
        "requestADemo": "Begär en demo",
        "signup": "Bli Medlem",
        "activeProjects": "Aktiva projekt",
        "profile": "Profil",
        "license": "Licens",
        "storage": "Lagring",
        "chooseYourPartner": "Välj din partner",
        "partner": "partner",
        "noPartner": "Ingen partner",
        "requestTrialFourteenDays": "Registrera dig för ett 14-dagars gratis provkonto",
        "itemsPerPage": "Objekt per sida",
        "belgium": "Belgien",
        "unitedKingdom": "Storbritannien",
        "germany": "Tyskland",
        "austria": "Österrike",
        "romania": "Rumänien",
        "sweden": "Sverige",
        "hungary": "Ungern",
        "netherlands": "Nederländerna",
        "norway": "Norge",
        "switzerland": "Schweiz",
        "spain": "Spanien",
        "downloadLogbook": "Ladda ner loggbok",
        "saveMarkerPosition": "Spara markörens position",
        "newMarker": "Lägg till ny markör",
        "fullscreen": "Fullskärm",
        "noLogin": "Jag har inget konto",
        "report": "Rapportera ett problem",
        "send": "Skicka",
        "checkInbox": "Kolla din inkorg.",
        "resetPasswordInstruction": "Du får ett e-postmeddelande med ytterligare instruktioner.",
        "resetPassword": "Återställ lösenord.",
        "forgotPassword": "glömt ditt lösenord?",
        "areyouSureYouWantToUpgrade": "Är du säker på att du vill lägga till AMOUNT GB för PRICE per månad?",
        "perMonth": "per månad",
        "chooseHowMuchStorageYouWantToAdd": "Välj hur mycket lagringsutrymme du vill lägga till. Observera: Du kan ha upp till 40 GB lagringsutrymme totalt. Vill du ha mer? Vänligen kontakta oss.",
        "addStorage": "Lägg till lagring",
        "manageUsers": "Välj vilka projekt, byggnadsdelar och ritningar som personen kan komma åt.",
        "properties": "Egenskaper",
        "termsOfService": "Användarvillkor",
        "readAndAccepted": "Jag har läst och accepterat användarvillkoren och sekretesspolicyn.",
        "agree": "Hålla med",
        "contactFunction": "Fungera",
        "contactEmail": "Kontakt e-post",
        "contactEmailHint": "Vi kommer att kontakta dig via den här e-postadressen.",
        "loginEmail": "Logga in e-post",
        "loginEmailHint": "E-postadressen som du kan logga in med.",
        "loginAlreadyExist": "Denna mailadress används redan ",
        "whatsnew": "Vad är nytt",
        "deleteBlueprintImage": "Radera ritning.",
        "7profile": "Administratör",
        "8profile": "Endast läsning",
        "14profile": "Montör",
        "15profile": "Ingen åtkomst",
        "clone": "Klona",
        "cloneAttributeWithValues": "Klona egenskaperna med underliggande värden?",
        "giveADifferentName": "Ange ett annat namn ",
        "ignore": "Ignorera",
        "areyousureyouwanttoignorethis": "Är du säker på att du vill ignorera?",
        "addReportToThisSolution": "Lägg till rapport till den här lösningen",
        "info_delete_attribute": "Du kan ta bort egenskaper eller värden som du lagt till dem själv under förutsättning  att de ännu inte används i en markör.",
        "info_clone_attribute": "Du kan klona egenskaper med deras underliggande värden så att du inte behöver skapa nya",
        "info_sync_attribute": "Detta synkroniserar standardvärden i Firelog.Detta rekomenderas attt man gör med jämna mellanrum.",
        "info_drag_attribute": "Du kan ändra ordningen genom att klicka och dra den till rätt position.",
        "info_star_attribute": "Standardaregenskaper och värden från Firelog",
        "newReports": "Nya rapporter",
        "moveMarker": "Flytta markörer",
        "markerLabel": "Eget namn på markör",
        "blueprintSeparated": "Separerad ritning  ",
        "blueprintSeparatedHint": "Få din ritnings med markörer separerade i hög kvalitet (.jpg)",
        "withDocuments": "Inkludera dokument",
        "withDocumentsHint": "Certifikat, datablad, ... Kan ta längre tid att ladda upp.",
        "selectYourPage": "Välj din sida",
        "downloadlogbookasaWordFile": "Loggbok laddas ned som Word-dokument",
        "takingSnapshot": "Ta en \"Snapshot\" av ",
        "modifiedBy": "Modifierad av",
        "installPWA": "Installera Firelog på din enhet: Tryck här",
        "addToHomeScreen": " Lägg sedan till på startskärmen",
        "readyForOffline": "Klar för offline, stäng av din wifi / 4G för att arbeta offline och slå på den igen när du är klar.",
        "goOnline": "Glöm inte att ansluta till internet för att spara dina ändringar. Uppdatera inte och stäng inte appen.",
        "changerImage": "Ändra bild",
        "addpicutre": "Lägg till bild",
        "tep": "Steg"
    }
};

/* harmony default export */ __webpack_exports__["a"] = (locales);

/***/ }),
/* 743 */,
/* 744 */,
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__ = __webpack_require__(746);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__casl_ability__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_jwt_decode__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store_store__ = __webpack_require__(146);





var user = void 0;
var permissions = {};
var permissionsOffline = {};
if (localStorage.getItem('auth')) {
    var decoded = __WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem('auth'));
    if (decoded.QRLOG !== undefined) {
        decoded.QRLOG.forEach(function (p) {
            var subject = p.split('_')[0];
            var action = p.split('_')[1];
            // let offline = p.split().length === 2 ? false : p.split('_')[2] === "offline" ? true : false;

            // if (!offline) {
            if (permissions[subject] === undefined) {
                permissions[subject] = [];
            }

            permissions[subject].push(action);

            // } else {
            //     if (permissionsOffline[subject] === undefined) {
            //         permissionsOffline[subject] = [];
            //     }

            //     permissionsOffline[subject].push(action);
            // }            
        });
        console.log(__WEBPACK_IMPORTED_MODULE_2_jwt_decode___default()(localStorage.getItem('auth')), "permissions");
    }
}

/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_1__casl_ability__["b" /* AbilityBuilder */].define(function (can) {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_object_keys___default()(permissions).forEach(function (subject) {
        return can(permissions[subject], subject);
    });
}));

/***/ }),
/* 746 */,
/* 747 */,
/* 748 */,
/* 749 */,
/* 750 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__ = __webpack_require__(316);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b81be334_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__ = __webpack_require__(751);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Loading_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b81be334_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Loading_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{attrs:{"align-center":"","align-content-center":"","fill-height":"","justify-center":""}},[_c('v-progress-circular',{attrs:{"size":50,"color":"primary","indeterminate":""}})],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingDialog_vue__ = __webpack_require__(317);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b5b52cd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingDialog_vue__ = __webpack_require__(754);
function injectStyle (ssrContext) {
  __webpack_require__(753)
}
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoadingDialog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6b5b52cd_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoadingDialog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 753 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","width":"300"},model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_c('v-card',{attrs:{"flat":"","color":"primary","dark":""}},[_c('v-card-text',[_vm._v("\n           "+_vm._s(_vm.text? _vm.text : _vm.$t('wait1'))+"\n           "),_c('v-progress-linear',{staticClass:"mb-0",attrs:{"indeterminate":"","color":"white"}})],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreYouSure_vue__ = __webpack_require__(318);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da31800_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreYouSure_vue__ = __webpack_require__(756);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreYouSure_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da31800_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreYouSure_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"290"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return [(_vm.button)?[_c('v-btn',{attrs:{"disabled":_vm.disabled,"small":"","depressed":"","color":_vm.color},on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_vm._v(_vm._s(_vm.text))])]:(_vm.list_item)?[_c('v-list-item',{on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_c('v-list-item-icon',[_c('v-icon',{attrs:{"disabled":_vm.disabled,"color":_vm.color,"small":_vm.small}},[_vm._v("delete")])],1),_vm._v(" "),_c('v-list-item-content',[_vm._v(_vm._s(_vm.$t('delete')))])],1)]:[(_vm.icon)?_c('v-icon',{attrs:{"disabled":_vm.disabled,"color":_vm.color,"small":_vm.small},on:{"click":function($event){$event.stopPropagation();_vm.dialog = true}}},[_vm._v("delete")]):_c('v-btn',_vm._g({attrs:{"disabled":_vm.disabled,"color":_vm.color,"icon":"","small":_vm.small}},on),[_c('v-icon',{attrs:{"disabled":_vm.disabled,"color":_vm.color,"small":_vm.small}},[_vm._v("delete")])],1)]]}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('warning')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('areYouSure')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":"","autofocus":""},on:{"click":function($event){_vm.dialog = false}}},[_vm._v(_vm._s(_vm.$t('cancel')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"red","text":""},on:{"click":function($event){return _vm.remove(_vm.id,_vm.fk)}}},[_vm._v(_vm._s(_vm.$t('delete')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListTransition_vue__ = __webpack_require__(319);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_445ceaab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListTransition_vue__ = __webpack_require__(758);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ListTransition_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_445ceaab_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ListTransition_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{attrs:{"name":"staggered-fade","tag":_vm.tag,"css":false},on:{"before-enter":_vm.beforeEnter,"enter":_vm.enter,"leave":_vm.leave}},[_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SaveBeforeLeave_vue__ = __webpack_require__(320);
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004607cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveBeforeLeave_vue__ = __webpack_require__(760);
var normalizeComponent = __webpack_require__(0)
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SaveBeforeLeave_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_004607cb_hasScoped_false_transformToRequire_video_src_poster_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SaveBeforeLeave_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-dialog',{attrs:{"persistent":"","max-width":"290"},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
return undefined}}]),model:{value:(_vm.dialog),callback:function ($$v) {_vm.dialog=$$v},expression:"dialog"}},[_vm._v(" "),_c('v-card',[_c('v-card-title',{staticClass:"headline"},[_vm._v(_vm._s(_vm.$t('saveChanges')))]),_vm._v(" "),_c('v-card-text',[_vm._v(_vm._s(_vm.$t('unsaved')))]),_vm._v(" "),_c('v-card-actions',[_c('v-spacer'),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":"","autofocus":""},on:{"click":function($event){return _vm.response(false)}}},[_vm._v(_vm._s(_vm.$t('discard')))]),_vm._v(" "),_c('v-btn',{attrs:{"color":"primary","text":""},on:{"click":function($event){return _vm.response(true)}}},[_vm._v(_vm._s(_vm.$t('save')))])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),
/* 761 */,
/* 762 */,
/* 763 */,
/* 764 */,
/* 765 */,
/* 766 */,
/* 767 */,
/* 768 */,
/* 769 */,
/* 770 */,
/* 771 */,
/* 772 */,
/* 773 */,
/* 774 */,
/* 775 */,
/* 776 */,
/* 777 */,
/* 778 */,
/* 779 */,
/* 780 */,
/* 781 */,
/* 782 */,
/* 783 */,
/* 784 */,
/* 785 */,
/* 786 */,
/* 787 */,
/* 788 */,
/* 789 */,
/* 790 */,
/* 791 */,
/* 792 */,
/* 793 */,
/* 794 */,
/* 795 */,
/* 796 */,
/* 797 */,
/* 798 */,
/* 799 */,
/* 800 */,
/* 801 */,
/* 802 */,
/* 803 */,
/* 804 */,
/* 805 */,
/* 806 */,
/* 807 */,
/* 808 */,
/* 809 */,
/* 810 */,
/* 811 */,
/* 812 */,
/* 813 */,
/* 814 */,
/* 815 */,
/* 816 */,
/* 817 */,
/* 818 */,
/* 819 */,
/* 820 */,
/* 821 */,
/* 822 */,
/* 823 */,
/* 824 */,
/* 825 */,
/* 826 */,
/* 827 */,
/* 828 */,
/* 829 */,
/* 830 */,
/* 831 */,
/* 832 */,
/* 833 */,
/* 834 */,
/* 835 */,
/* 836 */,
/* 837 */,
/* 838 */,
/* 839 */,
/* 840 */,
/* 841 */,
/* 842 */,
/* 843 */,
/* 844 */,
/* 845 */,
/* 846 */,
/* 847 */,
/* 848 */,
/* 849 */,
/* 850 */,
/* 851 */,
/* 852 */,
/* 853 */,
/* 854 */,
/* 855 */,
/* 856 */,
/* 857 */,
/* 858 */,
/* 859 */,
/* 860 */,
/* 861 */,
/* 862 */,
/* 863 */,
/* 864 */,
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(54);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__ = __webpack_require__(41);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__router_index_js__ = __webpack_require__(111);





var source = void 0;
var ajax = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.create({
    baseURL: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi
});

ajax.interceptors.request.use(function (config) {
    var token = localStorage.getItem('auth');
    if (navigator.onLine) {
        if (token) {
            config.headers['Authorization'] = "Bearer " + token;
        }
        return config;
    } else {
        return false;
    }
}, function (error) {
    console.log(error);
    if (error.response.status === 401) {
        // localStorage.removeItem("auth");
        // localStorage.removeItem("user");
        // this.$router.go();
    }
    return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
});

ajax.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    if (error.response.status === 401) {
        localStorage.removeItem("auth");
        localStorage.removeItem("user");
        __WEBPACK_IMPORTED_MODULE_3__router_index_js__["a" /* default */].go();
    }
    // if(error.response.status === 400 || error.response.status === 404)
    // {
    //     window.location.href = "/Error"
    // }
    else if (error.response.status === 404) {
            __WEBPACK_IMPORTED_MODULE_3__router_index_js__["a" /* default */].push({ name: "Error", params: { status: 404 } });
        } else if (error.response.status === 403) {
            __WEBPACK_IMPORTED_MODULE_3__router_index_js__["a" /* default */].push({ name: "Error", params: { status: 403 } });
        } else {
            //window.location.href = `${settings.baseUrl}/Error`
        }
    var html = '';
    console.log(error.response.data.message);
    var errs = void 0;
    try {
        errs = JSON.parse(error.response.data.message);
    } catch (e) {
        errs = error.response.data.message;
    }
    if (Array.isArray(errs)) {
        errs.forEach(function (err) {
            html += err + "</br>";
        });
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(html);
    }{
        html = errs;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(html);
    }
    // return Promise.reject(error)
});

/* harmony default export */ __webpack_exports__["a"] = ({

    // source,


    //GET
    getProjects: function getProjects() {
        var archived = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var linkedUser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

        if (linkedUser) {
            return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Projects?archived=" + archived + "&linkedUser=" + linkedUser);
        }
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Projects?archived=" + archived);
    },
    getProject: function getProject(id) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Projects/" + id));
    },
    getBuildingComponents: function getBuildingComponents(id) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/BuildingComponentsByProjectId/" + id));
    },
    getBuildingComponent: function getBuildingComponent(id) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/BuildingComponents/" + id));
    },
    getBlueprints: function getBlueprints(id) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/BlueprintsByBuildingComponentId/" + id));
    },
    getBlueprint: function getBlueprint(id) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Blueprints/" + id));
    },
    getMarkers: function getMarkers(id) {
        var light = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (source) {
            source.cancel();
        }
        var CancelToken = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken;
        source = CancelToken.source();
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/MarkersByBlueprintId/" + id + "?languageCode=" + localStorage.getItem('language') + "&light=" + light), {
            cancelToken: source.token
        });
    },
    getMarker: function getMarker(id) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Markers/" + id + "?languageCode=" + localStorage.getItem('language')));
    },
    getAttributes: function getAttributes(offline, visible) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/QRLogAttributes?languageCode=" + localStorage.getItem('language') + "&offline=" + offline + "&visible=" + visible));
    },
    getUnusedAttributes: function getUnusedAttributes(markerId) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/QRLogAttributesUnused/" + markerId + "?languageCode=" + localStorage.getItem('language')));
    },
    getUnusedAttributes2: function getUnusedAttributes2(markerxSolutionsId) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/QRLogAttributesUnused2/" + markerxSolutionsId + "?languageCode=" + localStorage.getItem('language')));
    },
    getAttributeClasses: function getAttributeClasses() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/QRLogAttributeClasses?languageCode=" + localStorage.getItem('language')));
    },
    showValues: function showValues(attributeId) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/QRLogAttributeListValuesByAttributeId/" + attributeId + "?languageCode=" + localStorage.getItem('language')));
    },
    getLanguages: function getLanguages() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Languages");
    },


    // getProductSolutions(includeEcommerce = false) {
    //     return ajax
    //         .get(settings.baseUrlApi + `/ProductSolutions/${includeEcommerce}`)
    // }
    getProductSolutions: function getProductSolutions() {
        var includeEcommerce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var search = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/ProductSolutions/" + includeEcommerce + "?search=" + search + "&languageCode=" + localStorage.getItem("language")));
    },
    getPIMProductSolutions: function getPIMProductSolutions() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/PIMProductSolutions?languageCode=" + localStorage.getItem("language")));
    },
    getLocalProductSolutions: function getLocalProductSolutions() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Products");
    },
    getProductsBySolutionId: function getProductsBySolutionId(productSolutionId) {
        var includeEcommerce = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/ProductSolutions/" + productSolutionId + "?includeEcommerce=" + includeEcommerce + "&languageCode=" + localStorage.getItem("language")));
    },
    getProductById: function getProductById(id) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Products/" + id));
    },
    getProducts: function getProducts() {
        var includeEcommerce = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
        var search = arguments[1];

        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Products/" + includeEcommerce + "?search=" + search + "&languageCode=" + localStorage.getItem("language")));
    },
    syncAttributes: function syncAttributes() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/SyncAttributes");
    },
    getMarkerByQRId: function getMarkerByQRId(id, markerId) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/QR/" + id + "?markerId=" + markerId);
    },
    getMarkerId: function getMarkerId(qrId, languageCode) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/QR/" + qrId + "?languageCode=" + languageCode);
    },
    getLog: function getLog(form) {
        return ajax({
            url: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Log",
            method: 'POST',
            data: form,
            headers: {
                'content-type': "multipart/form-data; boundary=" + form._boundary
            },
            responseType: 'blob'
        });
    },
    downloadQRStickers: function downloadQRStickers(amount, type) {
        return ajax({
            url: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/QRStickers?amount=" + amount + "&type=" + type + "&lc=" + localStorage.getItem("language"),
            method: 'GET',
            responseType: 'blob'
        });
    },
    downloadExcelExport: function downloadExcelExport() {
        var projectId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var buildingComponentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var blueprintId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';

        return ajax({
            url: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/ExcelExport?projectId=" + projectId + "&buildingComponentId=" + buildingComponentId + "&blueprintId=" + blueprintId + "&lc=" + localStorage.getItem("language"),
            method: 'GET',
            responseType: 'blob'
        });
    },
    getTodo: function getTodo() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Todo");
    },
    getReports: function getReports() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Report");
    },
    getOldReports: function getOldReports() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Report/old");
    },
    downloadLogbook: function downloadLogbook() {
        var projectId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
        var buildingComponentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
        var separated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
        var withDocuments = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

        return ajax({
            url: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/DownloadLogbook?projectId=" + projectId + "&buildingComponentId=" + buildingComponentId + "&languageCode=" + localStorage.getItem("language") + "&blueprintSeparated=" + separated + "&withDocuments=" + withDocuments),
            method: 'GET',
            responseType: 'blob'
        });
    },
    getHelp: function getHelp() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + '/Help?languageCode=' + localStorage.getItem("language"));
    },
    getStickerTemplate: function getStickerTemplate() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + '/StickerTemplates');
    },
    getInstallers: function getInstallers() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + '/Installers');
    },
    getLicenseInfo: function getLicenseInfo() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + '/Licenses');
    },
    getUnprocessedRequest: function getUnprocessedRequest() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/NotificationCustomers");
    },
    getStorageUpgrades: function getStorageUpgrades() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/FirelogStorageUpgrades");
    },
    getNotifications: function getNotifications() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Notifications");
    },
    getTodosGroupedByInstaller: function getTodosGroupedByInstaller() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Todo/Installers");
    },
    getReleaseNotes: function getReleaseNotes() {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/ReleaseNotes");
    },
    getAccounts: function getAccounts(s) {
        if (source) {
            source.cancel();
            console.log('cancelled');
        }
        var CancelToken = __WEBPACK_IMPORTED_MODULE_1_axios___default.a.CancelToken;
        source = CancelToken.source();
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].iHubBaseUrlApi + "/CustomerContactOverview?search=" + s, {
            cancelToken: source.token
        });
    },


    //POST
    addProject: function addProject(project) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Projects", project);
    },
    addBuildingComponent: function addBuildingComponent(buildingComponent) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/BuildingComponents", buildingComponent);
    },
    addBlueprint: function addBlueprint(blueprint) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Blueprints", blueprint);
    },
    addBlueprintFile: function addBlueprintFile(form) {
        return ajax({
            url: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Blueprints/upload",
            method: 'POST',
            data: form,
            headers: {
                'content-type': "multipart/form-data; boundary=" + form._boundary
            }
        });
    },
    addMarker: function addMarker(marker) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Markers?languageCode=" + localStorage.getItem('language')), marker);
    },
    uploadMarkerAttachment: function uploadMarkerAttachment(formData, markerId) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/AttachmentsFile?markerId=" + markerId), formData);
    },
    uploadMarkerAttachmentByCamera: function uploadMarkerAttachmentByCamera(attachment) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Attachments?languageCode=" + localStorage.getItem('language')), attachment);
    },
    postAttributesForMarker: function postAttributesForMarker(qrLogAttributeXMarkers) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/QRLogAttributeXMarkersList", qrLogAttributeXMarkers);
    },
    saveAttribute: function saveAttribute(attribute) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/QRLogAttributes?languageCode=" + localStorage.getItem('language')), attribute);
    },
    saveAttributeValue: function saveAttributeValue(data) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/QRLogAttributeListValues?languageCode=" + localStorage.getItem('language')), data);
    },
    addInstaller: function addInstaller(installer) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Installers", installer);
    },
    addSolution: function addSolution(form) {
        // return ajax
        //     .post(settings.baseUrlApi + "/ProductSolutions", solution)

        return ajax({
            url: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/ProductSolutions",
            method: 'POST',
            data: form,
            headers: {
                'content-type': "multipart/form-data; boundary=" + form._boundary
            }
        });
    },
    addProduct: function addProduct(solutionId, product) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Products?productSolutionId=" + solutionId), product);
    },
    login: function login(creadentials) {
        return __WEBPACK_IMPORTED_MODULE_1_axios___default.a.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].iHubBaseUrlApi + "/Authentication/Login", creadentials);
    },
    loginAsCustomer: function loginAsCustomer(data) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].iHubBaseUrlApi + "/Authentication/LoginAsCustomer", data);
    },
    updateAttributesPosition: function updateAttributesPosition(attributes) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + '/SortAttributes', attributes);
    },
    addSelectedProducts: function addSelectedProducts(selectedProducts) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/PostSelectedProducts", selectedProducts);
    },
    addReport: function addReport(report) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Report", report);
    },


    // addAttachment(form){
    //     return ajax.post(settings.baseUrlApi + `ProductAttachments`, form)
    // },


    uploadAttachment: function uploadAttachment(form) {
        return ajax({
            url: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/UploadProductAttachment",
            method: 'POST',
            data: form,
            headers: {
                'content-type': "multipart/form-data; boundary=" + form._boundary
            }
        });
    },
    uploadLogo: function uploadLogo(form) {
        return ajax({
            url: __WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/StickerTemplates",
            method: 'POST',
            data: form,
            headers: {
                'content-type': "multipart/form-data; boundary=" + form._boundary
            }
        });
    },
    forgotPasswordChallenge: function forgotPasswordChallenge(email) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + '/Authenticaton/ForgotPasswordChallenge', { email: email });
    },
    forgotPasswordChallengeCheck: function forgotPasswordChallengeCheck(token) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + '/Authenticaton/ForgotPasswordChallengeCheck', { token: token });
    },
    forgotPasswordReset: function forgotPasswordReset(password, token) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + '/Authenticaton/ForgotPasswordReset', { password: password, token: token });
    },
    postRequest: function postRequest(data) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/NotificationCustomers", data);
    },
    upgradeStorage: function upgradeStorage(data) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/FirelogStorageUpgrades", data);
    },
    updateProjectsXInstallers: function updateProjectsXInstallers(data) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Projects/AddUsers", data);
    },
    updateBuildingComponentsXInstallers: function updateBuildingComponentsXInstallers(data) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/BuildingComponents/AddUsers", data);
    },
    updateBlueprintXInstallers: function updateBlueprintXInstallers(data) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Blueprints/AddUsers", data);
    },
    acceptTermsOfService: function acceptTermsOfService() {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Licenses/AcceptTerms");
    },
    readReleaseNotes: function readReleaseNotes() {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/ReleaseNotes");
    },
    cloneQRLogAttribute: function cloneQRLogAttribute(a) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/QRLogAttributes/Clone", a);
    },


    //DELETE
    deleteProject: function deleteProject(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Projects/" + id);
    },
    deleteBuildingComponents: function deleteBuildingComponents(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/BuildingComponents/" + id));
    },
    deleteBlueprint: function deleteBlueprint(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Blueprints/" + id));
    },
    deleteMarker: function deleteMarker(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Markers/" + id));
    },
    deleteAttachment: function deleteAttachment(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Attachments/" + id));
    },
    deleteValues: function deleteValues(valueId) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/QRLogAttributeListValues/" + valueId));
    },
    deleteAttribute: function deleteAttribute(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/QRLogAttributes/" + id));
    },
    deleteMarkerXSolution: function deleteMarkerXSolution(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/MarkerXSolutions/" + id));
    },
    deleteSolutionXproduct: function deleteSolutionXproduct(id, fk) {
        return ajax.post(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/ProductSolutions?id=" + id + "&fk=" + fk), id);
        //.post(settings.baseUrlApi + `/DeleteProductSolutions?fk=${fk}`, id)
    },
    deleteProductSolution: function deleteProductSolution(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/ProductSolutions/" + id));
    },
    deleteProductAttachment: function deleteProductAttachment(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/DeleteProductAttachment/" + id));
    },
    deleteReport: function deleteReport(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Report/" + id));
    },
    deleteBlueprintFile: function deleteBlueprintFile(id) {
        return ajax.delete(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Blueprints/BlueprintFile/" + id);
    },


    //PUT
    updateProject: function updateProject(project) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Projects/" + project.id), project);
    },
    updateBlueprint: function updateBlueprint(blueprint) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Blueprints/" + blueprint.id), blueprint);
    },
    updateBuildingComponent: function updateBuildingComponent(buildingComponent) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/BuildingComponents/" + buildingComponent.id), buildingComponent);
    },
    updateMarker: function updateMarker(marker) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Markers/" + marker.id + "?languageCode=" + localStorage.getItem('language')), marker);
    },
    updateAttributesForMarker: function updateAttributesForMarker(qrLogAttributeXMarkers) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/QRLogAttributeXMarkersList", qrLogAttributeXMarkers);
    },
    updateAttribute: function updateAttribute(qRLogAttributes) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/UpdateQRLogAttributes?languageCode=" + localStorage.getItem('language'), qRLogAttributes);
    },
    updateAttributeValues: function updateAttributeValues(qRLogAttributeValues) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/UpdateQRLogAttributeValues?languageCode=" + localStorage.getItem('language'), qRLogAttributeValues);
    },
    updateAttributeValue: function updateAttributeValue(qRLogAttributeValue) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/UpdateQRLogAttributeValues?id=" + qRLogAttributeValue.id, qRLogAttributeValue);
    },
    changeVisibility: function changeVisibility(attribute) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/QRLogAttributes/" + attribute.id, attribute);
    },
    updateSolution: function updateSolution(solution) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Products/" + solution.id), solution);
    },
    lockBlueprint: function lockBlueprint(id, breakLock) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/LockBlueprint/" + id + "/" + (breakLock !== undefined ? breakLock : '')));
    },
    hidePIMSolution: function hidePIMSolution(id) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/HidePIMProductSolutions/" + id));
    },
    unhidePIMSolution: function unhidePIMSolution(id) {
        return ajax.get(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/UnHidePIMProductSolutions/" + id));
    },
    updateCustomerContact: function updateCustomerContact(user) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + ("/Installers?id=" + user.CustomerContactId), user);
    },
    takeOverBlueprintEdit: function takeOverBlueprintEdit(id) {
        return ajax.put(__WEBPACK_IMPORTED_MODULE_2__settings_settings_js__["a" /* default */].baseUrlApi + "/Blueprints/takeover/" + id);
    }
});

/***/ }),
/* 866 */,
/* 867 */,
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_register_service_worker__ = __webpack_require__(869);
/* eslint-disable no-console */



if (true) {
  Object(__WEBPACK_IMPORTED_MODULE_0_register_service_worker__["a" /* register */])('./service-worker.js', {
    ready: function ready() {
      console.log('App is being served from cache by a service worker.\n' + 'For more details, visit https://goo.gl/AFskqB');
    },
    registered: function registered() {
      console.log('Service worker has been registered.');
    },
    cached: function cached() {
      console.log('Content has been cached for offline use.');
    },
    updatefound: function updatefound() {
      console.log('New content is downloading.');
    },
    updated: function updated() {
      console.log('New content is available; please refresh.');
    },
    offline: function offline() {
      console.log('No internet connection found. App is running in offline mode.');
    },
    error: function error(_error) {
      console.error('Error during service worker registration:', _error);
    }
  });
}

/***/ })
]),[337]);


// WEBPACK FOOTER //
// static/js/app.2b9f945733f174c8e576.js